
import React, { useState, useEffect, useRef } from 'react';
import { Modal, Spinner, Offcanvas, Form, Badge, Row, Col, Card } from 'react-bootstrap';
import axios from 'axios';
import { useParams, useLocation } from "react-router-dom";
import BankList from '../bank/BankList';
import Select, { components } from 'react-select';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "react-datepicker/dist/react-datepicker.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";


const TransactionModal = ({ showModal, handleClose, transactionId, transactionData, setBanks, accountId, addTransaction, editTransaction, transactions, projects, fetchProjects, clients, fetchClients, categories, fetchCategories, banks, fetchBanks, vendors, fetchVendors, users, fetchUsers, isEditMode, setIsEditMode }) => {
    const [loading, setLoading] = useState(false); // Track loading state
    const [allTransactions, setAllTransactions] = useState([]);
    const location = useLocation();
    const bankIdFromUrl = location.pathname.split('/').pop();
    const [isDeductionVisible, setIsDeductionVisible] = useState(false);
    const [invoicePayments, setInvoicePayments] = useState({});
    const [vendorExpenses, setVendorExpenses] = useState([]);
    const [userExpenses, setUserExpenses] = useState([]);
    const [selectedUserExpenses, setSelectedUserExpenses] = useState([]);
    const [selectedVendorExpenses, setSelectedVendorExpenses] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    // Add these to your state variables
    const [selectedSalaries, setSelectedSalaries] = useState([]);
    const [totalSalaryAmount, setTotalSalaryAmount] = useState(0);
    const [providerBanks, setProviderBanks] = useState(null);
    const [pendingGuarantees, setPendingGuarantees] = useState([]);

    const [totalAdvance, setTotalAdvance] = useState(0);
    const [totalCredit, setTotalCredit] = useState(0);
    // Add to your state variables
    const [expenseBalances, setExpenseBalances] = useState({});
    const [invoices, setInvoices] = useState([]);
    const [selectedBank, setSelectedBank] = useState(null);
    const [transactionCurrency, setTransactionCurrency] = useState(null);
    const [convertedAmount, setConvertedAmount] = useState('');
    const [baseAmount, setBaseAmount] = useState('');
    const [validationMessages, setValidationMessages] = useState({});
    const [selectedProjects, setSelectedProjects] = useState([]);
    const [hasFetchedInvoices, setHasFetchedInvoices] = useState(false);
    const [hasFetchedProjects, setHasFetchedProjects] = useState(false);
    const [lastFetchedClientId, setLastFetchedClientId] = useState(null);
    // Add to state variables
    const [payrollProviders, setPayrollProviders] = useState([]);
    const [pendingSalaries, setPendingSalaries] = useState([]);
    const [selectedSalary, setSelectedSalary] = useState(null);
    const [salaryAmount, setSalaryAmount] = useState('');
    // const [wpsCharge, setWpsCharge] = useState(''); // REPLACED BY formData
    // const [wpsVat, setWpsVat] = useState(''); // REPLACED BY formData
    // Add to your state variables at the top



    const [pos, setPos] = useState([]);
    const [clientIncomeTransactions, setClientIncomeTransactions] = useState([]);
    const [clientCreditNotes, setClientCreditNotes] = useState([]);
    const [vatReturns, setVatReturns] = useState([]);
    const [allBanks, setAllBanks] = useState([]); // Local state for all accounts (Bank + Cash) for Contra
    const hasFetchedInvoicesRef = useRef(false); // Use Ref instead of state to avoid race conditions
    const hasFetchedAllBanksRef = useRef(false); // Track if all banks have been fetched
    const [formData, setFormData] = useState({
        date: new Date().toISOString().split("T")[0],
        type: '',
        transaction: '',
        account_id: '',
        project_id: '',
        client_id: '',
        vendor_id: '',
        amount: '',
        category_id: '',
        description: '',
        account_type: '',
        invoice_id: '',
        deduction_amount: '',
        bill_no: '',
        tax_type: '', // Reset tax type
        expense_type_id: '',
        user_id: '',
        payment_mode: '',
        expense_id: null,
        reference_no: '',
        reconciliation_status: 'pending',
        selected_invoices: [],
        use_advance: false,
        use_credit: false,
        credit_amount: '0.00',
        bank_service_charge: '',
        bank_vat_amount: '',
        transaction_currency: '', // Standardized: Currency of the transaction amount
        converted_amount: '', // Amount converted to base currency
        base_amount: '',
        salary_ids: [],
        vat_return_id: '',
        from_bank_id: '',
        to_bank_id: '',
        statement_file: null,
        commission_fee: '',
        commission_vat: '',
        related_transaction_id: '',
        advance_type: '', // Default to vendor
        received_amount: '',
        applied_advance: '',
        advance_amount: '', // Total advance amount (for overpayments)
        guarantee_id: '',
    });

    // Track original amount and currency for toggle/reset behavior
    const [originalAmountRef, setOriginalAmountRef] = useState({
        amount: null,
        currency: null
    });
    // Function to get currency ID from code
    const getCurrencyIdFromCode = (code) => {
        if (!code) {
            console.warn('?? getCurrencyIdFromCode: No code provided');
            return null;
        }

        const searchCode = code.toString().trim().toUpperCase();
        console.log('?? getCurrencyIdFromCode: Searching for', { searchCode });

        // First check if we have a selected bank with exchange rates
        if (selectedBank && selectedBank.exchange_rates && Array.isArray(selectedBank.exchange_rates)) {
            // Check base currency first
            if (selectedBank.base_currency?.currency?.toUpperCase() === searchCode) {
                console.log('? getCurrencyIdFromCode: Found in base currency', {
                    searchCode,
                    currencyId: selectedBank.base_currency_id,
                    currency: selectedBank.base_currency.currency
                });
                return selectedBank.base_currency_id;
            }

            // Then check exchange rates
            const rate = selectedBank.exchange_rates.find(
                r => r.currency?.currency?.toString().trim().toUpperCase() === searchCode
            );

            if (rate) {
                console.log('? getCurrencyIdFromCode: Found in exchange rates', {
                    searchCode,
                    currencyId: rate.currency_id,
                    currency: rate.currency.currency,
                    rate: rate.rate
                });
                return rate.currency_id;
            }
        }

        console.warn('?? getCurrencyIdFromCode: Not found', {
            searchCode,
            hasSelectedBank: !!selectedBank,
            baseCurrency: selectedBank?.base_currency?.currency,
            availableRates: selectedBank?.exchange_rates?.map(r => r.currency?.currency)
        });

        return null;
    };

    // Helper to get currency symbol/name
    const getCurrencySymbol = (currencyId) => {
        if (!currencyId || !selectedBank) return 'AED';
        if (currencyId == selectedBank.base_currency_id) {
            return selectedBank.base_currency?.currency || 'AED';
        }
        const rate = selectedBank.exchange_rates?.find(r => r.currency_id?.toString() === currencyId?.toString());
        if (rate?.currency?.currency) return rate.currency.currency;
        const country = countries?.find(c => c.id?.toString() === currencyId?.toString());
        return country?.currency || 'AED';
    };

    // Robust helper to find the recommended currency for the current entity/selection
    const getSelectedInvoiceExpenseCurrency = (data = null) => {
        const currentData = data || formData;
        if (currentData.payment_mode === 'petty_cash') return "AED";
        if (currentData.type === 'income') {
            if (currentData.selected_invoices?.length > 0) {
                const firstInvoiceVal = currentData.selected_invoices[0].value || currentData.selected_invoices[0];
                const firstInvoice = invoices?.find(inv => inv.id?.toString() === firstInvoiceVal?.toString());
                
                if (firstInvoice) {
                    const client = clients?.find(c => c.id?.toString() === (currentData.client_id || firstInvoice.client_id)?.toString());
                    const clientCurrency = client?.currency || 'AED';

                    // Rule: If imported, use import_currency. Otherwise use client currency.
                    if (firstInvoice.is_import && (firstInvoice.is_import === true || firstInvoice.is_import == 1 || firstInvoice.is_import === "1")) {
                        const importCurrency = firstInvoice.import_currency || firstInvoice.currency;
                        return importCurrency || clientCurrency;
                    }
                    
                    return clientCurrency;
                }
            }
            if (currentData.client_id && currentData.client_id.toString() !== "0") {
                const client = clients?.find(c => c.id?.toString() === currentData.client_id.toString());
                return client?.currency || null;
            }
        }
        if (currentData.type === 'expense') {
            if (currentData.bills?.length > 0) {
                const firstBillVal = currentData.bills[0].value || currentData.bills[0];
                const expense = selectedVendorExpenses?.find(exp => exp.id?.toString() === (firstBillVal)?.toString()) ||
                    selectedUserExpenses?.find(exp => exp.id?.toString() === (firstBillVal)?.toString());
                if (expense?.vendor_currency) return expense.vendor_currency;
            }
            if (currentData.vendor_id && currentData.vendor_id.toString() !== "0") {
                const vendor = vendors?.find(v => v.id?.toString() === currentData.vendor_id.toString());
                return vendor?.currency || null;
            }
        }
        if (currentData.type === 'advance') {
            const advType = currentData.advance_type || (currentData.client_id && currentData.client_id.toString() !== "0" ? 'client' : 'vendor');
            if (advType === 'vendor' && currentData.vendor_id && currentData.vendor_id.toString() !== "0") {
                if (currentData.po_id && pos?.length > 0) {
                    const selectedPO = pos.find(p => p.id?.toString() === currentData.po_id.toString());
                    if (selectedPO?.vendor?.currency || selectedPO?.currency)
                        return selectedPO?.vendor?.currency || selectedPO.currency;
                }
                const vendor = vendors?.find(v => v.id?.toString() === currentData.vendor_id.toString());
                return vendor?.currency || null;
            }
            if (advType === 'client' && currentData.client_id && currentData.client_id.toString() !== "0") {
                const client = clients?.find(c => c.id?.toString() === currentData.client_id.toString());
                return client?.currency || null;
            }
        }
        return null;
    };

    // Final source of truth for "What is the currency of the amount field right now?"
    // const getEffectiveCurrencyId = (currentFormData, currentBank) => {
    //     if (currentFormData?.transaction_currency) return currentFormData.transaction_currency;
    //     const code = getSelectedInvoiceExpenseCurrency();
    //     if (code) {
    //         const id = getCurrencyIdFromCode(code);
    //         if (id) return id;
    //     }
    //     return currentBank?.base_currency_id || currentBank?.currency_id;
    // };
    const getEffectiveCurrencyId = (currentFormData, currentBank) => {
        // 1. First check if there's already a selected currency
        if (currentFormData?.transaction_currency) return currentFormData.transaction_currency;

        // 2. For advance transactions with PO, prioritize PO currency
        if (currentFormData.type === 'advance' && currentFormData.po_id && pos?.length > 0) {
            const selectedPO = pos.find(p => p.id?.toString() === currentFormData.po_id.toString());
            if (selectedPO) {
                const poCurrencyCode = selectedPO?.vendor?.currency || selectedPO?.currency;
                console.log("?? getEffectiveCurrencyId: Checking PO currency", {
                    po_id: currentFormData.po_id,
                    poCurrencyCode,
                    selectedPO
                });
                if (poCurrencyCode) {
                    const poCurrencyId = getCurrencyIdFromCode(poCurrencyCode);
                    if (poCurrencyId) {
                        console.log("? getEffectiveCurrencyId: Found PO currency", {
                            po_id: currentFormData.po_id,
                            poCurrencyCode,
                            poCurrencyId
                        });
                        return poCurrencyId;
                    }
                }
            }
        }

        // 3. Check entity currency (existing logic)
        const code = getSelectedInvoiceExpenseCurrency();
        if (code) {
            const id = getCurrencyIdFromCode(code);
            if (id) return id;
        }

        // 4. Fallback to bank base currency
        return currentBank?.base_currency_id || currentBank?.currency_id;
    };

    // const getPrioritizedCurrencies = () => {
    //     if (!selectedBank) return [];

    //     const prioritized = [];
    //     const bankCurrency = selectedBank.base_currency?.currency || 'AED';
    //     const bankId = selectedBank.base_currency_id;

    //     // 1. Bank's Base Currency option (The target)
    //     prioritized.push({
    //         currency_id: bankId,
    //         currency: bankCurrency,
    //         label: bankCurrency,
    //         is_base: true,
    //         priority_label: 'Bank Base'
    //     });

    //     // 2. Add other supported exchange rates from the bank as "Source to Base"
    //     // THE USER REQUESTED: "[Input] to [Base]" (e.g., "USD to AED", "INR to AED")
    //     selectedBank.exchange_rates?.forEach(rate => {
    //         const code = rate.currency?.currency;
    //         if (code && code !== bankCurrency) {
    //             prioritized.push({
    //                 currency_id: rate.currency_id,
    //                 currency: code,
    //                 label: `${code} to ${bankCurrency}`,
    //                 rate: rate.rate
    //             });
    //         }
    //     });

    //     // 3. Recommended Entity Currency (if not base and not already in list)
    //     const entityCode = getSelectedInvoiceExpenseCurrency();
    //     if (entityCode && entityCode !== bankCurrency && !prioritized.some(p => p.currency === entityCode)) {
    //         const entityId = getCurrencyIdFromCode(entityCode);
    //         if (entityId) {
    //             prioritized.push({
    //                 currency_id: entityId,
    //                 currency: entityCode,
    //                 label: `${entityCode} to ${bankCurrency}`,
    //                 is_prioritized: true,
    //                 priority_label: 'Recommended'
    //             });
    //         }
    //     }

    //     return prioritized;
    // };

    const getPrioritizedCurrencies = () => {
        if (!selectedBank) return [];

        const prioritized = [];
        const bankCurrency = selectedBank.base_currency?.currency || 'AED';
        const bankId = selectedBank.base_currency_id;

        // 1. PO Currency (if advance transaction with PO)
        if (formData.type === 'advance' && formData.po_id && pos?.length > 0) {
            const selectedPO = pos.find(p => p.id?.toString() === formData.po_id.toString());
            if (selectedPO) {
                const poCurrencyCode = selectedPO?.vendor?.currency || selectedPO.currency_code;
                console.log("?? getPrioritizedCurrencies: Checking PO currency", {
                    po: selectedPO,
                    poCurrencyCode
                });
                const poCurrencyId = getCurrencyIdFromCode(poCurrencyCode);

                if (poCurrencyId && poCurrencyId !== bankId) {
                    prioritized.push({
                        currency_id: poCurrencyId,
                        currency: poCurrencyCode,
                        label: `${poCurrencyCode}`,
                        is_prioritized: true,
                        priority_label: 'PO Currency'
                    });
                }
            }
        }
        // NEW: Vendor Currency (if advance transaction without PO)
        else if (formData.type === 'advance' && formData.vendor_id && (!formData.po_id || pos?.length === 0)) {
            const vendor = vendors?.find(v => v.id?.toString() === formData.vendor_id.toString());
            if (vendor?.currency) {
                const vendorCurrencyId = getCurrencyIdFromCode(vendor.currency);
                if (vendorCurrencyId && vendorCurrencyId !== bankId) {
                    prioritized.push({
                        currency_id: vendorCurrencyId,
                        currency: vendor.currency,
                        label: `${vendor.currency}`,
                        is_prioritized: true,
                        priority_label: 'Vendor Currency'
                    });
                }
            }
        }

        // 2. Bank's Base Currency
        prioritized.push({
            currency_id: bankId,
            currency: bankCurrency,
            label: bankCurrency,
            is_base: true,
            priority_label: 'Bank Base'
        });

        // 3. Other exchange rates
        selectedBank.exchange_rates?.forEach(rate => {
            const code = rate.currency?.currency;
            if (code && code !== bankCurrency) {
                const isAlreadyAdded = prioritized.some(p => p.currency_id === rate.currency_id);
                if (!isAlreadyAdded) {
                    prioritized.push({
                        currency_id: rate.currency_id,
                        currency: code,
                        label: `${code}`,
                        rate: rate.rate
                    });
                }
            }
        });

        return prioritized;
    };

    // Handle currency selection with toggle behavior
    const handleCurrencySelection = (selectedCurrencyId, options = {}) => {
        const { skipConversion = false, isAutoSelect = false } = options;
        if (!selectedBank || !selectedCurrencyId) return;

        // Get current currency - if transaction_currency is set, use it; otherwise get effective currency
        const currentCurrencyId = formData.transaction_currency || getEffectiveCurrencyId(formData, selectedBank);
        const baseCurrencyId = selectedBank.base_currency_id;

        console.log('?? Currency Selection:', {
            selectedId: selectedCurrencyId,
            selectedSymbol: getCurrencySymbol(selectedCurrencyId),
            currentId: currentCurrencyId,
            currentSymbol: getCurrencySymbol(currentCurrencyId),
            baseId: baseCurrencyId,
            options,
            comparison: {
                areEqual: selectedCurrencyId?.toString() === currentCurrencyId?.toString()
            }
        });

        // 1. TOGGLE BEHAVIOR (Only for manual clicks)
        if (!isAutoSelect && selectedCurrencyId?.toString() === currentCurrencyId?.toString()) {
            console.log('?? Toggle detected - resetting to original');
            if (originalAmountRef.amount !== null && originalAmountRef.currency !== null) {
                setFormData(prev => ({
                    ...prev,
                    amount: originalAmountRef.amount,
                    transaction_currency: originalAmountRef.currency,
                    converted_amount: '',
                    base_amount: ''
                }));
                setOriginalAmountRef({ amount: null, currency: null });
            }
            return;
        }

        // 2. Clear or Store Original Reference
        if (isAutoSelect) {
            // If it's an auto-select (e.g. from choosing a bill), we treat this as a NEW baseline
            setOriginalAmountRef({ amount: null, currency: null });
        } else if (originalAmountRef.amount === null) {
            // Manual change: Store current as original before converting
            setOriginalAmountRef({
                amount: formData.amount,
                currency: currentCurrencyId
            });
        }

        // 3. Skip Conversion Case (e.g. selected a bill that is ALREADY in its own currency)
        if (skipConversion) {
            console.log('? Skipping conversion - setting currency directly');
            setFormData(prev => {
                const amount = parseFloat(prev.amount) || 0;
                let amountInBase = amount;

                // Still calculate base_amount for accounting
                if (selectedCurrencyId?.toString() !== baseCurrencyId?.toString()) {
                    const rate = selectedBank.exchange_rates?.find(
                        r => r.currency_id?.toString() === selectedCurrencyId?.toString()
                    );
                    if (rate && rate.rate) {
                        amountInBase = amount * parseFloat(rate.rate);
                    }
                }

                return {
                    ...prev,
                    transaction_currency: selectedCurrencyId,
                    converted_amount: amountInBase.toFixed(2),
                    base_amount: amountInBase.toFixed(2)
                };
            });
            return;
        }

        const currentAmount = parseFloat(formData.amount) || 0;
        if (currentAmount === 0) {
            setFormData(prev => ({
                ...prev,
                transaction_currency: selectedCurrencyId
            }));
            return;
        }

        // 4. FULL CONVERSION LOGIC
        let amountInBase = currentAmount;

        // Step 1: Convert current amount to base currency (AED)
        if (currentCurrencyId?.toString() !== baseCurrencyId?.toString()) {
            const currentRate = selectedBank.exchange_rates?.find(
                rate => rate.currency_id?.toString() === currentCurrencyId?.toString()
            );
            if (currentRate && currentRate.rate) {
                amountInBase = currentAmount * parseFloat(currentRate.rate);
            }
        }

        // Step 2: Convert from base currency to selected currency
        let convertedAmount = amountInBase;
        if (selectedCurrencyId?.toString() !== baseCurrencyId?.toString()) {
            const selectedRate = selectedBank.exchange_rates?.find(
                rate => rate.currency_id?.toString() === selectedCurrencyId?.toString()
            );
            if (selectedRate && selectedRate.rate) {
                convertedAmount = amountInBase / parseFloat(selectedRate.rate);
            }
        }

        // Update formData with new currency and converted amount
        setFormData(prev => ({
            ...prev,
            transaction_currency: selectedCurrencyId,
            amount: convertedAmount.toFixed(2),
            converted_amount: amountInBase.toFixed(2),
            base_amount: amountInBase.toFixed(2)
        }));

        console.log('? Currency conversion complete:', {
            newCurrency: getCurrencySymbol(selectedCurrencyId),
            newAmount: convertedAmount.toFixed(2)
        });
    };
    const [activeTab, setActiveTab] = useState('details');
    const MySwal = withReactContent(Swal);
    // Check if form should be read-only based on reconciliation status
    // Check if specific fields should be read-only based on reconciliation status
    const isReconciled = formData.reconciliation_status === 'reconciled' && transactionData;
    const isInvoiceFieldReadOnly = isReconciled && formData.type === 'income';
    const isExpenseFieldReadOnly = isReconciled && formData.type === 'expense';
    const showToast = (message, type = "error") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };
    const showToast1 = (message, type = "success") => {
        MySwal.fire({
            toast: true,
            position: "top-end",
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
        });
    };
    const formatCurrency = (amount) => {
        return Number(amount || 0).toLocaleString('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric'
        });
    };
    // Add this at the top of your TransactionModal component
    const [countries, setCountries] = useState([]);

    // Add this useEffect to fetch countries if not provided
    useEffect(() => {
        if (showModal && (!countries || countries.length === 0)) {
            fetchCountries();
        }
    }, [showModal]);
    const backendUrl = process.env.REACT_APP_BACKEND_URL;

    // Or if fetchCountries is not available, create a local function
    const fetchCountries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/countries`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setCountries(response.data?.data || response.data || []);
        } catch (error) {
            console.error("Error fetching countries:", error);
            setCountries([]);
        }
    };
    const handleDateInput = (e) => {
        let value = e.target.value;

        // Replace "/" or "." with "-"
        value = value.replace(/[\/.]/g, "-");

        // Convert dd-mm-yyyy ? yyyy-mm-dd
        const parts = value.split("-");
        if (parts.length === 3) {
            const [d, m, y] = parts;

            // If user typed dd-mm-yyyy
            if (y?.length === 4 && d.length <= 2 && m.length <= 2) {
                value = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
            }
        }

        setFormData({ ...formData, date: value });
    };


    const [errors, setErrors] = useState({});
    useEffect(() => {
        if (showModal) {
            fetchBanks();
            fetchVendors();
            fetchClients();
            fetchCategories();
            fetchUsers();
        }
    }, [showModal]);
    useEffect(() => {
        if (!transactionData && formData.account_type) {
            fetchBanks(formData.account_type);
        }
    }, [formData.account_type, transactionData]);




    const [relatedExpenses, setRelatedExpenses] = useState([]);
    // Add this function to fetch POs based on project and vendor
    const fetchPOs = async (projectId, vendorId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            if (!projectId || !vendorId) {
                setPos([]);
                return;
            }

            const response = await axios.get(`${backendUrl}/api/purchase-order`, {
                params: {
                    project_id: projectId,
                    vendor_id: vendorId,
                    product_null: true
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            // setPos(response.data?.purchaseorders || response.data || []);

            const posData = response.data?.purchaseorders || response.data || [];
            setPos(posData);
            if (formData.po_id && posData.length > 0) {
                const selectedPO = posData.find(po => po.id.toString() === formData.po_id.toString());
                if (selectedPO && selectedPO.amount) {
                    setFormData(prev => ({
                        ...prev,
                        amount: selectedPO.amount.toString()
                    }));
                }
            }
        } catch (error) {
            console.error("Error fetching purchase orders:", error);
            setPos([]);
        }
    };

    // Update the initFormData function in useEffect
    useEffect(() => {
        const initFormData = async () => {
            if (!transactionData) {
                let selectedBank = banks.find(bank => bank.id.toString() === bankIdFromUrl) || null;

                const baseCurrencyId = (selectedBank ? (selectedBank.base_currency_id || selectedBank.id.toString()) : '');

                setFormData((prev) => {
                    const initialData = {
                        ...prev,
                        date: prev.date || new Date().toISOString().split("T")[0],
                        account_id: prev.account_id || (selectedBank ? selectedBank.id.toString() : ''),
                        account_type: prev.account_type || (selectedBank ? selectedBank.type : ''),
                        exchange_rate: prev.exchange_rate || (selectedBank ? selectedBank.exchange_rate : ''),
                        transaction_currency: prev.transaction_currency || baseCurrencyId
                    };

                    // Auto-select based on initial entity/type
                    const prioritizedCurrencyId = autoSelectCurrency(initialData);
                    if (prioritizedCurrencyId) {
                        initialData.transaction_currency = prioritizedCurrencyId;
                    }

                    return initialData;
                });
            } else {
                let billResponse = { bills: [] };
                let fetchedRelatedExpenses = [];

                // Fetch bills only for 'expense' type transactions
                if (transactionData.type === 'expense' || transactionData.type === 'payroll') {
                    try {
                        const backendUrl = process.env.REACT_APP_BACKEND_URL;
                        const userInfo = JSON.parse(localStorage.getItem("user-info"));
                        const origin = localStorage.getItem('user-origin');
                        const token = userInfo?.token;

                        const response = await axios.get(`${backendUrl}/api/transaction/data/${transactionData.id}`, {
                            headers: {
                                Authorization: `Bearer ${token}`,
                                'Tenant-Origin': origin,
                            },
                            skipLoader: true,
                        });

                        billResponse = response.data.data;

                        // Check if related_expenses are available
                        if (response.data.data.related_expenses && Array.isArray(response.data.data.related_expenses)) {
                            fetchedRelatedExpenses = response.data.data.related_expenses;
                            setRelatedExpenses(fetchedRelatedExpenses);

                            // SYNC: Populate selection states for syncWithWebzash
                            console.log("?? Syncing related expenses to selection states for Webzash matching");

                            const vendorExps = fetchedRelatedExpenses.filter(e => e.vendor_id);
                            const userExps = fetchedRelatedExpenses.filter(e => e.user_id);

                            if (vendorExps.length > 0) {
                                setSelectedVendorExpenses(prev => {
                                    const existingIds = new Set(prev.map(e => e.id?.toString()));
                                    const newItems = vendorExps.filter(e => !existingIds.has(e.id?.toString()));
                                    return [...prev, ...newItems];
                                });
                            }

                            if (userExps.length > 0) {
                                setSelectedUserExpenses(prev => {
                                    const existingIds = new Set(prev.map(e => e.id?.toString()));
                                    const newItems = userExps.filter(e => !existingIds.has(e.id?.toString()));
                                    return [...prev, ...newItems];
                                });
                            }
                        }

                        console.log("Fetched related expenses:", fetchedRelatedExpenses);
                        console.log("Bills from API:", billResponse.bills);
                    } catch (error) {
                        console.error("Error fetching transaction bills:", error);
                        billResponse = { bills: [] };
                    }
                }

                let selectedProjectIds = [];
                let selectedProjectOptions = [];

                // Check if transaction has projects relationship (many-to-many)
                if (transactionData.projects && Array.isArray(transactionData.projects)) {
                    // Multiple projects from pivot table
                    selectedProjectIds = transactionData.projects.map(p => p.id);
                    selectedProjectOptions = transactionData.projects.map(p => ({
                        label: p.name,
                        value: p.id
                    }));
                } else if (transactionData.project_ids) {
                    // Check for multiple project IDs (string or array)
                    const pIds = Array.isArray(transactionData.project_ids)
                        ? transactionData.project_ids
                        : transactionData.project_ids.toString().split(',').map(id => id.trim());

                    selectedProjectIds = pIds;

                    if (projects && projects.length > 0) {
                        selectedProjectOptions = pIds.map(id => {
                            const p = projects.find(proj => proj.id.toString() === id.toString());
                            return p ? { label: p.name, value: p.id } : { label: `Project #${id}`, value: id };
                        }).filter(Boolean);
                    } else {
                        // Fallback labels if projects not loaded
                        selectedProjectOptions = pIds.map(id => ({ label: `Project #${id}`, value: id }));
                    }

                } else if (transactionData.project_id) {
                    // Single project from old field
                    selectedProjectIds = [transactionData.project_id];
                    const project = projects.find(p => p.id === transactionData.project_id);
                    if (project) {
                        selectedProjectOptions = [{
                            label: project.name,
                            value: project.id
                        }];
                    } else {
                        // Keep ID if name not found yet
                        selectedProjectOptions = [{
                            label: `Project #${transactionData.project_id}`,
                            value: transactionData.project_id
                        }];
                    }
                }

                // Set selected projects to state
                setSelectedProjects(selectedProjectOptions);

                // Initialize selected invoices for income transactions
                let selectedInvoices = [];
                // if (transactionData.type === 'income') {
                //     if (transactionData.invoice_id) {
                //         selectedInvoices = [{
                //             label: `Invoice #${transactionData.invoice_id}`,
                //             value: transactionData.invoice_id,
                //             amount: transactionData.amount || 0
                //         }];
                //     }
                //     if (transactionData.selected_invoices && Array.isArray(transactionData.selected_invoices)) {
                //         selectedInvoices = transactionData.selected_invoices.map(inv => ({
                //             label: inv.label || `Invoice #${inv.value || inv.id}`,
                //             value: inv.value || inv.id,
                //             amount: inv.amount || 0
                //         }));
                //     }
                // }

                // In your initFormData function, update the selected invoices initialization:

                // Initialize selected invoices for income transactions
                // In your useEffect where you initialize formData, update the selected invoices initialization:

                // Initialize selected invoices for income transactions
                // Initialize selected invoices for income transactions
                if (transactionData.type === 'income' || transactionData.type === 'bad_debt_written_off') {
                    console.log("?? Initializing invoices for income transaction", transactionData);

                    // Helper to format invoice label with remaining balance
                    const formatInvoiceLabel = (inv) => {
                        const amount = parseFloat(inv.amount || 0);
                        const id = inv.value || inv.id;
                        let label = inv.label || `Invoice #${id}`;

                        // Try to find full invoice details to show remaining balance
                        if (invoices && invoices.length > 0) {
                            const fullInvoice = invoices.find(i => i.id.toString() === id.toString());
                            if (fullInvoice) {
                                const original = parseFloat(fullInvoice.total_with_vat || fullInvoice.amount || 0);
                                const paidSoFar = parseFloat(fullInvoice.amount_paid || 0);
                                // Note: amount_paid might include THIS transaction if it's already processed? 
                                // Displaying the "remaining" from the perspective of "unpaid" might be tricky if data is stale.
                                // But usually for "View" we want to show what was paid in THIS transaction vs Total.

                                // User request: "if the selected invoices total not fully paid then the remaing balance also shown"
                                // We can show the CURRENT remaining balance of the invoice.
                                const remaining = parseFloat(fullInvoice.remaining_balance || 0);
                                if (remaining > 0) {
                                    // Use ref_no if available
                                    const ref = fullInvoice.ref_no || fullInvoice.invoice_no || `Invoice #${id}`;
                                    return `${ref} (Amount: ${formatCurrency(amount)}, Remaining: ${formatCurrency(remaining)})`;
                                }
                                const ref = fullInvoice.ref_no || fullInvoice.invoice_no || `Invoice #${id}`;
                                return `${ref} (Amount: ${formatCurrency(amount)})`;
                            }
                        }
                        return label;
                    };


                    // Check multiple sources for invoice data
                    // 1. First check if there's an array in selected_invoices field
                    if (transactionData.selected_invoices && Array.isArray(transactionData.selected_invoices)) {
                        console.log("Found selected_invoices array:", transactionData.selected_invoices);
                        selectedInvoices = transactionData.selected_invoices.map(inv => ({
                            label: formatInvoiceLabel(inv),
                            value: inv.value || inv.id,
                            amount: inv.amount || 0
                        }));
                    }
                    // 2. Check if there's a single invoice_id
                    else if (transactionData.invoice_id) {
                        console.log("Found single invoice_id:", transactionData.invoice_id);
                        const invData = {
                            // Pass full invoice object if available in transactionData
                            ...transactionData.invoice,
                            value: transactionData.invoice_id,
                            amount: transactionData.amount || 0,
                            label: transactionData.invoice ? (transactionData.invoice.display_ref_no || transactionData.invoice.ref_no) : undefined
                        };
                        selectedInvoices = [{
                            label: formatInvoiceLabel(invData),
                            value: transactionData.invoice_id,
                            amount: transactionData.amount || 0
                        }];
                    }
                    // 3. Check if there are invoices in the transaction details
                    else if (transactionData.invoices && Array.isArray(transactionData.invoices)) {
                        console.log("Found invoices array:", transactionData.invoices);
                        selectedInvoices = transactionData.invoices.map(inv => ({
                            label: formatInvoiceLabel({ ...inv, value: inv.id }),
                            value: inv.id,
                            amount: inv.amount || 0
                        }));
                    }

                    console.log("Final selected invoices to set:", selectedInvoices);
                }

                // Initialize bills for expense transactions
                let selectedBills = [];
                if (transactionData.type === 'expense') {
                    // First, use related expenses from API (this should have narration)
                    if (fetchedRelatedExpenses.length > 0) {
                        selectedBills = fetchedRelatedExpenses.map(exp => {
                            // Prioritize NARRATION, then expense type name
                            const displayName = exp.narration ||
                                exp.expense_type?.name ||
                                'Expense';

                            // Get invoice number if available
                            const invoiceNo = exp.invoice_no || 'No Invoice';

                            return {
                                // Show: Narration/ExpenseType - InvoiceNo (Amount)
                                label: `${displayName} - ${invoiceNo} (${formatCurrency(exp.total_amount || exp.amount)})`,
                                value: exp.id,
                                amount: exp.total_amount || exp.amount,
                                expense_type_id: exp.expense_type_id,
                                expense_type_name: exp.expense_type?.name,
                                invoice_no: exp.invoice_no,
                                narration: exp.narration,
                                identifier: exp.invoice_no || exp.expense_type?.name || `expense_${exp.id}`
                            };
                        });
                    }
                    // If no related expenses, check if bills exist in transactionData
                    else if (transactionData.bills && Array.isArray(transactionData.bills)) {
                        selectedBills = transactionData.bills.map(bill => {
                            if (typeof bill === 'object') {
                                // Try to extract meaningful information from the bill object
                                const displayName = bill.narration ||
                                    bill.expense_type_name ||
                                    (bill.label ? bill.label.split(' - ')[0] : 'Expense') ||
                                    'Expense';

                                const invoiceNo = bill.invoice_no ||
                                    (bill.label && bill.label.includes('-') ?
                                        bill.label.split('-')[1]?.split('(')[0]?.trim() : 'No Invoice');

                                return {
                                    label: `${displayName} - ${invoiceNo} (${formatCurrency(bill.amount || 0)})`,
                                    value: bill.value || bill.id,
                                    amount: bill.amount || 0,
                                    expense_type_id: bill.expense_type_id,
                                    expense_type_name: bill.expense_type_name,
                                    invoice_no: bill.invoice_no,
                                    narration: bill.narration,
                                    identifier: bill.identifier || bill.invoice_no
                                };
                            } else {
                                // For simple bill IDs, we don't have much info
                                return {
                                    label: `Expense #${bill}`,
                                    value: bill,
                                    amount: 0,
                                    identifier: `expense_${bill}`
                                };
                            }
                        });
                    }
                    // Finally, check expense_id for backward compatibility (single or multiple)
                    else if (transactionData.expense_id) {
                        const expenseIds = transactionData.expense_id.split(',').filter(id => id.trim());

                        selectedBills = expenseIds.map((id, index) => {
                            // Try to get amount per expense
                            const amountPerExpense = expenseIds.length > 1
                                ? (parseFloat(transactionData.amount) / expenseIds.length) || 0
                                : transactionData.amount || 0;

                            return {
                                label: `Expense #${id}`, // Fallback since we don't have more info
                                value: id,
                                amount: amountPerExpense
                            };
                        });
                    }
                }
                // In your initFormData function, add this:
                // In your initFormData function, add this:
                if (transactionData.bill_allocations && Array.isArray(transactionData.bill_allocations)) {
                    // Set bill allocations from transaction data
                    formData.bill_allocations = transactionData.bill_allocations;

                    // Also update the bills array with correct remaining balances
                    if (selectedBills && selectedBills.length > 0) {
                        selectedBills = selectedBills.map(bill => {
                            const allocation = transactionData.bill_allocations.find(
                                a => a.expense_id.toString() === bill.value?.toString()
                            );
                            if (allocation) {
                                return {
                                    ...bill,
                                    remaining_balance: allocation.remaining_balance,
                                    amount: allocation.remaining_balance || bill.amount
                                };
                            }
                            return bill;
                        });
                    }
                }

                // Initialize selected salaries for payroll transactions
                // let salarySource = transactionData.salaries;
                // if (!salarySource && billResponse && billResponse.salaries) {
                //     salarySource = billResponse.salaries;
                // }

                // if (transactionData.type === 'payroll' && salarySource && Array.isArray(salarySource)) {
                //     const mappedSalaries = salarySource.map(salary => ({
                //         label: `${salary.narration} - ${formatCurrency(salary.net_salary || salary.total_amount)} - ${salary.date}`,
                //         value: salary.id,
                //         amount: salary.total_amount
                //     }));
                //     setSelectedSalaries(mappedSalaries);

                //     // Calculate total salary amount
                //     const totalSal = mappedSalaries.reduce((sum, s) => sum + (parseFloat(s.amount) || 0), 0);
                //     setTotalSalaryAmount(totalSal);
                // }
                // Initialize selected salaries for payroll transactions - CORRECTED VERSION
                let salaryIds = [];
                let salarySource = [];

                // Get salary ID from transactionData
                if (transactionData.salary_id) {
                    salaryIds = [transactionData.salary_id]; // Single salary ID
                }

                // Also check salary_ids if it exists
                if (transactionData.salary_ids) {
                    if (Array.isArray(transactionData.salary_ids)) {
                        salaryIds = transactionData.salary_ids;
                    } else if (typeof transactionData.salary_ids === 'string') {
                        salaryIds = transactionData.salary_ids.split(',').map(id => id.trim());
                    }
                }

                // Get salary data from transaction_expense_items
                if (transactionData.transaction_expense_items && Array.isArray(transactionData.transaction_expense_items)) {
                    // Filter for salary type expenses
                    const salaryExpenses = transactionData.transaction_expense_items
                        .filter(item => item.expense && item.expense.type === 'salary')
                        .map(item => item.expense);

                    if (salaryExpenses.length > 0) {
                        salarySource = salaryExpenses;
                    }
                }

                // If we still don't have salary data but have IDs, fetch from pendingSalaries
                if (salaryIds.length > 0 && salarySource.length === 0) {
                    if (pendingSalaries && pendingSalaries.length > 0) {
                        salarySource = pendingSalaries.filter(salary =>
                            salaryIds.some(id => salary.id.toString() === id.toString())
                        );
                    }
                }

                if (transactionData.type === 'payroll' && salarySource.length > 0) {
                    const mappedSalaries = salarySource.map(salary => ({
                        label: `${salary.narration || 'Salary'} - ${formatCurrency(salary.total_amount || salary.amount || 0)} - ${salary.date || 'No Date'}`,
                        value: salary.id,
                        amount: salary.total_amount || salary.amount || 0,
                        wps_charge: salary.wps_charge || 0,
                        wps_vat: salary.wps_vat || 0
                    }));

                    setSelectedSalaries(mappedSalaries);

                    // Calculate total salary amount
                    const totalSal = mappedSalaries.reduce((sum, s) => sum + (parseFloat(s.amount) || 0), 0);
                    setTotalSalaryAmount(totalSal);

                    // Get bank charges from transactionData (they're at the root level)
                    const bankServiceCharge = parseFloat(transactionData.bank_service_charge || 0);
                    const bankVatAmount = parseFloat(transactionData.bank_vat_amount || 0);

                    // Calculate total amount including bank charges
                    const totalAmount = totalSal + bankServiceCharge + bankVatAmount;

                    // Update formData
                    setFormData(prev => ({
                        ...prev,
                        salary_ids: mappedSalaries.map(s => s.value),
                        salary_id: mappedSalaries.length > 0 ? mappedSalaries[0].value : null,
                        amount: totalAmount.toFixed(2),
                        bank_service_charge: transactionData.bank_service_charge || '',
                        bank_vat_amount: transactionData.bank_vat_amount || '',
                        wps_charge: transactionData.wps_charge || '',
                        wps_vat: transactionData.wps_vat || ''
                    }));
                }

                const selectedAccount = banks.find(acc => acc.id.toString() === (transactionData.account_id || bankIdFromUrl)?.toString());

                // Set initial form data
                setFormData({
                    date: transactionData.date || new Date().toISOString().split("T")[0],
                    type: transactionData.type || '',
                    transaction: transactionData.transaction || '',
                    description: transactionData.description || '',
                    client_id: (transactionData.client_id && transactionData.client_id !== '0') ? transactionData.client_id : '',
                    vendor_id: transactionData.vendor_id || '',
                    user_id: transactionData.user_id || '',
                    project_ids: selectedProjectIds,
                    project_id: selectedProjectIds.length > 0 ? selectedProjectIds[0] : (transactionData.project_id || ''),

                    category_id: transactionData.category_id || '',
                    amount: transactionData.amount || '',
                    remainingBalance: (transactionData.type === 'income' || transactionData.type === 'bad_debt_written_off')
                        ? (parseFloat(transactionData.amount || 0) + parseFloat(transactionData.applied_advance || transactionData.applied_amount || 0))
                        : 0,
                    account_id: transactionData.account_id || '',
                    account_type: transactionData.account_type || '',
                    invoice_id: transactionData.invoice_id || '',
                    deduction_amount: transactionData.deduction_amount || '',
                    uncategorized: transactionData.uncategorized ? "true" : "false",
                    bill_no: transactionData.bill_no || '',
                    tax_type: transactionData.tax_type || '',
                    user_id: transactionData.user_id || '',
                    payment_mode: transactionData.payment_mode || '',
                    expense_type_id: transactionData.expense_type_id || '',
                    expense_id: transactionData.expense_id || null,
                    reference_no: transactionData.reference_no || '',
                    reconciliation_status: transactionData.reconciliation_status || 'pending',
                    advance_amount: transactionData.advance_amount || '0.00',
                    received_amount: transactionData.received_amount || transactionData.amount || '',
                    applied_advance: transactionData.applied_advance || transactionData.applied_amount || '0.00',
                    use_advance: (parseFloat(transactionData.applied_advance) || parseFloat(transactionData.applied_amount) || 0) > 0,
                    selected_invoices: selectedInvoices,
                    bills: selectedBills,
                    bank_service_charge: transactionData.bank_service_charge || '',
                    bank_vat_amount: transactionData.bank_vat_amount || '',
                    commission_fee: transactionData.commission_fee || '',
                    commission_vat: transactionData.commission_vat || '',
                    // Consolidate to transaction_currency from either source
                    transaction_currency: transactionData.transaction_currency_id || (selectedAccount ? getCurrencyIdFromCode(transactionData.transaction_currency) : transactionData.transaction_currency),
                    converted_amount: transactionData.converted_amount,
                    base_amount: transactionData.base_amount,
                    // project_id is handled above
                    po_id: transactionData.po_id || '',
                    deduction_amount: transactionData.deduction_amount || '',
                    wps_charge: transactionData.wps_charge,
                    wps_vat: transactionData.wps_vat,
                    salary_ids: transactionData.salary_ids,
                    from_bank_id: transactionData.from_bank_id || '',
                    to_bank_id: transactionData.to_bank_id || '',
                    statement_file: transactionData.statement_file || null,
                    payroll_provider_id: transactionData.payroll_provider_id,
                    vat_return_id: transactionData.vat_return_id,
                    advance_type: transactionData.type === 'advance' ? (transactionData.advance_type || '') : '',
                    applied_amount: transactionData.applied_amount || '0.00',
                    guarantee_id: transactionData.guarantee_id || '',
                });
                if (transactionData.converted_amount) {
                    setConvertedAmount(transactionData.converted_amount);
                }
                if (transactionData.base_amount) {
                    setBaseAmount(transactionData.base_amount);
                }

                // Also ensure the currency conversion display works
                if (selectedBank && transactionData.transaction_currency) {
                    setFormData(prev => {
                        const newFormData = { ...prev };
                        // If amount exists, recalculate conversion
                        if (prev.amount && transactionData.transaction_currency) {
                            const converted = convertAmount(
                                parseFloat(prev.amount || 0),
                                transactionData.transaction_currency,
                                selectedBank.base_currency_id
                            );
                            newFormData.converted_amount = converted.toFixed(2);
                            newFormData.base_amount = converted.toFixed(2);
                            setConvertedAmount(converted.toFixed(2));
                            setBaseAmount(converted.toFixed(2));
                        }
                        return newFormData;
                    });
                }

                // Ensure all relevant list data is fetched for the transaction type in EDIT mode
                const currentType = transactionData.type;
                const currentClientId = transactionData.client_id || formData.client_id;
                const currentVendorId = transactionData.vendor_id || formData.vendor_id;
                const currentProjectId = transactionData.project_id || (selectedProjectIds.length > 0 ? selectedProjectIds[0] : null);

                // 1. Fetch Clients (Needed for most types to show names and filter projects)
                if (['income', 'advance', 'expense', 'bad_debt_written_off'].includes(currentType)) {
                    if (!clients || clients.length === 0) fetchClients();
                }

                // 2. Fetch Vendors (Needed for expense, advance, payroll)
                if (['expense', 'advance', 'payroll'].includes(currentType)) {
                    if (!vendors || vendors.length === 0) fetchVendors();
                }

                // 3. Fetch Projects
                if (currentClientId && currentClientId !== "0") {
                    if (currentClientId !== lastFetchedClientId) {
                        fetchProjects(currentClientId);
                        setLastFetchedClientId(currentClientId);
                    }

                    // 4. Fetch POs for advances specifically
                    if (currentType === 'advance' && currentVendorId && currentProjectId) {
                        fetchPOs(currentProjectId, currentVendorId);
                    }
                }

                if (currentType === 'expense') {
                    if (!categories || categories.length === 0) fetchCategories();
                    if (!users || users.length === 0) fetchUsers();
                }

                if (banks.length === 0) fetchBanks();

                // Fetch banks and invoices if needed
                if (banks.length === 0) {
                    fetchBanks();
                }
                //         if (transactionData.type === 'income' && transactionData.client_id && transactionData.project_id) {
                //     // Add this condition to prevent multiple calls
                //     if (invoices.length === 0 && (transactionData.reconciliation_status !== 'reconciled' || isEditMode)) {
                //         console.log('Fetching invoices once...');
                //         fetchInvoices(transactionData.client_id, transactionData.project_id);
                //     }
                // }
                // FIX: Check for any selected projects, not just single project_id
                const hasProjects = (transactionData.project_id) || (selectedProjectIds && selectedProjectIds.length > 0);

                if ((transactionData.type === 'income' || transactionData.type === 'bad_debt_written_off') && transactionData.client_id && hasProjects) {
                    // SIMPLE FIX: Only fetch invoices if we haven't fetched them yet (using Ref to avoid race conditions)
                    if (!hasFetchedInvoicesRef.current && (transactionData.reconciliation_status !== 'reconciled' || isEditMode)) {
                        console.log('Fetching invoices (first time only)...');
                        hasFetchedInvoicesRef.current = true; // Mark as fetched immediately
                        fetchInvoices(transactionData.client_id, selectedProjectIds);
                    }
                }

                if (transactionData.project_id && transactionData.vendor_id) {
                    // Small timeout to ensure state is updated before fetching
                    setTimeout(() => {
                        fetchPOs(transactionData.project_id, transactionData.vendor_id);
                    }, 100);
                }
            }
        };

        if (showModal) {
            initFormData();
        }
    }, [showModal, transactionData, bankIdFromUrl, projects, invoices]);

    useEffect(() => {
        console.log("?? DEBUG - Current State:", {
            payment_mode: formData.payment_mode,
            vendor_id: formData.vendor_id,
            user_id: formData.user_id,
            type: formData.type,
            selectedVendorExpenses_count: selectedVendorExpenses?.length || 0,
            selectedUserExpenses_count: selectedUserExpenses?.length || 0,
            selectedVendorExpenses_first: selectedVendorExpenses?.[0],
            selectedUserExpenses_first: selectedUserExpenses?.[0],
            expenseBalances_keys: Object.keys(expenseBalances),
            showModal: showModal
        });
    }, [formData.payment_mode, formData.vendor_id, formData.user_id, selectedVendorExpenses, selectedUserExpenses]);

    useEffect(() => {
        if (showModal && !transactionData && banks.length > 0) {
            let selectedBank = banks.find(bank => bank.id.toString() === bankIdFromUrl) || null;

            if (selectedBank) {
                setFormData((prev) => ({
                    ...prev, // ? Preserve manually entered values
                    account_id: prev.account_id || selectedBank.id.toString(),
                    account_type: prev.account_type || selectedBank.type,
                }));
            }
        }
    }, [banks]);
    // When account changes, fetch the bank details including exchange rates
    // Fetch Pending Bank Guarantees
    useEffect(() => {
        const fetchPendingGuarantees = async () => {
            if ((formData.type === 'bank_guarantee_released' || formData.type === 'bank_guarantee_charges') && formData.account_id) {
                try {
                    // setLoading(true); // Maybe avoid full page loader
                    const userInfo = JSON.parse(localStorage.getItem("user-info"));
                    const token = userInfo?.token;
                    const origin = localStorage.getItem('user-origin');

                    const response = await axios.get(`${backendUrl}/api/transactions`, {
                        params: {
                            type: 'bank_guarantee',
                            account_id: formData.account_id,
                            is_released: 0
                        },
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Tenant-Origin': origin,
                        },
                        skipLoader: true
                    });
                    setPendingGuarantees(response.data.data || []);
                } catch (error) {
                    console.error("Error fetching pending guarantees:", error);
                    showToast("Failed to fetch pending guarantees", "error");
                }
            } else {
                setPendingGuarantees([]);
            }
        };

        fetchPendingGuarantees();
    }, [formData.type, formData.account_id]);

    useEffect(() => {
        if (formData.account_id && banks?.length > 0) {
            const bank = banks.find(b => b.id.toString() === formData.account_id.toString());
            setSelectedBank(bank);

            // DON'T auto-set currency here - let autoSelectCurrency handle it
            // Only set transaction_currency if it's completely empty AND no entity currency is found
            if (bank && !formData.transaction_currency && !getSelectedInvoiceExpenseCurrency()) {
                const recommendedId = autoSelectCurrency({ ...formData, account_id: bank.id });
                setFormData(prev => ({
                    ...prev,
                    transaction_currency: recommendedId || bank.base_currency_id || bank.currency_id,
                    base_currency_id: bank.base_currency_id || bank.currency_id
                }));
            }
        }
    }, [formData.account_id, banks]);

    useEffect(() => {
        // CRITICAL: Skip auto-selection in Edit mode. 
        // We want to respect the currency the user saved in the transaction.
        // Manual changes are still handled by handleChange().
        if (transactionData || !selectedBank) return;

        if (formData.client_id || formData.vendor_id || formData.user_id || formData.type === 'advance') {
            // Force currency update when entity changes
            const recommendedId = autoSelectCurrency(formData);

            // Only update if we have a recommendation AND it's different from current
            if (recommendedId &&
                recommendedId.toString() !== formData.transaction_currency?.toString()) {

                console.log("?? Auto-setting currency to:", {
                    recommendedId,
                    current: formData.transaction_currency,
                    entity: formData.client_id ? 'client' : 'vendor'
                });

                // Update formData and CONVERT amount
                setFormData(prev => {
                    const newFormData = { ...prev, transaction_currency: recommendedId };

                    if (prev.amount && parseFloat(prev.amount) > 0) {
                        const oldId = getEffectiveCurrencyId(prev, selectedBank);

                        // Only convert if the logic suggests a change is needed
                        if (oldId?.toString() !== recommendedId?.toString()) {
                            const amountInBase = convertAmountToBase(parseFloat(prev.amount), oldId, selectedBank);

                            let newAmount = amountInBase;
                            if (recommendedId?.toString() !== selectedBank.base_currency_id?.toString()) {
                                const rate = getExchangeRate(recommendedId);
                                newAmount = amountInBase / (rate || 1);
                            }

                            newFormData.amount = newAmount.toFixed(2);
                            newFormData.converted_amount = amountInBase.toFixed(2);
                            newFormData.base_amount = amountInBase.toFixed(2);
                            setConvertedAmount(amountInBase.toFixed(2));
                            setBaseAmount(amountInBase.toFixed(2));
                        }
                    }

                    return newFormData;
                });
            }
        }
    }, [formData.client_id, formData.vendor_id, formData.user_id, formData.type, formData.advance_type, selectedBank]);

    // Handle currency change
    const handleCurrencyChange = (e) => {
        const { name, value } = e.target;

        setFormData(prev => {
            const newFormData = { ...prev, [name]: value };

            // If amount exists and currency changed, convert it
            if (name === 'transaction_currency' && prev.amount && value) {
                const converted = convertAmount(
                    parseFloat(prev.amount || 0),
                    value,
                    selectedBank.base_currency_id
                );
                newFormData.converted_amount = converted.toFixed(2);
                newFormData.base_amount = converted.toFixed(2);
                setConvertedAmount(converted.toFixed(2));
                setBaseAmount(converted.toFixed(2));
            }

            return newFormData;
        });
    };

    const validateExpenseAmount = (selectedBills, enteredAmount) => {
        if (!selectedBills || selectedBills.length === 0) return null;

        // Calculate total remaining balance of selected expenses
        const totalRemainingBalance = selectedBills.reduce((sum, bill) => {
            const remaining = expenseBalances[bill.value]?.remaining ||
                bill.remaining_balance ||
                bill.original_amount ||
                bill.amount || 0;
            return sum + parseFloat(remaining);
        }, 0);

        // Check if entered amount exceeds total remaining balance
        if (parseFloat(enteredAmount) > totalRemainingBalance) {
            return `Amount (${formatCurrency(enteredAmount)}) exceeds total remaining balance of selected expenses (${formatCurrency(totalRemainingBalance)}).`;
        }

        return null;
    };


    // const handleCurrencySelection = (currencyId) => {
    //     if (!currencyId || !selectedBank) return;

    //     setFormData(prev => {
    //         // Resolve oldCurrencyId: try state first, then infer from entity, then fallback to bank base
    //         let oldCurrencyId = prev.transaction_currency;

    //         if (!oldCurrencyId) {
    //             const entityCode = getSelectedInvoiceExpenseCurrency();
    //             if (entityCode) {
    //                 oldCurrencyId = getCurrencyIdFromCode(entityCode);
    //             }
    //         }

    //         if (!oldCurrencyId) {
    //             oldCurrencyId = selectedBank.base_currency_id || selectedBank.currency_id;
    //         }

    //         const newFormData = { ...prev, transaction_currency: currencyId };

    //         // If amount exists and currency actually changed, convert it
    //         if (prev.amount && oldCurrencyId?.toString() !== currencyId?.toString()) {
    //             // First convert old currency amount to BASE currency
    //             const amountInBase = convertAmountToBase(
    //                 parseFloat(prev.amount || 0),
    //                 oldCurrencyId,
    //                 selectedBank
    //             );

    //             // Then convert BASE currency amount to NEW selection
    //             const finalAmount = convertAmount(
    //                 amountInBase,
    //                 selectedBank.base_currency_id,
    //                 currencyId
    //             );

    //             newFormData.amount = finalAmount.toFixed(2);

    //             // Always sync converted/base amounts in base currency
    //             newFormData.converted_amount = amountInBase.toFixed(2);
    //             newFormData.base_amount = amountInBase.toFixed(2);
    //             setConvertedAmount(amountInBase.toFixed(2));
    //             setBaseAmount(amountInBase.toFixed(2));
    //         }

    //         return newFormData;
    //     });
    // };

    // const handleCurrencySelection = (targetCurrencyId) => {
    //     if (!targetCurrencyId || !selectedBank) return;

    //     setFormData(prev => {
    //         // 1. Resolve old and new currency IDs
    //         const oldCurrencyId = getEffectiveCurrencyId(prev, selectedBank);

    //         // If same currency, only update ID (no conversion)
    //         if (oldCurrencyId?.toString() === targetCurrencyId?.toString()) {
    //             return { ...prev, transaction_currency: targetCurrencyId };
    //         }

    //         const bankId = selectedBank.base_currency_id;
    //         const amount = parseFloat(prev.amount || 0);

    //         // Handle conversions targeted at the Bank Base (from user's "Source to AED" list)
    //         if (targetCurrencyId === bankId) {
    //             if (amount > 0 && oldCurrencyId !== bankId) {
    //                 const amountInBase = convertAmountToBase(amount, oldCurrencyId, selectedBank);
    //                 setConvertedAmount(amountInBase.toFixed(2));
    //                 setBaseAmount(amountInBase.toFixed(2));
    //                 return {
    //                     ...prev,
    //                     transaction_currency: bankId,
    //                     amount: amountInBase.toFixed(2),
    //                     converted_amount: amountInBase.toFixed(2),
    //                     base_amount: amountInBase.toFixed(2)
    //                 };
    //             }
    //         }

    //         // Standard conversion from current source to new target (Foreign to Foreign, etc.)
    //         if (amount > 0) {
    //             const amountInBase = convertAmountToBase(amount, oldCurrencyId, selectedBank);
    //             let newAmount = amountInBase;
    //             if (targetCurrencyId?.toString() !== bankId?.toString()) {
    //                 const rate = getExchangeRate(targetCurrencyId);
    //                 newAmount = amountInBase / (rate || 1);
    //             }

    //             setConvertedAmount(amountInBase.toFixed(2));
    //             setBaseAmount(amountInBase.toFixed(2));
    //             return {
    //                 ...prev,
    //                 transaction_currency: targetCurrencyId,
    //                 amount: newAmount.toFixed(2),
    //                 converted_amount: amountInBase.toFixed(2),
    //                 base_amount: amountInBase.toFixed(2)
    //             };
    // NOTE: handleCurrencySelection function is defined earlier in the file (around line 335)
    // with improved toggle/reset behavior as requested by user


    const showRemainingBalance = () => {
        if (formData.type !== 'income' || !formData.originalAmount) return null;

        const remainingBalance = formData.remainingBalance || formData.originalAmount;
        const percentage = ((remainingBalance / formData.originalAmount) * 100).toFixed(1);

        return (
            <Card className="mt-2 border-light">
                <Card.Body className="py-2 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div>
                            <small className="text-muted">Invoice Balance</small>
                            <div className="fw-semibold">{formatCurrency(remainingBalance)}</div>
                        </div>
                        <Badge bg={remainingBalance > 0 ? 'warning' : 'success'} className="px-3 py-1">
                            {percentage}%
                        </Badge>
                    </div>
                    <div className="progress" style={{ height: '6px' }}>
                        <div
                            className={`progress-bar ${remainingBalance > 0 ? 'bg-warning' : 'bg-success'}`}
                            style={{ width: `${percentage}%` }}
                        ></div>
                    </div>
                    <small className="text-muted d-block mt-1">
                        Original: {formatCurrency(formData.originalAmount)}
                    </small>
                </Card.Body>
            </Card>
        );
    };



    //  // Helper to auto-select currency based on current entity/type
    // const autoSelectCurrency = (newFormData) => {
    //     // 1. Petty Cash -> ALWAYS AED
    //     if (newFormData.payment_mode === 'petty_cash') {
    //         const aedId = getCurrencyIdFromCode("AED");
    //         if (aedId) return aedId;
    //     }

    //     // 2. For income transactions (invoices) -> Client Currency
    //     if (newFormData.type === 'income' || newFormData.type === 'bad_debt_written_off') {
    //         // Check selected invoices first
    //         if (newFormData.selected_invoices?.length > 0) {
    //             const firstInvoiceVal = newFormData.selected_invoices[0].value || newFormData.selected_invoices[0];
    //             const invoice = invoices?.find(inv => inv.id?.toString() === firstInvoiceVal?.toString());
    //             if (invoice?.currency_id) return invoice.currency_id;
    //         }

    //         // Client currency for income
    //         if (newFormData.client_id && newFormData.client_id.toString() !== "0") {
    //             const client = clients?.find(c => c.id?.toString() === newFormData.client_id.toString());
    //             if (client?.currency) {
    //                 const id = getCurrencyIdFromCode(client.currency);
    //                 if (id) return id;
    //             }
    //         }
    //     }

    //     // 3. For expense transactions (bills/expenses) -> Vendor Currency
    //     if (newFormData.type === 'expense') {
    //         // Check first selected bill if available
    //         if (newFormData.bills?.length > 0) {
    //             const firstBillVal = newFormData.bills[0].value || newFormData.bills[0];
    //             const expense = selectedVendorExpenses?.find(exp =>
    //                 exp.id?.toString() === firstBillVal?.toString()
    //             ) || selectedUserExpenses?.find(exp =>
    //                 exp.id?.toString() === firstBillVal?.toString()
    //             );

    //             if (expense?.vendor_currency) {
    //                 const id = getCurrencyIdFromCode(expense.vendor_currency);
    //                 if (id) return id;
    //             }
    //         }

    //         // Vendor currency for expense
    //         if (newFormData.vendor_id && newFormData.vendor_id.toString() !== "0") {
    //             const vendor = vendors?.find(v => v.id?.toString() === newFormData.vendor_id.toString());
    //             if (vendor?.currency) {
    //                 const id = getCurrencyIdFromCode(vendor.currency);
    //                 if (id) return id;
    //             }
    //         }
    //     }

    //    // In your autoSelectCurrency function, add this section after the expense section:

    // // For advance transactions - prioritize based on advance type
    // if (newFormData.type === 'advance') {
    //     const advType = newFormData.advance_type || 
    //                    (newFormData.client_id && newFormData.client_id.toString() !== "0" ? 'client' : 'vendor');

    //     if (advType === 'client' && newFormData.client_id && newFormData.client_id.toString() !== "0") {
    //         const client = clients?.find(c => c.id?.toString() === newFormData.client_id.toString());
    //         if (client?.currency) {
    //             const id = getCurrencyIdFromCode(client.currency);
    //             if (id) return id;
    //         }
    //     } else if (newFormData.vendor_id && newFormData.vendor_id.toString() !== "0") {
    //         // Check PO first if available
    //         if (newFormData.po_id && pos?.length > 0) {
    //             const selectedPO = pos.find(p => p.id?.toString() === newFormData.po_id.toString());
    //             if (selectedPO?.currency_code || selectedPO?.currency) {
    //                 const id = getCurrencyIdFromCode(selectedPO.currency_code || selectedPO.currency);
    //                 if (id) return id;
    //             }
    //         }

    //         const vendor = vendors?.find(v => v.id?.toString() === newFormData.vendor_id.toString());
    //         if (vendor?.currency) {
    //             const id = getCurrencyIdFromCode(vendor.currency);
    //             if (id) return id;
    //         }
    //     }
    // }

    //     // Default to bank's base currency if selectedBank available
    //     if (selectedBank) {
    //         return selectedBank.base_currency_id || selectedBank.currency_id;
    //     }

    //     return newFormData.transaction_currency;
    // };

    const autoSelectCurrency = (newFormData) => {
        // Find the current bank for context
        const currentBank = banks?.find(b => b.id?.toString() === newFormData.account_id?.toString()) || selectedBank;

        // 1. Petty Cash -> ALWAYS AED
        if (newFormData.payment_mode === 'petty_cash') {
            const aedId = getCurrencyIdFromCode("AED");
            if (aedId) return aedId;
        }

        // 2. Selection Priority: Specific Item Currency
        // For expense transactions (bills/expenses) -> Expense/Vendor Currency
        if (newFormData.type === 'expense' && newFormData.bills?.length > 0) {
            const firstBillVal = newFormData.bills[0].value || newFormData.bills[0];
            const expense = selectedVendorExpenses?.find(exp =>
                exp.id?.toString() === firstBillVal?.toString()
            ) || selectedUserExpenses?.find(exp =>
                exp.id?.toString() === firstBillVal?.toString()
            );

            if (expense?.vendor_currency) {
                const id = getCurrencyIdFromCode(expense.vendor_currency);
                if (id) return id;
            }
        }

        // For income transactions (invoices) -> Invoice Currency (Respecting is_import/import_currency)
        if ((newFormData.type === 'income' || newFormData.type === 'bad_debt_written_off') && newFormData.selected_invoices?.length > 0) {
            const firstInvoiceVal = newFormData.selected_invoices[0].value || newFormData.selected_invoices[0];
            const invoice = invoices?.find(inv => inv.id?.toString() === firstInvoiceVal?.toString());
            if (invoice) {
                if (invoice.is_import && (invoice.is_import === true || invoice.is_import == 1 || invoice.is_import === "1")) {
                    const client = clients?.find(c => c.id?.toString() === (newFormData.client_id || invoice.client_id)?.toString());
                    const clientCurrency = client?.currency || 'AED';
                    const importCurrencyCode = invoice.import_currency || invoice.currency;
                    
                    if (importCurrencyCode) {
                        const importCurrencyId = getCurrencyIdFromCode(importCurrencyCode);
                        if (importCurrencyId) return importCurrencyId;
                    }
                }
                if (invoice.currency_id) return invoice.currency_id;
            }
        }

        // 3. For advance transactions or direct selections - prioritize PO
        if (newFormData.type === 'advance' && newFormData.po_id && pos?.length > 0) {
            const selectedPO = pos.find(p => p.id?.toString() === newFormData.po_id.toString());
            if (selectedPO) {
                const poCurrencyCode = selectedPO?.vendor?.currency || selectedPO.currency;
                if (poCurrencyCode) {
                    const poCurrencyId = getCurrencyIdFromCode(poCurrencyCode);
                    if (poCurrencyId) return poCurrencyId;
                }
            }
        }

        // 4. Entity Default Fallback
        if (newFormData.type === 'income' || newFormData.type === 'bad_debt_written_off' || (newFormData.type === 'advance' && (newFormData.advance_type === 'client' || !newFormData.advance_type))) {
            if (newFormData.client_id && newFormData.client_id.toString() !== "0") {
                const client = clients?.find(c => c.id?.toString() === newFormData.client_id.toString());
                if (client?.currency) {
                    const id = getCurrencyIdFromCode(client.currency);
                    if (id) return id;
                }
            }
        }

        if (newFormData.type === 'expense' || (newFormData.type === 'advance' && newFormData.advance_type === 'vendor')) {
            if (newFormData.vendor_id && newFormData.vendor_id.toString() !== "0") {
                const vendor = vendors?.find(v => v.id?.toString() === newFormData.vendor_id.toString());
                if (vendor?.currency) {
                    const id = getCurrencyIdFromCode(vendor.currency);
                    if (id) return id;
                }
            }
        }

        if (newFormData.type === 'advance' && newFormData.advance_type === 'pettycash') {
            const aedId = getCurrencyIdFromCode("AED");
            if (aedId) return aedId;
        }

        // 5. Fallback to existing or bank base
        return newFormData.transaction_currency || (currentBank?.base_currency_id || currentBank?.currency_id);
    };

    const getCurrencyName = (currencyId) => {
        if (!currencyId || !countries || !Array.isArray(countries)) return '';
        const country = countries.find(c => c.id == currencyId);
        return country ? country.currency : '';
    };

    // Add this useEffect to debug currency issues
    useEffect(() => {
        if (formData.type === 'advance' && formData.po_id && formData.amount) {
            console.log("?? DEBUG Advance Currency:", {
                po_id: formData.po_id,
                amount: formData.amount,
                transaction_currency: formData.transaction_currency,
                selectedPO: pos.find(p => p.id?.toString() === formData.po_id.toString()),
                selectedBank: selectedBank,
                exchangeRates: selectedBank?.exchange_rates,
                currentCurrencySymbol: getCurrencySymbol(formData.transaction_currency)
            });
        }
    }, [formData.po_id, formData.amount, formData.transaction_currency, pos, selectedBank]);

    const fetchInvoices = async (clientId, projectIds) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            if (!clientId) {
                setInvoices([]);
                return;
            }

            console.log("?? fetchInvoices called with:", { clientId, projectIds });

            // 1. Fetch invoices
            const invoicesResponse = await axios.get(`${backendUrl}/api/proformainvoice`, {
                params: { client_id: clientId },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            let allInvoices = invoicesResponse.data.proformainvoice;

            // 2. Fetch ALL income transactions for this client (Optimized)
            // If we don't have them in state, fetch them now
            let payments = clientIncomeTransactions;

            if (!payments || payments.length === 0 || lastFetchedClientId !== clientId) {
                console.log("?? Fetching ALL client transactions from API");
                const paymentsResponse = await axios.get(`${backendUrl}/api/transactions`, {
                    params: {
                        client_id: clientId,
                        type: 'income'
                        // No invoice_ids filter - fetch ALL to be efficient and reusable
                    },
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    skipLoader: true,
                });
                payments = paymentsResponse.data?.data || [];
                setClientIncomeTransactions(payments); // Cache them!
            } else {
                console.log("? Using cached client transactions for invoice calculations");
            }

            // 3. Calculate total paid for each invoice
            const invoiceTotalPayments = {};

            // Check all payments (including current one if editing)
            payments.forEach(payment => {
                // Check transaction_invoice_items
                if (payment.transaction_invoice_items && Array.isArray(payment.transaction_invoice_items)) {
                    payment.transaction_invoice_items.forEach(item => {
                        const invoiceId = item.invoice_id;
                        const paidAmount = parseFloat(item.paid_amount || 0);

                        if (!invoiceTotalPayments[invoiceId]) {
                            invoiceTotalPayments[invoiceId] = 0;
                        }
                        invoiceTotalPayments[invoiceId] += paidAmount;
                    });
                }

                // Also check selected_invoices for backward compatibility
                if (payment.selected_invoices && Array.isArray(payment.selected_invoices)) {
                    payment.selected_invoices.forEach(inv => {
                        const invoiceId = inv.value || inv.id;
                        const amount = parseFloat(inv.amount || payment.amount || 0);

                        if (!invoiceTotalPayments[invoiceId]) {
                            invoiceTotalPayments[invoiceId] = 0;
                        }
                        invoiceTotalPayments[invoiceId] += amount;
                    });
                }
            });

            console.log("?? Invoice Payment Totals:", invoiceTotalPayments);

            // 4. Transform invoices with remaining balance
            const transformedInvoices = allInvoices.map(inv => {
                // Calculate invoice amount
                const invoiceAmount = parseFloat(
                    (inv.tax_invoice_generated === "1" && inv.tax_invoice)
                        ? (inv.tax_invoice.total_with_vat || inv.tax_invoice.total_amount || inv.total_with_vat)
                        : (inv.total_with_vat || inv.amount)
                );

                // Get total paid from all transactions
                const totalPaid = invoiceTotalPayments[inv.id] || 0;

                // Calculate remaining balance
                const remainingBalance = Math.max(0, invoiceAmount - totalPaid);
                const isFullyPaid = remainingBalance <= 0.01;

                // Create display label
                const displayRefNo = (inv.tax_invoice_generated === "1" && inv.tax_invoice)
                    ? (inv.tax_invoice.serial_no || `Tax: ${inv.ref_no}`)
                    : (inv.ref_no || inv.serial_no);

                // Format the label with payment details
                let label = `${displayRefNo} - ${formatCurrency(invoiceAmount)}`;

                if (totalPaid > 0) {
                    label = `${label} (Paid: ${formatCurrency(totalPaid)}, Remaining: ${formatCurrency(remainingBalance)})`;
                } else {
                    label = `${label} (Remaining: ${formatCurrency(remainingBalance)})`;
                }

                const transformed = {
                    ...inv,
                    display_ref_no: displayRefNo,
                    display_value: inv.id,
                    display_amount: invoiceAmount,
                    remaining_balance: remainingBalance,
                    total_paid: totalPaid,
                    original_amount: invoiceAmount,
                    label: label,
                    invoice_type: (inv.tax_invoice_generated === "1" && inv.tax_invoice) ? 'tax' : 'proforma',
                    has_tax_invoice: (inv.tax_invoice_generated === "1" && inv.tax_invoice) ? true : false,
                    is_paid: isFullyPaid,
                    calculated_remaining: remainingBalance
                };

                return transformed;
            });

            // 5. Filter logic
            let filteredInvoices = [];

            if (!transactionData) {
                // NEW TRANSACTION: Show invoices with remaining balance > 0 and NO credit notes
                filteredInvoices = transformedInvoices.filter(inv => {
                    const hasCreditNotes = (inv.credit_notes && inv.credit_notes.length > 0) ||
                        (inv.tax_invoice?.credit_notes && inv.tax_invoice.credit_notes.length > 0);

                    return inv.remaining_balance > 0.01 &&
                        inv.is_written_off != 1 &&
                        !hasCreditNotes;
                });
            } else {
                // EDIT MODE OR VIEW MODE: Show all invoices (so we can display them correctly even if paid)
                filteredInvoices = transformedInvoices;
            }

            // 6. If editing, mark which invoices are selected
            if (isEditMode && transactionData) {
                // Get selected invoice IDs
                const selectedInvoiceIds = new Set();

                // From transaction_invoice_items
                if (transactionData.transaction_invoice_items && Array.isArray(transactionData.transaction_invoice_items)) {
                    transactionData.transaction_invoice_items.forEach(item => {
                        selectedInvoiceIds.add(item.invoice_id.toString());
                    });
                }

                // From selected_invoices (backward compatibility)
                if (formData.selected_invoices && formData.selected_invoices.length > 0) {
                    formData.selected_invoices.forEach(inv => {
                        selectedInvoiceIds.add((inv.value || inv).toString());
                    });
                }

                // Mark selected invoices
                filteredInvoices = filteredInvoices.map(inv => ({
                    ...inv,
                    is_selected: selectedInvoiceIds.has(inv.id.toString())
                }));
            }

            setInvoices(filteredInvoices);

            // 7. Update formData for edit mode
            if (isEditMode && transactionData && transactionData.transaction_invoice_items) {
                const updatedSelectedInvoices = transactionData.transaction_invoice_items.map(item => {
                    const invoice = filteredInvoices.find(inv =>
                        inv.id.toString() === item.invoice_id?.toString()
                    );

                    if (invoice) {
                        return {
                            label: invoice.label,
                            value: invoice.id,
                            amount: item.paid_amount || invoice.remaining_balance,
                            remaining_balance: item.balance_amount || invoice.remaining_balance,
                            original_amount: invoice.original_amount,
                            paid_amount: item.paid_amount
                        };
                    }
                    return null;
                }).filter(Boolean);

                if (updatedSelectedInvoices.length > 0) {
                    const totalPaid = updatedSelectedInvoices.reduce((sum, inv) =>
                        sum + (parseFloat(inv.amount) || 0), 0);

                    setFormData(prev => ({
                        ...prev,
                        selected_invoices: updatedSelectedInvoices,
                        amount: totalPaid.toFixed(2)
                    }));
                }
            }

        } catch (error) {
            console.error("? Error fetching invoices:", error);
            setInvoices([]);
        }
    };
    const handleProjectSelect = (selectedOptions) => {
        const projectIds = selectedOptions.map(option => option.value);
        setSelectedProjects(selectedOptions);

        setFormData(prev => {
            // Filter currently selected invoices
            let updatedSelectedInvoices = prev.selected_invoices || [];

            // Only keep invoices that match the new selected projects
            if (updatedSelectedInvoices.length > 0 && invoices) {
                updatedSelectedInvoices = updatedSelectedInvoices.filter(selectedInv => {
                    const fullInvoice = invoices.find(inv => inv.id === selectedInv.value);
                    return fullInvoice && projectIds.includes(fullInvoice.project_id);
                });
            }

            // Recalculate amount based on remaining invoices
            const totalAmount = updatedSelectedInvoices.reduce(
                (sum, inv) => sum + (parseFloat(inv.amount) || 0),
                0
            );

            return {
                ...prev,
                project_ids: projectIds, // Store as array
                project_id: projectIds.length === 1 ? projectIds[0] : '', // Keep single for backward compatibility
                selected_invoices: updatedSelectedInvoices,
                amount: totalAmount > 0 ? totalAmount.toFixed(2) : "",
                invoice_id: updatedSelectedInvoices.length === 1 ? updatedSelectedInvoices[0].value.toString() : ''
            };
        });
    };

    useEffect(() => {
        if (formData.type === 'expense' && formData.vendor_id) {
            fetchVendorExpenses(formData.vendor_id);
        }

    }, [formData.vendor_id]);
    useEffect(() => {
        if (formData.payment_mode === 'petty_cash' && formData.user_id) {
            fetchUserExpenses(formData.user_id);
        }
    }, [formData.user_id, formData.payment_mode]);

    const fetchVendorExpenses = async (vendorId, taxType) => {

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Fetch ALL expenses for this vendor
            const allExpenseResponse = await axios.get(`${backendUrl}/api/expense`, {
                params: { vendor_id: vendorId, is_paid: false, },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            console.log("?? All expenses from API:", allExpenseResponse.data.data.map(e => ({
                id: e.id,
                is_paid: e.is_paid,
                amount: e.amount,
                total_amount: e.total_amount,
                narration: e.narration
            })));

            // CRITICAL FIX: Instead of filtering by is_paid, fetch transaction data to get ACTUAL remaining balances
            // Fetch transaction expenses to get actual paid amounts
            // const transactionExpensesResponse = await axios.get(`${backendUrl}/api/transaction-expenses`, {
            //     params: { vendor_id: vendorId },
            //     headers: {
            //         Authorization: `Bearer ${token}`,
            //         'Tenant-Origin': origin
            //     },
            //     skipLoader: true,
            // });

            // OR fetch all transactions and calculate
            const transactionResponse = await axios.get(`${backendUrl}/api/transactions`, {
                params: {
                    vendor_id: vendorId,
                    type: 'expense'
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            const vendorTransactions = transactionResponse.data?.data || [];

            // Calculate TOTAL paid amount for each expense from ALL transactions
            const expenseTotalPayments = {};

            vendorTransactions.forEach(transaction => {
                if (transaction.transaction_expense_items && Array.isArray(transaction.transaction_expense_items)) {
                    transaction.transaction_expense_items.forEach(item => {
                        const expenseId = item.expense_id;
                        const paidAmount = parseFloat(item.paid_amount || item.amount_paid || 0);

                        if (!expenseTotalPayments[expenseId]) {
                            expenseTotalPayments[expenseId] = 0;
                        }
                        expenseTotalPayments[expenseId] += paidAmount;
                    });
                }

                // Also check bill_allocations as fallback
                if (transaction.bill_allocations && Array.isArray(transaction.bill_allocations)) {
                    transaction.bill_allocations.forEach(allocation => {
                        const expenseId = allocation.expense_id;
                        const amountPaid = parseFloat(allocation.amount_paid || 0);

                        if (!expenseTotalPayments[expenseId]) {
                            expenseTotalPayments[expenseId] = 0;
                        }
                        expenseTotalPayments[expenseId] += amountPaid;
                    });
                }
            });

            console.log("?? Expense total payments calculated:", expenseTotalPayments);

            // Filter and calculate remaining balances
            const unpaidExpenses = [];
            const initialBalances = {};

            allExpenseResponse.data.data.forEach(exp => {
                if (exp.user_id) return; // Skip user expenses

                const originalAmount = parseFloat(exp.total_amount || exp.amount || 0);
                const totalPaid = expenseTotalPayments[exp.id] || 0;
                const remainingBalance = Math.max(0, originalAmount - totalPaid);

                console.log(`Expense ${exp.id}: Original=${originalAmount}, Paid=${totalPaid}, Remaining=${remainingBalance}`);

                initialBalances[exp.id] = {
                    original_amount: originalAmount,
                    remaining: remainingBalance,
                    paid: totalPaid,
                    is_fully_paid: remainingBalance <= 0.01
                };

                // Only include expenses with remaining balance > 0
                if (remainingBalance > 0) {
                    // Update expense object with correct values
                    const unpaidExpense = { ...exp };
                    unpaidExpense.remaining_balance = remainingBalance;
                    unpaidExpense.amount_paid = totalPaid;
                    unpaidExpense.is_fully_paid = false;

                    unpaidExpenses.push(unpaidExpense);

                    console.log(`? Adding expense ${exp.id} with remaining: ${remainingBalance}`);
                } else {
                    console.log(`? Skipping expense ${exp.id} - fully paid (remaining: ${remainingBalance})`);
                }
            });

            setExpenseBalances(initialBalances);
            setSelectedVendorExpenses(unpaidExpenses);

            console.log("? Final unpaid expenses to show:", {
                count: unpaidExpenses.length,
                expenses: unpaidExpenses.map(e => ({
                    id: e.id,
                    narration: e.narration,
                    original: e.total_amount,
                    paid: e.amount_paid,
                    remaining: e.remaining_balance
                }))
            });

        } catch (error) {
            console.error("Error fetching vendor expenses:", error);
            setSelectedVendorExpenses([]);
            setExpenseBalances({});
        }
    };



    const fetchUserExpenses = async (userId) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            // Fetch user expenses
            const userExpenseResponse = await axios.get(`${backendUrl}/api/expense`, {
                params: { user_id: userId, is_paid: false, },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            console.log("?? User expenses raw:", userExpenseResponse.data.data);

            // Fetch transactions for this user
            const transactionResponse = await axios.get(`${backendUrl}/api/transactions`, {
                params: {
                    user_id: userId,
                    type: 'expense',
                    payment_mode: 'petty_cash'
                },
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            const userTransactions = transactionResponse.data?.data || [];

            // Calculate total payments for each user expense
            const userExpensePayments = {};

            userTransactions.forEach(transaction => {
                if (transaction.transaction_expense_items && Array.isArray(transaction.transaction_expense_items)) {
                    transaction.transaction_expense_items.forEach(item => {
                        const expenseId = item.expense_id;
                        const paidAmount = parseFloat(item.paid_amount || item.amount_paid || 0);

                        if (!userExpensePayments[expenseId]) {
                            userExpensePayments[expenseId] = 0;
                        }
                        userExpensePayments[expenseId] += paidAmount;
                    });
                }

                if (transaction.bill_allocations && Array.isArray(transaction.bill_allocations)) {
                    transaction.bill_allocations.forEach(allocation => {
                        const expenseId = allocation.expense_id;
                        const amountPaid = parseFloat(allocation.amount_paid || 0);

                        if (!userExpensePayments[expenseId]) {
                            userExpensePayments[expenseId] = 0;
                        }
                        userExpensePayments[expenseId] += amountPaid;
                    });
                }
            });

            console.log("?? User expense payments:", userExpensePayments);

            // Calculate remaining balances for user expenses
            const unpaidUserExpenses = [];
            const userExpenseBalances = {};

            userExpenseResponse.data.data.forEach(exp => {
                // Only include user expenses (where user_id matches)
                if (exp.user_id && exp.user_id.toString() === userId.toString()) {
                    const originalAmount = parseFloat(exp.total_amount || exp.amount || 0);
                    const totalPaid = userExpensePayments[exp.id] || 0;
                    const remainingBalance = Math.max(0, originalAmount - totalPaid);

                    userExpenseBalances[exp.id] = {
                        original_amount: originalAmount,
                        remaining: remainingBalance,
                        paid: totalPaid,
                        is_fully_paid: remainingBalance <= 0.01
                    };

                    if (remainingBalance > 0) {
                        const unpaidExpense = { ...exp };
                        unpaidExpense.remaining_balance = remainingBalance;
                        unpaidExpense.amount_paid = totalPaid;
                        unpaidExpense.is_fully_paid = false;

                        unpaidUserExpenses.push(unpaidExpense);

                        console.log(`? Adding user expense ${exp.id}: Original=${originalAmount}, Paid=${totalPaid}, Remaining=${remainingBalance}`);
                    }
                }
            });

            // Set user expenses state
            setSelectedUserExpenses(unpaidUserExpenses);

            console.log("? Final unpaid user expenses:", {
                count: unpaidUserExpenses.length,
                expenses: unpaidUserExpenses.map(e => ({
                    id: e.id,
                    narration: e.narration,
                    original: e.total_amount,
                    paid: e.amount_paid,
                    remaining: e.remaining_balance
                }))
            });

        } catch (error) {
            console.error("Error fetching user expenses:", error);
            setSelectedUserExpenses([]);
        }
    };
    const fetchClientCredit = async (clientId) => {
        if (!clientId || clientId === "0" || clientId === 0 || formData.type !== 'income') {
            return 0;
        }

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const res = await axios.get(`${backendUrl}/api/credit-notes/client/${clientId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            const balances = res.data?.available_balance || 0;
            setClientCreditNotes(res.data?.data || []);
            return parseFloat(balances);

        } catch (err) {
            console.error("Failed to fetch client credit balance", err);
            return 0;
        }
    };
    const fetchAvailableAdvance = async ({ clientId = null, vendorId = null, userId = null, currentInvoiceId = null, excludedTransactionId = null }) => {
        const targetId = clientId || vendorId || userId;
        const idKey = clientId ? 'client_id' : (vendorId ? 'vendor_id' : 'user_id');

        if (!targetId || targetId === "0" || targetId === 0) return 0;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const params = {
                type: (clientId) ? 'income,advance' : 'expense,advance',
                _t: new Date().getTime()
            };

            if (clientId) params.client_id = clientId;
            if (vendorId) params.vendor_id = vendorId;
            if (userId) params.user_id = userId;

            console.log('🔍 Fetching advances with params:', params);

            const res = await axios.get(`${backendUrl}/api/transactions`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,
            });

            const transactions = res.data?.data || [];
            console.log('📦 API returned transactions:', transactions.length);

            if (clientId) setClientIncomeTransactions(transactions);

            let totalRemainingAdvance = 0;
            let totalAdvanceUsedInExpenses = 0;

            // IMPORTANT: Filter transactions to ensure they belong to the specific entity
            transactions.forEach(t => {
                // Double-check that this transaction belongs to the selected entity
                let belongsToEntity = false;

                if (clientId && t.client_id?.toString() === clientId.toString()) {
                    // Stricter check: If it's an advance, only count it if its type is 'client'
                    // or it doesn't have an explicit advance_type (backward compatibility)
                    if (t.type === 'advance' && t.advance_type && t.advance_type !== 'client') {
                        console.log('🚫 Skipping vendor/user advance for client balance:', t.id);
                        belongsToEntity = false;
                    } else {
                        belongsToEntity = true;
                    }
                } else if (vendorId && t.vendor_id?.toString() === vendorId.toString()) {
                    // Stricter check: If it's an advance, only count it if its type is 'vendor'
                    if (t.type === 'advance' && t.advance_type && t.advance_type !== 'vendor') {
                        console.log('🚫 Skipping client/user advance for vendor balance:', t.id);
                        belongsToEntity = false;
                    } else {
                        belongsToEntity = true;
                    }
                } else if (userId && t.user_id?.toString() === userId.toString()) {
                    // Stricter check: User advances (petty cash)
                    if (t.type === 'advance' && t.advance_type && !['pettycash', 'user', 'petty_cash'].includes(t.advance_type)) {
                        console.log('🚫 Skipping client/vendor advance for user balance:', t.id);
                        belongsToEntity = false;
                    } else {
                        belongsToEntity = true;
                    }
                }

                if (!belongsToEntity) {
                    return; // Skip this transaction
                }

                // Calculate advance created
                const advanceCreated = parseFloat(t.advance_amount || 0);
                const advanceUsedOnSource = parseFloat(t.applied_amount || 0);

                if (t.type === 'advance' && advanceCreated > 0) {
                    const remaining = Math.max(0, advanceCreated - advanceUsedOnSource);
                    console.log('✅ Found advance for entity:', {
                        transaction_id: t.id,
                        user_id: t.user_id,
                        advance_created: advanceCreated,
                        advance_used: advanceUsedOnSource,
                        remaining: remaining
                    });
                    totalRemainingAdvance += remaining;
                }

                // CRITICAL: Also check if this expense transaction used any advance
                if (t.type === 'expense' && t.payment_mode === 'petty_cash') {
                    const advanceUsedInThisExpense = parseFloat(t.applied_advance || t.applied_amount || 0);
                    if (advanceUsedInThisExpense > 0) {
                        console.log('📉 Found advance used in expense:', {
                            transaction_id: t.id,
                            user_id: t.user_id,
                            advance_used: advanceUsedInThisExpense,
                            description: t.description
                        });
                        totalAdvanceUsedInExpenses += advanceUsedInThisExpense;
                    }
                }
            });

            // Calculate net available advance
            let netAvailableAdvance = totalRemainingAdvance - totalAdvanceUsedInExpenses;

            console.log('💰 Advance Calculation Summary:', {
                totalAdvanceCreated: totalRemainingAdvance,
                totalAdvanceUsedInExpenses,
                netAvailableAdvance
            });

            if (transactionId) {
                const currentlyApplied = parseFloat(transactionData?.applied_advance || transactionData?.applied_amount || 0);
                const currentAdvanceAmount = parseFloat(transactionData?.advance_amount || 0);

                let entityMatches = false;
                if (clientId && transactionData?.client_id?.toString() === clientId.toString()) entityMatches = true;
                if (vendorId && transactionData?.vendor_id?.toString() === vendorId.toString()) entityMatches = true;
                if (userId && transactionData?.user_id?.toString() === userId.toString()) entityMatches = true;

                if (entityMatches) {
                    if (currentlyApplied > 0) {
                        netAvailableAdvance += currentlyApplied;
                        console.log('🔄 Added back currently applied advance for summary:', currentlyApplied);
                    }
                    if (currentAdvanceAmount > 0) {
                        // For income, if this transaction CREATED an advance, the "Available" for this transaction's context
                        // should technically NOT include that surplus as "available to use" but we want to show it in breakdown.
                    }
                }
            }

            console.log('💰 Final available advance for entity:', netAvailableAdvance);
            return Math.max(0, netAvailableAdvance); // Ensure never negative
        } catch (error) {
            console.error("❌ Error fetching advances:", error);
            return 0;
        }
    };
    useEffect(() => {
        const calculateAdvance = async () => {
            console.log('🔍 DEBUG - Advance calculation started:', {
                client_id: formData.client_id,
                vendor_id: formData.vendor_id,
                user_id: formData.user_id,
                type: formData.type,
                payment_mode: formData.payment_mode
            });

            try {
                let availableAdvance = 0;
                let availableCredit = 0;

                if (formData.type === 'income' || formData.type === 'bad_debt_written_off') {
                    // Client Advance - only fetch if client is selected
                    if (formData.client_id && formData.client_id !== '0') {
                        console.log('📊 Fetching advance for CLIENT ID:', formData.client_id);
                        availableAdvance = await fetchAvailableAdvance({
                            clientId: formData.client_id.toString(),
                            currentInvoiceId: formData.invoice_id,
                            excludedTransactionId: transactionId || null
                        });
                    } else {
                        console.log('⚠️ No client selected, advance = 0');
                    }
                } else if (formData.type === 'expense') {
                    // User Advance (Petty Cash) - only fetch if user is selected
                    if (formData.payment_mode === 'petty_cash' && formData.user_id) {
                        console.log('📊 Fetching advance for USER ID:', formData.user_id);
                        availableAdvance = await fetchAvailableAdvance({
                            userId: formData.user_id.toString(),
                            excludedTransactionId: transactionId || null
                        });
                        console.log('✅ User advance fetched:', availableAdvance);
                    } else if (formData.payment_mode === 'petty_cash' && !formData.user_id) {
                        console.log('⚠️ Petty cash mode but no user selected, advance = 0');
                    }
                    // Note: Vendor advances are excluded as per user request
                } else {
                    console.log('ℹ️ Advance logic skipped for type:', formData.type);
                    availableAdvance = 0;
                }

                console.log('💰 Final calculated advance:', availableAdvance);
                setTotalAdvance(availableAdvance);
                setTotalCredit(availableCredit);

                // If available advance is 0, reset apply fields (ONLY for new transactions)
                if (availableAdvance === 0 && !transactionId) {
                    console.log('🔄 Resetting advance fields to 0');
                    setFormData(prev => ({
                        ...prev,
                        use_advance: false,
                        applied_advance: "0.00",
                        applied_amount: "0.00"
                    }));
                }
            } catch (error) {
                console.error('❌ Error calculating balances:', error);
                setTotalAdvance(0);
                setTotalCredit(0);
            }
        };

        if (showModal) {
            calculateAdvance();
        }
    }, [formData.client_id, formData.vendor_id, formData.user_id, formData.type, formData.payment_mode, formData.invoice_id, invoices, showModal]);

    useEffect(() => {
        if (showModal) {
            // Reset advance to 0 when modal opens
            console.log('?? Modal opened - resetting advance fields');
            setFormData(prev => ({
                ...prev,
                advance_amount: "0.00",
                applied_amount: "0.00"
            }));
            setTotalAdvance(0);

            // Also clear any localStorage payments if needed
            const savedPayments = JSON.parse(localStorage.getItem("invoicePayments")) || {};
            setInvoicePayments(savedPayments);
        }
    }, [showModal]);

    const validateForm = () => {
        const newErrors = {};
        if (formData.type !== 'contra' && formData.type !== 'bad_debt_written_off') {
            if (!formData.account_id) newErrors.account_id = '*Please select a bank account';
            if (!formData.account_type) newErrors.account_type = '*Please select a account type';
        }
        if (!formData.type) newErrors.type = '*Please select a transaction type';


        if (formData.type === 'income' || formData.type === 'bad_debt_written_off') {
            if (!formData.client_id) newErrors.client_id = '*Please select a client';

        }

        if (formData.type === 'vat_payable') {
            if (!formData.vat_return_id) newErrors.vat_return_id = '*Please select a VAT return';
        }

        if (formData.type === 'contra') {
            if (!formData.from_bank_id) newErrors.from_bank_id = '*Please select a from bank';
            if (!formData.to_bank_id) newErrors.to_bank_id = '*Please select a to bank';
            if (formData.from_bank_id === formData.to_bank_id) {
                newErrors.to_bank_id = '*From bank and To bank cannot be the same';
            }

        }

        return newErrors;
    };
    const resetForm = () => {
        let selectedBank = banks.find(bank => bank.id.toString() === bankIdFromUrl) || null;
        setSelectedSalaries([]);
        setTotalSalaryAmount(0);
        setFormData({
            date: new Date().toISOString().split("T")[0],
            type: '',
            transaction: '',
            account_id: selectedBank ? selectedBank.id.toString() : '',  // Preserve the selected bank
            account_type: selectedBank ? selectedBank.type : '',  // Preserve the account type
            project_id: '',
            project_id: '',
            project_ids: [],
            client_id: '',
            vendor_id: '',
            amount: '',
            category_id: '',
            description: '',
            invoice_id: '',
            deduction_amount: '',
            bill_no: '',
            tax_type: '', // Reset tax type
            expense_type_id: '',
            user_id: '',
            payment_mode: '',
            expense_id: null,
            reference_no: '',
            wps_charge: '',
            wps_vat: '',
            from_bank_id: '',
            to_bank_id: '',
            statement_file: null,
            salary_ids: [],
            vat_return_id: '',
            payroll_provider_id: '',
            selected_invoices: [],

        });
        setSelectedBank(null);
        setSelectedProjects([]);
        setProviderBanks(null);

    };
    const [payrollProviderOptions, setPayrollProviderOptions] = useState([]);

    // Add these functions
    const fetchPayrollProviders = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/payroll-providers`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            setPayrollProviders(response.data?.data || []);
        } catch (error) {
            console.error("Error fetching payroll providers:", error);
        }
    };

    const fetchPendingSalaries = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/expense`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    is_paid: false,
                    type: 'salary',
                },
                skipLoader: true,
            });

            setPendingSalaries(response.data?.data || []);
        } catch (error) {
            console.error("Error fetching pending salaries:", error);
        }
    };

    const fetchPendingVatReturns = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/vat-returns/list`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                params: {
                    is_paid: false,
                },
                skipLoader: true,
            });

            // Filter for returns that are not yet 'paid'
            const pendingReturns = (response.data?.data || []).filter(item => item.status !== 'paid');
            setVatReturns(pendingReturns);
        } catch (error) {
            console.error("Error fetching pending VAT returns:", error);
            setVatReturns([]);
        }
    };

    // In your useEffect for fetching all banks, add a console.log to debug
    const fetchAllBanks = async () => {
        if (hasFetchedAllBanksRef.current) return;

        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,
                },
                skipLoader: true,
            });

            console.log('?? All accounts fetched for contra:', {
                count: response.data.account?.length || 0,
                accounts: response.data.account?.map(acc => ({
                    id: acc.id,
                    name: acc.name,
                    type: acc.type
                }))
            });

            setAllBanks(response.data.account || []);
            hasFetchedAllBanksRef.current = true;
        } catch (error) {
            console.error('Error fetching all banks:', error);
        }
    };

    const fetchBankProviders = async (accountType = '') => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            let url = `${backendUrl}/api/bank-accounts`;
            if (accountType) {
                url += `?type=${encodeURIComponent(accountType)}`; // Fetch specific type if provided
            }

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Tenant-Origin': origin,

                },
                params: {
                    is_payllod_provider: 'true', // Fetch payroll providers only
                },
                skipLoader: true,
            });

            setProviderBanks(response.data.account); // ? Update state with all banks

        } catch (error) {
            console.error('Error fetching banks:', error);
        }
    };
    const fetchPayrollProviderDropdown = async () => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const headers = {
                Authorization: `Bearer ${token}`,
                'Tenant-Origin': origin,
            };

            const [payrollRes, bankRes] = await Promise.all([
                axios.get(`${backendUrl}/api/payroll-providers`, {
                    headers,
                    skipLoader: true,
                }),
                axios.get(`${backendUrl}/api/bank-accounts`, {
                    headers,
                    params: { is_payroll_provider: true, type: 'bank account' },
                    skipLoader: true,
                }),
            ]);


            const payrollProviders = (payrollRes.data?.data || []).map(p => ({
                id: p.id,
                name: p.name,
                provider_type: 'payroll',
            }));

            const bankProviders = (bankRes.data?.account || []).map(b => ({
                id: b.id,
                name: b.name,
                provider_type: 'bank',
            }));

            setPayrollProviderOptions([
                ...payrollProviders,
                ...bankProviders,
            ]);

        } catch (err) {
            console.error(err);
        }
    };



    const handleVatReturnSelect = (selectedOption) => {
        if (!selectedOption) {
            setFormData(prev => ({
                ...prev,
                vat_return_id: '',
                amount: '',
                description: '',
                transaction: ''
            }));
            return;
        }

        const vatReturn = selectedOption.vatReturn;
        const startDate = dayjs(vatReturn.period_start).format('DD MMM YYYY');
        const endDate = dayjs(vatReturn.period_end).format('DD MMM YYYY');
        const description = `VAT Payment for period ${startDate} to ${endDate}`;

        setFormData(prev => ({
            ...prev,
            vat_return_id: vatReturn.id,
            amount: vatReturn.net_vat_payable.toString(),
            description: description,
        }));
    };


    // Add to useEffect when type changes
    useEffect(() => {
        if (formData.type === 'payroll') {
            // fetchPayrollProviders();
            fetchPendingSalaries();
            // fetchBankProviders(); // Fetch payroll banks only
            fetchPayrollProviderDropdown();
        } else if (formData.type === 'vat_payable') {
            fetchPendingVatReturns();
        } else if (formData.type === 'contra') {
            fetchAllBanks();
        } else {
            hasFetchedAllBanksRef.current = false;
        }
    }, [formData.type]);

    useEffect(() => {
        if (!showModal) {
            setErrors({});
            resetForm();
            setSelectedProjects([]);
            // ?? RESET the fetch flags when modal closes
            setHasFetchedInvoices(false);
            setHasFetchedProjects(false);
            setHasFetchedProjects(false);
            setLastFetchedClientId(null);
            setClientIncomeTransactions([]); // Clear cache on close
        }
    }, [showModal]);


    const markBillAsPaid = async (vendorId, bills, Expense, paymentAmount) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            if (!Array.isArray(bills)) {
                bills = [bills];
            }
            await axios.post(`${backendUrl}/api/expense/mark-paid`, {
                vendor_id: vendorId,
                bills: bills,
                expense_type_id: Expense,
                amount: paymentAmount,

            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,

            });

            // Refresh the vendor expenses list
            if (formData.vendor_id) {
                fetchVendorExpenses(formData.vendor_id);
            }
        } catch (error) {
            console.error("Error marking bill as paid:", error);
        }
    };



    const markEmployeeBillAsPaid = async (userId, bills, pettyCash = false, Expense) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;
            if (!Array.isArray(bills)) {
                bills = [bills];
            }
            await axios.post(`${backendUrl}/api/expense/employee-paid`, {
                user_id: userId,
                bills: bills,
                is_petty_cash: pettyCash ? 'true' : 'false',
                expense_type_id: Expense,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin
                },
                skipLoader: true,

            });

            // Refresh the vendor expenses list
            // if (formData.vendor_id) {
            //     fetchVendorExpenses(formData.vendor_id);
            // }
            if (formData.user_id && formData.payment_mode === 'petty_cash') {
                fetchUserExpenses(formData.user_id);
            }
        } catch (error) {
            console.error("Error marking bill as paid:", error);
        }
    };
    const [selectedPOAmount, setSelectedPOAmount] = useState(0);
    const handleChange = (e) => {
        const { name, value } = e.target;

        console.log("?? handleChange triggered:");
        console.log("Field name:", name);
        console.log("Field value:", value);
        console.log("FormData type:", formData.type);
        setFormData((prev) => {
            let newFormData = { ...prev, [name]: value };

            // Auto-calculate VAT for Bank Charges and Commission Fees
            if (name === 'bank_service_charge') {
                const charge = parseFloat(value) || 0;
                newFormData.bank_vat_amount = (charge * 0.05).toFixed(2);
            }
            if (name === 'commission_fee') {
                const fee = parseFloat(value) || 0;
                newFormData.commission_vat = (fee * 0.05).toFixed(2);
            }

            // Auto-select currency ONLY if entity or mode changes
            if (['client_id', 'vendor_id', 'user_id', 'payment_mode', 'advance_type', 'po_id'].includes(name)) {
                const prioritizedCurrencyId = autoSelectCurrency(newFormData);
                if (prioritizedCurrencyId) {
                    // Trigger handleCurrencySelection for centralized conversion/state updates
                    setTimeout(() => handleCurrencySelection(prioritizedCurrencyId, { isAutoSelect: true }), 0);
                }
            }

            if (name === 'type') {
                // When transaction type changes, clear all type-specific and entity-specific fields
                newFormData.advance_type = value === 'advance' ? (newFormData.advance_type || '') : '';
                newFormData.client_id = '';
                newFormData.vendor_id = '';
                newFormData.user_id = '';
                newFormData.project_id = '';
                newFormData.project_ids = [];
                newFormData.invoice_id = '';
                newFormData.expense_id = null;
                newFormData.category_id = '';
                newFormData.po_id = '';
                newFormData.salary_id = null;
                newFormData.salary_ids = [];
                newFormData.guarantee_id = '';
                newFormData.vat_return_id = '';
                newFormData.from_bank_id = '';
                newFormData.to_bank_id = '';
                newFormData.statement_file = null;
                newFormData.selected_invoices = [];
                newFormData.bills = [];
                newFormData.bill_allocations = [];
                newFormData.use_advance = false;
                newFormData.use_credit = false;
                newFormData.credit_amount = '0.00';
                newFormData.deduction_amount = '';
                newFormData.bank_service_charge = '';
                newFormData.bank_vat_amount = '';
                newFormData.commission_fee = '';
                newFormData.commission_vat = '';
                newFormData.advance_amount = '';
                newFormData.applied_advance = '';
                newFormData.received_amount = '';
                newFormData.bill_no = '';
                newFormData.expense_type_id = '';
                newFormData.tax_type = '';

                // Also reset temporary state variables
                setSelectedProjects([]);
                setSelectedSalaries([]);
                setInvoicePayments({});
                setClientIncomeTransactions([]);
                setPos([]);
            }

            // For bank selection change: Only update the bank context, don't jump the amount or currency
            if (name === 'account_id' && newFormData.amount && parseFloat(newFormData.amount) > 0) {
                const newBank = banks?.find(b => b.id?.toString() === value?.toString());
                if (newBank) {
                    const effectiveCurrencyId = getEffectiveCurrencyId(newFormData, newBank);
                    // Update underlying base amounts correctly for the new bank
                    const amountInBase = convertAmountToBase(parseFloat(newFormData.amount), effectiveCurrencyId, newBank);
                    newFormData.converted_amount = amountInBase.toFixed(2);
                    newFormData.base_amount = amountInBase.toFixed(2);
                    setConvertedAmount(amountInBase.toFixed(2));
                    setBaseAmount(amountInBase.toFixed(2));
                }
            }
            if (name === "vendor_id" && newFormData.type === 'expense') {
                // Reset category and amount when vendor changes
                // newFormData.bill_no = '';
                newFormData.amount = '';
            }
            // if (isReconciled) {
            //     // Only block changes to invoice/expense related fields
            //     const readOnlyFields = ['selected_invoices', 'bills', 'invoice_id', 'expense_id'];
            //     if (readOnlyFields.includes(name)) {
            //         return;
            //     }
            // }
            // In handleChange function, add logic for advance transactions
            // In handleChange function, add case for payroll_provider_id:
            if (name === "payroll_provider_id") {
                setFormData(prev => ({ ...prev, [name]: value }));
            }
            if (name === "client_id") {
                if (value && value !== "0") {
                    // Only fetch if client changed to a valid one
                    if (value !== lastFetchedClientId) {
                        fetchProjects(value);
                        fetchInvoices(value); // This now caches transactions too!
                        setLastFetchedClientId(value);
                    }
                } else {
                    setInvoices([]);
                    setClientIncomeTransactions([]);
                }

                // Always reset dependent fields
                setFormData(prev => ({
                    ...prev,
                    project_id: "",
                    // vendor_id: "", // DONT clear vendor when client changes
                    po_id: "",
                    project_ids: [],
                    [name]: value === "0" ? "0" : value,
                    uncategorised: value === "0" ? "true" : "false"
                }));
                setSelectedProjects([]);
                setPos([]);
            }

            if (name === "advance_type") {
                // If switching between Client and Vendor advance, reset dependent fields
                newFormData.client_id = "";
                newFormData.vendor_id = "";
                newFormData.user_id = "";
                newFormData.project_id = "";
                newFormData.project_ids = [];
                newFormData.po_id = "";
                setPos([]);
                setSelectedProjects([]);
            }

            if (name === "project_id") {
                setFormData(prev => ({
                    ...prev,
                    // vendor_id: "", // DONT clear vendor when project changes
                    po_id: ""
                }));
                // setPos([]); // Don't clear POs immediately, let fetchPOs handle it

                if (value && formData.type === 'advance') {
                    // Only fetch vendors if we want to filter by project users
                    // fetchVendors(value); 
                }

                // ? FIX: Fetch POs if vendor is already selected when project changes
                if (value && formData.vendor_id) {
                    fetchPOs(value, formData.vendor_id);
                }
            }

            if (name === "vendor_id") {
                setFormData(prev => ({
                    ...prev,
                    po_id: ""
                }));

                // ? FIX: Fetch POs when vendor is selected AND project is already selected
                if (prev.project_id && value) {
                    fetchPOs(prev.project_id, value);
                }
            }

            // ? FIX: Also handle when project changes via multiple selection
            if (name === "project_ids") {
                // If vendor is already selected, fetch POs for the first project
                if (prev.vendor_id && value && value.length > 0) {
                    fetchPOs(value[0], prev.vendor_id);
                }
            }
            if (name === "bills" && newFormData.type === 'expense' && newFormData.vendor_id) {
                const selectedBills = Array.isArray(value) ? value : [value];

                newFormData.bills = selectedBills;

                const selectedExpenses = selectedVendorExpenses.filter(exp =>
                    selectedBills.includes(exp.id?.toString()) // ? Match by ID, not invoice_no
                );

                const totalAmount = selectedExpenses.reduce((sum, exp) => {
                    const amount = parseFloat(exp.total_amount) || 0;
                    return sum + amount;
                }, 0);

                newFormData.amount = totalAmount;
                newFormData.expense_type_id = selectedExpenses[0]?.expense_type_id || '';
                newFormData.bill_no = selectedExpenses.map(e => e.invoice_no).join(', ');
            }
            // if (name === "po_id") {
            //     // When PO is selected, auto-populate the amount
            //     if (value) {
            //         const selectedPO = pos.find(po => po.id.toString() === value.toString());
            //         if (selectedPO) {
            //             // Get the PO amount (check different possible field names)
            //             const poAmount = selectedPO.amount ||
            //                 selectedPO.total_amount ||
            //                 selectedPO.po_amount ||
            //                 selectedPO.value ||
            //                 0;

            //             setSelectedPOAmount(poAmount);

            //             // Auto-populate the amount field with PO amount
            //             newFormData.amount = parseFloat(poAmount).toFixed(2);
            //         }
            //     } else {
            //         // If PO is cleared, reset the amount
            //         setSelectedPOAmount(0);
            //         newFormData.amount = '';
            //     }
            // }

            if (name === "po_id") {
                if (value) {
                    const selectedPO = pos.find(po => po.id.toString() === value.toString());
                    if (selectedPO) {
                        // Get the PO amount
                        const poAmount = selectedPO.amount ||
                            selectedPO.total_amount ||
                            selectedPO.po_amount ||
                            selectedPO.value ||
                            0;

                        setSelectedPOAmount(poAmount);

                        // Get PO currency
                        const poCurrencyCode = selectedPO?.vendor?.currency || selectedPO.currency;
                        let poCurrencyId = null;
                        if (poCurrencyCode) {
                            poCurrencyId = getCurrencyIdFromCode(poCurrencyCode);
                        }

                        console.log("?? PO Selected - Setting amount:", {
                            po_id: value,
                            poAmount,
                            poCurrencyCode,
                            poCurrencyId,
                            currentTransactionCurrency: prev.transaction_currency
                        });

                        // Set the new form data
                        const newFormData = {
                            ...prev,
                            po_id: value,
                            amount: parseFloat(poAmount).toFixed(2)  // <-- CRITICAL: Set amount HERE
                        };

                        // If PO has a currency and it's different from current currency, set it
                        if (poCurrencyId && poCurrencyId.toString() !== prev.transaction_currency?.toString()) {
                            newFormData.transaction_currency = poCurrencyId;

                            // Trigger currency conversion after a short delay to ensure state is updated
                            setTimeout(() => {
                                handleCurrencySelection(poCurrencyId);
                            }, 50);
                        }

                        return newFormData;
                    }
                } else {
                    setSelectedPOAmount(0);
                    return {
                        ...prev,
                        amount: '',
                        po_id: ''
                    };
                }
            }
            if (name === "expense_type_id" && newFormData.type === 'expense') {
                const selectedExpense = selectedVendorExpenses.find(
                    exp => exp.expense_type_id.toString() === value.toString()
                );
                if (selectedExpense) {
                    newFormData.amount = selectedExpense.amount || '';
                    newFormData.bill_no = selectedExpense.invoice_no || '';
                    newFormData.expense_type_id = value;


                    // ?? Mark as paid immediately for single expense
                    // markBillAsPaid(formData.vendor_id, selectedExpense.invoice_no, selectedExpense.expense_type_id,formData.amount);
                } else {
                    newFormData.amount = '';
                    newFormData.bill_no = '';
                    newFormData.expense_type_id = value;


                }

            }

            // if (name === 'client_id') {
            //     const selectedClient = clients.find(c => c.id.toString() === value.toString());
            //     if (selectedClient) {
            //         setSelectedCurrency(selectedClient.currency || null);
            //     }

            // }

            // if (name === 'vendor_id') {
            //     const selectedVendor = vendors.find(v => v.id.toString() === value.toString());
            //     if (selectedVendor) {
            //         setSelectedCurrency(selectedVendor.currency || null);
            //     }
            // }
            if (name === 'client_id') {
                const selectedClient = clients.find(c => c.id.toString() === value.toString());
                if (selectedClient) {
                    setSelectedCurrency(selectedClient.currency || null);

                    // Auto-select client's currency
                    if (selectedClient.currency) {
                        const currencyId = getCurrencyIdFromCode(selectedClient.currency);
                        if (currencyId) {
                            // Use a small timeout to ensure form data is updated
                            setTimeout(() => {
                                handleCurrencySelection(currencyId);
                            }, 100);
                        }
                    }
                }
            }

            if (name === 'vendor_id') {
                const selectedVendor = vendors.find(v => v.id.toString() === value.toString());
                if (selectedVendor) {
                    setSelectedCurrency(selectedVendor.currency || null);

                    // Auto-select vendor's currency for advance transactions
                    if (selectedVendor.currency && formData.type === 'advance') {
                        const currencyId = getCurrencyIdFromCode(selectedVendor.currency);
                        if (currencyId) {
                            setTimeout(() => {
                                handleCurrencySelection(currencyId);
                            }, 100);
                        }
                    }
                }
            }


            // Removed redundant client_id check

            if (name === "invoice_id") {
                const selectedInvoice = invoices.find(inv => inv.id.toString() === value);
                console.log("selectedInvoice", selectedInvoice);
                if (selectedInvoice) {
                    const savedPayments = JSON.parse(localStorage.getItem("invoicePayments")) || {};
                    const originalInvoiceAmount = parseFloat(selectedInvoice.amount || 0);
                    const previouslyPaid = savedPayments[selectedInvoice.id] || 0;
                    const remainingBalance = originalInvoiceAmount - previouslyPaid;

                    console.log("?? DEBUG - Invoice Amount Calculation:");
                    console.log("Selected Invoice:", selectedInvoice);
                    console.log("Invoice ID:", selectedInvoice.id);
                    console.log("Original Amount from Invoice:", originalInvoiceAmount);
                    console.log("Previously Paid from localStorage:", previouslyPaid);
                    console.log("Saved Payments object:", savedPayments);
                    console.log("Remaining Balance Calculation:", originalInvoiceAmount, "-", previouslyPaid, "=", remainingBalance);

                    // Don't auto-apply advance - let user decide
                    newFormData.originalAmount = originalInvoiceAmount;
                    newFormData.amount = remainingBalance.toFixed(2); // Show full remaining balance
                    newFormData.remainingBalance = remainingBalance;

                    // Reset advance fields
                    newFormData.advance_amount = '0.00';
                    newFormData.use_advance = false;
                }
                setIsDeductionVisible(false);
            }

            // Add this new section for advance_amount handling:
            if (name === "use_advance") {
                const checked = e.target.checked;
                newFormData.use_advance = checked;

                // Derive Total Required from the selected bills/invoices
                let totalNeeded = 0;
                if (prev.type === 'income') {
                    if (prev.selected_invoices?.length > 0) {
                        totalNeeded = prev.selected_invoices.reduce((sum, inv) => sum + (parseFloat(inv.remaining_balance || inv.amount) || 0), 0);
                    } else if (prev.invoice_id) {
                        const invoice = invoices.find(inv => inv.id.toString() === prev.invoice_id);
                        totalNeeded = invoice ? parseFloat(invoice.remaining_balance || invoice.display_amount || 0) : 0;
                    }
                } else if (prev.type === 'expense' && prev.bills?.length > 0) {
                    totalNeeded = prev.bills.reduce((sum, b) => sum + (parseFloat(b.remaining_balance || b.original_amount || b.amount) || 0), 0);
                } else {
                    // Fallback to current transaction total (Cash + Applied)
                    totalNeeded = (parseFloat(prev.amount) || 0) + (prev.use_advance ? (parseFloat(prev.applied_advance) || 0) : 0);
                }

                if (checked) {
                    // Auto-calculate: Amount = Total - Advance
                    const applied = Math.min(totalAdvance, totalNeeded);
                    newFormData.applied_advance = applied.toFixed(2);
                    newFormData.amount = (totalNeeded - applied).toFixed(2);
                    newFormData.received_amount = (totalNeeded - applied).toFixed(2);
                } else {
                    newFormData.applied_advance = "0.00";
                    newFormData.amount = totalNeeded.toFixed(2);
                    newFormData.received_amount = totalNeeded.toFixed(2);
                }
            }

            if (name === "applied_advance") {
                let totalNeeded = 0;
                if (prev.type === 'income') {
                    if (prev.selected_invoices?.length > 0) {
                        totalNeeded = prev.selected_invoices.reduce((sum, inv) => sum + (parseFloat(inv.remaining_balance || inv.amount) || 0), 0);
                    } else if (prev.invoice_id) {
                        const invoice = invoices.find(inv => inv.id.toString() === prev.invoice_id);
                        totalNeeded = invoice ? parseFloat(invoice.remaining_balance || invoice.display_amount || 0) : 0;
                    }
                } else if (prev.type === 'expense' && prev.bills?.length > 0) {
                    totalNeeded = prev.bills.reduce((sum, b) => sum + (parseFloat(b.remaining_balance || b.original_amount || b.amount) || 0), 0);
                } else {
                    totalNeeded = (parseFloat(prev.amount) || 0) + (parseFloat(prev.applied_advance) || 0);
                }

                const applied = parseFloat(value) || 0;
                // Limit applied advance to totalAdvance and totalNeeded
                let finalApplied = Math.min(applied, totalAdvance, totalNeeded);

                newFormData.applied_advance = finalApplied.toFixed(2);

                // Recalculate amount: Amount = Total - Applied
                newFormData.amount = (totalNeeded - finalApplied).toFixed(2);
                newFormData.received_amount = (totalNeeded - finalApplied).toFixed(2);
            }

            if (name === "advance_amount" && formData.invoice_id) {
                const selectedInvoice = invoices.find(inv => inv.id.toString() === formData.invoice_id);
                if (selectedInvoice) {
                    const savedPayments = JSON.parse(localStorage.getItem("invoicePayments")) || {};
                    const originalInvoiceAmount = parseFloat(selectedInvoice.amount || 0);
                    const previouslyPaid = savedPayments[selectedInvoice.id] || 0;
                    const remainingBalance = originalInvoiceAmount - previouslyPaid;

                    const enteredAdvance = parseFloat(value) || 0;
                    const maxAdvance = Math.min(totalAdvance, remainingBalance);
                    const appliedAdvance = Math.min(enteredAdvance, maxAdvance);

                    const recalculatedAmount = Math.max(remainingBalance - appliedAdvance, 0);

                    newFormData.amount = recalculatedAmount;
                    newFormData.advance_amount = appliedAdvance.toFixed(2);

                    // Automatically check the "use advance" box if advance is entered
                    newFormData.use_advance = appliedAdvance > 0;
                }
            }
            if (name === "deduction_amount" && newFormData.type === 'income') {
                const deduction = parseFloat(value) || 0;
                
                // Get the base total from selected invoices or invoice_id
                let totalDue = 0;
                if (newFormData.selected_invoices?.length > 0) {
                    totalDue = newFormData.selected_invoices.reduce((sum, inv) => {
                        return sum + (parseFloat(inv.remaining_balance || inv.amount) || 0);
                    }, 0);
                } else if (newFormData.invoice_id) {
                    const fullInv = invoices?.find(i => i.id.toString() === newFormData.invoice_id.toString());
                    totalDue = fullInv ? parseFloat(fullInv.remaining_balance || fullInv.display_amount || 0) : 0;
                }

                if (totalDue > 0) {
                    const applied = parseFloat(newFormData.applied_advance) || 0;
                    const creditUsed = parseFloat(newFormData.credit_amount) || 0;
                    
                    // Automatically update amount: Amount = Total - Applied - Credit - Deduction
                    const finalAmount = Math.max(0, totalDue - applied - creditUsed - deduction);
                    newFormData.amount = finalAmount.toFixed(2);
                    newFormData.received_amount = finalAmount.toFixed(2);
                }
            }

            if ((name === "deduction_amount" || name === "amount") && newFormData.type !== 'income') {
                const deduction = parseFloat(newFormData.deduction_amount) || 0;
                const enteredAmount = parseFloat(newFormData.amount) || 0;
                const originalAmount = newFormData.originalAmount || 0;

                // Ensure the balance doesn't go negative
                const newBalance = Math.max(0, originalAmount - (enteredAmount + deduction));
                newFormData.remainingBalance = newBalance;
            }

            if (name === "amount") {
                setIsDeductionVisible(true);
            }

            // For contra transactions, sync account_id with from_bank_id for backward compatibility
            if (name === "from_bank_id" && newFormData.type === 'contra') {
                newFormData.account_id = value;
                newFormData.account_type = 'bank account';
            }

            return newFormData;
        });
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
        if (name === 'type') {
            // if (value === 'income' || value === 'advance') {
            //     fetchClients(); // Fetch clients for income
            //     if (value === 'advance') {
            //         fetchVendors(); // Fetch all vendors for advance
            //     }
            // } 
            if (value !== 'payroll') {
                setSelectedSalaries([]);
                setTotalSalaryAmount(0);
                setFormData(prev => ({
                    ...prev,
                    salary_ids: [],
                    wps_charge: '',
                    wps_vat: '',
                    bank_service_charge: '',
                    bank_vat_amount: ''
                }));
            }
            if (value === 'income' || value === 'advance' || value === 'bad_debt_written_off') {
                // Only fetch clients if not already fetched
                if (clients.length === 0) {
                    fetchClients();
                }
                if (value === 'advance') {
                    // Only fetch vendors if not already fetched
                    if (vendors.length === 0) {
                        fetchVendors();
                    }
                }
            }

            else if (value === 'expense') {
                fetchCategories(); // Fetch categories for expenses
                fetchVendors(); // Fetch vendors since payor ? payee
                // fetchUsers(); // Fetch users for employee expenses
            }
        }
        if (name === 'payment_mode') {
            if (value === 'petty_cash') {
                fetchUsers(); // Fetch users only when petty_cash is selected
            }
        }


        // if (name === "client_id") {
        //     fetchProjects(value);  // Fetch projects for the selected client
        //     setFormData((prev) => ({ ...prev, project_id: "" })); // Reset project selection
        // }
        // if (name === "client_id") {
        //     fetchProjects(value);  // Fetch projects for the selected client
        //     setFormData(prev => ({
        //         ...prev,
        //         project_id: "",
        //         project_ids: []
        //     }));
        //     setSelectedProjects([]); // Clear selected projects
        //     setInvoices([]); // Clear invoices
        // }

        // Removed redundant client_id handler

        // Fetch invoices **only when both client and project are selected**
        if (name === "project_id") {
            if (formData.client_id && value) {
                fetchInvoices(formData.client_id, value);
            }
        }

        // if (name === 'account_type') {
        //     fetchBanks(value); // Pass selected account type to the parent function
        // }
    };
    const allocateInvoicePayments = (paymentAmount, selectedInvoices) => {
        if (!paymentAmount || !selectedInvoices || selectedInvoices.length === 0) {
            return [];
        }

        // Sort invoices by due date or ID (oldest first)
        const sortedInvoices = [...selectedInvoices].sort((a, b) => {
            // Sort by remaining balance (smallest first) or by invoice ID
            return (a.remaining_balance || a.amount || 0) - (b.remaining_balance || b.amount || 0);
        });

        let remainingPayment = parseFloat(paymentAmount);
        const allocations = [];

        // Sequential allocation
        sortedInvoices.forEach(invoice => {
            if (remainingPayment <= 0) return;

            const invoiceRemaining = parseFloat(invoice.remaining_balance || invoice.amount || invoice.original_amount || 0);
            const amountToPay = Math.min(remainingPayment, invoiceRemaining);

            if (amountToPay > 0) {
                allocations.push({
                    invoice_id: invoice.value || invoice.id,
                    amount_paid: parseFloat(amountToPay.toFixed(2)),
                    is_fully_paid: amountToPay >= invoiceRemaining,
                    remaining_balance: Math.max(0, invoiceRemaining - amountToPay)
                });

                remainingPayment -= amountToPay;
            }
        });

        return allocations;
    };
    const [lockError, setLockError] = useState('');
    // Helper to check if date is locked using your backend API
    const checkIfDateLocked = async (date) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem('user-info'));
            const origin = localStorage.getItem('user-origin');
            const token = userInfo?.token;

            const response = await axios.get(
                `${backendUrl}/api/accounting/check-lock-status`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Tenant-Origin': origin,
                    },
                    params: { date },
                    skipLoader: true,
                }
            );

            return response.data.is_locked || false;
        } catch (error) {
            console.error('Error checking date lock:', error);
            return false; // Don't block on error, let backend handle it
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        // if (isEditMode && transactionData && formData.bills && formData.bills.length > 0) {
        //     const validationError = validateExpenseAmount(
        //         formData.bills,
        //         formData.amount,
        //         isEditMode
        //     );
        //     if (validationError) {
        //         showToast(validationError, "warning");
        //         setValidationMessages({ amount: validationError });
        //         return; // Prevent submission
        //     }
        // }

        setLoading(true);
        const validationErrors = validateForm();

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            setLoading(false);
            return;
        }
        setLockError('');


        try {
            const isDateLocked = await checkIfDateLocked(formData.date);
            if (isDateLocked) {
                setLockError('This date is in a locked financial period. Transaction cannot be created or modified.');
                setLoading(false);
                return; // Stop immediately
            }

            console.log("?? DEBUG - handleSubmit started");
            console.log("Form Data:", formData);
            console.log("Type:", formData.type);
            console.log("Payment Mode:", formData.payment_mode);
            console.log("Vendor ID:", formData.vendor_id);
            console.log("Bills:", formData.bills);

            const expenseIds = formData?.bills?.map(bill => {
                if (typeof bill === 'object' && bill.value) {
                    return bill.value;
                }
                return bill;
            }).filter(Boolean).join(',') || '';

            console.log("Expense IDs:", expenseIds);

            // Get bill identifiers (invoice_no)
            const billIdentifiers = formData?.bills?.map(bill => {
                if (typeof bill === 'object') {
                    const label = bill.label || '';
                    console.log("Processing bill label:", label);

                    // For "No Invoice" cases, use expense type name
                    if (label.includes("No Invoice")) {
                        const expenseTypeName = label.split('-')[0]?.trim();
                        console.log("No Invoice case - using expense type name:", expenseTypeName);
                        return expenseTypeName || bill.value;
                    }

                    // Try to extract invoice number from the label
                    const match = label.match(/-\s*([^-\(]+)\s*\(/);
                    if (match && match[1]) {
                        return match[1].trim();
                    }

                    if (bill.invoice_no) {
                        return bill.invoice_no;
                    }

                    return bill.value;
                }
                return bill;
            }).filter(Boolean);

            console.log("Bill Identifiers:", billIdentifiers);
            console.log("Bill Identifiers length:", billIdentifiers?.length || 0);

            const selectedInvoiceIds = formData?.selected_invoices?.map(inv => inv.value) || [];

            // Get available advance first
            const availableAdvance = await fetchAvailableAdvance({
                clientId: formData.client_id,
                vendorId: formData.vendor_id,
                userId: formData.user_id,
                currentInvoiceId: formData.invoice_id
            });

            // FIX: Support both multi-select state and single-select formData.project_id
            let finalProjectIds = selectedProjects.map(p => p.value);
            if (finalProjectIds.length === 0 && formData.project_id) {
                finalProjectIds = [formData.project_id];
            }

            // DECLARE VARIABLES AT FUNCTION SCOPE
            let hasMultipleInvoices = selectedInvoiceIds.length > 0;
            let totalInvoiceAmount = 0;
            let cashPayment = parseFloat(formData.amount || 0);
            let newAdvance = 0;
            let advanceToUse = 0;
            let receivedAmount = parseFloat(formData.received_amount || formData.amount || 0);
            let deduction = parseFloat(formData.deduction_amount || 0);
            let netReceived = 0;

            let formDataToSubmit = {
                ...formData,
                bill_no: formData.bill_no || '',
                expense_type_id: formData.expense_type_id || '',
                expense_id: expenseIds,
                bills: billIdentifiers || [],
                selected_invoices: selectedInvoiceIds,
                project_ids: finalProjectIds, // Array for pivot table sync
                project_id: finalProjectIds.length > 0 ? finalProjectIds[0] : null, // For backward compatibility
                bill_allocations: formData.bill_allocations || [],
                is_partial_payment: formData.is_partial_payment || false,
                salary_ids: formData.salary_ids || selectedSalaries?.map(s => s.value) || [], // Include salary_ids
                from_bank_id: formData.from_bank_id || '',
                to_bank_id: formData.to_bank_id || '',
                use_advance: formData.use_advance || false,
                credit_amount: formData.credit_amount || '0.00',
                transaction_currency_id: parseInt(formData.transaction_currency || (selectedBank?.base_currency_id || 1), 10),
                transaction_currency: formData.transaction_currency || (selectedBank?.base_currency_id || 1),
                applied_advance: formData.use_advance ? (formData.applied_advance || formData.applied_amount || '0.00') : '0.00',
                applied_amount: formData.use_advance ? (formData.applied_advance || formData.applied_amount || '0.00') : '0.00',
                advance_type: formData.type === 'advance' ? (formData.advance_type || 'vendor') : null,
            };

            // For contra transactions, set account_id to from_bank_id for backward compatibility
            if (formData.type === 'contra') {
                formDataToSubmit.account_id = formData.from_bank_id || formData.account_id;
                formDataToSubmit.account_type = 'bank account';
            }

            // For expense transactions, handle total payment calculation for balance updates
            if (formData.type === 'expense') {
                const appliedFromAdvance = formData.use_advance ? (parseFloat(formData.applied_advance) || 0) : 0;
                const cashPaid = parseFloat(formData.amount) || 0;
                const totalCreditToBills = cashPaid + appliedFromAdvance;

                const expenseCurrency = getSelectedInvoiceExpenseCurrency();
                const billCurrencyId = getCurrencyIdFromCode(expenseCurrency);
                const currentCurrencyId = formData.transaction_currency || (selectedBank?.base_currency_id || 1);

                // Convert total credit to bill currency for accurate allocation
                let amountToDistribute = totalCreditToBills;
                if (billCurrencyId && currentCurrencyId && billCurrencyId.toString() !== currentCurrencyId.toString()) {
                    const inBase = convertAmountToBase(totalCreditToBills, currentCurrencyId, selectedBank);
                    if (billCurrencyId.toString() === selectedBank.base_currency_id?.toString()) {
                        amountToDistribute = inBase;
                    } else {
                        const rate = selectedBank.exchange_rates?.find(r => r.currency_id?.toString() === billCurrencyId.toString());
                        if (rate && rate.rate) {
                            amountToDistribute = inBase / parseFloat(rate.rate);
                        }
                    }
                }

                formDataToSubmit.amount = cashPaid.toFixed(2);
                // Remove received_amount for expenses to prevent doubling in backend if it exists as a column
                formDataToSubmit.received_amount = "";

                // Recalculate allocations in handleSubmit for ultimate safety
                if (formData.bills && formData.bills.length > 0) {
                    const sortedBills = [...formData.bills].sort((a, b) => {
                        if (formData.payment_mode === 'petty_cash') {
                            return new Date(a.date || 0) - new Date(b.date || 0) ||
                                parseFloat(a.amount || 0) - parseFloat(b.amount || 0);
                        } else {
                            const balB = parseFloat(b.remaining_balance || b.original_amount || b.amount || 0);
                            const balA = parseFloat(a.remaining_balance || a.original_amount || a.amount || 0);
                            return balB - balA;
                        }
                    });

                    // SEQUENTIAL DISTRIBUTION IN BILL CURRENCY
                    let remainingToApply = amountToDistribute;
                    const allocations = [];

                    sortedBills.forEach((bill) => {
                        if (remainingToApply <= 0) return;
                        const billRemaining = parseFloat(bill.remaining_balance || bill.original_amount || bill.amount || 0);
                        const amountToPay = Math.min(remainingToApply, billRemaining);

                        if (amountToPay > 0) {
                            allocations.push({
                                expense_id: bill.value || bill.id,
                                amount_paid: parseFloat(amountToPay.toFixed(2)),
                                is_fully_paid: amountToPay >= billRemaining - 0.01,
                                remaining_balance: Math.max(0, billRemaining - amountToPay)
                            });
                            remainingToApply -= amountToPay;
                        }
                    });

                    // Handle overpayment if any
                    if (remainingToApply > 0 && allocations.length > 0) {
                        allocations[0].amount_paid += remainingToApply;
                        allocations[0].amount_paid = parseFloat(allocations[0].amount_paid.toFixed(2));
                        allocations[0].remaining_balance = 0;
                        allocations[0].is_fully_paid = true;
                    }

                    formDataToSubmit.bill_allocations = allocations;
                    formDataToSubmit.is_partial_payment = allocations.some(a => a.remaining_balance > 0.01);
                }
            }
            else if (formData.type === 'advance') {
                // Determine Advance type (Client or Vendor)
                // If it's a CLIENT advance, we must set 'advance_amount' so it shows up in fetchClientAdvance
                // If it's a VENDOR advance, we might not need it, but it doesn't hurt.
                formDataToSubmit.amount = formData.amount || '0.00';
                formDataToSubmit.advance_amount = formData.amount || '0.00';
                formDataToSubmit.applied_amount = '0.00'; // New advances have 0 applied initially
                formDataToSubmit.client_id = formData.client_id; // Explicitly ensure this is sent
            }

            else if (formData.type === 'income') {
                // Calculate invoice totals
                if (hasMultipleInvoices) {
                    totalInvoiceAmount = formData.selected_invoices.reduce((sum, inv) => {
                        return sum + (parseFloat(inv.remaining_balance || inv.amount) || 0);
                    }, 0);
                } else if (formData.invoice_id) {
                    const invoice = invoices.find(inv => inv.id.toString() === formData.invoice_id);
                    totalInvoiceAmount = invoice ? parseFloat(invoice.remaining_balance || invoice.display_amount || 0) : 0;
                }

                // Total amount to credit to invoices is net cash entered + applied advance
                const cashReceived = parseFloat(formData.received_amount || formData.amount) || 0;
                const appliedFromAdvance = formData.use_advance ? (parseFloat(formData.applied_advance) || 0) : 0;
                const totalCreditToInvoices = cashReceived + appliedFromAdvance + (formData.use_credit ? (parseFloat(formData.credit_amount) || 0) : 0);

                netReceived = cashReceived - deduction; // amount that actually hits the bank

                console.log('DEBUG - Advance Logic values:', {
                    totalInvoiceAmount,
                    availableAdvance,
                    cashReceived,
                    appliedFromAdvance,
                    totalCreditToInvoices,
                    deduction,
                    netReceived
                });

                // Determine if we are creating a NEW advance (overpayment)
                if (totalCreditToInvoices > totalInvoiceAmount) {
                    newAdvance = totalCreditToInvoices - totalInvoiceAmount;
                } else {
                    newAdvance = 0;
                }

                cashPayment = netReceived;
                advanceToUse = appliedFromAdvance;

                formDataToSubmit.amount = cashPayment.toFixed(2); // Only save BANK RECEIVED amount
                formDataToSubmit.advance_amount = newAdvance.toFixed(2);
                formDataToSubmit.applied_amount = appliedFromAdvance.toFixed(2);
                formDataToSubmit.applied_advance = appliedFromAdvance.toFixed(2);
                formDataToSubmit.received_amount = (cashReceived + appliedFromAdvance).toFixed(2); // Full amount credited
                formDataToSubmit.deduction_amount = deduction.toFixed(2);

                // CRITICAL: Set use_advance flag for both scenarios
                // Scenario 1: Using existing advance (appliedFromAdvance > 0)
                // Scenario 2: Creating new advance from overpayment (newAdvance > 0)
                formDataToSubmit.use_advance = appliedFromAdvance > 0 || newAdvance > 0;

                // Removed explicit setting of advance_type to 'client' for income overpayments
                // as it should be null for non-advance types


                // GENERATE ALLOCATIONS WITH CORRECT AMOUNT
                if (formData.selected_invoices && formData.selected_invoices.length > 0) {
                    const invoiceAllocations = allocateInvoicePayments(
                        totalCreditToInvoices,
                        formData.selected_invoices
                    );
                    formDataToSubmit.invoice_allocations = invoiceAllocations;
                    formDataToSubmit.is_partial_payment = invoiceAllocations.some(allocation =>
                        allocation.remaining_balance > 0
                    );

                    console.log('? Generated Allocations:', {
                        totalCreditToInvoices,
                        allocations: invoiceAllocations
                    });
                }
            }
            setFormData(prev => ({
                ...prev,
                amount: cashPayment.toFixed(2),
                advance_amount: newAdvance.toFixed(2),
                applied_amount: advanceToUse.toFixed(2),
                received_amount: (cashPayment + advanceToUse).toFixed(2),
                deduction_amount: deduction.toFixed(2)
            }));

            console.log('Final formDataToSubmit:', {
                amount: formDataToSubmit.amount,
                advance_amount: formDataToSubmit.advance_amount,
                applied_amount: formDataToSubmit.applied_amount,
                received_amount: formDataToSubmit.received_amount,
                deduction_amount: formDataToSubmit.deduction_amount
            });

            if (formDataToSubmit.client_id === "0") {
                formDataToSubmit.client_id = null;
                formDataToSubmit.uncategorized = true;
            } else {
                formDataToSubmit.uncategorized = false;
            }

            const selectedAccount = banks.find(acc => acc.id.toString() === formData.account_id?.toString());
            const selectedClient = clients.find(c => c.id.toString() === formData.client_id?.toString());

            if (selectedAccount && !formDataToSubmit.exchange_rate) {
                formDataToSubmit.exchange_rate = selectedAccount.exchange_rate;
            }
            // In handleSubmit function, add payroll handling
            if (formData.type === 'payroll') {
                // Get salary_ids from selectedSalaries state
                const salaryIds = selectedSalaries.map(s => s.value);

                // Calculate total salary amount
                const totalSalaryAmount = selectedSalaries.reduce((sum, salary) => {
                    const originalSalary = pendingSalaries?.find(s => s.id === salary.value);
                    return sum + (parseFloat(originalSalary?.total_amount) || 0);
                }, 0);

                // const totalAmount =
                //     totalSalaryAmount +
                //     parseFloat(formData.wps_charge || 0) +
                //     parseFloat(formData.wps_vat || 0);
                const bankServiceCharge = parseFloat(formData.bank_service_charge || 0);
                const bankVatAmount = parseFloat(formData.bank_vat_amount || 0);
                const totalAmount = totalSalaryAmount + bankServiceCharge + bankVatAmount;

                formDataToSubmit = {
                    ...formDataToSubmit,
                    amount: totalAmount.toFixed(2),
                    salary_ids: salaryIds, // Array for potentially other handling
                    salary_id: salaryIds.length > 0 ? salaryIds[0] : null, // Send SINGLE ID to satisfy BigInt column
                    payroll_provider_id: formData.payroll_provider_id,
                    wps_charge: formData.wps_charge,
                    wps_vat: formData.wps_vat,
                    total_salary_amount: totalSalaryAmount.toFixed(2) // Optional: send total for verification
                };
            }

            let journalResult = null;
            if (formData.type === 'income') {
                // Pass ALL amounts to syncIncomeWithWebzash
                journalResult = await syncIncomeWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    client: selectedClient,
                    selected_invoices: formData.selected_invoices,
                    // Pass ALL calculated amounts
                    amount: cashPayment, // Cash payment to bank
                    advance_amount: newAdvance,
                    applied_amount: advanceToUse,
                    received_amount: receivedAmount, // Full received amount (1050)
                    deduction_amount: deduction, // Deduction (0 in your case)
                    total_invoice_amount: totalInvoiceAmount, // Invoice total (1000)
                    net_received: netReceived, // receivedAmount - deduction
                    available_advance: availableAdvance,
                    use_credit: formData.use_credit,
                    credit_amount: formData.credit_amount,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            } else if (formData.type === 'expense' && formData.account_type) {
                journalResult = await syncWithWebzash(
                    {
                        ...formData,
                        account: selectedAccount,
                        entry_id: transactionData?.entry_id || formData.entry_id,
                        journal_id: transactionData?.journal_id || formData.journal_id,
                        id: transactionData?.id || formData.id
                    },
                    selectedVendorExpenses,
                    selectedUserExpenses
                );
            }
            else if (formData.type === 'capital') {
                // Handle capital transaction
                journalResult = await syncCapitalWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    owner_name: formData.owner_name || "Owner",
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'bank_guarantee') {
                journalResult = await syncBankGuaranteeWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'bank_guarantee_released') {
                journalResult = await syncBankGuaranteeReleasedWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'bad_debt_written_off') {
                journalResult = await syncBadDebtWithWebzash({
                    ...formData,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'withdrawal') {
                // Handle capital transaction
                journalResult = await syncWithdrawalWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    owner_name: formData.owner_name || "Owner",
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'bank_guarantee_charges') {
                journalResult = await syncBankGuaranteeChargesWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'advance') {
                journalResult = await syncAdvanceWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    vendor: vendors.find(v => v.id == formData.vendor_id),
                    client: clients.find(c => c.id == formData.client_id),
                    user: users.find(u => u.id == formData.user_id),
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id,
                    po_id: formData.po_id || null,
                    advance_type: formData.advance_type || ''
                });
            }
            // In handleSubmit, add payroll case
            else if (formData.type === 'payroll') {
                journalResult = await syncPayrollWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    salary_ids: selectedSalaries.map(s => s.value),
                    salary_amounts: selectedSalaries.map(s => s.amount),
                    total_salary_amount: totalSalaryAmount,
                    wps_charge: formData.wps_charge,
                    wps_vat: formData.wps_vat,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }
            else if (formData.type === 'vat_payable') {
                journalResult = await syncVatPayableWithWebzash({
                    ...formData,
                    account: selectedAccount,
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id,
                    bank_service_charge: formData.bank_service_charge,
                    bank_vat_amount: formData.bank_vat_amount,


                });
            }
            else if (formData.type === 'contra') {
                const accountList = allBanks.length > 0 ? allBanks : banks;

                const fromBank = accountList.find(b => b.id.toString() === formData.from_bank_id?.toString());
                const toBank = accountList.find(b => b.id.toString() === formData.to_bank_id?.toString());

                console.log('?? Contra bank objects found:', { fromBank, toBank });

                if (!fromBank || !toBank) {
                    throw new Error(`Bank account not found. From: ${formData.from_bank_id}, To: ${formData.to_bank_id}`);
                }

                journalResult = await syncContraWithWebzash({
                    ...formData,
                    from_bank: fromBank,
                    to_bank: toBank,
                    account: fromBank, // Use from_bank as primary account for backward compatibility
                    entry_id: transactionData?.entry_id || formData.entry_id,
                    journal_id: transactionData?.journal_id || formData.journal_id,
                    id: transactionData?.id || formData.id
                });
            }

            formDataToSubmit.journal_id = journalResult?.journal_id || null;
            formDataToSubmit.entry_id = journalResult?.entry_id || null;

            // Handle file upload for ALL transaction types
            let finalDataToSubmit = formDataToSubmit;
            if (formData.statement_file) {
                // Convert to FormData for file upload
                const formDataForUpload = new FormData();
                Object.keys(formDataToSubmit).forEach(key => {
                    if (key === 'statement_file') {
                        formDataForUpload.append('statement_file', formData.statement_file);
                    } else if (formDataToSubmit[key] !== null && formDataToSubmit[key] !== undefined) {
                        // Handle arrays
                        if (Array.isArray(formDataToSubmit[key])) {
                            formDataToSubmit[key].forEach(item => {
                                // Handle potential objects in array (though mostly we expect primitive IDs here)
                                const itemValue = typeof item === 'object' ? JSON.stringify(item) : item;
                                formDataForUpload.append(`${key}[]`, itemValue);
                            });
                        } else if (typeof formDataToSubmit[key] === 'boolean') {
                            formDataForUpload.append(key, formDataToSubmit[key] ? '1' : '0');
                        } else if (typeof formDataToSubmit[key] === 'object') {
                            formDataForUpload.append(key, JSON.stringify(formDataToSubmit[key]));
                        } else {
                            formDataForUpload.append(key, formDataToSubmit[key]);
                        }
                    }
                });
                finalDataToSubmit = formDataForUpload;
            }

            let apiErrors;
            if (transactionData) {
                apiErrors = await editTransaction(transactionData.id, finalDataToSubmit);
                if (apiErrors && apiErrors.lockError) {
                    setLockError('Financial year is locked. Transaction cannot be updated.');
                    setLoading(false);
                    return; // Stop further execution
                }
            } else {
                apiErrors = await addTransaction(finalDataToSubmit);
                if (apiErrors && apiErrors.lockError) {
                    setLockError('Financial year is locked. Transaction cannot be created.');
                    setLoading(false);
                    return; // Stop further execution
                }
            }
            if (journalResult && journalResult.lockError) {
                setLockError(journalResult.message || 'Financial year is locked. Sync with accounting system failed.');
                setLoading(false);
                return;
            }

            // if (apiErrors && Object.keys(apiErrors).length > 0) {
            //     setErrors(apiErrors);
            // } else {
            //     setErrors({});
            //     handleClose();
            //     resetForm();
            // }
            if (apiErrors && Object.keys(apiErrors).length > 0 && !apiErrors.lockError) {
                // Rollback Webzash entry if it was created but the main transaction failed
                if (journalResult?.entry_id) {
                    await rollbackWebzashEntry(journalResult.entry_id, formData.type);
                }

                setErrors(apiErrors);
                if (apiErrors.genericError) {
                    showToast("? Database Error: " + apiErrors.genericError, "error");
                }
                setLoading(false);
                return;
            } else if (!apiErrors || (apiErrors && !apiErrors.lockError)) {
                // Success - no errors
                setErrors({});
                handleClose();
                resetForm();

                showToast1("Transaction Added Successfully.");
            }

            // Update invoice status - variables are now defined
            if (formData.type === 'income') {
                const totalCredit = cashPayment + advanceToUse;
                if (hasMultipleInvoices) {
                    for (const inv of formData.selected_invoices) {
                        const invoice = invoices.find(i => i.id === inv.value);
                        if (invoice) {
                            const invoiceRemaining = parseFloat(invoice.remaining_balance || invoice.display_amount || 0);
                            // If we have any overpayment or we covered this specific invoice
                            if (totalCredit >= totalInvoiceAmount || inv.amount_paid >= invoiceRemaining) {
                                await updateInvoiceStatus(invoice.id, "payment_received");
                            } else if (inv.amount_paid > 0) {
                                await updateInvoiceStatus(invoice.id, "partially_paid");
                            }
                        }
                    }
                } else if (formDataToSubmit.invoice_id) {
                    if (totalCredit >= totalInvoiceAmount) {
                        await updateInvoiceStatus(formDataToSubmit.invoice_id, "payment_received");
                    } else if (totalCredit > 0) {
                        await updateInvoiceStatus(formDataToSubmit.invoice_id, "partially_paid");
                    }
                }
            }

            /* 
            // REMOVED: Redundant and harmful. TransactionController handles this logic correctly now.
            // These calls would over-write the correct status with 'Fully Paid' regardless of balance.
            if (formDataToSubmit.type === 'expense' && billIdentifiers && billIdentifiers.length > 0) {
                const appliedFromAdvance = formData.use_advance ? (parseFloat(formData.applied_advance) || 0) : 0;
                const cashPaid = parseFloat(formData.amount) || 0;
                const totalCreditToBills = cashPaid + appliedFromAdvance;

                if (formDataToSubmit.payment_mode === 'petty_cash' && formDataToSubmit.user_id) {
                    await markEmployeeBillAsPaid(
                        formDataToSubmit.user_id,
                        billIdentifiers,
                        true,
                        formDataToSubmit.expense_type_id
                    );
                } else if (formDataToSubmit.vendor_id) {
                    await markBillAsPaid(
                        formDataToSubmit.vendor_id,
                        billIdentifiers,
                        formDataToSubmit.expense_type_id,
                        totalCreditToBills.toFixed(2) // CRITICAL: Pass total (cash + advance)
                    );
                }
            }
            */


        } catch (error) {
            console.error("An error occurred:", error);
            showToast("? Transaction failed: " + error.message);
        } finally {
            setLoading(false);
        }
    };
    const handleResetCurrency = () => {
        const recommendedCurrencyId = autoSelectCurrency(formData);
        if (recommendedCurrencyId) {
            handleCurrencySelection(recommendedCurrencyId);
        }
    };

    const getCurrentCurrencyDisplay = () => {
        const id = getEffectiveCurrencyId(formData, selectedBank);
        return getCurrencySymbol(id);
    };

    // const showConversionDisplay = () => {
    //     if (!formData.transaction_currency ||
    //         !formData.amount ||
    //         !selectedBank ||
    //         formData.transaction_currency == selectedBank.base_currency_id) {
    //         return null;
    //     }

    //     const exchangeRate = selectedBank.exchange_rates?.find(
    //         r => r.currency_id?.toString() === formData.transaction_currency?.toString()
    //     );

    //     if (!exchangeRate) return null;

    //     // Convert amount to base currency
    //     const convertedAmount = parseFloat(formData.amount) * parseFloat(exchangeRate.rate);

    //     return (
    //         <div className="mt-2 p-2 bg-light border rounded">
    //             <small className="text-muted d-block">
    //                 <i className="mdi mdi-currency-exchange me-1"></i>
    //                 Conversion: 1 {exchangeRate.currency?.currency} = {parseFloat(exchangeRate.rate).toFixed(4)} {selectedBank.base_currency?.currency}
    //             </small>
    //             <small className="text-primary d-block mt-1">
    //                 {formatCurrency(formData.amount)} {exchangeRate.currency?.currency} = {formatCurrency(convertedAmount)} {selectedBank.base_currency?.currency}
    //             </small>
    //         </div>
    //     );
    // };
    const showConversionDisplay = () => {
        if (!formData.transaction_currency ||
            !formData.amount ||
            !selectedBank ||
            formData.transaction_currency == selectedBank.base_currency_id) {
            return null;
        }

        const exchangeRate = selectedBank.exchange_rates?.find(
            r => r.currency_id?.toString() === formData.transaction_currency?.toString()
        );

        if (!exchangeRate) return null;

        // For advance transactions with PO, we need to calculate differently
        if (formData.type === 'advance' && formData.po_id) {
            const selectedPO = pos.find(p => p.id?.toString() === formData.po_id.toString());
            if (selectedPO) {
                const poAmount = parseFloat(selectedPO.amount || selectedPO.total_amount || selectedPO.po_amount || 0);
                const convertedAmount = poAmount * parseFloat(exchangeRate.rate);

                return (
                    <div className="mt-2 p-2 bg-light border rounded">
                        <small className="text-muted d-block">
                            <i className="mdi mdi-currency-exchange me-1"></i>
                            PO Conversion: 1 {exchangeRate.currency?.currency} = {parseFloat(exchangeRate.rate).toFixed(4)} {selectedBank.base_currency?.currency}
                        </small>
                        <small className="text-primary d-block mt-1">
                            {formatCurrency(poAmount)} {exchangeRate.currency?.currency} = {formatCurrency(convertedAmount)} {selectedBank.base_currency?.currency}
                        </small>
                    </div>
                );
            }
        }

        // For regular transactions
        const transactionCurrencySymbol = getCurrencySymbol(formData.transaction_currency);
        const baseCurrencySymbol = selectedBank.base_currency?.currency;

        // Calculate what the amount should be in the transaction currency
        // We need to work backwards from AED to the foreign currency
        const amountInAED = parseFloat(formData.converted_amount || formData.base_amount || formData.amount || 0);
        const amountInForeignCurrency = amountInAED / parseFloat(exchangeRate.rate);

        return (
            <div className="mt-2 p-2 bg-light border rounded">
                <small className="text-muted d-block">
                    <i className="mdi mdi-currency-exchange me-1"></i>
                    Conversion: 1 {transactionCurrencySymbol} = {parseFloat(exchangeRate.rate).toFixed(4)} {baseCurrencySymbol}
                </small>
                <small className="text-primary d-block mt-1">
                    {formatCurrency(amountInForeignCurrency)} {transactionCurrencySymbol} = {formatCurrency(amountInAED)} {baseCurrencySymbol}
                </small>
            </div>
        );
    };
    const convertAmountToBase = (amount, fromCurrencyId, bank) => {
        if (!amount || !fromCurrencyId || !bank) return amount;
        if (fromCurrencyId == bank.base_currency_id) return amount;
        const exchangeRate = bank.exchange_rates?.find(rate => rate.currency_id == fromCurrencyId);
        if (exchangeRate && exchangeRate.rate) {
            return amount * parseFloat(exchangeRate.rate);
        }
        return amount;
    };
    // Get currency symbol/name
    // const getCurrencySymbol = (currencyId) => {
    //     if (!currencyId || !selectedBank) return '';

    //     if (currencyId == selectedBank.base_currency_id) {
    //         return selectedBank.base_currency?.currency || 'AED';
    //     }

    //     const rate = selectedBank.exchange_rates?.find(r => r.currency_id == currencyId);
    //     return rate?.currency?.currency || '';
    // };

    // Get exchange rate for specific currency
    const getExchangeRate = (currencyId) => {
        if (!currencyId || !selectedBank) return 1;

        if (currencyId == selectedBank.base_currency_id) {
            return 1;
        }

        const rate = selectedBank.exchange_rates?.find(r => r.currency_id == currencyId);
        return rate ? parseFloat(rate.rate) : 1;
    };

    // Convert amount based on selected currency
    // const convertAmount = (amount, fromCurrencyId, toCurrencyId = selectedBank?.base_currency_id) => {
    //     if (!amount || !fromCurrencyId || !selectedBank) return amount;

    //     const numericAmount = parseFloat(amount);
    //     if (isNaN(numericAmount)) return amount;

    //     // If same currency, no conversion needed
    //     if (fromCurrencyId == toCurrencyId) {
    //         return numericAmount;
    //     }

    //     // If converting from foreign to base
    //     if (fromCurrencyId != selectedBank.base_currency_id) {
    //         const exchangeRate = selectedBank.exchange_rates?.find(
    //             rate => rate.currency_id == fromCurrencyId
    //         );

    //         if (exchangeRate && exchangeRate.rate) {
    //             // Convert using: Base Amount = Foreign Amount × Rate
    //             return numericAmount * parseFloat(exchangeRate.rate);
    //         }
    //     }
    //     // If converting from base to foreign (shouldn't happen in your case)
    //     else {
    //         const exchangeRate = selectedBank.exchange_rates?.find(
    //             rate => rate.currency_id == toCurrencyId
    //         );

    //         if (exchangeRate && exchangeRate.rate) {
    //             // Convert using: Foreign Amount = Base Amount ÷ Rate
    //             return numericAmount / parseFloat(exchangeRate.rate);
    //         }
    //     }

    //     return numericAmount; // Return original if no rate found
    // };
    const convertAmount = (amount, fromCurrencyId, toCurrencyId = selectedBank?.base_currency_id) => {
        if (!amount || !fromCurrencyId || !selectedBank) return amount;

        const numericAmount = parseFloat(amount);
        if (isNaN(numericAmount)) return amount;

        // If same currency, no conversion needed
        if (fromCurrencyId == toCurrencyId) {
            return numericAmount;
        }

        // If converting from foreign to base (USD to AED)
        if (fromCurrencyId != selectedBank.base_currency_id && toCurrencyId == selectedBank.base_currency_id) {
            const exchangeRate = selectedBank.exchange_rates?.find(
                rate => rate.currency_id == fromCurrencyId
            );

            if (exchangeRate && exchangeRate.rate) {
                // Correct conversion: Foreign Amount × Rate = Base Amount
                return numericAmount * parseFloat(exchangeRate.rate);
            }
        }
        // If converting from base to foreign (AED to USD) - should not happen in your case
        else if (fromCurrencyId == selectedBank.base_currency_id && toCurrencyId != selectedBank.base_currency_id) {
            const exchangeRate = selectedBank.exchange_rates?.find(
                rate => rate.currency_id == toCurrencyId
            );

            if (exchangeRate && exchangeRate.rate) {
                // Base Amount ÷ Rate = Foreign Amount
                return numericAmount / parseFloat(exchangeRate.rate);
            }
        }

        return numericAmount; // Return original if no rate found
    };

    // const getPrioritizedCurrencies = () => {
    //     if (!selectedBank) return [];

    //     const prioritized = [];
    //     const entityCurrency = getSelectedInvoiceExpenseCurrency();
    //     const bankCurrency = selectedBank.base_currency?.currency || 'AED';

    //     // Helper to formatting labels like "USD to AED"
    //     const formatDirectionalLabel = (fromCode, toCode) => {
    //         if (fromCode === toCode) return fromCode;
    //         return `${fromCode} to ${toCode}`;
    //     };

    //     const currentCurrencyCode = getCurrencyName(formData.transaction_currency) || bankCurrency;

    //     // 1. Add Entity Currency (Client/Vendor/AED for Petty Cash)
    //     if (entityCurrency) {
    //         const entityCurrencyId = getCurrencyIdFromCode(entityCurrency);
    //         if (entityCurrencyId) {
    //             prioritized.push({
    //                 currency_id: entityCurrencyId,
    //                 currency: entityCurrency,
    //                 label: entityCurrency, // Just "USD"
    //                 is_prioritized: true,
    //                 priority_label: 'Recommended'
    //             });
    //         }
    //     }

    //     // 2. Add Bank Base Currency
    //     if (bankCurrency && (bankCurrency !== entityCurrency || currentCurrencyCode !== bankCurrency)) {
    //         prioritized.push({
    //             currency_id: selectedBank.base_currency_id,
    //             currency: bankCurrency,
    //             label: formatDirectionalLabel(currentCurrencyCode, bankCurrency), // e.g., "USD to AED"
    //             is_base: true,
    //             priority_label: 'Bank Base'
    //         });
    //     }

    //     // 3. Add other exchange rates
    //     selectedBank.exchange_rates?.forEach(rate => {
    //         const currencyName = rate.currency?.currency;
    //         if (currencyName !== entityCurrency && currencyName !== bankCurrency) {
    //             prioritized.push({
    //                 currency_id: rate.currency_id,
    //                 currency: currencyName,
    //                 label: formatDirectionalLabel(currencyName, bankCurrency), // e.g., "INR to AED"
    //                 rate: rate.rate
    //             });
    //         }
    //     });

    //     return prioritized;
    // };

    // const getPrioritizedCurrencies = () => {
    //     if (!selectedBank) return [];

    //     const prioritized = [];
    //     const entityCurrency = getSelectedInvoiceExpenseCurrency();
    //     const bankCurrency = selectedBank.base_currency?.currency || 'AED';

    //     // Get the current effective currency showing on the label right now
    //     const currentEffectiveId = getEffectiveCurrencyId(formData, selectedBank);
    //     const currentEffectiveCode = getCurrencySymbol(currentEffectiveId);

    //     // Helper to format directional labels (e.g., "USD to AED")
    //     const formatDirectionalLabel = (targetCode) => {
    //         if (currentEffectiveCode === targetCode) return targetCode;
    //         return `${currentEffectiveCode} to ${targetCode}`;
    //     };

    //     // 1. Add Bank Base Currency FIRST as requested
    //     if (bankCurrency) {
    //         prioritized.push({
    //             currency_id: selectedBank.base_currency_id,
    //             currency: bankCurrency,
    //             label: formatDirectionalLabel(bankCurrency), // Just "AED" or "USD to AED"
    //             is_base: true,
    //             priority_label: 'Bank Base'
    //         });
    //     }

    //     // 2. Add Entity Currency (Client/Vendor/AED for Petty Cash)
    //     if (entityCurrency) {
    //         const entityCurrencyId = getCurrencyIdFromCode(entityCurrency);
    //         if (entityCurrencyId && entityCurrencyId !== selectedBank.base_currency_id) {
    //             prioritized.push({
    //                 currency_id: entityCurrencyId,
    //                 currency: entityCurrency,
    //                 label: formatDirectionalLabel(entityCurrency),
    //                 is_prioritized: true,
    //                 priority_label: 'Recommended'
    //             });
    //         }
    //     }

    //     // 3. Add other exchange rates
    //     selectedBank.exchange_rates?.forEach(rate => {
    //         const currencyName = rate.currency?.currency;
    //         if (currencyName !== entityCurrency && currencyName !== bankCurrency) {
    //             prioritized.push({
    //                 currency_id: rate.currency_id,
    //                 currency: currencyName,
    //                 label: formatDirectionalLabel(currencyName),
    //                 rate: rate.rate
    //             });
    //         }
    //     });

    //     // 4. Add Currently Selected Currency (if not already there)
    //     if (formData.transaction_currency) {
    //         const isAlreadyAdded = prioritized.some(p => p.currency_id?.toString() === formData.transaction_currency?.toString());
    //         if (!isAlreadyAdded) {
    //             const currencyName = getCurrencySymbol(formData.transaction_currency);
    //             prioritized.push({
    //                 currency_id: formData.transaction_currency,
    //                 currency: currencyName,
    //                 label: formatDirectionalLabel(currencyName),
    //                 priority_label: 'Custom Selection'
    //             });
    //         }
    //     }

    //     return prioritized;
    // };
    useEffect(() => {
        if (showModal) {
            // Retrieve saved invoice payments from localStorage
            const savedPayments = JSON.parse(localStorage.getItem("invoicePayments")) || {};
            setInvoicePayments(savedPayments);
        }
    }, [showModal]);

    const updateInvoiceStatus = async (invoiceId, status) => {
        try {
            const backendUrl = process.env.REACT_APP_BACKEND_URL;
            const userInfo = JSON.parse(localStorage.getItem("user-info"));
            const origin = localStorage.getItem('user-origin');

            const token = userInfo?.token;

            await axios.post(`${backendUrl}/api/proformainvoice/${invoiceId}/status`, {
                pi_status: status,
                paid_date: status === "payment_received" ? new Date().toISOString() : null
            }, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Tenant-Origin': origin,

                }
            });

            console.log(`Invoice ${invoiceId} status updated to ${status}`);
        } catch (error) {
            console.error("Error updating invoice status:", error);
        }
    };
    // console.log("FormData:", formData);
    // console.log("Bill No from FormData:", formData.bill_no);


    // console.log("selectedVendorExpenses:", selectedVendorExpenses); // Check vendor expenses
    // console.log("formData.bills:", formData?.bills); // Check if formData.bills is populated

    const selectedValues = (formData?.bills || []).map(invoiceNo => {
        const found = selectedVendorExpenses?.find(e => e.invoice_no === invoiceNo);
        console.log(`Finding selected invoiceNo: ${invoiceNo}`, found); // Log invoice selection lookup
        return found ? {
            label: found?.invoice_no || invoiceNo,
            value: invoiceNo,
            amount: found?.total_amount || 0,
        } : null;
    }).filter(Boolean); // Filter out null if no match is found

    // console.log("Selected Values for <Select>:", selectedValues);

    // Filter only unpaid invoices for the dropdown, excluding selected ones
    const unpaidOptions = selectedVendorExpenses
        ?.filter(exp =>
            (exp.is_paid === false || exp.is_paid === "false") &&
            !formData?.bills?.includes(exp.invoice_no) // Ensure not selecting already selected items
        )
        .map(exp => ({
            label: exp.invoice_no,
            value: exp.invoice_no,
            amount: exp.total_amount,
        }));


    const handleAmountChange = (e) => {
        const { name, value } = e.target;
        const totalPaymentAmount = parseFloat(value) || 0;

        setFormData(prev => {
            const newFormData = { ...prev, [name]: value };



            // Handle currency conversion for amount or received_amount
            if ((name === 'amount' || name === 'received_amount') && prev.transaction_currency && value) {
                const amountToConvert = parseFloat(value) || 0;
                const converted = convertAmountToBase(
                    amountToConvert,
                    prev.transaction_currency,
                    selectedBank
                );
                newFormData.converted_amount = converted.toFixed(2);
                newFormData.base_amount = converted.toFixed(2);
                setConvertedAmount(converted.toFixed(2));
                setBaseAmount(converted.toFixed(2));
            }

            // NEW: Handle income invoice payment distribution
            if ((name === "amount" || name === "received_amount" || name === "applied_advance") && prev.type === 'income' && (prev.selected_invoices?.length > 0 || prev.invoice_id)) {
                let totalInvoiceAmount = 0;
                if (prev.selected_invoices?.length > 0) {
                    totalInvoiceAmount = prev.selected_invoices.reduce((sum, inv) => {
                        return sum + (parseFloat(inv.remaining_balance || inv.amount) || 0);
                    }, 0);
                } else if (prev.invoice_id) {
                    const invoice = invoices.find(inv => inv.id.toString() === prev.invoice_id);
                    totalInvoiceAmount = invoice ? parseFloat(invoice.remaining_balance || invoice.display_amount || 0) : 0;
                }

                let cashReceived = (name === "received_amount" || name === "amount") ? totalPaymentAmount : (parseFloat(prev.received_amount || prev.amount) || 0);
                let appliedFromAdvance = name === "applied_advance" ? totalPaymentAmount : (prev.use_advance ? (parseFloat(prev.applied_advance) || 0) : 0);
                let deductionAmt = parseFloat(prev.deduction_amount) || 0;

                // If user changed the advance amount, update the cash received to fill the bill total
                if (name === "applied_advance") {
                    // Limit advance to total available and bill total
                    const maxCanApply = Math.max(0, totalInvoiceAmount - deductionAmt);
                    appliedFromAdvance = Math.min(appliedFromAdvance, totalAdvance, maxCanApply);
                    newFormData.applied_advance = appliedFromAdvance.toFixed(2);

                    cashReceived = Math.max(0, totalInvoiceAmount - appliedFromAdvance - deductionAmt);
                    newFormData.received_amount = cashReceived.toFixed(2);
                    newFormData.amount = cashReceived.toFixed(2);
                }

                const totalToBeDistributed = cashReceived + appliedFromAdvance + deductionAmt;

                // Calculate surplus (New Advance)
                if (totalToBeDistributed > totalInvoiceAmount) {
                    newFormData.advance_amount = (totalToBeDistributed - totalInvoiceAmount).toFixed(2);
                } else {
                    newFormData.advance_amount = "0.00";
                }

                if (prev.selected_invoices?.length > 0) {
                    // Use the existing allocation helper
                    const allocations = allocateInvoicePayments(totalToBeDistributed, prev.selected_invoices);

                    // Update selected_invoices with redistributed amounts for UI consistency
                    newFormData.selected_invoices = prev.selected_invoices.map(inv => {
                        const invId = inv.value || inv.id;
                        const allocation = allocations.find(a => a.invoice_id == invId);
                        return {
                            ...inv,
                            amount: allocation ? allocation.amount_paid : 0
                        };
                    });
                }
            }

            // Handle expense bills payment distribution - SEQUENTIAL LOGIC
            // This is CRITICAL for the remaining balance payment
            if ((name === "amount" || name === "applied_advance") && prev.bills && prev.bills.length > 0) {
                const selectedBills = prev.bills;
                const totalInvoiceAmount = selectedBills.reduce((sum, b) => sum + (parseFloat(b.remaining_balance || b.original_amount || b.amount) || 0), 0);

                let cashAmount = name === "amount" ? totalPaymentAmount : (parseFloat(prev.amount) || 0);
                let appliedFromAdvance = name === "applied_advance" ? totalPaymentAmount : (prev.use_advance ? (parseFloat(prev.applied_advance) || 0) : 0);

                // Residual logic: If user changed Advance, update Cash amount to cover total bill
                if (name === "applied_advance") {
                    // Limit applied advance to totalAdvance and bill total
                    appliedFromAdvance = Math.min(appliedFromAdvance, totalAdvance, totalInvoiceAmount);
                    newFormData.applied_advance = appliedFromAdvance.toFixed(2);

                    cashAmount = Math.max(0, totalInvoiceAmount - appliedFromAdvance);
                    newFormData.amount = cashAmount.toFixed(2);
                }

                const totalToBeDistributed = cashAmount + appliedFromAdvance;
                
                // Convert totalToBeDistributed to bill currency if needed
                const billCurrencyCode = getSelectedInvoiceExpenseCurrency(newFormData);
                const billCurrencyId = getCurrencyIdFromCode(billCurrencyCode);
                const currentCurrencyId = newFormData.transaction_currency || getEffectiveCurrencyId(newFormData, selectedBank);

                let amountToDistribute = totalToBeDistributed;
                if (billCurrencyId && currentCurrencyId && billCurrencyId.toString() !== currentCurrencyId.toString()) {
                    const inBase = convertAmountToBase(totalToBeDistributed, currentCurrencyId, selectedBank);
                    if (billCurrencyId.toString() === selectedBank.base_currency_id?.toString()) {
                        amountToDistribute = inBase;
                    } else {
                        const rate = selectedBank.exchange_rates?.find(r => r.currency_id?.toString() === billCurrencyId.toString());
                        if (rate && rate.rate) {
                            amountToDistribute = inBase / parseFloat(rate.rate);
                        }
                    }
                }

                console.log('Distributing payment:', { totalInvoiceAmount, cashAmount, appliedFromAdvance, totalToBeDistributed, amountToDistribute, billCurrency: billCurrencyCode });

                // Sort bills for sequential payment
                const sortedBills = [...selectedBills].sort((a, b) => {
                    if (prev.payment_mode === 'petty_cash') {
                        return new Date(a.date || 0) - new Date(b.date || 0) ||
                            parseFloat(a.amount || 0) - parseFloat(b.amount || 0);
                    } else {
                        const balB = parseFloat(b.remaining_balance || b.original_amount || b.amount || 0);
                        const balA = parseFloat(a.remaining_balance || a.original_amount || a.amount || 0);
                        return balB - balA;
                    }
                });

                // SEQUENTIAL DISTRIBUTION
                let remainingPayment = amountToDistribute;
                const billAllocations = [];

                // Distribute payment sequentially
                sortedBills.forEach((bill) => {
                    if (remainingPayment <= 0) return;

                    const billRemaining = parseFloat(bill.remaining_balance || bill.original_amount || bill.amount || 0);
                    const amountToPay = Math.min(remainingPayment, billRemaining);

                    if (amountToPay > 0) {
                        billAllocations.push({
                            expense_id: bill.value,
                            amount_paid: parseFloat(amountToPay.toFixed(2)),
                            is_fully_paid: amountToPay >= billRemaining,
                            remaining_balance: Math.max(0, billRemaining - amountToPay)
                        });

                        remainingPayment -= amountToPay;
                    }
                });

                // If there's any leftover payment, add to first bill
                if (remainingPayment > 0 && billAllocations.length > 0) {
                    billAllocations[0].amount_paid += remainingPayment;
                    billAllocations[0].amount_paid = parseFloat(billAllocations[0].amount_paid.toFixed(2));
                    billAllocations[0].remaining_balance = 0;
                    billAllocations[0].is_fully_paid = true;
                }

                // ? CRITICAL: Update formData with allocations
                newFormData.bill_allocations = billAllocations;
                newFormData.is_partial_payment = billAllocations.some(allocation =>
                    allocation.remaining_balance > 0
                );

                console.log('✅ Updated Bill Allocations (Sequential):', {
                    totalToBeDistributed,
                    billAllocations
                });
            }

            return newFormData;
        });

        // Clear error for this field
        if (errors[name]) {
            setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));
        }
    };
    const syncWithWebzash = async (transaction, selectedVendorExpenses, selectedUserExpenses = []) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId || transaction.id;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== DEBUG ===");
            console.log("Raw transaction.entry_id:", transaction.entry_id);
            console.log("Computed entryId:", entryId);
            console.log("isEditMode:", isEditMode);
            console.log("Payment Mode:", transaction.payment_mode);
            console.log("Transaction type:", transaction.payment_mode === 'petty_cash' ? "Petty Cash" : "Normal Payment");
            console.log("=== END DEBUG ===");
            const accountType = transaction.account_type?.toLowerCase();
            const groupName =
                accountType === "bank account"
                    ? "Bank Accounts"
                    : accountType === "cash account"
                        ? "Cash-in-Hand"
                        : null;

            if (!groupName) {
                throw new Error("Invalid account type. Cannot create/find group.");
            }

            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            let allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            if (!Array.isArray(allGroups) || allGroups.length === 0) {
                throw new Error("Failed to fetch or parse group list.");
            }

            let groupWrapper = allGroups.find(
                (g) => g.Group?.name?.toLowerCase() === groupName.toLowerCase()
            );
            let group = groupWrapper?.Group;

            if (!group) {
                const parentGroup = allGroups.find((g) => g.Group?.name === "Assets");
                const parentId = parentGroup?.Group?.id;
                if (!parentId) {
                    throw new Error("Cannot find parent group 'Assets'");
                }

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentId,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: {
                        ...headers,
                        "Content-Type": "application/json",
                    },
                });

                group = { id: groupResponse.data?.id, name: groupName };
                const updatedGroupsResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
                allGroups = updatedGroupsResponse.data || [];
            }

            if (!group?.id) {
                throw new Error("Failed to find or create group for ledger.");
            }

            const groupId = group.id;

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // CREDIT LEDGER (Bank/Cash account)
            const creditLedgerName = transaction.account?.name || "Unnamed Account";
            let creditLedger = allLedgers.find((l) => l.Ledger?.name === creditLedgerName);
            let creditLedgerId;

            const selectedBank = transaction.account;
            const selectedCurrencyId = transaction.transaction_currency || transaction.transaction_currency_id;

            // Find the exchange rate for the selected currency
            let bankExchangeRate = 1;
            if (selectedBank && selectedBank.exchange_rates && selectedCurrencyId) {
                // If selected currency is the base currency, rate is 1
                if (selectedCurrencyId == selectedBank.base_currency_id) {
                    bankExchangeRate = 1;
                } else {
                    // Find the exchange rate for the selected currency
                    const exchangeRateObj = selectedBank.exchange_rates.find(
                        rate => rate.currency_id == selectedCurrencyId
                    );
                    if (exchangeRateObj && exchangeRateObj.rate) {
                        bankExchangeRate = parseFloat(exchangeRateObj.rate);
                    }
                }
            }


            if (creditLedger) {
                creditLedgerId = creditLedger.Ledger.id;

                if (creditLedger.Ledger.type !== 1) {
                    const updatePayload = {
                        Ledger: {
                            id: creditLedger.Ledger.id,
                            name: creditLedger.Ledger.name,
                            group_id: creditLedger.Ledger.group_id,
                            op_balance: creditLedger.Ledger.op_balance || 0,
                            op_balance_dc: creditLedger.Ledger.op_balance_dc || "D",
                            notes: creditLedger.Ledger.notes || "",
                            type: 1,
                            code: creditLedger.Ledger.code || null,
                            reconciliation: creditLedger.Ledger.reconciliation || 0,
                        },
                    };

                    await axios.post(`${backendUrl}/ledgers/edit/${creditLedgerId}`, updatePayload, {
                        headers: {
                            ...headers,
                            "Content-Type": "application/json",
                        },
                    });
                }
            } else {
                const creditLedgerPayload = {
                    Ledger: {
                        name: creditLedgerName,
                        code: null,
                        group_id: groupId,
                        op_balance: (transaction.account?.opening_balance || 0) * bankExchangeRate,
                        op_balance_dc: "D",
                        notes: "",
                        type: 1,
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, creditLedgerPayload, { headers });
                    creditLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
                } catch (err) {
                    const isDuplicate = err.response?.data?.errors?.name?.includes("Ledger name is already in use");
                    if (isDuplicate) {
                        const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        const existing = refreshLedgers.data?.data?.find(
                            (l) => l.Ledger?.name === creditLedgerName
                        );
                        creditLedgerId = existing?.Ledger?.id;
                        if (!creditLedgerId) {
                            throw new Error("Ledger exists but ID not found.");
                        }
                    } else {
                        showToast("? Failed to add credit ledger.");
                        return;
                    }
                }
            }




            if (
                transaction.payment_mode === 'petty_cash' &&
                Array.isArray(transaction.bills) &&
                transaction.bills.length > 0
            ) {
                console.log("? Petty Cash block entered - Processing", transaction.bills.length, "bills");

                try {
                    // ? ACCUMULATE TOTALS for ALL bills
                    let totalInvoiceAED = 0;
                    let totalPaymentAED = 0;
                    let totalExchangeGain = 0;
                    let totalExchangeLoss = 0;
                    const billDetails = [];
                    let userLoanLedgerId = null;
                    let userLoanLedgerName = "";

                    // ========== SEQUENTIAL PAYMENT LOGIC ==========
                    // First, sort bills in the order they should be paid
                    const sortedBills = [...transaction.bills].sort((a, b) => {
                        // Sort by:
                        // 1. Date (oldest first)
                        // 2. Amount (smallest first) 
                        // 3. Or any other priority logic
                        return new Date(a.date || 0) - new Date(b.date || 0) ||
                            parseFloat(a.amount || 0) - parseFloat(b.amount || 0);
                    });

                    // CRITICAL: Include BOTH cash and advance in total payment available
                    const cashAmount = parseFloat(transaction.amount || 0);
                    const appliedAdvance = parseFloat(transaction.applied_advance || transaction.applied_amount || 0);
                    let remainingPayment = cashAmount + appliedAdvance;

                    console.log('💰 Starting bill payment allocation:', {
                        cashAmount,
                        appliedAdvance,
                        totalAvailablePayment: remainingPayment,
                        numberOfBills: sortedBills.length
                    });

                    // Process bills in sequence
                    for (const bill of sortedBills) {
                        if (remainingPayment <= 0) break; // No more money to pay

                        // CRITICAL FIX: Proper bill identification
                        let matchedExpense = null;
                        const billId = bill.value || bill.id;
                        const billIdentifier = bill.identifier || bill.invoice_no;

                        console.log("?? Looking for expense for bill:", {
                            billId,
                            billIdentifier,
                            bill: bill
                        });

                        // Strategy 1: Try to find by expense ID in selectedUserExpenses
                        if (billId) {
                            matchedExpense = selectedUserExpenses?.find(exp =>
                                exp.id?.toString() === billId?.toString()
                            );

                            // Also check in selectedVendorExpenses as fallback
                            if (!matchedExpense) {
                                matchedExpense = selectedVendorExpenses?.find(exp =>
                                    exp.id?.toString() === billId?.toString()
                                );
                            }
                        }

                        // Strategy 2: Try by identifier/invoice_no
                        if (!matchedExpense && billIdentifier) {
                            matchedExpense = selectedUserExpenses?.find(exp =>
                                exp.invoice_no?.toString() === billIdentifier?.toString() ||
                                exp.narration?.toLowerCase() === billIdentifier?.toLowerCase()
                            );

                            if (!matchedExpense) {
                                matchedExpense = selectedVendorExpenses?.find(exp =>
                                    exp.invoice_no?.toString() === billIdentifier?.toString() ||
                                    exp.narration?.toLowerCase() === billIdentifier?.toLowerCase()
                                );
                            }
                        }

                        // Strategy 3: Try by expense_type_id
                        if (!matchedExpense && bill.expense_type_id) {
                            matchedExpense = selectedUserExpenses?.find(exp =>
                                exp.expense_type_id?.toString() === bill.expense_type_id?.toString()
                            );

                            if (!matchedExpense) {
                                matchedExpense = selectedVendorExpenses?.find(exp =>
                                    exp.expense_type_id?.toString() === bill.expense_type_id?.toString()
                                );
                            }
                        }

                        // DEBUG: Log what we found
                        if (matchedExpense) {
                            console.log("? Found matching expense:", {
                                billId: bill.value,
                                expenseId: matchedExpense.id,
                                expenseType: matchedExpense.expense_type?.name,
                                narration: matchedExpense.narration,
                                vendor_currency: matchedExpense.vendor_currency
                            });
                        } else {
                            console.error("? Could not match expense for bill:", {
                                billValue: bill.value,
                                billId: billId,
                                billIdentifier: billIdentifier,
                                expense_type_id: bill.expense_type_id,
                                amount: bill.amount,
                                availableUserExpenses: selectedUserExpenses?.map(exp => ({
                                    id: exp.id,
                                    invoice_no: exp.invoice_no,
                                    expense_type_id: exp.expense_type_id,
                                    expense_type_name: exp.expense_type?.name,
                                    narration: exp.narration,
                                    amount: exp.amount,
                                    vendor_currency: exp.vendor_currency
                                })),
                                availableVendorExpenses: selectedVendorExpenses?.map(exp => ({
                                    id: exp.id,
                                    invoice_no: exp.invoice_no,
                                    expense_type_id: exp.expense_type_id,
                                    expense_type_name: exp.expense_type?.name,
                                    narration: exp.narration,
                                    amount: exp.amount,
                                    vendor_currency: exp.vendor_currency
                                }))
                            });

                            // If we can't match, skip this bill
                            continue;
                        }

                        userLoanLedgerName = matchedExpense.user?.name || "User Loan";

                        // Get or create user loan ledger (once)
                        if (!userLoanLedgerId) {
                            let userLoanLedger = allLedgers.find(l => l.Ledger?.name === userLoanLedgerName);
                            if (!userLoanLedger) {
                                const liabilitiesGroup = allGroups.find(g => g.Group?.name === "Loans (Liabilities)");
                                if (!liabilitiesGroup) throw new Error("'Loans (Liabilities)' group not found");

                                const response = await axios.post(`${backendUrl}/ledgers/add`, {
                                    Ledger: {
                                        name: userLoanLedgerName,
                                        group_id: liabilitiesGroup.Group.id,
                                        op_balance: 0,
                                        op_balance_dc: "C",
                                        notes: "User Loan ledger",
                                        code: null,
                                    }
                                }, { headers });

                                userLoanLedger = { Ledger: { id: response.data.data.id } };
                            }
                            userLoanLedgerId = userLoanLedger.Ledger.id;
                        }

                        // ========== CRITICAL: Calculate payment for this bill ==========
                        let paymentAmountAED = 0;
                        const billRemaining = parseFloat(bill.remaining_balance || bill.amount || matchedExpense.amount || 0);

                        // Check for bill_allocations first (created in handleAmountChange)
                        if (transaction.bill_allocations && Array.isArray(transaction.bill_allocations)) {
                            const allocation = transaction.bill_allocations.find(
                                alloc => alloc.expense_id?.toString() === bill.value?.toString() ||
                                    alloc.expense_id?.toString() === matchedExpense.id?.toString()
                            );

                            if (allocation && allocation.amount_paid) {
                                paymentAmountAED = parseFloat(allocation.amount_paid);
                                console.log('? Using pre-calculated allocation:', {
                                    expenseId: bill.value,
                                    allocatedAmount: paymentAmountAED,
                                    remainingAfter: allocation.remaining_balance
                                });
                            }
                        }

                        // If no allocation, use sequential logic
                        if (paymentAmountAED <= 0) {
                            // SEQUENTIAL: Pay as much as possible of this bill
                            paymentAmountAED = Math.min(remainingPayment, billRemaining);
                            console.log('?? Sequential payment calculation:', {
                                billRemaining,
                                remainingPaymentBefore: remainingPayment,
                                paymentAmountAED,
                                willFullyPay: paymentAmountAED >= billRemaining
                            });
                        }

                        // Update remaining payment
                        remainingPayment -= paymentAmountAED;

                        // If this bill is partially paid, log it
                        if (paymentAmountAED < billRemaining) {
                            console.log(`?? Bill ${bill.identifier} partially paid: ${paymentAmountAED} of ${billRemaining}`);
                        }

                        console.log('?? Petty Cash Payment Amount:', {
                            billId: bill.identifier || bill.value,
                            originalBillAmount: bill.amount,
                            remainingBalance: bill.remaining_balance,
                            paymentAmountAED,
                            remainingPaymentAfter: remainingPayment,
                            transactionAmount: parseFloat(transaction.amount || 0)
                        });

                        // ========== USD CONVERSION HANDLING ==========
                        const isUSDVendor = matchedExpense?.vendor_currency === "USD";
                        const vendorExchangeRate = parseFloat(matchedExpense?.exchange_rate || 3.692);
                        const bankExchangeRate = parseFloat(transaction?.account?.exchange_rate || 3.692);

                        let invoiceAED = 0;
                        let paymentAED = 0;
                        let exchangeGain = 0;
                        let exchangeLoss = 0;

                        // CRITICAL: Get the original invoice amount
                        const originalInvoiceUSD = parseFloat(matchedExpense.total_amount || matchedExpense.amount || 0);

                        if (isUSDVendor) {
                            console.log('?? USD Vendor Processing - Simple & Correct');

                            // paymentAmountAED is USD amount from allocations (200, 300)
                            const paymentUSD = paymentAmountAED;

                            // Get the exchange rate to use
                            let exchangeRate = vendorExchangeRate;
                            if (transaction.transaction_currency && transaction.account?.exchange_rates) {
                                const selectedRate = transaction.account.exchange_rates.find(
                                    r => r.currency_id == transaction.transaction_currency
                                );
                                if (selectedRate?.rate) {
                                    exchangeRate = parseFloat(selectedRate.rate);
                                }
                            }

                            // Convert USD payment to AED
                            const paymentAEDValue = paymentUSD * exchangeRate; // Changed variable name

                            // For partial payment: only recognize the paid portion of the invoice
                            const paymentPercentage = paymentUSD / originalInvoiceUSD;
                            const recognizedInvoiceAED = (originalInvoiceUSD * vendorExchangeRate) * paymentPercentage;

                            // Set values
                            invoiceAED = recognizedInvoiceAED;
                            paymentAED = paymentAEDValue; // Use different variable name

                            console.log('?? Final USD Calculation:', {
                                paymentUSD,
                                exchangeRate,
                                paymentAED: paymentAEDValue,
                                originalInvoiceUSD,
                                vendorExchangeRate,
                                paymentPercentage: (paymentPercentage * 100).toFixed(1) + '%',
                                recognizedInvoiceAED
                            });

                            // Calculate exchange gain/loss if rates differ
                            if (Math.abs(exchangeRate - vendorExchangeRate) > 0.001) {
                                const diff = (originalInvoiceUSD * vendorExchangeRate * paymentPercentage) -
                                    (paymentUSD * exchangeRate);
                                if (Math.abs(diff) >= 0.01) {
                                    if (diff > 0) {
                                        exchangeGain = parseFloat(diff.toFixed(2));
                                    } else {
                                        exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                                    }
                                }
                            }

                        } else {
                            // AED vendor
                            invoiceAED = paymentAmountAED;
                            paymentAED = paymentAmountAED;
                        }
                        // ? ACCUMULATE TOTALS
                        totalInvoiceAED += invoiceAED;
                        totalPaymentAED += paymentAED;
                        totalExchangeGain += exchangeGain;
                        totalExchangeLoss += exchangeLoss;

                        billDetails.push({
                            user: userLoanLedgerName,
                            billId: bill.identifier || bill.value,
                            originalAmount: bill.amount,
                            paidAmount: paymentAmountAED,
                            remainingAfterPayment: billRemaining - paymentAmountAED,
                            currency: isUSDVendor ? 'USD' : 'AED',
                            invoiceAED,
                            paymentAED,
                            exchangeGain,
                            exchangeLoss
                        });

                        console.log("? Bill processed:", {
                            billId: bill.identifier,
                            originalBillAmount: bill.amount,
                            paidAmount: paymentAmountAED,
                            remainingAfter: billRemaining - paymentAmountAED,
                            isFullyPaid: paymentAmountAED >= billRemaining,
                            invoiceAED,
                            paymentAED,
                            exchangeGain,
                            exchangeLoss
                        });
                    }

                    // Log the sequential payment summary
                    console.log('?? SEQUENTIAL PAYMENT SUMMARY:', {
                        totalBills: transaction.bills.length,
                        totalTransactionAmount: parseFloat(transaction.amount || 0),
                        totalPaid: totalPaymentAED,
                        remainingPayment: remainingPayment,
                        totalInvoiceAED,
                        totalExchangeGain,
                        totalExchangeLoss,
                        billsPaid: billDetails.map(b => ({
                            billId: b.billId,
                            paid: b.paidAmount,
                            invoiceAmount: b.invoiceAED,
                            remaining: b.remainingAfterPayment,
                            status: b.paidAmount >= parseFloat(b.originalAmount || 0) ? 'FULL' : 'PARTIAL'
                        }))
                    });

                    // If there's any payment left unused, log it
                    if (remainingPayment > 0.01) {
                        console.warn(`?? ${remainingPayment.toFixed(2)} AED payment remaining unused!`);
                    }

                    // Add bank charges if any
                    const bankServiceCharge = parseFloat(transaction.bank_service_charge || 0);
                    const bankVatAmount = parseFloat(transaction.bank_vat_amount || 0);

                    // Note: cashAmount and appliedAdvance are already calculated earlier (line 4789-4790)
                    // totalInvoiceAED now includes the full expense amount (cash + advance)
                    // because remainingPayment was set to cashAmount + appliedAdvance

                    console.log('💰 Petty Cash Payment Breakdown:', {
                        totalInvoiceAED_fullExpense: totalInvoiceAED,
                        totalPaymentAED,
                        cashAmount,
                        appliedAdvance,
                        bankServiceCharge,
                        bankVatAmount,
                        totalPayment: cashAmount + appliedAdvance
                    });

                    // 📝 Create SINGLE consolidated journal entry
                    const entryItems = [
                        {
                            dc: "D",
                            ledger_id: userLoanLedgerId,
                            dr_amount: totalInvoiceAED.toFixed(2),  // Full expense amount (already includes advance)
                            cr_amount: null,
                        }
                    ];

                    // Credit bank account for cash portion + charges
                    if (cashAmount > 0 || bankServiceCharge > 0 || bankVatAmount > 0) {
                        const totalBankDebit = cashAmount + bankServiceCharge + bankVatAmount;
                        entryItems.push({
                            dc: "C",
                            ledger_id: creditLedgerId,
                            dr_amount: null,
                            cr_amount: totalBankDebit.toFixed(2),
                        });
                    }

                    // 🎯 CRITICAL: Handle Employee Advance Application
                    if (appliedAdvance > 0 && transaction.user_id) {
                        console.log('🔄 Processing employee advance application:', {
                            user_id: transaction.user_id,
                            appliedAdvance,
                            user_name: userLoanLedgerName
                        });

                        // Find or create a SINGLE shared Employee Advance ledger
                        const employeeAdvanceLedgerName = "Employee Advance";
                        let employeeAdvanceLedger = allLedgers.find(l => l.Ledger?.name === employeeAdvanceLedgerName);
                        let employeeAdvanceLedgerId;

                        if (!employeeAdvanceLedger) {
                            console.log('📝 Creating shared Employee Advance ledger');
                            const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets");
                            if (!currentAssetsGroup) throw new Error("'Current Assets' group not found");

                            const response = await axios.post(`${backendUrl}/ledgers/add`, {
                                Ledger: {
                                    name: employeeAdvanceLedgerName,
                                    group_id: currentAssetsGroup.Group.id,
                                    op_balance: 0,
                                    op_balance_dc: "D",
                                    notes: "Shared ledger for all employee advances",
                                    code: null,
                                }
                            }, { headers });

                            employeeAdvanceLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
                            console.log('✅ Created Employee Advance ledger with ID:', employeeAdvanceLedgerId);
                        } else {
                            employeeAdvanceLedgerId = employeeAdvanceLedger.Ledger.id;
                            console.log('✅ Found existing Employee Advance ledger with ID:', employeeAdvanceLedgerId);
                        }

                        // Credit the shared Employee Advance ledger
                        // The user_id in the entry will track which employee's advance is being used
                        entryItems.push({
                            dc: "C",
                            ledger_id: employeeAdvanceLedgerId,
                            dr_amount: null,
                            cr_amount: appliedAdvance.toFixed(2),
                        });

                        console.log('✅ Added credit entry to Employee Advance ledger:', {
                            ledger_name: employeeAdvanceLedgerName,
                            ledger_id: employeeAdvanceLedgerId,
                            amount: appliedAdvance.toFixed(2),
                            tracked_by_user_id: transaction.user_id
                        });
                    }


                    // Add bank charges entries if applicable
                    if (bankServiceCharge > 0) {
                        // Find or create Bank Charges Expense ledger
                        let bankChargeLedger = allLedgers.find(l => l.Ledger?.name === "Bank Charges");
                        let bankChargeLedgerId;

                        if (!bankChargeLedger) {
                            const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                            if (!indirectExpensesGroup) {
                                const parentExpGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group;
                                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                                    Group: {
                                        name: "Indirect Expenses",
                                        parent_id: parentExpGroup.id,
                                        code: null,
                                        affects_gross: 1,
                                    }
                                }, { headers });

                                const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                                allGroups = updatedGroups.data;
                            }

                            const indirectExpensesGroupFinal = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;

                            const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                                Ledger: {
                                    name: "Bank Charges",
                                    group_id: indirectExpensesGroupFinal.id,
                                    op_balance: 0,
                                    op_balance_dc: "D",
                                    notes: "Bank service charges and fees",
                                    code: null,
                                }
                            }, { headers });

                            bankChargeLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
                        } else {
                            bankChargeLedgerId = bankChargeLedger.Ledger.id;
                        }

                        entryItems.push({
                            dc: "D",
                            ledger_id: bankChargeLedgerId,
                            dr_amount: bankServiceCharge.toFixed(2),
                            cr_amount: null,
                        });
                    }

                    // Add VAT on bank charge entry if applicable
                    if (bankVatAmount > 0) {
                        let inputVatLedger = allLedgers.find(l => l.Ledger?.name === "Input VAT");
                        let inputVatLedgerId;

                        if (!inputVatLedger) {
                            const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                            if (!currentAssetsGroup) {
                                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                                    Group: {
                                        name: "Current Assets",
                                        parent_id: parentAssetsGroup.id,
                                        code: null,
                                        affects_gross: 0,
                                    }
                                }, { headers });

                                const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                                allGroups = updatedGroups.data;
                            }

                            const currentAssetsGroupFinal = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                            const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                                Ledger: {
                                    name: "Input VAT",
                                    group_id: currentAssetsGroupFinal.id,
                                    op_balance: 0,
                                    op_balance_dc: "D",
                                    notes: "VAT paid on purchases and expenses",
                                    code: null,
                                }
                            }, { headers });

                            inputVatLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
                        } else {
                            inputVatLedgerId = inputVatLedger.Ledger.id;
                        }

                        entryItems.push({
                            dc: "D",
                            ledger_id: inputVatLedgerId,
                            dr_amount: bankVatAmount.toFixed(2),
                            cr_amount: null,
                        });
                    }

                    // Add exchange gain/loss if applicable
                    const gainLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Gain");
                    const lossLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Loss");

                    if (totalExchangeGain > 0 && gainLedger) {
                        entryItems.push({
                            dc: "C",
                            ledger_id: gainLedger.Ledger.id,
                            dr_amount: null,
                            cr_amount: totalExchangeGain.toFixed(2)
                        });
                    }

                    if (totalExchangeLoss > 0 && lossLedger) {
                        entryItems.push({
                            dc: "D",
                            ledger_id: lossLedger.Ledger.id,
                            dr_amount: totalExchangeLoss.toFixed(2),
                            cr_amount: null
                        });
                    }

                    // Validate the entry balances
                    const drTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.dr_amount) || 0), 0);
                    const crTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.cr_amount) || 0), 0);

                    console.log('📊 All Journal Entry Items:', entryItems.map((item, idx) => ({
                        index: idx,
                        dc: item.dc,
                        ledger_id: item.ledger_id,
                        dr_amount: item.dr_amount,
                        cr_amount: item.cr_amount
                    })));

                    console.log('Petty Cash Entry Validation:', {
                        totalInvoiceAED,
                        totalPaymentAED,
                        cashAmount,
                        appliedAdvance,
                        totalExchangeGain,
                        totalExchangeLoss,
                        bankServiceCharge,
                        bankVatAmount,
                        drTotal,
                        crTotal,
                        difference: drTotal - crTotal,
                        balanced: Math.abs(drTotal - crTotal) < 0.01
                    });

                    if (Math.abs(drTotal - crTotal) > 0.01) {
                        throw new Error(`Petty cash entry doesn't balance! DR: ${drTotal}, CR: ${crTotal}, Diff: ${drTotal - crTotal}`);
                    }

                    // Create consolidated narration
                    const billSummary = billDetails.map(b =>
                        `${b.billId} (${formatCurrency(b.invoiceAED)} - ${b.currency})`
                    ).join(', ');

                    if (isEditMode) {
                        // UPDATE existing petty cash entry
                        const updatePayload = {
                            Entry: {
                                id: transaction.entry_id,
                                tag_id: null,
                                date: transaction.date,
                                number: Date.now(),
                                narration: transaction.description || `Petty Cash Payment for multiple expenses`,
                                reference_no: transaction.reference_no || '',
                                project_id: transaction.project_id || null,
                                client_id: transaction.client_id || null,
                                user_id: transaction.user_id || null,
                                journal_id: transaction.journal_id || null,
                                is_import: true,
                            },
                            Entryitem: entryItems,
                        };

                        console.log("?? Updating petty cash journal entry:", updatePayload);
                        const response = await axios.post(`${backendUrl}/entries/edit/payment/${transaction.entry_id}`, updatePayload, { headers });

                        if (response.data?.status === 'error') {
                            throw new Error(response.data.message || "Petty cash update failed.");
                        }

                        console.log("? Petty Cash Transaction Updated!");
                        return {
                            journal_id: transaction.journal_id,
                            entry_id: transaction.entry_id,
                        };
                    } else {
                        // CREATE new petty cash entry
                        const payload = {
                            Entry: {
                                number: Date.now() || 12 || 12222 || 1,

                                tag_id: null,
                                date: transaction.date,
                                narration: transaction.description || `Petty Cash Payment for multiple expenses`,
                                reference_no: transaction.reference_no || '',
                                project_id: transaction.project_id || null,
                                client_id: transaction.client_id || null,
                                user_id: transaction.user_id || null,
                                journal_id: null,
                                is_import: true,
                            },
                            Entryitem: entryItems,
                        };

                        const response = await axios.post(`${backendUrl}/entries/add/payment`, payload, { headers });
                        const entryId = response.data?.entry_id || response.data?.entry_id;

                        showToast("? Petty Cash Transaction Added!", "success");
                        return {
                            journal_id: null,
                            entry_id: entryId,
                        };
                    }

                } catch (error) {
                    console.error("Error in petty cash processing:", error);
                    showToast(`? Failed: ${error.message}`);
                }
                return;
            }

            // NORMAL PAYMENT ENTRY (for bank / cash payments) - FIXED FOR MULTIPLE BILLS
            if (!Array.isArray(selectedVendorExpenses)) {
                showToast("? selectedVendorExpenses is not an array.");
                return;
            }

            // ? Check if we have multiple bills
            if (!transaction.bills || !Array.isArray(transaction.bills) || transaction.bills.length === 0) {
                throw new Error("No bills found in transaction.");
            }

            console.log("Processing vendor payment with", transaction.bills.length, "bills");

            // ? ACCUMULATE TOTALS for ALL bills
            let totalInvoiceAED = 0;
            let totalPaymentAED = 0;
            let totalExchangeGain = 0;
            let totalExchangeLoss = 0;
            const billDetails = [];
            let debitLedgerId = null;
            let debitLedgerName = "";
            let debitLedgerGroupName = "";
            let firstMatchedExpense = null;

            // // // Process each bill
            // for (const bill of transaction.bills) {
            //     const billNo = bill?.value || bill?.label || bill?.identifier;
            //     let matchedExpense = null;

            //     console.log("Processing bill:", billNo, bill);

            //     if (billNo) {
            //         // Try to find by invoice_no first
            //         matchedExpense = selectedVendorExpenses.find(
            //             (exp) => exp.invoice_no === billNo
            //         );

            //         // If not found by invoice_no, try by ID
            //         if (!matchedExpense && bill.value) {
            //             matchedExpense = selectedVendorExpenses.find(
            //                 (exp) => exp.id?.toString() === bill.value?.toString()
            //             );
            //         }

            //         // If still not found, try by expense type name
            //         if (!matchedExpense) {
            //             matchedExpense = selectedVendorExpenses.find(
            //                 (exp) => exp.expense_type?.name === billNo
            //             );
            //         }
            //     }

            //     // For "No Invoice" cases
            //     if (!matchedExpense && bill?.label?.includes("No Invoice")) {
            //         const expenseTypeName = bill.label.split('-')[0]?.trim();
            //         if (expenseTypeName) {
            //             matchedExpense = selectedVendorExpenses.find(
            //                 (exp) => exp.expense_type?.name === expenseTypeName
            //             );
            //         }
            //     }

            //     // Try by expense ID
            //     if (!matchedExpense && transaction.expense_id) {
            //         matchedExpense = selectedVendorExpenses.find(
            //             (exp) => exp.id?.toString() === transaction.expense_id?.toString()
            //         );
            //     }

            //     if (!matchedExpense) {
            //         console.warn(`Could not match expense for bill: ${billNo}`);
            //         continue;
            //     }

            //     // Save first matched expense for reference
            //     if (!firstMatchedExpense) {
            //         firstMatchedExpense = matchedExpense;
            //     }
            for (const bill of transaction.bills) {
                const billNo = bill?.value || bill?.label || bill?.identifier;
                let matchedExpense = null;

                console.log("Processing bill:", billNo, bill);

                if (billNo) {
                    // Try to find by invoice_no first
                    matchedExpense = selectedVendorExpenses.find(
                        (exp) => exp.invoice_no === billNo
                    );

                    // If not found by invoice_no, try by ID
                    if (!matchedExpense && bill.value) {
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => exp.id?.toString() === bill.value?.toString()
                        );
                    }

                    // If still not found, try by expense type ID
                    if (!matchedExpense && bill.expense_type_id) {
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => exp.expense_type_id?.toString() === bill.expense_type_id?.toString()
                        );
                    }

                    // If still not found, try by expense type name
                    if (!matchedExpense && bill.expense_type_name) {
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => exp.expense_type?.name?.toLowerCase() === bill.expense_type_name?.toLowerCase()
                        );
                    }
                }

                // For "No Invoice" cases - IMPROVED VERSION
                if (!matchedExpense && bill?.label?.includes("No Invoice")) {
                    console.log("Trying to match 'No Invoice' bill:", bill.label);

                    // Method 1: Try to extract expense type name more robustly
                    const label = bill.label;
                    const expenseTypeMatch = label.match(/^(.*?)\s*-\s*No Invoice/);

                    if (expenseTypeMatch && expenseTypeMatch[1]) {
                        const expenseTypeName = expenseTypeMatch[1].trim();
                        console.log("Extracted expense type name:", expenseTypeName);

                        // Try case-insensitive matching
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => exp.expense_type?.name?.toLowerCase().includes(expenseTypeName.toLowerCase()) ||
                                expenseTypeName.toLowerCase().includes(exp.expense_type?.name?.toLowerCase())
                        );
                    }

                    // Method 2: If still not found, try by expense type ID
                    if (!matchedExpense && bill.expense_type_id) {
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => exp.expense_type_id?.toString() === bill.expense_type_id?.toString()
                        );
                    }

                    // Method 3: If still not found, try by amount
                    if (!matchedExpense && bill.amount) {
                        const billAmount = parseFloat(bill.amount);
                        matchedExpense = selectedVendorExpenses.find(
                            (exp) => Math.abs(parseFloat(exp.amount || exp.total_amount || 0) - billAmount) < 0.01
                        );
                    }
                }

                // Try by expense ID as fallback
                if (!matchedExpense && transaction.expense_id) {
                    matchedExpense = selectedVendorExpenses.find(
                        (exp) => exp.id?.toString() === transaction.expense_id?.toString()
                    );
                }

                // DEBUG LOGGING
                if (!matchedExpense) {
                    console.warn(`Could not match expense for bill:`, {
                        billNo,
                        billLabel: bill?.label,
                        billValue: bill?.value,
                        expense_type_id: bill?.expense_type_id,
                        expense_type_name: bill?.expense_type_name,
                        amount: bill?.amount,
                        availableExpenses: selectedVendorExpenses.map(exp => ({
                            id: exp.id,
                            invoice_no: exp.invoice_no,
                            expense_type_name: exp.expense_type?.name,
                            expense_type_id: exp.expense_type_id,
                            amount: exp.amount
                        }))
                    });
                    continue;
                } else {
                    console.log("Successfully matched expense:", {
                        billNo,
                        matchedExpenseId: matchedExpense.id,
                        matchedInvoiceNo: matchedExpense.invoice_no,
                        matchedExpenseType: matchedExpense.expense_type?.name,
                        matchedAmount: matchedExpense.amount
                    });
                }


                // Set ledger info from the first matched expense
                if (!debitLedgerId) {
                    if (matchedExpense.vendor && matchedExpense.user) {
                        debitLedgerName = matchedExpense.user.name;
                        debitLedgerGroupName = "Loans (Liabilities)";
                    } else if (matchedExpense.vendor) {
                        debitLedgerName = matchedExpense.vendor.name;
                        debitLedgerGroupName = "Sundry Creditors (Vendors)";
                    } else if (matchedExpense.user) {
                        debitLedgerName = matchedExpense.user.name;
                        debitLedgerGroupName = "Loans (Liabilities)";
                    } else {
                        console.warn("Neither vendor nor user found in matched expense:", matchedExpense);
                        continue;
                    }

                    // Find or create the debit ledger group
                    let debitGroup = allGroups.find(g => g.Group?.name === debitLedgerGroupName)?.Group;
                    if (!debitGroup) {
                        const parentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
                        if (!parentLiabilitiesGroup) {
                            throw new Error("'Liabilities and Owners Equity' group not found.");
                        }

                        const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                            Group: {
                                name: debitLedgerGroupName,
                                parent_id: parentLiabilitiesGroup.id,
                                affect_gross: 0,
                                code: null
                            }
                        }, { headers });

                        // Refresh groups and find the new group
                        const groupRes2 = await axios.get(`${backendUrl}/groups/index`, { headers });
                        allGroups = groupRes2.data;
                        debitGroup = allGroups.find(g => g.Group?.id == groupRes.data?.id)?.Group;

                        if (!debitGroup) {
                            throw new Error(`Could not find newly created group: ${debitLedgerGroupName}`);
                        }
                    }

                    // Find or create the debit ledger
                    let debitLedger = allLedgers.find(l => l.Ledger?.name === debitLedgerName);
                    if (debitLedger) {
                        debitLedgerId = debitLedger.Ledger.id;
                    } else {
                        try {
                            const res = await axios.post(`${backendUrl}/ledgers/add`, {
                                Ledger: {
                                    name: debitLedgerName,
                                    group_id: debitGroup.id,
                                    op_balance: 0,
                                    op_balance_dc: "C",
                                    notes: "",
                                    code: null,
                                    type: 0,
                                    reconciliation: 0,
                                }
                            }, { headers });
                            debitLedgerId = res.data?.data?.Ledger?.id || res.data?.data?.id;
                        } catch (err) {
                            if (err.response?.data?.errors?.name?.includes("Ledger name is already in use")) {
                                const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                                const existing = refresh.data?.data?.find(l => l.Ledger?.name === debitLedgerName);
                                debitLedgerId = existing?.Ledger?.id;
                            } else {
                                throw err;
                            }
                        }
                    }
                }

                // Calculate amounts for this bill
                // const transactionAmount = parseFloat(transaction.base_amount || transaction.amount || bill.amount || 0);
                const transactionAmount = parseFloat(transaction.base_amount || transaction.converted_amount || transaction.amount || bill.amount || 0);

                // const isUSDVendor = matchedExpense?.vendor_currency === "USD";
                // const invoiceUSD = parseFloat(matchedExpense.amount || matchedExpense.total_amount || 0);
                const transactionUSD = parseFloat(transaction.amount || bill.amount || 0);
                const paymentExchangeRate = parseFloat(transaction?.account?.exchange_rate || 3.67);
                // const invoiceExchangeRate = parseFloat(matchedExpense?.exchange_rate || 3.67);

                let invoiceAED = 0;
                let paymentAED = 0;
                let exchangeGain = 0;
                let exchangeLoss = 0;

                // if (isUSDVendor) {
                //     invoiceAED = invoiceUSD * invoiceExchangeRate;
                //     paymentAED = transactionUSD * paymentExchangeRate;
                //     const diff = invoiceAED - paymentAED;

                //     if (Math.abs(diff) >= 0.01) {
                //         if (diff > 0) {
                //             exchangeGain = parseFloat(diff.toFixed(2));
                //         } else {
                //             exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //         }
                //     }
                // } else {
                //     invoiceAED = parseFloat(transactionAmount || 0);
                //     paymentAED = invoiceAED;
                // }
                // if (isUSDVendor) {
                //     const originalExchangeRate = parseFloat(matchedExpense?.exchange_rate || 3.67);
                //     const paymentExchangeRate = parseFloat(transaction.exchange_rate || originalExchangeRate);

                //     // If exchange rates differ, calculate gain/loss
                //     if (Math.abs(originalExchangeRate - paymentExchangeRate) > 0.0001) {
                //         const originalAED = (parseFloat(matchedExpense.amount || matchedExpense.total_amount || 0) * originalExchangeRate);
                //         const paidAED = transactionAmount;
                //         const diff = originalAED - paidAED;

                //         if (Math.abs(diff) >= 0.01) {
                //             if (diff > 0) {
                //                 exchangeGain = parseFloat(diff.toFixed(2));
                //             } else {
                //                 exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //             }
                //         }
                //     }
                // } else {
                //     invoiceAED = parseFloat(transactionAmount || 0);
                //     paymentAED = invoiceAED;
                // }

                // const paymentAmountAED = parseFloat(transaction.base_amount || transaction.converted_amount || transaction.amount || 0);

                // const isUSDVendor = matchedExpense?.vendor_currency === "USD";
                // const invoiceUSD = parseFloat(matchedExpense.amount || matchedExpense.total_amount || 0);
                // const invoiceExchangeRate = parseFloat(matchedExpense?.exchange_rate || 3.67);
                // console.log('ISUSD',isUSDVendor);


                // if (isUSDVendor) {
                //     // Convert invoice from USD to AED
                //     invoiceAED = invoiceUSD * invoiceExchangeRate;

                //     // Payment is already in AED (converted in frontend)
                //     paymentAED = paymentAmountAED;

                //     // Calculate exchange difference
                //     const diff = invoiceAED - paymentAED;

                //     console.log("DEBUG - USD Vendor Calculation:", {
                //         invoiceUSD,
                //         invoiceExchangeRate,
                //         invoiceAED,
                //         paymentAmountAED,
                //         paymentAED,
                //         diff
                //     });

                //     if (Math.abs(diff) >= 0.01) {
                //         if (diff > 0) {
                //             exchangeGain = parseFloat(diff.toFixed(2));
                //         } else {
                //             exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //         }
                //     }
                // } else {
                //     // For AED vendors, amounts are the same
                //     invoiceAED = paymentAmountAED;
                //     paymentAED = paymentAmountAED;
                // }
                // // ? ACCUMULATE TOTALS
                // totalInvoiceAED += invoiceAED;
                // totalPaymentAED += paymentAED;
                // NEW CODE (CORRECT) - Replace the above section with this:
                // NEW CODE (CORRECTED) - Replace the section with this:
                const isUSDVendor = matchedExpense?.vendor_currency === "USD";
                const invoiceUSD = parseFloat(matchedExpense.amount || matchedExpense.total_amount || 0);
                let vendorExchangeRate = parseFloat(matchedExpense?.exchange_rate || 3.692);
                console.log('vendorexchnage', vendorExchangeRate);

                // Get transaction amount in whatever currency user selected

                console.log('DEBUG - Input values:', {
                    isUSDVendor,
                    invoiceUSD,
                    vendorExchangeRate,
                    transactionAmount,
                    transactionCurrencyId: formData.transaction_currency_id,
                    bankBaseCurrencyId: selectedBank.base_currency_id,
                    isTransactionInBaseCurrency: formData.transaction_currency_id == selectedBank.base_currency_id
                });


                // if (isUSDVendor) {
                //     // IMPORTANT: Check what transactionAmount represents
                //     console.log('CHECK - What is transactionAmount?', {
                //         transactionAmount,
                //         transactionCurrencyId: formData.transaction_currency_id,
                //         bankBaseCurrencyId: selectedBank.base_currency_id,
                //         amount: transaction.amount, // Original entered amount
                //         converted_amount: transaction.converted_amount,
                //         base_amount: transaction.base_amount
                //     });

                //     // Check if transactionAmount is already in AED
                //     if (formData.transaction_currency_id == selectedBank.base_currency_id) {
                //         // transactionAmount is already in AED
                //         invoiceAED = transactionAmount; // 733.96 AED
                //         paymentAED = transactionAmount; // 733.96 AED

                //         // Calculate what this is in USD
                //         const paidUSD = transactionAmount / vendorExchangeRate; // 733.96 ÷ 3.67 = 200 USD
                //         console.log('Payment already in AED:', { paidUSD, invoiceAED });
                //     } else {
                //         // User selected USD currency, but amount might already be converted

                //         // Check: Is transactionAmount the ORIGINAL USD amount or already converted?
                //         // Look at the original amount user entered
                //         const originalAmount = parseFloat(transaction.amount || 0); // This should be 200 USD

                //         // Use originalAmount if it exists and makes sense
                //         if (originalAmount > 0 && originalAmount !== transactionAmount) {
                //             console.log('Using original amount:', { originalAmount, transactionAmount });

                //             // originalAmount is in USD (200)
                //             // Convert to AED using bank's rate
                //             const selectedCurrencyRate = selectedBank.exchange_rates?.find(
                //                 rate => rate.currency_id == formData.transaction_currency
                //             );

                //             if (selectedCurrencyRate) {
                //                 const bankExchangeRate = parseFloat(selectedCurrencyRate.rate);
                //                 invoiceAED = originalAmount * bankExchangeRate; // 200 × 3.67 = 734 AED
                //                 paymentAED = invoiceAED;

                //                 // Calculate exchange difference
                //                 const paidAtVendorRate = originalAmount * vendorExchangeRate; // 200 × 3.67 = 734 AED
                //                 const diff = paidAtVendorRate - invoiceAED;

                //                 if (Math.abs(diff) >= 0.01) {
                //                     if (diff > 0) {
                //                         exchangeGain = parseFloat(diff.toFixed(2));
                //                     } else {
                //                         exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //                     }
                //                 }
                //             } else {
                //                 // Fallback
                //                 invoiceAED = transactionAmount;
                //                 paymentAED = transactionAmount;
                //             }
                //         } else {
                //             // transactionAmount is already AED, not USD
                //             invoiceAED = transactionAmount; // 733.96 AED
                //             paymentAED = transactionAmount; // 733.96 AED
                //         }
                //     }
                // } else {
                //     // ? AED vendor (THIS WAS MISSING)
                //     invoiceAED = parseFloat(transactionAmount || 0);
                //     paymentAED = parseFloat(transactionAmount || 0);
                // }

                // // ? ACCUMULATE TOTALS
                // totalInvoiceAED += invoiceAED;
                // totalPaymentAED += paymentAED;
                // totalExchangeGain += exchangeGain;
                // totalExchangeLoss += exchangeLoss;


                // totalExchangeGain += exchangeGain;
                // totalExchangeLoss += exchangeLoss;

                const totalTransactionAmountAED = parseFloat(transaction.base_amount || transaction.converted_amount || transaction.amount || 0);
                const totalTransactionAmountSelected = parseFloat(transaction.amount || 0);

                // CRITICAL: Calculate this bill's proportion relative to all bills in this transaction
                let proportion = 1 / (transaction.bills?.length || 1);
                const totalOfAllBillAmounts = transaction.bills.reduce((sum, b) => {
                    return sum + (parseFloat(b.amount) || parseFloat(b.original_amount) || 0);
                }, 0);

                if (totalOfAllBillAmounts > 0) {
                    proportion = (parseFloat(bill.amount) || parseFloat(bill.original_amount) || 0) / totalOfAllBillAmounts;
                }

                // The portion of the total transaction amount (in selected currency and AED) for this bill
                const billAmountAED = totalTransactionAmountAED * proportion;
                const billAmountSelected = totalTransactionAmountSelected * proportion;

                console.log("?? Bill proportional allocation:", {
                    billId: bill.value,
                    proportion: (proportion * 100).toFixed(2) + '%',
                    billAmountAED: billAmountAED.toFixed(2),
                    billAmountSelected: billAmountSelected.toFixed(2),
                    totalTransactionAED: totalTransactionAmountAED
                });



                if (isUSDVendor && selectedBank && selectedBank.exchange_rates) {
                    // Find USD exchange rate from bank
                    const usdRate = selectedBank.exchange_rates.find(
                        rate => rate.currency?.currency === "USD"
                    );
                    if (usdRate && usdRate.rate) {
                        vendorExchangeRate = parseFloat(usdRate.rate);
                        console.log("? Using bank USD exchange rate:", vendorExchangeRate);
                    } else {
                        console.log("?? Using default USD exchange rate:", vendorExchangeRate);
                    }
                }

                console.log('DEBUG - Input values:', {
                    isUSDVendor,
                    invoiceUSD,
                    vendorExchangeRate,
                    billAmountAED,
                    totalTransactionAmountAED,
                    transactionCurrencyId: formData.transaction_currency_id,
                    bankBaseCurrencyId: selectedBank.base_currency_id,
                    isTransactionInBaseCurrency: formData.transaction_currency_id == selectedBank.base_currency_id
                });


                // if (isUSDVendor) {
                //     // Calculate what the bill should be in AED based on original USD amount
                //     const originalBillUSD = parseFloat(matchedExpense.total_amount || matchedExpense.amount || 0);

                //     // What was the original invoice amount in AED?
                //     const originalInvoiceAED = originalBillUSD * vendorExchangeRate;

                //     // What are we actually paying for this bill in AED?
                //     const paidAmountAED = billAmountAED;

                //     console.log('?? USD Vendor Calculation:', {
                //         originalBillUSD,
                //         vendorExchangeRate,
                //         originalInvoiceAED,
                //         paidAmountAED,
                //         difference: originalInvoiceAED - paidAmountAED
                //     });

                //     // For USD vendors, invoice amount is based on original USD converted to AED
                //     invoiceAED = originalInvoiceAED;

                //     // Payment amount is what we're actually paying in AED
                //     paymentAED = paidAmountAED;

                //     // Calculate exchange gain/loss if there's a difference
                //     const diff = originalInvoiceAED - paidAmountAED;

                //     if (Math.abs(diff) >= 0.01) {
                //         if (diff > 0) {
                //             exchangeGain = parseFloat(diff.toFixed(2));
                //             console.log(`?? Exchange gain: ${exchangeGain} AED`);
                //         } else {
                //             exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //             console.log(`?? Exchange loss: ${exchangeLoss} AED`);
                //         }
                //     }
                // } 
                // if (isUSDVendor) {
                //     // Calculate what the bill should be in AED based on original USD amount
                //     const originalBillUSD = parseFloat(matchedExpense.total_amount || matchedExpense.amount || 0);

                //     // What was the original invoice amount in AED?
                //     const originalInvoiceAED = originalBillUSD * vendorExchangeRate;

                //     // For USD vendors, the payment should also be in AED equivalent
                //     // transactionAmount should be the AED equivalent of the USD payment
                //     let paidAmountAED = billAmountAED;

                //     // But if billAmountAED is too small (like 20,000 vs 73,400), 
                //     // we need to check if it's actually representing USD
                //     if (billAmountAED < originalInvoiceAED * 0.5) {
                //         // Suspicious! Check if this is actually USD amount, not AED
                //         console.warn("?? Suspicious payment amount. Might be in USD, not AED:", {
                //             billAmountAED,
                //             originalInvoiceAED,
                //             ratio: billAmountAED / originalInvoiceAED
                //         });

                //         // Try to get the transaction amount from the right source
                //         const transactionAmountAED = parseFloat(transaction.base_amount || transaction.converted_amount || 0);

                //         // If we have a sensible AED amount, use it
                //         if (transactionAmountAED > originalInvoiceAED * 0.5) {
                //             paidAmountAED = transactionAmountAED;
                //         } else {
                //             // Last resort: calculate from original USD
                //             paidAmountAED = originalBillUSD * paymentExchangeRate;
                //         }
                //     }

                //     console.log('?? USD Vendor Calculation:', {
                //         originalBillUSD,
                //         vendorExchangeRate,
                //         originalInvoiceAED,
                //         paidAmountAED,
                //         difference: originalInvoiceAED - paidAmountAED
                //     });

                //     // For USD vendors, invoice amount is based on original USD converted to AED
                //     invoiceAED = originalInvoiceAED;

                //     // Payment amount is what we're actually paying in AED
                //     paymentAED = paidAmountAED;

                //     // Calculate exchange gain/loss if there's a difference
                //     const diff = originalInvoiceAED - paidAmountAED;

                //     if (Math.abs(diff) >= 0.01) {
                //         if (diff > 0) {
                //             exchangeGain = parseFloat(diff.toFixed(2));
                //             console.log(`?? Exchange gain: ${exchangeGain} AED`);
                //         } else {
                //             exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                //             console.log(`?? Exchange loss: ${exchangeLoss} AED`);
                //         }
                //     }
                // }
                // In your syncWithWebzash function, find the section where you process USD vendors:

                if (isUSDVendor) {
                    // Use the proportional amount for this bill
                    const userEnteredAmount = billAmountSelected;

                    // CRITICAL: Check what currency the user entered amount is in
                    console.log('?? USD Vendor - Checking Currency:', {
                        userEnteredAmount,
                        transactionAmount: transaction.amount,
                        transactionCurrencyId: formData.transaction_currency,
                        bankBaseCurrencyId: selectedBank?.base_currency_id,
                        isTransactionInBaseCurrency: formData.transaction_currency == selectedBank?.base_currency_id,
                        transactionCurrencyName: getCurrencySymbol(formData.transaction_currency),
                        bankBaseCurrency: selectedBank?.base_currency?.currency
                    });

                    // Determine the exchange rate to use
                    let exchangeRateToUse = vendorExchangeRate; // Default to vendor's rate (3.692)

                    // If user selected a specific currency in the dropdown
                    if (formData.transaction_currency && formData.transaction_currency != selectedBank.base_currency_id) {
                        // Find the exchange rate for the selected currency
                        const selectedRate = selectedBank.exchange_rates?.find(
                            rate => rate.currency_id == formData.transaction_currency
                        );

                        if (selectedRate && selectedRate.rate) {
                            exchangeRateToUse = parseFloat(selectedRate.rate);
                            console.log('? Using selected currency exchange rate:', {
                                currencyId: formData.transaction_currency,
                                rate: exchangeRateToUse,
                                currencyName: getCurrencySymbol(formData.transaction_currency)
                            });
                        }
                    } else if (formData.transaction_currency == selectedBank.base_currency_id) {
                        // User selected AED (base currency)
                        exchangeRateToUse = 1;
                        console.log('? User selected AED directly');
                    }

                    // Calculate amounts
                    let paidAED = 0;
                    let paidUSD = 0;

                    // Check if userEnteredAmount is in USD or AED
                    const originalInvoiceUSD = parseFloat(matchedExpense.total_amount || matchedExpense.amount || 0);
                    const originalInvoiceAED = originalInvoiceUSD * vendorExchangeRate; // Vendor's original AED amount

                    console.log('?? Original Invoice:', {
                        originalInvoiceUSD,
                        vendorExchangeRate,
                        originalInvoiceAED
                    });

                    // Determine if user entered USD or AED
                    // Rule: If transaction currency is USD, amount is in USD. If AED, amount is in AED.
                    if (formData.transaction_currency && formData.transaction_currency != selectedBank.base_currency_id) {
                        // User selected a foreign currency (likely USD)
                        console.log('?? User entered foreign currency amount:', {
                            amount: userEnteredAmount,
                            currency: getCurrencySymbol(formData.transaction_currency),
                            exchangeRate: exchangeRateToUse
                        });

                        // Convert from foreign currency to AED
                        paidAED = userEnteredAmount * exchangeRateToUse;
                        paidUSD = userEnteredAmount; // Keep original USD

                        console.log('?? Conversion to AED:', {
                            foreignAmount: userEnteredAmount,
                            rate: exchangeRateToUse,
                            paidAED,
                            paidUSD
                        });
                    } else {
                        // User entered AED amount directly
                        console.log('?? User entered AED amount directly:', userEnteredAmount);
                        paidAED = userEnteredAmount;
                        paidUSD = userEnteredAmount / vendorExchangeRate; // Convert back to USD for comparison
                    }

                    console.log('?? Final USD Vendor Calculation:', {
                        originalInvoiceUSD,
                        originalInvoiceAED,
                        paidUSD,
                        paidAED,
                        difference: originalInvoiceAED - paidAED,
                        conversionRateUsed: exchangeRateToUse
                    });

                    // For USD vendors, invoice amount is based on the PORTION of USD being paid, converted at original rate
                    invoiceAED = paidUSD * vendorExchangeRate;

                    // Payment amount is what we're actually paying in AED
                    paymentAED = paidAED;

                    // Calculate exchange gain/loss if there's a difference
                    const diff = originalInvoiceAED - paidAED;

                    if (Math.abs(diff) >= 0.01) {
                        if (diff > 0) {
                            exchangeGain = parseFloat(diff.toFixed(2));
                            console.log(`?? Exchange gain: ${exchangeGain} AED`);
                        } else {
                            exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                            console.log(`?? Exchange loss: ${exchangeLoss} AED`);
                        }
                    }
                }

                else {
                    // ? AED vendor
                    invoiceAED = billAmountAED;

                    // SIMPLE FIX: For single bill, payment = transaction amount
                    if (transaction.bills.length === 1) {
                        paymentAED = parseFloat(
                            transaction.base_amount ||
                            transaction.converted_amount ||
                            transaction.amount ||
                            0
                        );
                    } else {
                        // For multiple bills, use sequential payment logic
                        const totalTransactionAED = parseFloat(
                            transaction.base_amount ||
                            transaction.converted_amount ||
                            transaction.amount ||
                            0
                        );

                        // Get total of all bill amounts
                        const totalInvoiceAED_AllBills = transaction.bills.reduce(
                            (sum, b) => sum + (parseFloat(b.amount) || parseFloat(b.original_amount) || 0),
                            0
                        );

                        if (totalInvoiceAED_AllBills > 0) {
                            // Calculate this bill's proportion
                            const thisBillAmount = parseFloat(bill.amount) || parseFloat(bill.original_amount) || invoiceAED;
                            const proportion = thisBillAmount / totalInvoiceAED_AllBills;
                            paymentAED = +(totalTransactionAED * proportion).toFixed(2);
                        } else {
                            // Distribute evenly
                            paymentAED = +(totalTransactionAED / transaction.bills.length).toFixed(2);
                        }
                    }

                    console.log("?? AED Vendor - SIMPLE Payment Calculation:", {
                        billNo,
                        invoiceAED,
                        paymentAED,
                        numberOfBills: transaction.bills.length,
                        isSingleBill: transaction.bills.length === 1
                    });
                }

                // ? ACCUMULATE TOTALS
                totalInvoiceAED += invoiceAED;
                totalPaymentAED += paymentAED;
                totalExchangeGain += exchangeGain;
                totalExchangeLoss += exchangeLoss;

                console.log("? Bill processed:", {
                    billNo,
                    originalInvoiceUSD: invoiceUSD,
                    calculatedInvoiceAED: invoiceAED,
                    paymentAED,
                    exchangeGain,
                    exchangeLoss,
                    accumulated: {
                        totalInvoiceAED,
                        totalPaymentAED,
                        totalExchangeGain,
                        totalExchangeLoss
                    }
                });
                billDetails.push({
                    billNo: billNo,
                    amount: invoiceAED,
                    vendor: debitLedgerName
                });

                console.log("Bill processed:", {
                    billNo,
                    invoiceUSD,
                    transactionUSD,
                    invoiceAED,
                    paymentAED,
                    exchangeGain,
                    exchangeLoss,
                    accumulated: {
                        totalInvoiceAED,
                        totalPaymentAED,
                        totalExchangeGain,
                        totalExchangeLoss
                    }
                });
            }

            if (billDetails.length === 0) {
                throw new Error("No valid bills could be processed.");
            }

            const bankServiceCharge = parseFloat(transaction.bank_service_charge || 0);
            const bankVatAmount = parseFloat(transaction.bank_vat_amount || 0);
            // const totalBankDebit = totalPaymentAED + bankServiceCharge + bankVatAmount;
            const totalBillPaymentAED = totalPaymentAED; // This is distributed bill amount
            const totalBankChargesAED = bankServiceCharge + bankVatAmount;
            const totalBankDebit = totalBillPaymentAED + totalBankChargesAED;

            console.log('?? Payment Breakdown:', {
                totalBillPaymentAED,
                bankServiceCharge,
                bankVatAmount,
                totalBankChargesAED,
                totalBankDebit
            });


            // ? Create SINGLE consolidated journal entry
            const entryItems = [
                {
                    dc: "D",
                    ledger_id: debitLedgerId,
                    dr_amount: totalPaymentAED.toFixed(2),
                    cr_amount: null,
                },
                {
                    dc: "C",
                    ledger_id: creditLedgerId,
                    dr_amount: null,
                    cr_amount: totalBankDebit.toFixed(2),
                }
            ];
            if (bankServiceCharge > 0) {
                // Find or create Bank Charges Expense ledger
                let bankChargeLedger = allLedgers.find(l => l.Ledger?.name === "Bank Charges");
                let bankChargeLedgerId;

                if (!bankChargeLedger) {
                    // Create under Indirect Expenses group
                    const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                    if (!indirectExpensesGroup) {
                        // Create Indirect Expenses group if it doesn't exist
                        const parentExpGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group;
                        const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                            Group: {
                                name: "Indirect Expenses",
                                parent_id: parentExpGroup.id,
                                code: null,
                                affects_gross: 1,
                            }
                        }, { headers });

                        const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                        allGroups = updatedGroups.data;
                    }

                    const indirectExpensesGroupFinal = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;

                    const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name: "Bank Charges",
                            group_id: indirectExpensesGroupFinal.id,
                            op_balance: 0,
                            op_balance_dc: "D",
                            notes: "Bank service charges and fees",
                            code: null,
                        }
                    }, { headers });

                    bankChargeLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
                } else {
                    bankChargeLedgerId = bankChargeLedger.Ledger.id;
                }

                entryItems.push({
                    dc: "D",
                    ledger_id: bankChargeLedgerId,
                    dr_amount: bankServiceCharge.toFixed(2),
                    cr_amount: null,
                });
            }

            // Add VAT on bank charge entry if applicable
            if (bankVatAmount > 0) {
                // Find or create Input VAT ledger
                let inputVatLedger = allLedgers.find(l => l.Ledger?.name === "Input VAT");
                let inputVatLedgerId;

                if (!inputVatLedger) {
                    // Create under Current Assets group
                    const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                    if (!currentAssetsGroup) {
                        // Create Current Assets group if it doesn't exist
                        const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                        const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                            Group: {
                                name: "Current Assets",
                                parent_id: parentAssetsGroup.id,
                                code: null,
                                affects_gross: 0,
                            }
                        }, { headers });

                        const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                        allGroups = updatedGroups.data;
                    }

                    const currentAssetsGroupFinal = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                    const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name: "Input VAT",
                            group_id: currentAssetsGroupFinal.id,
                            op_balance: 0,
                            op_balance_dc: "D",
                            notes: "VAT paid on purchases and expenses",
                            code: null,
                        }
                    }, { headers });

                    inputVatLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
                } else {
                    inputVatLedgerId = inputVatLedger.Ledger.id;
                }

                entryItems.push({
                    dc: "D",
                    ledger_id: inputVatLedgerId,
                    dr_amount: bankVatAmount.toFixed(2),
                    cr_amount: null,
                });
            }


            // Add exchange gain/loss if applicable
            const gainLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Gain");
            const lossLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Loss");

            if (totalExchangeGain > 0 && gainLedger) {
                entryItems.push({
                    dc: "C",
                    ledger_id: gainLedger.Ledger.id,
                    dr_amount: null,
                    cr_amount: totalExchangeGain.toFixed(2)
                });
            }

            if (totalExchangeLoss > 0 && lossLedger) {
                entryItems.push({
                    dc: "D",
                    ledger_id: lossLedger.Ledger.id,
                    dr_amount: totalExchangeLoss.toFixed(2),
                    cr_amount: null
                });
            }

            // Validate balance
            const drTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.dr_amount) || 0), 0);
            const crTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.cr_amount) || 0), 0);

            console.log('Vendor Payment Entry Validation:', {
                totalInvoiceAED,
                totalPaymentAED,
                totalExchangeGain,
                totalExchangeLoss,
                drTotal,
                crTotal,
                balanced: Math.abs(drTotal - crTotal) < 0.01,
                entryItems: entryItems.map(item => ({
                    ledger_id: item.ledger_id,
                    dc: item.dc,
                    dr: item.dr_amount,
                    cr: item.cr_amount
                }))
            });

            // if (Math.abs(drTotal - crTotal) > 0.01) {
            //     throw new Error(`Vendor payment entry doesn't balance! DR: ${drTotal.toFixed(2)}, CR: ${crTotal.toFixed(2)}, Diff: ${(drTotal - crTotal).toFixed(2)}`);
            // }

            // Create narration
            const billSummary = "bills";


            if (isEditMode) {
                // UPDATE EXISTING ENTRY
                console.log("?? Updating existing journal entry #", transaction.entry_id);

                const updatePayload = {
                    Entry: {
                        id: transaction.entry_id,
                        tag_id: null,
                        date: transaction.date,
                        number: Date.now(),
                        narration: transaction.description || `Payment for multiple expenses`,
                        reference_no: transaction.reference_no || '',
                        project_id: transaction.project_id || null,
                        client_id: transaction.client_id || null,
                        user_id: transaction.user_id || null,
                        journal_id: transaction.journal_id || null,
                        is_import: true,
                    },
                    Entryitem: entryItems
                };

                console.log("?? Update payload:", updatePayload);

                const response = await axios.post(`${backendUrl}/entries/edit/payment/${transaction.entry_id}`, updatePayload, { headers });

                if (response.data?.status === 'success') {
                    console.log("? Journal entry updated successfully");
                    showToast("Transaction Updated Successfully!", "success");

                    return {
                        journal_id: transaction.journal_id,
                        entry_id: transaction.entry_id
                    };
                } else {
                    throw new Error(response.data?.message || "Update failed");
                }

            } else {
                // CREATE NEW ENTRY
                const entryPayload = {
                    Entry: {
                        tag_id: null,
                        date: transaction.date,
                        number: Date.now(),
                        narration: transaction.description || `Payment for multiple expenses`,
                        reference_no: transaction.reference_no || '',
                        project_id: transaction.project_id || null,
                        client_id: transaction.client_id || null,
                        user_id: transaction.user_id || null,
                        journal_id: transaction.journal_id || null,
                        is_import: true
                    },
                    Entryitem: entryItems
                };

                console.log("Sending new journal entry:", entryPayload);
                const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, { headers });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Transaction failed.");
                }

                const entryId = response.data?.entry_id || response.data?.entry_id;
                const journalId = firstMatchedExpense?.journal_id || null;

                console.log("Journal entry created successfully:", { journalId, entryId });
                showToast("Vendor Transaction Added Successfully!", "success");

                return {
                    journal_id: journalId,
                    entry_id: entryId,
                };
            }

        } catch (error) {
            console.error("Error during sync:", error);
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked.'
                };
            }
            showToast(`Sync failed: ${error.message}`);
            throw error;
        }
    };

    const syncIncomeWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== INCOME TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("Transaction ID:", transaction.id);
            console.log("Transaction Currency:", transaction.transaction_currency);
            console.log("Bank:", transaction.account);
            console.log("=== END DEBUG ===");

            // Get the selected bank and its exchange rates
            const selectedBank = transaction.account;
            const selectedCurrencyId = transaction.transaction_currency || transaction.transaction_currency_id;

            // Find the exchange rate for the selected currency
            let bankExchangeRate = 1;
            if (selectedBank && selectedBank.exchange_rates && selectedCurrencyId) {
                // If selected currency is the base currency, rate is 1
                if (selectedCurrencyId == selectedBank.base_currency_id) {
                    bankExchangeRate = 1;
                } else {
                    // Find the exchange rate for the selected currency
                    const exchangeRateObj = selectedBank.exchange_rates.find(
                        rate => rate.currency_id == selectedCurrencyId
                    );
                    if (exchangeRateObj && exchangeRateObj.rate) {
                        bankExchangeRate = parseFloat(exchangeRateObj.rate);
                    }
                }
            }

            console.log("Selected Bank Exchange Rate:", bankExchangeRate);

            const accountType = transaction.account_type?.toLowerCase();
            const groupName =
                accountType === "bank account"
                    ? "Bank Accounts"
                    : accountType === "cash account"
                        ? "Cash-in-Hand"
                        : null;

            if (!groupName) throw new Error("Invalid account type. Cannot determine group.");

            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            if (!Array.isArray(allGroups) || allGroups.length === 0) {
                throw new Error("Failed to fetch group list.");
            }

            // ==== Ensure Bank/Cash Group ====
            let groupWrapper = allGroups.find(
                (g) => g.Group?.name?.toLowerCase() === groupName.toLowerCase()
            );
            let group = groupWrapper?.Group;

            if (!group) {
                const parentGroup = allGroups.find((g) => g.Group?.name === "Assets");
                const parentId = parentGroup?.Group?.id;
                if (!parentId) throw new Error("Parent group 'Assets' not found.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentId,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: {
                        ...headers,
                        "Content-Type": "application/json",
                    },
                });

                group = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const groupId = group.id;

            // ==== Ensure Credit Ledger (Bank/Cash) ====
            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            const creditLedgerName = transaction.account?.name || "Unnamed Account";
            let creditLedger = allLedgers.find((l) => l.Ledger?.name === creditLedgerName);
            let creditLedgerId;

            if (creditLedger) {
                creditLedgerId = creditLedger.Ledger.id;

                if (creditLedger.Ledger.type !== 1) {
                    const updatePayload = {
                        Ledger: {
                            id: creditLedger.Ledger.id,
                            name: creditLedger.Ledger.name,
                            group_id: creditLedger.Ledger.group_id,
                            op_balance: creditLedger.Ledger.op_balance || 0,
                            op_balance_dc: creditLedger.Ledger.op_balance_dc || "D",
                            notes: creditLedger.Ledger.notes || "",
                            type: 1,
                            code: creditLedger.Ledger.code || null,
                            reconciliation: creditLedger.Ledger.reconciliation || 0,
                        },
                    };

                    await axios.post(`${backendUrl}/ledgers/edit/${creditLedgerId}`, updatePayload, {
                        headers: {
                            ...headers,
                            "Content-Type": "application/json",
                        },
                    });
                }
            } else {
                const creditLedgerPayload = {
                    Ledger: {
                        name: creditLedgerName,
                        code: null,
                        group_id: groupId,
                        op_balance: (transaction.account?.opening_balance || 0) * bankExchangeRate,
                        op_balance_dc: "D",
                        notes: "",
                        type: 1,
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, creditLedgerPayload, { headers });
                    creditLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    const isDuplicate = err.response?.data?.errors?.name?.includes("Ledger name is already in use");
                    if (isDuplicate) {
                        const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        const existing = refreshLedgers.data?.data?.find(
                            (l) => l.Ledger?.name === creditLedgerName
                        );
                        creditLedgerId = existing?.Ledger?.id;
                    } else {
                        throw new Error("Failed to add/find bank ledger.");
                    }
                }
            }

            // ==== Ensure Client Ledger (Accounts Receivable) ====
            const receivablesGroupName = "Accounts Receivable";
            let receivablesGroup = allGroups.find((g) => g.Group?.name === receivablesGroupName)?.Group;

            if (!receivablesGroup) {
                const parentAssets = allGroups.find((g) => g.Group?.name === "Assets")?.Group?.id;
                if (!parentAssets) throw new Error("Cannot find 'Assets' group for receivables.");

                const groupPayload = {
                    Group: {
                        name: receivablesGroupName,
                        parent_id: parentAssets,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: {
                        ...headers,
                        "Content-Type": "application/json",
                    },
                });

                receivablesGroup = {
                    id: groupResponse.data?.id,
                    name: receivablesGroupName,
                };
            }

            const receivablesGroupId = receivablesGroup.id;

            const clientName = transaction.client?.name || "Unnamed Client";
            let clientLedger = allLedgers.find((l) => l.Ledger?.name === clientName);
            let clientLedgerId;

            if (clientLedger) {
                clientLedgerId = clientLedger.Ledger.id;
            } else {
                const clientLedgerPayload = {
                    Ledger: {
                        name: clientName,
                        code: null,
                        group_id: receivablesGroupId,
                        op_balance: 0,
                        op_balance_dc: "C",
                        notes: "",
                        type: 0,
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, clientLedgerPayload, { headers });
                    clientLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    const isDuplicate = err.response?.data?.errors?.name?.includes("Ledger name is already in use");
                    if (isDuplicate) {
                        const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        const existing = refreshLedgers.data?.data?.find((l) => l.Ledger?.name === clientName);
                        clientLedgerId = existing?.Ledger?.id;
                    } else {
                        showToast("? Failed to add/find client ledger.");
                        return;
                    }
                }
            }


            // ==== Ensure Bank Charges Ledger ====
            const indirectExpGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
            let indirectExpGroupId = indirectExpGroup?.id;

            if (!indirectExpGroupId) {
                const parentExpGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group?.id;
                if (!parentExpGroup) throw new Error("Cannot find 'Expenses' group for indirect expenses.");

                const bankChargeGroupPayload = {
                    Group: {
                        name: "Indirect Expenses",
                        parent_id: parentExpGroup,
                        code: null,
                        affects_gross: 1,
                    },
                };

                const groupRes = await axios.post(`${backendUrl}/groups/add`, bankChargeGroupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });
                indirectExpGroupId = groupRes.data?.id;
            }

            let bankChargeLedger = allLedgers.find(l => l.Ledger?.name === "Bank Charges");
            let bankChargeLedgerId;

            if (!bankChargeLedger) {
                const payload = {
                    Ledger: {
                        name: "Bank Charges",
                        code: null,
                        group_id: indirectExpGroupId,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Auto-generated for client deductions",
                        type: 0,
                    },
                };

                const res = await axios.post(`${backendUrl}/ledgers/add`, payload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });
                bankChargeLedgerId = res.data?.data?.Ledger?.id;
            } else {
                bankChargeLedgerId = bankChargeLedger.Ledger.id;
            }

            // ==== Ensure Customer Advance Ledger ====
            let advanceLedger = allLedgers.find(l => l.Ledger?.name === "Customer Advance");
            let advanceLedgerId;

            if (!advanceLedger) {
                const liabilitiesGroup = allGroups.find(g => g.Group?.name === "Current Liabilities");
                if (!liabilitiesGroup) throw new Error("Cannot find 'Liabilities' group for Customer Advance.");

                const payload = {
                    Ledger: {
                        name: "Customer Advance",
                        code: null,
                        group_id: liabilitiesGroup.Group.id,
                        op_balance: 0,
                        op_balance_dc: "C", // CREDIT balance for liability
                        notes: "Advance payments from clients",
                        type: 0,
                    },
                };

                const res = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
                advanceLedgerId = res.data?.data?.Ledger?.id;
            } else {
                advanceLedgerId = advanceLedger.Ledger.id;
            }

            // ==== Ensure Customer Credit Ledger ====
            let customerCreditLedger = allLedgers.find(l => l.Ledger?.name === "Customer Credit");
            let customerCreditLedgerId;

            if (!customerCreditLedger) {
                const liabilitiesGroup = allGroups.find(g => g.Group?.name === "Current Liabilities");
                if (!liabilitiesGroup) throw new Error("Cannot find 'Liabilities' group for Customer Credit.");

                const payload = {
                    Ledger: {
                        name: "Customer Credit",
                        code: null,
                        group_id: liabilitiesGroup.Group.id,
                        op_balance: 0,
                        op_balance_dc: "C",
                        notes: "Credits from client credit notes",
                        type: 0,
                    },
                };

                const res = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
                customerCreditLedgerId = res.data?.data?.Ledger?.id;
            } else {
                customerCreditLedgerId = customerCreditLedger.Ledger.id;
            }


            const currency = transaction.client?.currency || "AED";
            // const bankExchangeRate = parseFloat(transaction.account?.exchange_rate || 0);

            // Get amounts from transaction
            const cashPayment = parseFloat(transaction.amount || 0); // Cash payment against invoice (e.g., 1000)
            const newAdvance = parseFloat(transaction.advance_amount || 0); // NEW advance from overpayment (e.g., 10)
            const usedAdvance = parseFloat(transaction.applied_amount || 0); // EXISTING advance used (e.g., 0)
            const usedCredit = parseFloat(transaction.credit_amount || 0); // EXISTING credit used
            let receivedAmount = parseFloat(transaction.received_amount || 0); // Full received (e.g., 1060)
            const deduction = parseFloat(transaction.deduction_amount || 0); // Deduction (e.g., 0)

            console.log('syncIncomeWithWebzash - Received amounts:', {
                cashPayment,
                newAdvance,
                usedAdvance,
                usedCredit,
                receivedAmount,
                deduction,
                currency,
                bankExchangeRate
            });

            // IMPORTANT VALIDATION: receivedAmount should equal cashPayment + newAdvance - usedAdvance + deduction
            // const calculatedReceived = cashPayment + newAdvance;
            // const calculatedReceived = cashPayment + newAdvance;
            // const calculatedReceived = cashPayment + deduction + newAdvance - usedAdvance;

            // if (Math.abs(receivedAmount - calculatedReceived) > 0.01) {
            //     console.warn('Amount mismatch - recalculating received amount');
            //     // Recalculate to ensure consistency
            //     receivedAmount = calculatedReceived;
            // }
            const calculatedReceived = cashPayment + newAdvance + deduction + usedAdvance;

            if (Math.abs(receivedAmount - calculatedReceived) > 0.01) {
                console.warn('Amount mismatch - recalculating received amount');
                // Recalculate to ensure consistency
                receivedAmount = calculatedReceived;
            }

            // Convert to AED if needed
            let cashPaymentAED = cashPayment;
            let newAdvanceAED = newAdvance;
            let usedAdvanceAED = usedAdvance;
            let usedCreditAED = usedCredit;
            let receivedAmountAED = receivedAmount;
            let deductionAED = deduction;

            if (currency !== "AED" && bankExchangeRate > 0) {
                cashPaymentAED = cashPayment * bankExchangeRate;
                newAdvanceAED = newAdvance * bankExchangeRate;
                usedAdvanceAED = usedAdvance * bankExchangeRate;
                usedCreditAED = usedCredit * bankExchangeRate;
                receivedAmountAED = receivedAmount * bankExchangeRate;
                deductionAED = deduction * bankExchangeRate;
            }

            console.log('syncIncomeWithWebzash - AED amounts:', {
                cashPaymentAED,
                newAdvanceAED,
                usedAdvanceAED,
                usedCreditAED,
                receivedAmountAED,
                deductionAED
            });

            // ==== CREATE JOURNAL ENTRY ITEMS ====
            const entryItems = [];
            if (isEditMode) {
                // Recalculate Bank/Cash DR only
                // New advance should NOT be created during edit
                // DR = receivedAmount - usedAdvance - deduction (ignore newAdvance)
                cashPaymentAED = receivedAmountAED - usedAdvanceAED - deductionAED;

                // Prevent creating new advance in edit mode
                newAdvanceAED = 0;
                console.log('Edit Mode Adjustments:', {
                    cashPaymentAED
                });
            }

            // 1. Debit Bank/Cash for the actual cash received
            if (parseFloat((cashPaymentAED || 0).toFixed(2)) > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: creditLedgerId,
                    dr_amount: cashPaymentAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // 2. If there's deduction, debit Bank Charges
            if (parseFloat((deductionAED || 0).toFixed(2)) > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: bankChargeLedgerId,
                    dr_amount: deductionAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // 3. If using existing advance: DEBIT Advance (reducing liability)
            // USER REQUEST: "Dr Customer Advance 19,000"
            if (parseFloat((usedAdvanceAED || 0).toFixed(2)) > 0) {
                entryItems.push({
                    dc: "D", // DEBIT to reduce advance liability
                    ledger_id: advanceLedgerId,
                    dr_amount: usedAdvanceAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // 3.1. If using existing customer credit: DEBIT Customer Credit (reducing liability)
            if (parseFloat((usedCreditAED || 0).toFixed(2)) > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: customerCreditLedgerId,
                    dr_amount: usedCreditAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // 4. Credit Client A/R for the total credit (cash payment + used advance + used credit)
            const totalClientCredit = Math.max(0, (cashPaymentAED + deductionAED + usedAdvanceAED + usedCreditAED) - newAdvanceAED);

            if (totalClientCredit && !isNaN(totalClientCredit) && parseFloat(totalClientCredit.toFixed(2)) > 0) {
                entryItems.push({
                    dc: "C",
                    ledger_id: clientLedgerId,
                    dr_amount: null,
                    cr_amount: totalClientCredit.toFixed(2),
                });
            }

            // 5. If creating NEW advance: CREDIT Advance (increasing liability)
            if (parseFloat((newAdvanceAED || 0).toFixed(2)) > 0) {

                entryItems.push({
                    dc: "C", // CREDIT to increase advance liability
                    ledger_id: advanceLedgerId,
                    dr_amount: null,
                    cr_amount: newAdvanceAED.toFixed(2), // 10
                });
            }

            // Verify the entry balances
            const drTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.dr_amount) || 0), 0);
            const crTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.cr_amount) || 0), 0);

            console.log('Journal Entry Verification:', {
                receivedAmountAED,
                cashPaymentAED,
                usedAdvanceAED,
                newAdvanceAED,
                deductionAED,
                totalClientCredit,
                drTotal,
                crTotal,
                balanced: Math.abs(drTotal - crTotal) < 0.01
            });

            if (Math.abs(drTotal - crTotal) > 0.01) {
                throw new Error(`Journal entry doesn't balance! DR: ${drTotal}, CR: ${crTotal}, Diff: ${drTotal - crTotal}`);
            }

            // ==== Create the Journal Entry ====
            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Payment received from ${clientName} - Invoice: ${transaction.invoice_id || 'Multiple'}`,
                    reference_no: transaction.reference_no || '',
                    journal_id: transaction?.invoice?.journal_id,
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('Sending journal entry:', entryPayload);

            // const res = await axios.post(`${backendUrl}/entries/add/receipt`, entryPayload, {
            //     headers: { ...headers, "Content-Type": "application/json" },
            // });

            // if (!res?.data) throw new Error("Failed to create journal entry.");

            // if (res.data?.status === 'error') {
            //     throw new Error(res.data.message || "Journal entry creation failed");
            // }

            // const journalId = transaction?.invoice?.journal_id || null;
            // const entryId = res.data?.entry_id;

            // console.log('Journal entry created successfully:', { journalId, entryId });

            // return {
            //     journal_id: journalId,
            //     entry_id: entryId
            // };
            console.log('Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing receipt
                console.log('?? Updating existing receipt entry #', entryId);

                // Add the entry ID to the payload for update
                // entryPayload.Entry.id = entryId;

                // const response = await axios.post(`${backendUrl}/entries/edit/receipt/${entryId}`, entryPayload, {
                //     headers: { ...headers, "Content-Type": "application/json" },
                // });

                // if (response.data?.status === 'error') {
                //     throw new Error(response.data.message || "Failed to update receipt entry.");
                // }
                console.log("?? Deleting old receipt entry:", entryId);

                // 1?? Delete old journal entry completely
                await axios.post(
                    `${backendUrl}/entries/delete/receipt/${entryId}`,
                    {},
                    { headers }
                );

                console.log("?? Creating new receipt entry with updated values");

                // 2?? Create new receipt entry
                const response = await axios.post(
                    `${backendUrl}/entries/add/receipt`,
                    entryPayload,
                    { headers: { ...headers, "Content-Type": "application/json" } }
                );

                if (!response?.data) {
                    throw new Error("Failed to recreate receipt entry");
                }

                console.log('? Receipt entry updated successfully');
                showToast(" Receipt Updated Successfully!", "success");

                return {
                    journal_id: transaction.journal_id || null,
                    entry_id: response.data?.entry_id,
                };
            } else {
                // CREATE new receipt
                console.log('?? Creating new receipt entry');

                const response = await axios.post(`${backendUrl}/entries/add/receipt`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (!response?.data) throw new Error("Failed to create journal entry.");

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Journal entry creation failed");
                }

                const newEntryId = response.data?.entry_id;
                const journalId = transaction?.journal_id || null;

                console.log('? New receipt entry created successfully:', { journalId, entry_id: newEntryId });
                showToast("Receipt Created Successfully!", "success");

                return {
                    journal_id: journalId,
                    entry_id: newEntryId
                };
            }

        } catch (error) {
            console.error("? Error syncing payment:", error);
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            throw new Error(error.message || "Failed to sync income transaction.");
        }
    };

    // const syncVatPayableWithWebzash = async (transaction) => {
    //     const userInfo = JSON.parse(localStorage.getItem("user-info"));
    //     const API = process.env.REACT_APP_WEBZASH_URL;
    //     const backendUrl = `${API}/api`;

    //     const headers = {
    //         "x-api-key": process.env.REACT_APP_API_KEY,
    //         Accept: "application/json",
    //     };

    //     try {
    //         const entryId = transaction.entry_id || transaction.entryId;
    //         const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

    //         console.log("=== VAT PAYABLE TRANSACTION DEBUG ===");
    //         console.log("Entry ID:", entryId);
    //         console.log("Is Edit Mode:", isEditMode);
    //         console.log("=== END DEBUG ===");

    //         // ==== 1. Get all groups and ledgers ====
    //         const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
    //         const allGroups = Array.isArray(groupListResponse.data?.data)
    //             ? groupListResponse.data.data
    //             : Array.isArray(groupListResponse.data)
    //                 ? groupListResponse.data
    //                 : [];

    //         const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //         const allLedgers = ledgerListResponse.data?.data || [];

    //         // ==== 2. Ensure "Duties and Taxes" group exists ====
    //         const vatGroupName = "Duties and Taxes";
    //         let vatGroup = allGroups.find(g => g.Group?.name === vatGroupName)?.Group;

    //         if (!vatGroup) {
    //             const parentGroup = allGroups.find(g => g.Group?.name === "Current Liabilities")?.Group;
    //             if (!parentGroup) throw new Error("Cannot find 'Current Liabilities' group.");

    //             const groupPayload = {
    //                 Group: {
    //                     name: vatGroupName,
    //                     parent_id: parentGroup.id,
    //                     code: null,
    //                     affects_gross: 0,
    //                 },
    //             };

    //             const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             vatGroup = {
    //                 id: groupResponse.data?.id,
    //                 name: vatGroupName,
    //             };
    //         }

    //         // ==== 3. Ensure "VAT Payable" ledger exists ====
    //         const vatLedgerName = "VAT Payable";
    //         let vatLedger = allLedgers.find(l => l.Ledger?.name === vatLedgerName)?.Ledger;
    //         let vatLedgerId;

    //         if (!vatLedger) {
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: vatLedgerName,
    //                     code: null,
    //                     group_id: vatGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "C", // Liability is CREDIT
    //                     notes: `VAT Payable ledger for tax payments`,
    //                     type: 0,
    //                 },
    //             };

    //             const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //             vatLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
    //         } else {
    //             vatLedgerId = vatLedger.id;
    //         }

    //         // ==== 4. Ensure Bank/Cash ledger ====
    //         const accountType = transaction.account_type?.toLowerCase();
    //         const groupName = accountType === "bank account"
    //             ? "Bank Accounts"
    //             : accountType === "cash account"
    //                 ? "Cash-in-Hand"
    //                 : null;

    //         if (!groupName) throw new Error("Invalid account type for VAT Payable transaction.");

    //         let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

    //         if (!accountGroup) {
    //             const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
    //             if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

    //             const groupPayload = {
    //                 Group: {
    //                     name: groupName,
    //                     parent_id: parentAssetsGroup.id,
    //                     code: null,
    //                     affects_gross: 0,
    //                 },
    //             };

    //             const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             accountGroup = {
    //                 id: groupResponse.data?.id,
    //                 name: groupName,
    //             };
    //         }

    //         const accountName = transaction.account?.name || "Unnamed Account";
    //         let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
    //         let bankLedgerId;

    //         if (!bankLedger) {
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: accountName,
    //                     code: null,
    //                     group_id: accountGroup.id,
    //                     op_balance: (transaction.account?.opening_balance || 0),
    //                     op_balance_dc: "D",
    //                     notes: "",
    //                     type: 1, // Bank/Cash
    //                 },
    //             };

    //             try {
    //                 const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                 bankLedgerId = response.data?.data?.Ledger?.id;
    //             } catch (err) {
    //                 const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //                 const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
    //                 bankLedgerId = existing?.Ledger?.id;
    //             }
    //         } else {
    //             bankLedgerId = bankLedger.id;
    //         }

    //         // ==== 5. Create Journal Entry ====
    //         const amountAED = parseFloat(transaction.amount || 0) * parseFloat(transaction.account?.exchange_rate || 1);

    //         const entryItems = [
    //             {
    //                 dc: "D", // DEBIT VAT Payable (Reduce Liability)
    //                 ledger_id: vatLedgerId,
    //                 dr_amount: amountAED.toFixed(2),
    //                 cr_amount: null,
    //             },
    //             {
    //                 dc: "C", // CREDIT Bank (Reduce Asset)
    //                 ledger_id: bankLedgerId,
    //                 dr_amount: null,
    //                 cr_amount: amountAED.toFixed(2),
    //             },
    //         ];

    //         const entryPayload = {
    //             Entry: {
    //                 tag_id: null,
    //                 number: Date.now(),
    //                 date: transaction.date || new Date().toISOString().split("T")[0],
    //                 narration: transaction.description || `VAT Payment to Tax Authority`,
    //                 reference_no: transaction.reference_no || '',
    //                 vat_return_id: transaction.vat_return_id,
    //                 is_import: true,
    //             },
    //             Entryitem: entryItems,
    //         };

    //         console.log('VAT Payable Entry Payload:', entryPayload);

    //         if (isEditMode && entryId) {
    //             // UPDATE existing payment
    //             console.log('?? Updating existing VAT Payable payment entry #', entryId);
    //             entryPayload.Entry.id = entryId;

    //             const response = await axios.post(`${backendUrl}/entries/edit/payment/${entryId}`, entryPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             if (response.data?.status === 'error') {
    //                 throw new Error(response.data.message || "Failed to update VAT Payable payment entry.");
    //             }

    //             console.log('? VAT Payable payment entry updated successfully');
    //             showToast("? VAT Payment Updated Successfully!", "success");

    //             return {
    //                 journal_id: null,
    //                 entry_id: entryId,
    //             };
    //         } else {
    //             // CREATE new payment
    //             console.log('?? Creating new VAT Payable payment entry');

    //             const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             if (response.data?.status === 'error') {
    //                 throw new Error(response.data.message || "VAT Payable transaction failed.");
    //             }

    //             const newEntryId = response.data?.entry_id;

    //             console.log('? New VAT Payable payment entry created successfully:', { entry_id: newEntryId });
    //             showToast("? VAT Payment Created Successfully!", "success");

    //             return {
    //                 journal_id: null,
    //                 entry_id: newEntryId,
    //             };
    //         }

    //     } catch (error) {
    //         if (error.response?.status === 403) {
    //             return {
    //                 lockError: true,
    //                 message: error.response.data?.message || 'Financial year is locked in accounting system.'
    //             };
    //         }
    //         console.error("? Error syncing VAT Payable transaction:", error);
    //         throw new Error(error.message || "Failed to sync VAT Payable transaction.");
    //     }
    // };
    const syncVatPayableWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== VAT PAYABLE TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("Bank Service Charge:", transaction.bank_service_charge);
            console.log("Bank VAT Amount:", transaction.bank_vat_amount);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure "Duties and Taxes" group exists ====
            const vatGroupName = "Duties and Taxes";
            let vatGroup = allGroups.find(g => g.Group?.name === vatGroupName)?.Group;

            if (!vatGroup) {
                const parentGroup = allGroups.find(g => g.Group?.name === "Current Liabilities")?.Group;
                if (!parentGroup) throw new Error("Cannot find 'Current Liabilities' group.");

                const groupPayload = {
                    Group: {
                        name: vatGroupName,
                        parent_id: parentGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                vatGroup = {
                    id: groupResponse.data?.id,
                    name: vatGroupName,
                };
            }

            // ==== 3. Ensure "VAT Payable" ledger exists ====
            const vatLedgerName = "VAT Payable";
            let vatLedger = allLedgers.find(l => l.Ledger?.name === vatLedgerName)?.Ledger;
            let vatLedgerId;

            if (!vatLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: vatLedgerName,
                        code: null,
                        group_id: vatGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C", // Liability is CREDIT
                        notes: "VAT Payable ledger for tax payments",
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                vatLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                vatLedgerId = vatLedger.id;
            }

            // ==== 4. Ensure Bank/Cash ledger ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type for VAT Payable transaction.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentAssetsGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                accountGroup = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;

            if (!bankLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: accountName,
                        code: null,
                        group_id: accountGroup.id,
                        op_balance: (transaction.account?.opening_balance || 0),
                        op_balance_dc: "D",
                        notes: "",
                        type: 1, // Bank/Cash
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    bankLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                    bankLedgerId = existing?.Ledger?.id;
                }
            } else {
                bankLedgerId = bankLedger.id;
            }

            // ==== 5. Ensure Bank Charges Ledger ====
            const bankChargesLedgerName = "Bank Charges";
            let bankChargesLedger = allLedgers.find(l => l.Ledger?.name === bankChargesLedgerName)?.Ledger;
            let bankChargesLedgerId;

            if (!bankChargesLedger) {
                const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                if (!indirectExpensesGroup) {
                    const parentExpensesGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group;
                    if (!parentExpensesGroup) throw new Error("Cannot find 'Expenses' group.");

                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Indirect Expenses",
                            parent_id: parentExpensesGroup.id,
                            code: null,
                            affects_gross: 1,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const indirectExpensesGroupFinal = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: bankChargesLedgerName,
                        group_id: indirectExpensesGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Bank service charges and fees",
                        code: null,
                    }
                }, { headers });

                bankChargesLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                bankChargesLedgerId = bankChargesLedger.id;
            }

            // ==== 6. Ensure Input VAT Ledger ====
            const inputVatLedgerName = "Input VAT";
            let inputVatLedger = allLedgers.find(l => l.Ledger?.name === inputVatLedgerName)?.Ledger;
            let inputVatLedgerId;

            if (!inputVatLedger) {
                const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                if (!currentAssetsGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Current Assets",
                            parent_id: parentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const currentAssetsGroupFinal = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: inputVatLedgerName,
                        group_id: currentAssetsGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "VAT paid on purchases and expenses",
                        code: null,
                    }
                }, { headers });

                inputVatLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                inputVatLedgerId = inputVatLedger.id;
            }

            // ==== 7. Calculate amounts ====
            const vatAmountAED = parseFloat(transaction.amount || 0);
            const bankServiceChargeAED = parseFloat(transaction.bank_service_charge || 0);
            const bankVatAmountAED = parseFloat(transaction.bank_vat_amount || 0);
            const totalBankDebit = vatAmountAED + bankServiceChargeAED + bankVatAmountAED;

            console.log('VAT Payment Breakdown:', {
                vatAmountAED,
                bankServiceChargeAED,
                bankVatAmountAED,
                totalBankDebit
            });

            // ==== 8. Create Journal Entry ====
            const entryItems = [
                {
                    dc: "D", // DEBIT VAT Payable (Reduce Liability)
                    ledger_id: vatLedgerId,
                    dr_amount: vatAmountAED.toFixed(2),
                    cr_amount: null,
                }
            ];

            // Add bank service charge entry if applicable
            if (bankServiceChargeAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Bank Charges Expense
                    ledger_id: bankChargesLedgerId,
                    dr_amount: bankServiceChargeAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // Add VAT on bank charge entry if applicable
            if (bankVatAmountAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Input VAT
                    ledger_id: inputVatLedgerId,
                    dr_amount: bankVatAmountAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // Add Bank CREDIT entry
            entryItems.push({
                dc: "C", // CREDIT Bank (Reduce Asset)
                ledger_id: bankLedgerId,
                dr_amount: null,
                cr_amount: totalBankDebit.toFixed(2),
            });

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `VAT Payment to Tax Authority`,
                    reference_no: transaction.reference_no || '',
                    vat_return_id: transaction.vat_return_id,
                    bank_service_charge: transaction.bank_service_charge,
                    bank_vat_amount: transaction.bank_vat_amount,
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('VAT Payable Entry Payload:', entryPayload);

            // if (isEditMode && entryId) {
            //     // UPDATE existing payment
            //     console.log('?? Updating existing VAT Payable payment entry #', entryId);
            //     entryPayload.Entry.id = entryId;

            //     const response = await axios.post(`${backendUrl}/entries/edit/payment/${entryId}`, entryPayload, {
            //         headers: { ...headers, "Content-Type": "application/json" },
            //     });

            //     if (response.data?.status === 'error') {
            //         throw new Error(response.data.message || "Failed to update VAT Payable payment entry.");
            //     }

            //     console.log('? VAT Payable payment entry updated successfully');
            //     showToast("? VAT Payment Updated Successfully!", "success");

            //     return {
            //         journal_id: null,
            //         entry_id: entryId,
            //     };
            // } 
            console.log('Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing receipt
                console.log('?? Updating existing receipt entry #', entryId);

                // Add the entry ID to the payload for update
                // entryPayload.Entry.id = entryId;

                // const response = await axios.post(`${backendUrl}/entries/edit/receipt/${entryId}`, entryPayload, {
                //     headers: { ...headers, "Content-Type": "application/json" },
                // });

                // if (response.data?.status === 'error') {
                //     throw new Error(response.data.message || "Failed to update receipt entry.");
                // }
                console.log("?? Deleting old receipt entry:", entryId);

                // 1?? Delete old journal entry completely
                await axios.post(
                    `${backendUrl}/entries/delete/payment/${entryId}`,
                    {},
                    { headers }
                );

                console.log("?? Creating new receipt entry with updated values");

                // 2?? Create new receipt entry
                const response = await axios.post(
                    `${backendUrl}/entries/add/payment`,
                    entryPayload,
                    { headers: { ...headers, "Content-Type": "application/json" } }
                );

                if (!response?.data) {
                    throw new Error("Failed to recreate receipt entry");
                }

                console.log('? Receipt entry updated successfully');
                showToast("Receipt Updated Successfully!", "success");

                return {
                    journal_id: transaction.journal_id || null,
                    entry_id: response.data?.entry_id,
                };
            } else {
                // CREATE new payment
                console.log('?? Creating new VAT Payable payment entry');

                const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "VAT Payable transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New VAT Payable payment entry created successfully:', { entry_id: newEntryId });
                showToast(" VAT Payment Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }

        } catch (error) {
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            console.error("? Error syncing VAT Payable transaction:", error);
            throw new Error(error.message || "Failed to sync VAT Payable transaction.");
        }
    };

    const syncContraWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== CONTRA TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("From Bank ID:", transaction.from_bank_id);
            console.log("To Bank ID:", transaction.to_bank_id);
            console.log("All Banks:", allBanks); // Add this to debug
            console.log("Transaction:", transaction);
            console.log("=== END DEBUG ===");

            // Get all groups and ledgers
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // IMPORTANT FIX: Find the bank objects from the available banks
            const fromBank = allBanks.find(b => b.id.toString() === transaction.from_bank_id?.toString());
            const toBank = allBanks.find(b => b.id.toString() === transaction.to_bank_id?.toString());

            console.log("Found bank objects:", { fromBank, toBank });

            if (!fromBank) throw new Error("From account not found in bank list");
            if (!toBank) throw new Error("To account not found in bank list");

            // Function to get or create account group and ledger
            const getOrCreateAccountLedger = async (account) => {
                const accountType = account.type?.toLowerCase();
                const groupName = accountType === "bank account"
                    ? "Bank Accounts"
                    : accountType === "cash account"
                        ? "Cash-in-Hand"
                        : null;

                if (!groupName) throw new Error(`Invalid account type: ${accountType}`);

                let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

                if (!accountGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                    const groupPayload = {
                        Group: {
                            name: groupName,
                            parent_id: parentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        },
                    };

                    const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                        headers: { ...headers, "Content-Type": "application/json" },
                    });

                    accountGroup = {
                        id: groupResponse.data?.id,
                        name: groupName,
                    };
                }

                const accountName = account?.name || "Unnamed Account";
                let accountLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
                let accountLedgerId;

                if (!accountLedger) {
                    const ledgerPayload = {
                        Ledger: {
                            name: accountName,
                            code: null,
                            group_id: accountGroup.id,
                            op_balance: (account?.opening_balance || 0),
                            op_balance_dc: "D",
                            notes: "",
                            type: 1, // Bank/Cash type
                        },
                    };

                    try {
                        const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                        accountLedgerId = response.data?.data?.Ledger?.id;
                    } catch (err) {
                        const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                        accountLedgerId = existing?.Ledger?.id;
                    }
                } else {
                    accountLedgerId = accountLedger.id;
                }

                return accountLedgerId;
            };

            // Get ledger IDs for both accounts
            const fromAccountLedgerId = await getOrCreateAccountLedger(fromBank);
            const toAccountLedgerId = await getOrCreateAccountLedger(toBank);

            // ==== Ensure Bank Charges Ledger ====
            const bankChargesLedgerName = "Bank Charges";
            let bankChargesLedger = allLedgers.find(l => l.Ledger?.name === bankChargesLedgerName)?.Ledger;
            let bankChargesLedgerId;

            if (!bankChargesLedger) {
                const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                if (!indirectExpensesGroup) {
                    const parentExpensesGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group;
                    if (!parentExpensesGroup) throw new Error("Cannot find 'Expenses' group.");

                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Indirect Expenses",
                            parent_id: parentExpensesGroup.id,
                            code: null,
                            affects_gross: 1,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const indirectExpensesGroupFinal = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: bankChargesLedgerName,
                        group_id: indirectExpensesGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Bank service charges and fees",
                        code: null,
                    }
                }, { headers });

                bankChargesLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                bankChargesLedgerId = bankChargesLedger.id;
            }

            // ==== Ensure Input VAT Ledger ====
            const inputVatLedgerName = "Input VAT";
            let inputVatLedger = allLedgers.find(l => l.Ledger?.name === inputVatLedgerName)?.Ledger;
            let inputVatLedgerId;

            if (!inputVatLedger) {
                const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                if (!currentAssetsGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Current Assets",
                            parent_id: parentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const currentAssetsGroupFinal = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: inputVatLedgerName,
                        group_id: currentAssetsGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "VAT paid on purchases and expenses",
                        code: null,
                    }
                }, { headers });

                inputVatLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                inputVatLedgerId = inputVatLedger.id;
            }

            // Create Journal Entry
            const fromBankExchangeRate = parseFloat(fromBank?.exchange_rate || 1);
            const amountAED = parseFloat(transaction.amount || 0) * fromBankExchangeRate;
            const bankServiceChargeAED = parseFloat(transaction.bank_service_charge || 0) * fromBankExchangeRate;
            const bankVatAmountAED = parseFloat(transaction.bank_vat_amount || 0) * fromBankExchangeRate;
            const totalBankCreditAED = amountAED + bankServiceChargeAED + bankVatAmountAED;

            const entryItems = [
                {
                    dc: "D", // DEBIT To Account (Money going in)
                    ledger_id: toAccountLedgerId,
                    dr_amount: amountAED.toFixed(2),
                    cr_amount: null,
                }
            ];

            // Add bank service charge entry if applicable
            if (bankServiceChargeAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Bank Charges Expense
                    ledger_id: bankChargesLedgerId,
                    dr_amount: bankServiceChargeAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // Add VAT on bank charge entry if applicable
            if (bankVatAmountAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Input VAT
                    ledger_id: inputVatLedgerId,
                    dr_amount: bankVatAmountAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // CREDIT From Account (Money going out - includes charges)
            entryItems.push({
                dc: "C",
                ledger_id: fromAccountLedgerId,
                dr_amount: null,
                cr_amount: totalBankCreditAED.toFixed(2),
            });

            const narration = transaction.description ||
                `Transfer from ${fromBank?.name} to ${toBank?.name}`;

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: narration,
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('Contra Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing payment
                console.log('?? Updating existing contra payment entry #', entryId);
                entryPayload.Entry.id = entryId;

                const response = await axios.post(`${backendUrl}/entries/edit/contra/${entryId}`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Failed to update contra payment entry.");
                }

                console.log('? Contra payment entry updated successfully');
                showToast("Transfer Updated Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: entryId,
                };
            } else {
                // CREATE new payment
                console.log('?? Creating new contra payment entry');

                const response = await axios.post(`${backendUrl}/entries/add/contra`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Contra transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New contra payment entry created successfully:', { entry_id: newEntryId });
                showToast("Transfer Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }

        } catch (error) {
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            console.error("? Error syncing contra transaction:", error);
            throw new Error(error.message || "Failed to sync contra transaction.");
        }
    };
    const getDisplayName = (id, list, field = 'name') => {
        if (!id || !list) return 'N/A';
        const item = list.find(item => item.id.toString() === id.toString());
        return item ? item[field] : 'N/A';
    };
    const getExpenseDisplayInfo = (expenseId, expensesList) => {
        if (!expenseId || !expensesList || !Array.isArray(expensesList)) return null;

        const expense = expensesList.find(exp =>
            exp.id?.toString() === expenseId?.toString() ||
            exp.expense_id?.toString() === expenseId?.toString()
        );

        if (!expense) return null;

        return {
            po_number: expense.po_number || expense.invoice_no || 'N/A',
            total_amount: expense.total_amount || expense.amount || 0,
            expense_type: expense.expense_type?.name || 'N/A',
            narration: expense.narration || expense.description || '',
            vendor_name: expense.vendor?.name || expense.vendor_name || 'N/A',
            user_name: expense.user?.name || expense.user_name || 'N/A'
        };
    };

    const getExpenseTypeDisplayName = (expenseTypeId) => {
        if (!expenseTypeId || !categories || !Array.isArray(categories)) return 'N/A';
        const expenseType = categories.find(cat => cat.id?.toString() === expenseTypeId?.toString());
        return expenseType ? expenseType.name : 'N/A';
    };

    const getVendorDisplayName = (vendorId) => {
        if (!vendorId || !vendors || !Array.isArray(vendors)) return 'N/A';
        const vendor = vendors.find(v => v.id?.toString() === vendorId?.toString());
        return vendor ? vendor.name : 'N/A';
    };

    const getUserDisplayName = (userId) => {
        if (!userId || !users || !Array.isArray(users)) return 'N/A';
        const user = users.find(u => u.id?.toString() === userId?.toString());
        return user ? user.name : 'N/A';
    };

    const syncCapitalWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {

            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== CAPITAL TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure Capital Account group exists ====
            const capitalGroupName = "Capital Account";
            let capitalGroup = allGroups.find(g => g.Group?.name === capitalGroupName)?.Group;

            if (!capitalGroup) {
                const parentGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
                if (!parentGroup) throw new Error("Cannot find 'Liabilities and Owners Equity' group.");

                const groupPayload = {
                    Group: {
                        name: capitalGroupName,
                        parent_id: parentGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                capitalGroup = {
                    id: groupResponse.data?.id,
                    name: capitalGroupName,
                };
            }

            // ==== 3. Create or get Owner's Capital ledger ====
            const ownerLedgerName = "Owner's Capital";
            let ownerCapitalLedger = allLedgers.find(l => l.Ledger?.name === ownerLedgerName)?.Ledger;
            let ownerCapitalLedgerId;

            if (!ownerCapitalLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: ownerLedgerName,
                        code: null,
                        group_id: capitalGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C", // Capital is CREDIT
                        notes: `Owner's capital investment ledger`,
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                ownerCapitalLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                ownerCapitalLedgerId = ownerCapitalLedger.id;
            }

            // ==== 4. Ensure Bank/Cash ledger ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type for capital transaction.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentAssetsGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                accountGroup = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;

            if (!bankLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: accountName,
                        code: null,
                        group_id: accountGroup.id,
                        op_balance: (transaction.account?.opening_balance || 0),
                        op_balance_dc: "D",
                        notes: "",
                        type: 1, // Bank/Cash
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    bankLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    // In case ledger already exists
                    const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                    bankLedgerId = existing?.Ledger?.id;
                }
            } else {
                bankLedgerId = bankLedger.id;
            }

            // ==== 5. Create Journal Entry ====
            const amountAED = parseFloat(transaction.amount || 0) * parseFloat(transaction.account?.exchange_rate || 1);

            const entryItems = [
                {
                    dc: "D",
                    ledger_id: bankLedgerId,
                    dr_amount: amountAED.toFixed(2),
                    cr_amount: null,
                },
                {
                    dc: "C",
                    ledger_id: ownerCapitalLedgerId,
                    dr_amount: null,
                    cr_amount: amountAED.toFixed(2),
                },
            ];

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Owner's capital investment - ${transaction.owner_name}`,
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            // const response = await axios.post(`${backendUrl}/entries/add/receipt`, entryPayload, {
            //     headers: { ...headers, "Content-Type": "application/json" },
            // });

            // if (response.data?.status === 'error') {
            //     throw new Error(response.data.message || "Capital transaction failed.");
            // }

            // return {
            //     journal_id: null,
            //     entry_id: response.data?.entry_id,
            // };

            console.log('Capital Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing receipt
                console.log('?? Updating existing capital receipt entry #', entryId);

                // Add the entry ID to the payload for update
                entryPayload.Entry.id = entryId;

                const response = await axios.post(`${backendUrl}/entries/edit/receipt/${entryId}`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Failed to update capital receipt entry.");
                }

                console.log('? Capital receipt entry updated successfully');
                showToast("Capital Receipt Updated Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: entryId,
                };
            } else {
                // CREATE new receipt
                console.log('?? Creating new capital receipt entry');

                const response = await axios.post(`${backendUrl}/entries/add/receipt`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Capital transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New capital receipt entry created successfully:', { entry_id: newEntryId });
                showToast("Capital Receipt Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }


        } catch (error) {
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            console.error("? Error syncing capital transaction:", error);
            throw new Error(error.message || "Failed to sync capital transaction.");
        }
    };
    const syncWithdrawalWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {

            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== Drawing TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure Capital Account group exists ====
            const capitalGroupName = "Capital Account";
            let capitalGroup = allGroups.find(g => g.Group?.name === capitalGroupName)?.Group;

            if (!capitalGroup) {
                const parentGroup = allGroups.find(g => g.Group?.name === "Liabilities and Owners Equity")?.Group;
                if (!parentGroup) throw new Error("Cannot find 'Liabilities and Owners Equity' group.");

                const groupPayload = {
                    Group: {
                        name: capitalGroupName,
                        parent_id: parentGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                capitalGroup = {
                    id: groupResponse.data?.id,
                    name: capitalGroupName,
                };
            }

            // ==== 3. Create or get Owner's Capital ledger ====
            const ownerLedgerName = "Owners Drawings";
            let ownerCapitalLedger = allLedgers.find(l => l.Ledger?.name === ownerLedgerName)?.Ledger;
            let ownerCapitalLedgerId;

            if (!ownerCapitalLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: ownerLedgerName,
                        code: null,
                        group_id: capitalGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C", // Capital is CREDIT
                        notes: `Owner's capital withdrawel ledger`,
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                ownerCapitalLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                ownerCapitalLedgerId = ownerCapitalLedger.id;
            }

            // ==== 4. Ensure Bank/Cash ledger ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type for capital transaction.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentAssetsGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                accountGroup = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;

            if (!bankLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: accountName,
                        code: null,
                        group_id: accountGroup.id,
                        op_balance: (transaction.account?.opening_balance || 0),
                        op_balance_dc: "D",
                        notes: "",
                        type: 1, // Bank/Cash
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    bankLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    // In case ledger already exists
                    const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                    bankLedgerId = existing?.Ledger?.id;
                }
            } else {
                bankLedgerId = bankLedger.id;
            }

            // ==== Ensure Bank Charges Ledger (Same as Contra) ====
            const bankChargesLedgerName = "Bank Charges";
            let bankChargesLedger = allLedgers.find(l => l.Ledger?.name === bankChargesLedgerName)?.Ledger;
            let bankChargesLedgerId;

            if (!bankChargesLedger) {
                const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                if (!indirectExpensesGroup) {
                    const parentExpensesGroup = allGroups.find(g => g.Group?.name === "Expenses")?.Group;
                    if (!parentExpensesGroup) throw new Error("Cannot find 'Expenses' group.");

                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Indirect Expenses",
                            parent_id: parentExpensesGroup.id,
                            code: null,
                            affects_gross: 1,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const indirectExpensesGroupFinal = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: bankChargesLedgerName,
                        group_id: indirectExpensesGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "Bank service charges and fees",
                        code: null,
                    }
                }, { headers });

                bankChargesLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                bankChargesLedgerId = bankChargesLedger.id;
            }

            // ==== Ensure Input VAT Ledger (Same as Contra) ====
            const inputVatLedgerName = "Input VAT";
            let inputVatLedger = allLedgers.find(l => l.Ledger?.name === inputVatLedgerName)?.Ledger;
            let inputVatLedgerId;

            if (!inputVatLedger) {
                const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                if (!currentAssetsGroup) {
                    const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                    const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                        Group: {
                            name: "Current Assets",
                            parent_id: parentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        }
                    }, { headers });

                    const updatedGroups = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = updatedGroups.data;
                }

                const currentAssetsGroupFinal = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                const ledgerRes = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: inputVatLedgerName,
                        group_id: currentAssetsGroupFinal.id,
                        op_balance: 0,
                        op_balance_dc: "D",
                        notes: "VAT paid on purchases and expenses",
                        code: null,
                    }
                }, { headers });

                inputVatLedgerId = ledgerRes.data?.data?.Ledger?.id || ledgerRes.data?.data?.id;
            } else {
                inputVatLedgerId = inputVatLedger.id;
            }


            // ==== 5. Create Journal Entry ====
            const amountAED = parseFloat(transaction.amount || 0) * parseFloat(transaction.account?.exchange_rate || 1);

            // Check for both property styles (Withdrawal vs Contra)
            const bankChargeValue = parseFloat(transaction.bank_service_charge || transaction.bank_charge || 0);
            const vatChargeValue = parseFloat(transaction.bank_vat_amount || transaction.vat_charge || 0);

            const bankChargeAED = bankChargeValue * parseFloat(transaction.account?.exchange_rate || 1);
            const vatChargeAED = vatChargeValue * parseFloat(transaction.account?.exchange_rate || 1);

            const totalBankCreditAED = amountAED + bankChargeAED + vatChargeAED;

            const entryItems = [
                {
                    dc: "D", // DEBIT Owner's Capital
                    ledger_id: ownerCapitalLedgerId,
                    dr_amount: amountAED.toFixed(2),
                    cr_amount: null,
                }
            ];

            // Add Bank Charges entry if applicable
            if (bankChargeAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Bank Charges
                    ledger_id: bankChargesLedgerId,
                    dr_amount: bankChargeAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // Add VAT Charges entry if applicable
            if (vatChargeAED > 0) {
                entryItems.push({
                    dc: "D", // DEBIT Input VAT
                    ledger_id: inputVatLedgerId,
                    dr_amount: vatChargeAED.toFixed(2),
                    cr_amount: null,
                });
            }

            // CREDIT Bank Account (Total Amount)
            entryItems.push({
                dc: "C",
                ledger_id: bankLedgerId,
                dr_amount: null,
                cr_amount: totalBankCreditAED.toFixed(2),
            });

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Owner's capital withdrawl - ${transaction.owner_name}`,
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            // If updating, delete the old entry first
            if (isEditMode && entryId) {
                console.log(`??? Deleting existing capital withdrawal entry #${entryId} before creating new one...`);
                try {
                    await axios.post(`${backendUrl}/entries/delete/payment/${entryId}`, {}, { headers });
                    console.log(`? Deleted old entry #${entryId}`);
                } catch (delError) {
                    console.warn(`?? Failed to delete old entry #${entryId}, proceeding to create new one anyway:`, delError);
                }
            }

            console.log('?? Creating new capital payment entry');
            const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
                headers: { ...headers, "Content-Type": "application/json" },
            });

            if (response.data?.status === 'error') {
                throw new Error(response.data.message || "Capital transaction failed.");
            }

            const newEntryId = response.data?.entry_id || response.data?.data?.entry?.id;
            console.log('? Capital payment entry created successfully:', { entry_id: newEntryId });
            showToast("Capital Withdrawal Synced Successfully!", "success");


            return {
                journal_id: null,
                entry_id: newEntryId,
            };

        } catch (error) {
            console.error("? Error syncing capital transaction:", error);
            throw new Error(error.message || "Failed to sync capital transaction.");
        }
    };
    const syncBadDebtWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            // 1.Get all groups and ledgers
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data.data)
                ? groupListResponse.data.data : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data.data || [];

            const ensureGroup = async (name, parentName) => {
                let group = allGroups.find(g => g.Group.name === name).Group;
                if (!group) {
                    const parentGroup = allGroups.find(g => g.Group.name === parentName).Group;
                    if (!parentGroup) throw new Error(`Cannot find '${parentName}' group.`);
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name, parent_id: parentGroup.id, code: null, affects_gross: 0 }
                    }, { headers });
                    group = { id: res.data.id, name };
                }
                return group;
            };

            const getOrCreateLedger = async (name, groupName, parentGroupName, opBalanceDc = "D", notes = "") => {
                let ledger = allLedgers.find(l => l.Ledger.name === name).Ledger;
                if (!ledger) {
                    const group = await ensureGroup(groupName, parentGroupName);
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name, group_id: group.id, op_balance: 0,
                            op_balance_dc: opBalanceDc, notes, code: null, type: 0
                        }
                    }, { headers });
                    return res.data.data.Ledger.id || res.data.data.id;
                }
                return ledger.id;
            };

            // 2.Bad Debt Expense Ledger (Debit)
            const badDebtLedgerId = await getOrCreateLedger(
                "Bad Debt Expense",
                "Business Operation",

                "Indirect Expenses",
                "D",
                "Bad debt written off"
            );

            // 3.Client Ledger (Credit)
            const clientName = getDisplayName(transaction.client_id, clients);
            const clientLedgerId = await getOrCreateLedger(
                clientName,
                "Accounts Receivable",
                "Assets",
                "D"
            );

            // 4.Construct Journal Entry
            // Dr Bad Debt Expense
            // Cr Client
            const amount = parseFloat(transaction.amount);
            const entryItems = [
                { dc: "D", ledger_id: badDebtLedgerId, dr_amount: amount.toFixed(2), cr_amount: null },
                { dc: "C", ledger_id: clientLedgerId, dr_amount: null, cr_amount: amount.toFixed(2) }
            ];

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.transaction || transaction.description || "Bad Debt Written Off",
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems
            };

            // 5.Submit
            if (isEditMode) {
                try {
                    await axios.post(`${backendUrl}/entries/delete/${entryId}`, {}, { headers });
                } catch (e) {
                    console.warn("Could not delete old entry", e);
                }
            }

            const response = await axios.post(`${backendUrl}/entries/add/journal`, entryPayload, { headers });

            if (response.data.status === "error") {
                throw new Error(response.data.msg || "Webzash API Error");
            }

            const newEntryId = response.data.entry_id || response.data.data.entry.id;

            showToast("Bad Debt Synced Successfully!", "success");

            return {
                journal_id: newEntryId, // Journal entries act as journal_id usually
                entry_id: newEntryId,
            };

        } catch (error) {
            console.error("Ã¢ÂÅ’ Error syncing Bad Debt:", error);
            showToast(`Failed to sync Bad Debt: ${error.message}`, "error");
            throw error;
        }
    };

    const syncBankGuaranteeWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== BANK GUARANTEE TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("Amount (Guarantee):", transaction.amount);
            console.log("Commission:", transaction.commission_fee);
            console.log("Bank Charge:", transaction.bank_service_charge);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure Bank/Cash ledger (Credit Account) ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type.");
            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            // Helper to create group if missing
            const ensureGroup = async (name, parentName, affectsGross = 0) => {
                let group = allGroups.find(g => g.Group?.name === name)?.Group;
                if (!group) {
                    const parentGroup = allGroups.find(g => g.Group?.name === parentName)?.Group;
                    if (!parentGroup) throw new Error(`Cannot find '${parentName}' group.`);
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name, parent_id: parentGroup.id, code: null, affects_gross: affectsGross }
                    }, { headers });
                    group = { id: res.data?.id, name };
                }
                return group;
            };

            // Helper to get/create ledger
            const getOrCreateLedger = async (name, groupName, parentGroupName, opBalanceDc = "D", notes = "") => {
                let ledger = allLedgers.find(l => l.Ledger?.name === name)?.Ledger;
                if (!ledger) {
                    const group = await ensureGroup(groupName, parentGroupName);
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name, group_id: group.id, op_balance: 0,
                            op_balance_dc: opBalanceDc, notes, code: null, type: 0
                        }
                    }, { headers });
                    return res.data?.data?.Ledger?.id || res.data?.data?.id;
                }
                return ledger.id;
            };

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");
                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                    Group: { name: groupName, parent_id: parentAssetsGroup.id, code: null, affects_gross: 0 }
                }, { headers });
                accountGroup = { id: groupRes.data?.id };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;
            if (!bankLedger) {
                // Create bank ledger logic simplified
                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: accountName, group_id: accountGroup.id, op_balance: transaction.account?.opening_balance || 0,
                        op_balance_dc: "D", type: 1
                    }
                }, { headers });
                bankLedgerId = res.data?.data?.Ledger?.id;
            } else {
                bankLedgerId = bankLedger.id;
            }


            // ==== 3. Get/Create Required Ledgers ====

            // A. Bank Guarantee Security (Asset)
            const securityLedgerId = await getOrCreateLedger("Bank Guarantee Security", "Current Assets", "Assets", "D", "Security Deposit for Bank Guarantees");

            // B. Bank Commission Expense
            const commissionLedgerId = await getOrCreateLedger("Bank Commission Charges", "Business Operation", "Indirect Expenses", "D", "Commission fees for banking services");

            // C. Bank Service Charges (reuse name)
            const chargesLedgerId = await getOrCreateLedger("Bank Charges", "Business Operation", "Indirect Expenses", "D", "General bank service charges");

            // D. Input VAT (Asset)
            const vatLedgerId = await getOrCreateLedger("Input VAT", "Current Assets", "Assets", "D", "VAT on purchases/expenses");


            // ==== 4. Calculate Amounts ====
            const exchangeRate = parseFloat(transaction.account?.exchange_rate || 1);
            const guaranteeAmount = parseFloat(transaction.amount || 0) * exchangeRate;
            const commissionFee = parseFloat(transaction.commission_fee || 0) * exchangeRate;
            const commissionVat = parseFloat(transaction.commission_vat || 0) * exchangeRate;
            const bankCharge = parseFloat(transaction.bank_service_charge || 0) * exchangeRate;
            const bankVat = parseFloat(transaction.bank_vat_amount || 0) * exchangeRate;

            // Total Credit to Bank
            const totalCredit = guaranteeAmount + commissionFee + commissionVat + bankCharge + bankVat;

            const entryItems = [
                // 1. Dr Bank Guarantee Security
                { dc: "D", ledger_id: securityLedgerId, dr_amount: guaranteeAmount.toFixed(2), cr_amount: null },
            ];

            // 2. Dr Bank Commission Expense
            if (commissionFee > 0) {
                entryItems.push({ dc: "D", ledger_id: commissionLedgerId, dr_amount: commissionFee.toFixed(2), cr_amount: null });
            }
            // 3. Dr Input VAT (for Commission)
            if (commissionVat > 0) {
                entryItems.push({ dc: "D", ledger_id: vatLedgerId, dr_amount: commissionVat.toFixed(2), cr_amount: null });
            }

            // 4. Dr Bank Service Charge
            if (bankCharge > 0) {
                entryItems.push({ dc: "D", ledger_id: chargesLedgerId, dr_amount: bankCharge.toFixed(2), cr_amount: null });
            }

            // 5. Dr Input VAT (for Bank Charge) - Could combine with above VAT but keeping separate entries usually clearer or if specific line item needed. 
            // Actually better to combine or list separate? User said "then it vat auto calute... then the bank service chanrge and bank vat auto calute". 
            // Usually VAT is all to Input VAT ledger. Listings as separate lines is fine.
            if (bankVat > 0) {
                entryItems.push({ dc: "D", ledger_id: vatLedgerId, dr_amount: bankVat.toFixed(2), cr_amount: null });
            }

            // 6. Cr Bank Account
            entryItems.push({ dc: "C", ledger_id: bankLedgerId, dr_amount: null, cr_amount: totalCredit.toFixed(2) });


            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Bank Guarantee - ${transaction.reference_no || ''}`,
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            // If updating, delete the old entry first
            if (isEditMode && entryId) {
                console.log(`??? Deleting existing BG entry #${entryId} before creating new one...`);
                try {
                    // Start with generic delete, adjust if specific type needed
                    await axios.post(`${backendUrl}/entries/delete/payment/${entryId}`, {}, { headers });
                    console.log(`? Deleted old entry #${entryId}`);
                } catch (delError) {
                    console.warn(`?? Failed to delete old entry #${entryId}, proceeding:`, delError);
                }
            }

            console.log('?? Creating new Bank Guarantee entry');
            // Assuming 'payment' type is appropriate for this money-out transaction
            const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
                headers: { ...headers, "Content-Type": "application/json" },
            });

            if (response.data?.status === 'error') {
                throw new Error(response.data.message || "Bank Guarantee transaction failed.");
            }

            const newEntryId = response.data?.entry_id || response.data?.data?.entry?.id;
            console.log('? BG entry created successfully:', { entry_id: newEntryId });
            showToast("Bank Guarantee Synced Successfully!", "success");

            return {
                journal_id: null,
                entry_id: newEntryId,
            };

        } catch (error) {
            console.error("? Error syncing BG transaction:", error);
            throw new Error(error.message || "Failed to sync Bank Guarantee transaction.");
        }
    };

    const syncBankGuaranteeReleasedWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== BANK GUARANTEE RELEASE DEBUG ===");
            console.log("Amount (Guarantee):", transaction.amount);
            console.log("Bank Charge:", transaction.bank_service_charge);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure Bank/Cash ledger (Debit Account) ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type.");
            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            const ensureGroup = async (name, parentName, affectsGross = 0) => {
                let group = allGroups.find(g => g.Group?.name === name)?.Group;
                if (!group) {
                    const parentGroup = allGroups.find(g => g.Group?.name === parentName)?.Group;
                    if (!parentGroup) throw new Error(`Cannot find '${parentName}' group.`);
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name, parent_id: parentGroup.id, code: null, affects_gross: affectsGross }
                    }, { headers });
                    group = { id: res.data?.id, name };
                }
                return group;
            };

            const getOrCreateLedger = async (name, groupName, parentGroupName, opBalanceDc = "D", notes = "") => {
                let ledger = allLedgers.find(l => l.Ledger?.name === name)?.Ledger;
                if (!ledger) {
                    const group = await ensureGroup(groupName, parentGroupName);
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name, group_id: group.id, op_balance: 0,
                            op_balance_dc: opBalanceDc, notes, code: null, type: 0
                        }
                    }, { headers });
                    return res.data?.data?.Ledger?.id || res.data?.data?.id;
                }
                return ledger.id;
            };

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");
                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                    Group: { name: groupName, parent_id: parentAssetsGroup.id, code: null, affects_gross: 0 }
                }, { headers });
                accountGroup = { id: groupRes.data?.id };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;
            if (!bankLedger) {
                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: accountName, group_id: accountGroup.id, op_balance: transaction.account?.opening_balance || 0,
                        op_balance_dc: "D", type: 1
                    }
                }, { headers });
                bankLedgerId = res.data?.data?.Ledger?.id;
            } else {
                bankLedgerId = bankLedger.id;
            }

            // ==== 3. Get/Create Required Ledgers ====
            const securityLedgerId = await getOrCreateLedger("Bank Guarantee Security", "Current Assets", "Assets", "D", "Security Deposit for Bank Guarantees");
            const chargesLedgerId = await getOrCreateLedger("Bank Charges", "Business Operation", "Indirect Expenses", "D", "General bank service charges");
            const vatLedgerId = await getOrCreateLedger("Input VAT", "Current Assets", "Assets", "D", "VAT on purchases/expenses");

            // ==== 4. Calculate Amounts ====
            const exchangeRate = parseFloat(transaction.account?.exchange_rate || 1);
            const guaranteeAmount = parseFloat(transaction.amount || 0) * exchangeRate; // Credit to Security
            const bankCharge = parseFloat(transaction.bank_service_charge || 0) * exchangeRate; // Debit Charge
            const bankVat = parseFloat(transaction.bank_vat_amount || 0) * exchangeRate; // Debit VAT

            const netBankDebit = guaranteeAmount - bankCharge - bankVat;

            const entryItems = [
                // 1. Cr Bank Guarantee Security (Releasing the asset)
                { dc: "C", ledger_id: securityLedgerId, dr_amount: null, cr_amount: guaranteeAmount.toFixed(2) },

                // 2. Dr Bank Account (Net Amount)
                { dc: "D", ledger_id: bankLedgerId, dr_amount: netBankDebit.toFixed(2), cr_amount: null },
            ];

            // 3. Dr Bank Service Charge
            if (bankCharge > 0) {
                entryItems.push({ dc: "D", ledger_id: chargesLedgerId, dr_amount: bankCharge.toFixed(2), cr_amount: null });
            }

            // 4. Dr Input VAT
            if (bankVat > 0) {
                entryItems.push({ dc: "D", ledger_id: vatLedgerId, dr_amount: bankVat.toFixed(2), cr_amount: null });
            }

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Bank Guarantee Released - ${transaction.reference_no || ''}`,
                    reference_no: transaction.reference_no || '',
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            if (isEditMode && entryId) {
                try {
                    await axios.post(`${backendUrl}/entries/delete/payment/${entryId}`, {}, { headers });
                } catch (delError) {
                    console.warn(`?? Failed to delete old entry #${entryId}, proceeding:`, delError);
                }
            }

            console.log('?? Creating new Bank Guarantee Released entry');
            const response = await axios.post(`${backendUrl}/entries/add/receipt`, entryPayload, {
                headers: { ...headers, "Content-Type": "application/json" },
            });

            if (response.data?.status === 'error') {
                throw new Error(response.data.message || "Bank Guarantee Release transaction failed.");
            }

            const newEntryId = response.data?.entry_id || response.data?.data?.entry?.id;
            console.log('? BG Release entry created successfully:', { entry_id: newEntryId });
            showToast("Bank Guarantee Released Synced Successfully!", "success");

            return {
                journal_id: null,
                entry_id: newEntryId,
            };

        } catch (error) {
            console.error("? Error syncing BG Release transaction:", error);
            throw new Error(error.message || "Failed to sync Bank Guarantee Release transaction.");
        }
    };
    // const syncAdvanceWithWebzash = async (transaction) => {
    //     const userInfo = JSON.parse(localStorage.getItem("user-info"));
    //     const origin = localStorage.getItem("user-origin");
    //     const token = userInfo?.token;
    //     const API = process.env.REACT_APP_WEBZASH_URL;
    //     const backendUrl = `${API}/api`;

    //     const headers = {
    //         "x-api-key": process.env.REACT_APP_API_KEY,
    //         Accept: "application/json",
    //     };

    //     try {
    //         const entryId = transaction.entry_id || transaction.entryId;
    //         const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

    //         console.log("=== ADVANCE TRANSACTION DEBUG ===");
    //         console.log("Entry ID:", entryId);
    //         console.log("Is Edit Mode:", isEditMode);
    //         console.log("Transaction Vendor ID:", transaction.vendor_id);
    //         console.log("Transaction Vendor:", transaction.vendor);
    //         console.log("=== END DEBUG ===");

    //         // Get all groups and ledgers
    //         const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
    //         const allGroups = Array.isArray(groupListResponse.data?.data)
    //             ? groupListResponse.data.data
    //             : Array.isArray(groupListResponse.data)
    //                 ? groupListResponse.data
    //                 : [];

    //         const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //         const allLedgers = ledgerListResponse.data?.data || [];

    //         // 1. Ensure "Vendor Advances" ledger exists (ONE ledger for all vendors)
    //         const advancesLedgerName = "Vendor Advances";
    //         let advancesLedger = allLedgers.find(l => l.Ledger?.name === advancesLedgerName)?.Ledger;
    //         let advancesLedgerId;

    //         if (!advancesLedger) {
    //             // First, ensure "Vendor Advances" group exists under Current Assets
    //             const advancesGroupName = "Vendor Advance";
    //             let advancesGroup = allGroups.find(g => g.Group?.name === advancesGroupName)?.Group;

    //             if (!advancesGroup) {
    //                 const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
    //                 if (!currentAssetsGroup) throw new Error("Cannot find 'Current Assets' group.");

    //                 const groupPayload = {
    //                     Group: {
    //                         name: advancesGroupName,
    //                         parent_id: currentAssetsGroup.id,
    //                         code: null,
    //                         affects_gross: 0,
    //                     },
    //                 };

    //                 const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
    //                     headers: { ...headers, "Content-Type": "application/json" },
    //                 });

    //                 advancesGroup = {
    //                     id: groupResponse.data?.id,
    //                     name: advancesGroupName,
    //                 };
    //             }

    //             // Create the Vendor Advances ledger
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: advancesLedgerName,
    //                     code: null,
    //                     group_id: advancesGroup.id,
    //                     op_balance: 0,
    //                     op_balance_dc: "D", // Debit balance (Asset)
    //                     notes: "Advances paid to vendors - track vendor_id in entry metadata",
    //                     type: 0,
    //                 },
    //             };

    //             const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //             advancesLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
    //         } else {
    //             advancesLedgerId = advancesLedger.id;
    //         }

    //         // 2. Ensure Bank/Cash ledger
    //         const accountType = transaction.account_type?.toLowerCase();
    //         const groupName = accountType === "bank account"
    //             ? "Bank Accounts"
    //             : accountType === "cash account"
    //                 ? "Cash-in-Hand"
    //                 : null;

    //         if (!groupName) throw new Error("Invalid account type for advance payment.");

    //         let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

    //         if (!accountGroup) {
    //             const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
    //             if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

    //             const groupPayload = {
    //                 Group: {
    //                     name: groupName,
    //                     parent_id: parentAssetsGroup.id,
    //                     code: null,
    //                     affects_gross: 0,
    //                 },
    //             };

    //             const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             accountGroup = {
    //                 id: groupResponse.data?.id,
    //                 name: groupName,
    //             };
    //         }

    //         const accountName = transaction.account?.name || "Unnamed Account";
    //         let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
    //         let bankLedgerId;

    //         if (!bankLedger) {
    //             const ledgerPayload = {
    //                 Ledger: {
    //                     name: accountName,
    //                     code: null,
    //                     group_id: accountGroup.id,
    //                     op_balance: (transaction.account?.opening_balance || 0),
    //                     op_balance_dc: "D",
    //                     notes: "",
    //                     type: 1, // Bank/Cash type
    //                 },
    //             };

    //             try {
    //                 const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
    //                 bankLedgerId = response.data?.data?.Ledger?.id;
    //             } catch (err) {
    //                 const isDuplicate = err.response?.data?.errors?.name?.includes("Ledger name is already in use");
    //                 if (isDuplicate) {
    //                     const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
    //                     const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
    //                     bankLedgerId = existing?.Ledger?.id;
    //                 } else {
    //                     throw new Error("Failed to add/find bank ledger.");
    //                 }
    //             }
    //         } else {
    //             bankLedgerId = bankLedger.id;
    //         }

    //         // 3. Create Journal Entry for Advance Payment
    //         const amountAED = parseFloat(transaction.amount || 0);
    //         const vendorName = transaction.vendor?.name || "Vendor";

    //         const entryItems = [
    //             {
    //                 dc: "D",
    //                 ledger_id: advancesLedgerId,
    //                 dr_amount: amountAED.toFixed(2),
    //                 cr_amount: null,
    //             },
    //             {
    //                 dc: "C",
    //                 ledger_id: bankLedgerId,
    //                 dr_amount: null,
    //                 cr_amount: amountAED.toFixed(2),
    //             },
    //         ];

    //         // Prepare entry payload with vendor_id
    //         const entryPayload = {
    //             Entry: {
    //                 tag_id: null,
    //                 number: Date.now(),
    //                 date: transaction.date || new Date().toISOString().split("T")[0],
    //                 narration: transaction.description || `Advance payment to ${vendorName}${transaction.po_id ? ` (PO: ${transaction.po_id})` : ''}`,
    //                 reference_no: transaction.reference_no || '',
    //                 // ? KEY: Store vendor_id in the Entry to track WHICH vendor this advance belongs to
    //                 vendor_id: transaction.vendor_id,
    //                 project_id: transaction.project_id,
    //                 po_id: transaction.po_id,
    //                 client_id: transaction.client_id,
    //                 is_import: true,
    //             },
    //             Entryitem: entryItems,
    //         };

    //         console.log('Advance Entry Payload:', entryPayload);

    //         if (isEditMode && entryId) {
    //             // UPDATE existing advance entry
    //             console.log('?? Updating existing advance entry #', entryId);

    //             entryPayload.Entry.id = entryId;

    //             const response = await axios.post(`${backendUrl}/entries/edit/payment/${entryId}`, entryPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             if (response.data?.status === 'error') {
    //                 throw new Error(response.data.message || "Advance update failed.");
    //             }

    //             console.log('? Advance entry updated successfully');
    //             showToast("? Advance Payment Updated Successfully!", "success");

    //             return {
    //                 journal_id: transaction.journal_id,
    //                 entry_id: entryId,
    //             };
    //         } else {
    //             // CREATE new advance entry
    //             console.log('?? Creating new advance entry');

    //             const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
    //                 headers: { ...headers, "Content-Type": "application/json" },
    //             });

    //             if (response.data?.status === 'error') {
    //                 throw new Error(response.data.message || "Advance transaction failed.");
    //             }

    //             const newEntryId = response.data?.entry_id;

    //             console.log('? New advance entry created successfully:', { entry_id: newEntryId });
    //             showToast("? Advance Payment Created Successfully!", "success");

    //             return {
    //                 journal_id: null,
    //                 entry_id: newEntryId,
    //             };
    //         }

    //     } catch (error) {
    //         console.error("? Error syncing advance transaction:", error);
    //         throw new Error(error.message || "Failed to sync advance transaction.");
    //     }
    // };
    const syncAdvanceWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== ADVANCE TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("Transaction Vendor ID:", transaction.vendor_id);
            console.log("Transaction Vendor:", transaction.vendor);
            console.log("Selected Bank:", selectedBank);
            console.log("Transaction Currency:", transaction.transaction_currency);
            console.log("=== END DEBUG ===");

            // Get all groups and ledgers
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            let allLedgers = ledgerListResponse.data?.data || [];

            // Helper to get or create ledger
            const getOrCreateLedger = async (name, groupName, parentGroupName, opBalanceDc = "D", notes = "") => {
                let ledger = allLedgers.find(l => l.Ledger?.name === name)?.Ledger;
                if (!ledger) {
                    let group = allGroups.find(g => g.Group?.name === groupName)?.Group;
                    if (!group) {
                        const parentGroup = allGroups.find(g => g.Group?.name === parentGroupName)?.Group;
                        if (!parentGroup) throw new Error(`Cannot find '${parentGroupName}' group.`);

                        const gRes = await axios.post(`${backendUrl}/groups/add`, {
                            Group: { name: groupName, parent_id: parentGroup.id, code: null, affects_gross: 0 }
                        }, { headers: { ...headers, "Content-Type": "application/json" } });
                        group = { id: gRes.data?.id, name: groupName };
                    }
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: { name, code: null, group_id: group.id, op_balance: 0, op_balance_dc: opBalanceDc, notes, type: 0 }
                    }, { headers });
                    ledger = res.data?.data?.Ledger || res.data?.data || res.data;
                }
                return ledger.id;
            };

            // 1. Ensure "Vendor Advances" ledger exists (ONE ledger for all vendors)
            const advancesLedgerName = "Vendor Advances";
            let advancesLedger = allLedgers.find(l => l.Ledger?.name === advancesLedgerName)?.Ledger;
            let advancesLedgerId;

            if (!advancesLedger) {
                // First, ensure "Vendor Advances" group exists under Current Assets
                const advancesGroupName = "Vendor Advance";
                let advancesGroup = allGroups.find(g => g.Group?.name === advancesGroupName)?.Group;

                if (!advancesGroup) {
                    const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                    if (!currentAssetsGroup) throw new Error("Cannot find 'Current Assets' group.");

                    const groupPayload = {
                        Group: {
                            name: advancesGroupName,
                            parent_id: currentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        },
                    };

                    const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                        headers: { ...headers, "Content-Type": "application/json" },
                    });

                    advancesGroup = {
                        id: groupResponse.data?.id,
                        name: advancesGroupName,
                    };
                }

                // Create the Vendor Advances ledger
                const ledgerPayload = {
                    Ledger: {
                        name: advancesLedgerName,
                        code: null,
                        group_id: advancesGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D", // Debit balance (Asset)
                        notes: "Advances paid to vendors - track vendor_id in entry metadata",
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                advancesLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                advancesLedgerId = advancesLedger.id;
            }

            // 2. Ensure Bank/Cash ledger
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type for advance payment.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentAssetsGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                accountGroup = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;

            if (!bankLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: accountName,
                        code: null,
                        group_id: accountGroup.id,
                        op_balance: (transaction.account?.opening_balance || 0),
                        op_balance_dc: "D",
                        notes: "",
                        type: 1, // Bank/Cash type
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    bankLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    const isDuplicate = err.response?.data?.errors?.name?.includes("Ledger name is already in use");
                    if (isDuplicate) {
                        const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                        bankLedgerId = existing?.Ledger?.id;
                    } else {
                        throw new Error("Failed to add/find bank ledger.");
                    }
                }
            } else {
                bankLedgerId = bankLedger.id;
            }

            // 2.1 Ensure Bank Charges and Input VAT ledgers
            const bankChargeLedgerId = await getOrCreateLedger("Bank Charges", "Indirect Expenses", "Expenses", "D", "Automatic bank charges");
            const inputVatLedgerId = await getOrCreateLedger("Input VAT", "Current Assets", "Assets", "D", "VAT on purchases/bank charges");

            // ========== USD CONVERSION HANDLING FOR ADVANCE ==========
            const isUSDVendor = transaction.vendor?.currency === "USD";
            const isUSDClient = transaction.client?.currency === "USD";
            const isUSDAdvance = isUSDVendor || isUSDClient;

            console.log('?? USD Conversion Check for Advance:', {
                vendorCurrency: transaction.vendor?.currency,
                clientCurrency: transaction.client?.currency,
                transactionCurrencyId: transaction.transaction_currency,
                selectedBankBaseCurrency: selectedBank?.base_currency?.currency,
                isUSDAdvance
            });

            let amountAED = parseFloat(transaction.amount || 0);
            let exchangeGain = 0;
            let exchangeLoss = 0;

            if (isUSDAdvance) {
                console.log('?? USD Foreign Advance Detected');

                // Get the exchange rate from the selected bank
                let exchangeRateToUse = 1;

                // If user selected a specific currency in the dropdown
                if (transaction.transaction_currency && transaction.transaction_currency != selectedBank.base_currency_id) {
                    // Find the exchange rate for the selected currency
                    const selectedRate = selectedBank.exchange_rates?.find(
                        rate => rate.currency_id == transaction.transaction_currency
                    );

                    if (selectedRate && selectedRate.rate) {
                        exchangeRateToUse = parseFloat(selectedRate.rate);
                        console.log('? Using selected currency exchange rate:', {
                            currencyId: transaction.transaction_currency,
                            rate: exchangeRateToUse,
                            currencyName: getCurrencySymbol(transaction.transaction_currency)
                        });
                    }
                } else if (transaction.transaction_currency == selectedBank.base_currency_id) {
                    // User selected AED (base currency)
                    exchangeRateToUse = 1;
                    console.log('? User selected AED directly for advance');
                } else {
                    // Default to USD rate if available
                    const usdRate = selectedBank.exchange_rates?.find(
                        rate => rate.currency?.currency === "USD"
                    );
                    if (usdRate && usdRate.rate) {
                        exchangeRateToUse = parseFloat(usdRate.rate);
                        console.log('? Using bank USD exchange rate for advance:', exchangeRateToUse);
                    } else {
                        exchangeRateToUse = 3.692; // Default fallback
                        console.log('?? Using default USD exchange rate for advance:', exchangeRateToUse);
                    }
                }

                // Determine if user entered USD or AED amount
                const userEnteredAmount = parseFloat(transaction.amount || 0);

                if (transaction.transaction_currency && transaction.transaction_currency != selectedBank.base_currency_id) {
                    // User entered foreign currency (likely USD)
                    console.log('?? User entered foreign currency amount for advance:', {
                        amount: userEnteredAmount,
                        currency: getCurrencySymbol(transaction.transaction_currency),
                        exchangeRate: exchangeRateToUse
                    });

                    // Convert from foreign currency to AED
                    amountAED = userEnteredAmount * exchangeRateToUse;

                    console.log('?? Advance Conversion to AED:', {
                        foreignAmount: userEnteredAmount,
                        rate: exchangeRateToUse,
                        amountAED
                    });
                } else {
                    // User entered AED amount directly
                    console.log('?? User entered AED amount directly for advance:', userEnteredAmount);
                    amountAED = userEnteredAmount;
                }

                // For USD entities, we might need to track exchange gain/loss
                // Check if vendor/client has a different exchange rate than what we used
                const entityExchangeRate = isUSDClient 
                    ? parseFloat(transaction.client?.exchange_rate || 3.67)
                    : parseFloat(transaction.vendor?.exchange_rate || 3.67);

                if (Math.abs(exchangeRateToUse - entityExchangeRate) > 0.001) {
                    // Calculate the original foreign amount based on the entity's expected rate vs bank's rate
                    const originalAED = userEnteredAmount * entityExchangeRate;
                    const paidAED = amountAED;
                    const diff = originalAED - paidAED;

                    if (Math.abs(diff) >= 0.01) {
                        if (diff > 0) {
                            exchangeGain = parseFloat(diff.toFixed(2));
                            console.log(`?? Advance Exchange gain: ${exchangeGain} AED`);
                        } else {
                            exchangeLoss = parseFloat(Math.abs(diff).toFixed(2));
                            console.log(`?? Advance Exchange loss: ${exchangeLoss} AED`);
                        }
                    }
                }
            } else {
                // AED vendor - no conversion needed
                console.log('?? AED Vendor Advance - No conversion needed');
                amountAED = parseFloat(transaction.amount || 0);
            }

            console.log('?? Final Advance Amount in AED:', amountAED);

            const bankChargeAED = parseFloat(transaction.bank_service_charge || 0);
            const bankVatAED = parseFloat(transaction.bank_vat_amount || 0);
            const totalChargesAED = bankChargeAED + bankVatAED;

            // 3. Determine Advance Logic based on type
            const isClientAdvance = transaction.advance_type === 'client';
            const isPettyCashAdvance = transaction.advance_type === 'pettycash';

            let targetName = "Unknown";
            if (isClientAdvance) targetName = transaction.client?.name || "Client";
            else if (isPettyCashAdvance) targetName = transaction.user?.name || "User";
            else targetName = transaction.vendor?.name || "Vendor";

            // For Client Advance: CREDIT Customer Advance (Liability), DEBIT Bank
            // For Vendor Advance: DEBIT Vendor Advances (Asset), CREDIT Bank

            const entryItems = [];

            if (isClientAdvance) {
                // Ensure "Customer Advance" ledger (reuse logic from syncIncome)
                let clientAdvanceLedger = allLedgers.find(l => l.Ledger?.name === "Customer Advance")?.Ledger;
                let clientAdvanceLedgerId;

                if (!clientAdvanceLedger) {
                    const liabilitiesGroup = allGroups.find(g => g.Group?.name === "Current Liabilities");
                    if (!liabilitiesGroup) throw new Error("Cannot find 'Liabilities' group for Customer Advance.");

                    const payload = {
                        Ledger: {
                            name: "Customer Advance",
                            code: null,
                            group_id: liabilitiesGroup.Group.id,
                            op_balance: 0,
                            op_balance_dc: "C",
                            notes: "Advance payments from clients",
                            type: 0,
                        },
                    };
                    const res = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
                    clientAdvanceLedgerId = res.data?.data?.Ledger?.id;
                } else {
                    clientAdvanceLedgerId = clientAdvanceLedger.id;
                }

                entryItems.push({
                    dc: "D",
                    ledger_id: bankLedgerId,
                    dr_amount: (amountAED - totalChargesAED).toFixed(2),
                    cr_amount: null,
                });
                if (bankChargeAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: bankChargeLedgerId,
                        dr_amount: bankChargeAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                if (bankVatAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: inputVatLedgerId,
                        dr_amount: bankVatAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                entryItems.push({
                    dc: "C",
                    ledger_id: clientAdvanceLedgerId,
                    dr_amount: null,
                    cr_amount: amountAED.toFixed(2),
                });
            } else if (isPettyCashAdvance) {
                // PETTY CASH ADVANCE LOGIC
                // Create structure: Current Assets -> Employee Advances (group) -> Employee Advance (ledger)

                // First, ensure "Employee Advances" group exists
                const employeeAdvancesGroupName = "Employee Advances";
                let employeeAdvancesGroup = allGroups.find(g => g.Group?.name === employeeAdvancesGroupName)?.Group;

                if (!employeeAdvancesGroup) {
                    console.log("Creating 'Employee Advances' group...");
                    const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;

                    if (!currentAssetsGroup) throw new Error("Cannot find 'Current Assets' group.");

                    const groupPayload = {
                        Group: {
                            name: employeeAdvancesGroupName,
                            parent_id: currentAssetsGroup.id,
                            code: null,
                            affects_gross: 0,
                        },
                    };

                    const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                        headers: { ...headers, "Content-Type": "application/json" },
                    });

                    employeeAdvancesGroup = {
                        id: groupResponse.data?.id,
                        name: employeeAdvancesGroupName,
                    };

                    // Refresh groups after creation
                    const groupRes2 = await axios.get(`${backendUrl}/groups/index`, { headers });
                    allGroups = groupRes2.data;
                }

                // Now create/find "Employee Advance" ledger under "Employee Advances" group
                const employeeAdvanceLedgerName = "Employee Advance";
                let employeeAdvanceLedger = allLedgers.find(l => l.Ledger?.name === employeeAdvanceLedgerName);
                let employeeAdvanceLedgerId;

                if (!employeeAdvanceLedger) {
                    console.log("Creating 'Employee Advance' ledger...");

                    const payload = {
                        Ledger: {
                            name: employeeAdvanceLedgerName,
                            code: null,
                            group_id: employeeAdvancesGroup.id,
                            op_balance: 0,
                            op_balance_dc: "D", // Asset
                            notes: "Advances paid to employees",
                            type: 0,
                        },
                    };

                    try {
                        const res = await axios.post(`${backendUrl}/ledgers/add`, payload, { headers });
                        employeeAdvanceLedgerId = res.data?.data?.Ledger?.id || res.data?.data?.id;

                        // Refresh ledgers
                        const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        allLedgers = refresh.data?.data || refresh.data;
                    } catch (err) {
                        console.error("Error creating Employee Advance ledger:", err);
                        // Fallback check if it was created in race condition
                        const refresh = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                        allLedgers = refresh.data?.data || refresh.data;
                        const existing = allLedgers.find(l => l.Ledger?.name === employeeAdvanceLedgerName);
                        if (existing) {
                            employeeAdvanceLedgerId = existing.Ledger.id;
                        } else {
                            throw err;
                        }
                    }
                } else {
                    employeeAdvanceLedgerId = employeeAdvanceLedger.Ledger.id;
                }

                if (!employeeAdvanceLedgerId) throw new Error("Failed to resolve Employee Advance Ledger ID");

                entryItems.push({
                    dc: "D",
                    ledger_id: employeeAdvanceLedgerId, // Debit Employee Advance (Asset)
                    dr_amount: amountAED.toFixed(2),
                    cr_amount: null,
                });
                if (bankChargeAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: bankChargeLedgerId,
                        dr_amount: bankChargeAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                if (bankVatAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: inputVatLedgerId,
                        dr_amount: bankVatAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                entryItems.push({
                    dc: "C",
                    ledger_id: bankLedgerId, // Credit Bank
                    dr_amount: null,
                    cr_amount: (amountAED + totalChargesAED).toFixed(2),
                });

            } else {
                // Vendor Advance (Existing logic)
                entryItems.push({
                    dc: "D",
                    ledger_id: advancesLedgerId,
                    dr_amount: amountAED.toFixed(2),
                    cr_amount: null,
                });
                if (bankChargeAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: bankChargeLedgerId,
                        dr_amount: bankChargeAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                if (bankVatAED > 0) {
                    entryItems.push({
                        dc: "D",
                        ledger_id: inputVatLedgerId,
                        dr_amount: bankVatAED.toFixed(2),
                        cr_amount: null,
                    });
                }
                entryItems.push({
                    dc: "C",
                    ledger_id: bankLedgerId,
                    dr_amount: null,
                    cr_amount: (amountAED + totalChargesAED).toFixed(2),
                });
            }

            // Add exchange gain/loss if applicable
            const gainLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Gain");
            const lossLedger = allLedgers.find(l => l.Ledger?.name === "Exchange Loss");

            if (exchangeGain > 0 && gainLedger) {
                entryItems.push({
                    dc: "C",
                    ledger_id: gainLedger.Ledger.id,
                    dr_amount: null,
                    cr_amount: exchangeGain.toFixed(2)
                });
            }

            if (exchangeLoss > 0 && lossLedger) {
                entryItems.push({
                    dc: "D",
                    ledger_id: lossLedger.Ledger.id,
                    dr_amount: exchangeLoss.toFixed(2),
                    cr_amount: null
                });
            }

            // Prepare entry payload
            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Advance ${isClientAdvance ? 'received from' : 'paid to'} ${targetName} ${transaction.po_id ? ` (PO: ${transaction.po_id})` : ''}`,
                    reference_no: transaction.reference_no || '',
                    vendor_id: transaction.vendor_id,
                    client_id: transaction.client_id,
                    project_id: transaction.project_id,
                    po_id: transaction.po_id,
                    user_id: transaction.user_id, // Pass User ID
                    user_name: transaction.user?.name, // Pass User Name
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('Advance Entry Payload:', entryPayload);

            // Validate the entry balances
            const drTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.dr_amount) || 0), 0);
            const crTotal = entryItems.reduce((sum, item) => sum + (parseFloat(item.cr_amount) || 0), 0);

            console.log('Advance Entry Validation:', {
                amountAED,
                exchangeGain,
                exchangeLoss,
                drTotal,
                crTotal,
                balanced: Math.abs(drTotal - crTotal) < 0.01
            });

            if (Math.abs(drTotal - crTotal) > 0.01) {
                throw new Error(`Advance entry doesn't balance! DR: ${drTotal.toFixed(2)}, CR: ${crTotal.toFixed(2)}, Diff: ${(drTotal - crTotal).toFixed(2)}`);
            }

            if (isEditMode && entryId) {
                // UPDATE existing advance entry
                console.log('?? Updating existing advance entry #', entryId);

                entryPayload.Entry.id = entryId;

                const endpoint = isClientAdvance ? 'receipt' : 'payment';
                const response = await axios.post(`${backendUrl}/entries/edit/${endpoint}/${entryId}`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Advance update failed.");
                }

                console.log('? Advance entry updated successfully');
                showToast("Advance Payment Updated Successfully!", "success");

                return {
                    journal_id: transaction.journal_id,
                    entry_id: entryId,
                };
            } else {
                // CREATE new advance entry
                console.log('?? Creating new advance entry');

                const endpoint = isClientAdvance ? 'receipt' : 'payment';
                const response = await axios.post(`${backendUrl}/entries/add/${endpoint}`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Advance transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New advance entry created successfully:', { entry_id: newEntryId });
                showToast("Advance Payment Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }

        } catch (error) {
            console.error("? Error syncing advance transaction:", error);
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            throw new Error(error.message || "Failed to sync advance transaction.");
        }
    };
    const CalendarButton = React.forwardRef(({ value, onClick }, ref) => (
        <button
            type="button"
            className="btn btn-light"
            onClick={onClick}
            ref={ref}
            style={{
                border: "none",
                background: "transparent",
                cursor: "pointer",
                marginLeft: "-35px"
            }}
        >
            ??
        </button>
    ));
    const syncPayrollWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const origin = localStorage.getItem("user-origin");
        const token = userInfo?.token;
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== PAYROLL TRANSACTION DEBUG ===");
            console.log("Salary IDs:", transaction.salary_ids);
            console.log("Total Salaries:", transaction.salary_ids?.length);
            console.log("Total Salary Amount:", transaction.total_salary_amount);
            console.log("=== END DEBUG ===");

            // Get all groups and ledgers
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // 1. Ensure Bank/Cash ledger
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type for payroll transaction.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");

                const groupPayload = {
                    Group: {
                        name: groupName,
                        parent_id: parentAssetsGroup.id,
                        code: null,
                        affects_gross: 0,
                    },
                };

                const groupResponse = await axios.post(`${backendUrl}/groups/add`, groupPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                accountGroup = {
                    id: groupResponse.data?.id,
                    name: groupName,
                };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;

            if (!bankLedger) {
                const ledgerPayload = {
                    Ledger: {
                        name: accountName,
                        code: null,
                        group_id: accountGroup.id,
                        op_balance: (transaction.account?.opening_balance || 0),
                        op_balance_dc: "D",
                        notes: "",
                        type: 1, // Bank/Cash
                    },
                };

                try {
                    const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                    bankLedgerId = response.data?.data?.Ledger?.id;
                } catch (err) {
                    const refreshLedgers = await axios.get(`${backendUrl}/ledgers/index`, { headers });
                    const existing = refreshLedgers.data?.data?.find(l => l.Ledger?.name === accountName);
                    bankLedgerId = existing?.Ledger?.id;
                }
            } else {
                bankLedgerId = bankLedger.id;
            }

            // 2. Ensure Salary Payable Ledger
            const salaryPayableLedgerName = "Salary Payable";
            let salaryPayableLedger = allLedgers.find(l => l.Ledger?.name === salaryPayableLedgerName)?.Ledger;
            let salaryPayableLedgerId;

            if (!salaryPayableLedger) {
                const currentLiabilitiesGroup = allGroups.find(g => g.Group?.name === "Current Liabilities")?.Group;
                if (!currentLiabilitiesGroup) throw new Error("Cannot find 'Current Liabilities' group.");

                const ledgerPayload = {
                    Ledger: {
                        name: salaryPayableLedgerName,
                        code: null,
                        group_id: currentLiabilitiesGroup.id,
                        op_balance: 0,
                        op_balance_dc: "C", // Credit for liability
                        notes: "Salary payable to employees",
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                salaryPayableLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                salaryPayableLedgerId = salaryPayableLedger.id;
            }

            const bankChargesLedgerName = "Bank Charges";
            let bankChargesLedger = allLedgers.find(l => l.Ledger?.name === bankChargesLedgerName)?.Ledger;
            let bankChargesLedgerId;

            if (!bankChargesLedger) {
                const indirectExpensesGroup = allGroups.find(g => g.Group?.name === "Indirect Expenses")?.Group;
                if (!indirectExpensesGroup) throw new Error("Cannot find 'Indirect Expenses' group.");

                const ledgerPayload = {
                    Ledger: {
                        name: bankChargesLedgerName,
                        code: null,
                        group_id: indirectExpensesGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D", // Debit for expense
                        notes: "Bank service charges and fees",
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                bankChargesLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                bankChargesLedgerId = bankChargesLedger.id;
            }

            // 4. Ensure Input VAT Ledger
            const inputVatLedgerName = "Input VAT";
            let inputVatLedger = allLedgers.find(l => l.Ledger?.name === inputVatLedgerName)?.Ledger;
            let inputVatLedgerId;

            if (!inputVatLedger) {
                const currentAssetsGroup = allGroups.find(g => g.Group?.name === "Current Assets")?.Group;
                if (!currentAssetsGroup) throw new Error("Cannot find 'Current Assets' group.");

                const ledgerPayload = {
                    Ledger: {
                        name: inputVatLedgerName,
                        code: null,
                        group_id: currentAssetsGroup.id,
                        op_balance: 0,
                        op_balance_dc: "D", // Debit for asset
                        notes: "VAT paid on expenses",
                        type: 0,
                    },
                };

                const response = await axios.post(`${backendUrl}/ledgers/add`, ledgerPayload, { headers });
                inputVatLedgerId = response.data?.data?.Ledger?.id || response.data?.data?.id;
            } else {
                inputVatLedgerId = inputVatLedger.id;
            }

            // 5. Create Journal Entry for Multiple Salaries
            // Journal Entry for multiple salaries:
            // Dr Salary Payable              (Total of all salaries)
            // Dr WPS Charges Expense         (Total WPS charge) - ONLY IF > 0
            // Dr Input VAT                   (VAT on WPS) - ONLY IF > 0
            //    Cr Bank                     (Sum of all above)

            const totalSalaryAmount = parseFloat(transaction.total_salary_amount || transaction.amount || 0);
            const bankServiceCharge = parseFloat(transaction.bank_service_charge || 0);
            const bankVat = parseFloat(transaction.bank_vat_amount || 0);

            // Calculate total bank credit based on what's actually included
            const totalBankCredit = totalSalaryAmount +
                (bankServiceCharge > 0 ? bankServiceCharge : 0) +
                (bankVat > 0 ? bankVat : 0);

            // Build entry items array
            const entryItems = [
                // Debit Salary Payable (total of all salaries) - ALWAYS included
                {
                    dc: "D",
                    ledger_id: salaryPayableLedgerId,
                    dr_amount: totalSalaryAmount.toFixed(2),
                    cr_amount: null,
                }
            ];

            // Debit Bank Charges Expense ONLY if > 0
            if (bankServiceCharge > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: bankChargesLedgerId,
                    dr_amount: bankServiceCharge.toFixed(2),
                    cr_amount: null,
                });
            }

            // Debit Input VAT ONLY if > 0
            if (bankVat > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: inputVatLedgerId,
                    dr_amount: bankVat.toFixed(2),
                    cr_amount: null,
                });
            }

            // Credit Bank - ALWAYS included
            entryItems.push({
                dc: "C",
                ledger_id: bankLedgerId,
                dr_amount: null,
                cr_amount: totalBankCredit.toFixed(2),
            });

            // Create narration with details of salaries
            const salaryCount = transaction.salary_ids?.length || 0;
            const narration = transaction.description ||
                `Salary payment for ${salaryCount} employee${salaryCount > 1 ? 's' : ''}${transaction.payroll_provider_id ? ' via ' + (transaction.payroll_provider?.name || 'payroll') : ''}`;

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: narration,
                    reference_no: transaction.reference_no || '',
                    salary_ids: transaction.salary_ids ? JSON.stringify(transaction.salary_ids) : null,
                    payroll_provider_id: transaction.payroll_provider_id,
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('Payroll Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing payroll entry
                console.log('?? Updating existing payroll entry #', entryId);
                entryPayload.Entry.id = entryId;

                const response = await axios.post(`${backendUrl}/entries/edit/payment/${entryId}`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Payroll update failed.");
                }

                console.log('? Payroll entry updated successfully');
                showToast("Payroll Transaction Updated Successfully!", "success");

                return {
                    journal_id: transaction.journal_id,
                    entry_id: entryId,
                };
            } else {
                // CREATE new payroll entry
                console.log('?? Creating new payroll entry');

                const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Payroll transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New payroll entry created successfully:', { entry_id: newEntryId });
                showToast("Payroll Transaction Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }

        } catch (error) {
            console.error("? Error syncing payroll transaction:", error);
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            throw new Error(error.message || "Failed to sync payroll transaction.");
        }
    };
    const syncBankGuaranteeChargesWithWebzash = async (transaction) => {
        const userInfo = JSON.parse(localStorage.getItem("user-info"));
        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;

        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            const entryId = transaction.entry_id || transaction.entryId;
            const isEditMode = !!entryId && entryId !== "undefined" && entryId !== "null";

            console.log("=== BANK GUARANTEE CHARGES TRANSACTION DEBUG ===");
            console.log("Entry ID:", entryId);
            console.log("Is Edit Mode:", isEditMode);
            console.log("Commission Fee:", transaction.commission_fee);
            console.log("Commission VAT:", transaction.commission_vat);
            console.log("Bank Service Charge:", transaction.bank_service_charge);
            console.log("Bank VAT Amount:", transaction.bank_vat_amount);
            console.log("=== END DEBUG ===");

            // ==== 1. Get all groups and ledgers ====
            const groupListResponse = await axios.get(`${backendUrl}/groups/index`, { headers });
            const allGroups = Array.isArray(groupListResponse.data?.data)
                ? groupListResponse.data.data
                : Array.isArray(groupListResponse.data)
                    ? groupListResponse.data
                    : [];

            const ledgerListResponse = await axios.get(`${backendUrl}/ledgers/index`, { headers });
            const allLedgers = ledgerListResponse.data?.data || [];

            // ==== 2. Ensure Bank/Cash ledger ====
            const accountType = transaction.account_type?.toLowerCase();
            const groupName = accountType === "bank account"
                ? "Bank Accounts"
                : accountType === "cash account"
                    ? "Cash-in-Hand"
                    : null;

            if (!groupName) throw new Error("Invalid account type.");

            let accountGroup = allGroups.find(g => g.Group?.name?.toLowerCase() === groupName.toLowerCase())?.Group;

            const ensureGroup = async (name, parentName, affectsGross = 0) => {
                let group = allGroups.find(g => g.Group?.name === name)?.Group;
                if (!group) {
                    const parentGroup = allGroups.find(g => g.Group?.name === parentName)?.Group;
                    if (!parentGroup) throw new Error(`Cannot find '${parentName}' group.`);
                    const res = await axios.post(`${backendUrl}/groups/add`, {
                        Group: { name, parent_id: parentGroup.id, code: null, affects_gross: affectsGross }
                    }, { headers });
                    group = { id: res.data?.id, name };
                }
                return group;
            };

            const getOrCreateLedger = async (name, groupName, parentGroupName, opBalanceDc = "D", notes = "") => {
                let ledger = allLedgers.find(l => l.Ledger?.name === name)?.Ledger;
                if (!ledger) {
                    const group = await ensureGroup(groupName, parentGroupName);
                    const res = await axios.post(`${backendUrl}/ledgers/add`, {
                        Ledger: {
                            name, group_id: group.id, op_balance: 0,
                            op_balance_dc: opBalanceDc, notes, code: null, type: 0
                        }
                    }, { headers });
                    return res.data?.data?.Ledger?.id || res.data?.data?.id;
                }
                return ledger.id;
            };

            if (!accountGroup) {
                const parentAssetsGroup = allGroups.find(g => g.Group?.name === "Assets")?.Group;
                if (!parentAssetsGroup) throw new Error("Cannot find 'Assets' group.");
                const groupRes = await axios.post(`${backendUrl}/groups/add`, {
                    Group: { name: groupName, parent_id: parentAssetsGroup.id, code: null, affects_gross: 0 }
                }, { headers });
                accountGroup = { id: groupRes.data?.id };
            }

            const accountName = transaction.account?.name || "Unnamed Account";
            let bankLedger = allLedgers.find(l => l.Ledger?.name === accountName)?.Ledger;
            let bankLedgerId;
            if (!bankLedger) {
                const res = await axios.post(`${backendUrl}/ledgers/add`, {
                    Ledger: {
                        name: accountName, group_id: accountGroup.id,
                        op_balance: transaction.account?.opening_balance || 0,
                        op_balance_dc: "D", type: 1
                    }
                }, { headers });
                bankLedgerId = res.data?.data?.Ledger?.id;
            } else {
                bankLedgerId = bankLedger.id;
            }

            // ==== 3. Get/Create Required Ledgers ====
            // A. Bank Commission Expense
            const commissionLedgerId = await getOrCreateLedger(
                "Bank Commission Charges",
                "Business Operation",
                "Indirect Expenses",
                "D",
                "Commission fees for banking services"
            );

            // B. Bank Service Charges
            const chargesLedgerId = await getOrCreateLedger(
                "Bank Charges",
                "Business Operation",
                "Indirect Expenses",
                "D",
                "General bank service charges"
            );

            // C. Input VAT (Asset)
            const vatLedgerId = await getOrCreateLedger(
                "Input VAT",
                "Current Assets",
                "Assets",
                "D",
                "VAT on purchases/expenses"
            );

            // ==== 4. Calculate Amounts ====
            const exchangeRate = parseFloat(transaction.account?.exchange_rate || 1);
            const commissionFee = parseFloat(transaction.commission_fee || 0) * exchangeRate;
            const commissionVat = parseFloat(transaction.commission_vat || 0) * exchangeRate;
            const bankCharge = parseFloat(transaction.bank_service_charge || 0) * exchangeRate;
            const bankVat = parseFloat(transaction.bank_vat_amount || 0) * exchangeRate;

            const totalBankCredit = commissionFee + commissionVat + bankCharge + bankVat;

            // ==== 5. Create Journal Entry ====
            const entryItems = [];

            // Debit Commission Expense
            if (commissionFee > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: commissionLedgerId,
                    dr_amount: commissionFee.toFixed(2),
                    cr_amount: null
                });
            }

            // Debit Bank Service Charge
            if (bankCharge > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: chargesLedgerId,
                    dr_amount: bankCharge.toFixed(2),
                    cr_amount: null
                });
            }

            // Debit Input VAT (for both commission and bank charge)
            const totalVat = commissionVat + bankVat;
            if (totalVat > 0) {
                entryItems.push({
                    dc: "D",
                    ledger_id: vatLedgerId,
                    dr_amount: totalVat.toFixed(2),
                    cr_amount: null
                });
            }

            // Credit Bank Account (Total Amount)
            entryItems.push({
                dc: "C",
                ledger_id: bankLedgerId,
                dr_amount: null,
                cr_amount: totalBankCredit.toFixed(2),
            });

            const entryPayload = {
                Entry: {
                    tag_id: null,
                    number: Date.now(),
                    date: transaction.date || new Date().toISOString().split("T")[0],
                    narration: transaction.description || `Bank Guarantee Charges`,
                    reference_no: transaction.reference_no || '',
                    related_transaction_id: transaction.related_transaction_id,
                    is_import: true,
                },
                Entryitem: entryItems,
            };

            console.log('Bank Guarantee Charges Entry Payload:', entryPayload);

            if (isEditMode && entryId) {
                // UPDATE existing entry
                console.log('?? Updating existing bank guarantee charges entry #', entryId);

                console.log("?? Deleting old entry:", entryId);
                await axios.post(
                    `${backendUrl}/entries/delete/payment/${entryId}`,
                    {},
                    { headers }
                );

                console.log("?? Creating new entry with updated values");
                const response = await axios.post(
                    `${backendUrl}/entries/add/payment`,
                    entryPayload,
                    { headers: { ...headers, "Content-Type": "application/json" } }
                );

                if (!response?.data) {
                    throw new Error("Failed to recreate entry");
                }

                console.log('? Bank guarantee charges entry updated successfully');
                showToast("Bank Guarantee Charges Updated Successfully!", "success");

                return {
                    journal_id: transaction.journal_id || null,
                    entry_id: response.data?.entry_id,
                };
            } else {
                // CREATE new entry
                console.log('?? Creating new bank guarantee charges entry');

                const response = await axios.post(`${backendUrl}/entries/add/payment`, entryPayload, {
                    headers: { ...headers, "Content-Type": "application/json" },
                });

                if (response.data?.status === 'error') {
                    throw new Error(response.data.message || "Bank guarantee charges transaction failed.");
                }

                const newEntryId = response.data?.entry_id;

                console.log('? New bank guarantee charges entry created successfully:', { entry_id: newEntryId });
                showToast("Bank Guarantee Charges Created Successfully!", "success");

                return {
                    journal_id: null,
                    entry_id: newEntryId,
                };
            }

        } catch (error) {
            console.error("? Error syncing bank guarantee charges transaction:", error);
            if (error.response?.status === 403) {
                return {
                    lockError: true,
                    message: error.response.data?.message || 'Financial year is locked in accounting system.'
                };
            }
            throw new Error(error.message || "Failed to sync bank guarantee charges transaction.");
        }
    };

    const rollbackWebzashEntry = async (entryId, type) => {
        if (!entryId) return;

        const API = process.env.REACT_APP_WEBZASH_URL;
        const backendUrl = `${API}/api`;
        const headers = {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Accept: "application/json",
        };

        try {
            console.log(`?? Rolling back Webzash entry #${entryId} (Type: ${type}) due to transaction failure...`);

            // Map transaction types to Webzash entry delete types
            let deleteType = 'payment'; // Default for most (expense, advance, payroll, etc)

            if (type === 'income' || type === 'capital' || type === 'bank_guarantee_released' || type === 'withdrawal') {
                deleteType = 'receipt';
            } else if (type === 'contra') {
                deleteType = 'contra';
            } else if (type === 'bad_debt_written_off') {
                deleteType = 'journal';
            }

            await axios.post(`${backendUrl}/entries/delete/${deleteType}/${entryId}`, {}, { headers });
            console.log(`? Webzash entry #${entryId} (${deleteType}) rolled back successfully.`);
        } catch (error) {
            console.error(`? Failed to rollback Webzash entry #${entryId}:`, error);
        }
    };

    return (


        <Offcanvas show={showModal} onHide={handleClose} placement="end" style={{ width: '600px' }}>
            {/* Header */}
            <Offcanvas.Header closeButton className="border-bottom px-4 py-3">
                <div className="d-flex align-items-center w-100">
                    <div className="bg-primary rounded-circle p-2 me-3">
                        <i className="mdi mdi-receipt text-white fs-5"></i>
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="mb-0 fw-semibold">
                            {isEditMode ? (transactionId ? 'Edit Transaction' : 'New Transaction') : 'Transaction Details'}
                        </h5>
                        <small className="text-muted">
                            {!isEditMode ? 'View complete transaction information' :
                                transactionId ? 'Update transaction details' : 'Create new transaction'}
                        </small>
                    </div>
                    {!isEditMode && (
                        <Badge bg="light" text="dark" className="ms-2">
                        </Badge>
                    )}
                </div>
            </Offcanvas.Header>
            <Offcanvas.Body className="d-flex flex-column">
                {!isEditMode && transactionId ? (
                    <div className="d-flex flex-column h-100">
                        <ul className="nav nav-tabs nav-tabs-custom mb-3">
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'details' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('details')}
                                    href="#"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Details
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    className={`nav-link ${activeTab === 'preview' ? 'active' : ''}`}
                                    onClick={() => setActiveTab('preview')}
                                    href="#"
                                    style={{ cursor: 'pointer' }}
                                >
                                    Attachment Preview
                                </a>
                            </li>
                        </ul>

                        <div className="tab-content flex-grow-1" style={{ overflowY: 'auto' }}>
                            {activeTab === 'details' ? (
                                <div className="p-2">
                                    {/* Header Summary */}
                                    <div className="bg-light border rounded p-3 mb-4">
                                        <div className="d-flex align-items-center">
                                            <div className={`rounded-circle p-3 me-3 ${formData.type === 'income' ? 'bg-success' : 'bg-light'}`}>
                                                <i className={`mdi mdi-${formData.type === 'income' ? 'arrow-down' : 'arrow-up'} text-${formData.type === 'income' ? 'white' : 'dark'} fs-4`}></i>
                                            </div>
                                            <div>
                                                <h4 className="mb-1 fw-bold text-dark">
                                                    {formData.type === 'bank_guarantee_charges' ? (
                                                        formatCurrency(parseFloat(formData.amount || 0))
                                                    ) : (
                                                        formatCurrency(
                                                            parseFloat(formData.amount || 0) +
                                                            (formData.type === 'bank_guarantee' ?
                                                                parseFloat(formData.commission_fee || 0) +
                                                                parseFloat(formData.commission_vat || 0) +
                                                                parseFloat(formData.bank_service_charge || 0) +
                                                                parseFloat(formData.bank_vat_amount || 0)
                                                                : 0) +
                                                            (formData.type === 'contra' || formData.type === 'withdrawal' || formData.type === 'vat_payable' || formData.type === 'payroll' ?
                                                                parseFloat(formData.bank_service_charge || 0) +
                                                                parseFloat(formData.bank_vat_amount || 0)
                                                                : 0)
                                                        )
                                                    )}
                                                </h4>
                                                <div className="d-flex align-items-center gap-2 flex-wrap">
                                                    <Badge bg="secondary">{formData.type ? formData.type.toUpperCase() : 'N/A'}</Badge>
                                                    <span className="text-muted">•</span>
                                                    <span className="text-muted">{formatDate(formData.date)}</span>
                                                    <span className="text-muted">•</span>
                                                    <Badge bg={formData.reconciliation_status === 'reconciled' ? 'success' : 'warning'}>
                                                        {formData.reconciliation_status ? formData.reconciliation_status.toUpperCase() : 'PENDING'}
                                                    </Badge>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Common Transaction Details */}
                                    <Card className="mb-4 shadow-sm">
                                        <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                            <h6 className="mb-0 fw-semibold text-dark">Transaction Information</h6>
                                        </Card.Header>
                                        <Card.Body className="pt-2">
                                            <Row>
                                                <Col md={6} className="mb-3">
                                                    <label className="text-muted small">Reference No</label>
                                                    <div className="fw-medium">{formData.reference_no || '-'}</div>
                                                </Col>
                                                <Col md={6} className="mb-3">
                                                    <label className="text-muted small">Details</label>
                                                    <div className="fw-medium">{formData.transaction || formData.description || '-'}</div>
                                                </Col>
                                                {formData.account && (
                                                    <Col md={12} className="mb-3">
                                                        <label className="text-muted small">Account</label>
                                                        <div className="fw-medium">{formData.account.name}</div>
                                                    </Col>
                                                )}
                                            </Row>
                                        </Card.Body>
                                    </Card>

                                    {/* Income-specific details */}
                                    {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && (
                                        <Row>
                                            {/* Show invoice details */}
                                            {formData.invoice_id && (
                                                <Col md={12}>
                                                    <div className="transaction-field mt-3">
                                                        <label className="form-label text-muted small fw-normal mb-1">Invoice Details</label>
                                                        <div className="border rounded p-3 bg-light">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                                                                <span className="text-muted">Invoice:</span>
                                                                <span className="fw-medium">
                                                                    {(() => {
                                                                        // 1. Check direct override from formData
                                                                        if (formData.invoice_ref_no) return formData.invoice_ref_no;

                                                                        // 2. Check transactionData for nested invoice object (Source of Truth)
                                                                        if (transactionData?.invoice) {
                                                                            const inv = transactionData.invoice;
                                                                            return inv.display_ref_no || inv.ref_no || inv.invoice_no || inv.reference_no || `Invoice #${inv.id}`;
                                                                        }

                                                                        // 3. Check loaded invoices list
                                                                        const inv = invoices?.find(i => i.id.toString() === formData.invoice_id?.toString());
                                                                        if (inv) {
                                                                            return inv.display_ref_no || inv.ref_no || inv.invoice_no || `Invoice #${inv.id}`;
                                                                        }

                                                                        return `Invoice #${formData.invoice_id}`;
                                                                    })()}
                                                                </span>
                                                            </div>
                                                            <div className="d-flex justify-content-between mb-2">
                                                                <span className="text-muted">Invoice Amount:</span>
                                                                <span className="fw-medium">
                                                                    {(() => {
                                                                        const invoice = invoices.find(inv => inv.id.toString() === formData.invoice_id?.toString());
                                                                        return invoice ? formatCurrency(invoice.display_amount || invoice.total_with_vat || 0) : '';
                                                                    })()}
                                                                </span>
                                                            </div>
                                                            {formData.advance_amount && parseFloat(formData.advance_amount) > 0 && (
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <span className="text-muted">Advance Amount:</span>
                                                                    <span className="fw-medium text-info">
                                                                        {formatCurrency(formData.advance_amount)}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {formData.deduction_amount && parseFloat(formData.deduction_amount) > 0 && (
                                                                <div className="d-flex justify-content-between mb-2">
                                                                    <span className="text-muted">Deduction:</span>
                                                                    <span className="fw-medium text-danger">
                                                                        {formatCurrency(formData.deduction_amount)}
                                                                    </span>
                                                                </div>
                                                            )}
                                                            {formData.type === 'income' && parseFloat(formData.applied_advance || transactionData?.applied_advance || 0) > 0 ? (
                                                                <>
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <span className="text-muted">Applied Advance Amount:</span>
                                                                        <span className="fw-medium text-danger">-{formatCurrency(formData.applied_advance || transactionData?.applied_advance)}</span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mb-2">
                                                                        <span className="text-muted">Invoice Amount:</span>
                                                                        <span className="fw-medium text-dark">
                                                                            {formatCurrency(
                                                                                parseFloat(formData.amount || 0) +
                                                                                parseFloat(formData.applied_advance || transactionData?.applied_advance || 0)
                                                                            )}
                                                                        </span>
                                                                    </div>
                                                                    <div className="d-flex justify-content-between mt-2 pt-2 border-top">
                                                                        <span className="fw-semibold">Paid Amount:</span>
                                                                        <span className="fw-bold text-success">
                                                                            {formatCurrency(formData.amount)}
                                                                        </span>
                                                                    </div>
                                                                </>
                                                            ) : (
                                                                <div className="d-flex justify-content-between mt-2 pt-2 border-top">
                                                                    <span className="fw-semibold">Net Amount:</span>
                                                                    <span className="fw-semibold text-primary">
                                                                        {formatCurrency(formData.amount)}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}

                                            {/* For multiple invoices */}
                                            {formData.selected_invoices && formData.selected_invoices.length > 0 && (
                                                <Col md={12}>
                                                    <div className="transaction-field mt-3">
                                                        <label className="form-label text-muted small fw-normal mb-1">Invoices Applied</label>
                                                        <div className="border rounded">
                                                            {formData.selected_invoices.map((invoice, index) => (
                                                                <div key={index} className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                                                    <div>
                                                                        <div className="fw-medium">
                                                                            {(() => {
                                                                                // 1. Try to get ref_no from invoices list if label is generic
                                                                                const invId = invoice.value || invoice.id;

                                                                                // Check transactionData invoices first (if they exist as objects)
                                                                                if (transactionData?.invoices && Array.isArray(transactionData.invoices)) {
                                                                                    const tInv = transactionData.invoices.find(i => i.id == invId);
                                                                                    if (tInv && (tInv.display_ref_no || tInv.ref_no || tInv.invoice_no)) {
                                                                                        return `${tInv.display_ref_no || tInv.ref_no || tInv.invoice_no} `;
                                                                                    }
                                                                                }

                                                                                const fullInv = invoices?.find(i => i.id == invId);
                                                                                if (fullInv && (fullInv.display_ref_no || fullInv.ref_no || fullInv.invoice_no)) {
                                                                                    return `${fullInv.display_ref_no || fullInv.ref_no || fullInv.invoice_no} `;
                                                                                }
                                                                                return invoice.label || `Invoice #${invId}`;
                                                                            })()}
                                                                        </div>
                                                                        <small className="text-muted">
                                                                            {invoice.invoice_type === 'tax' ? 'Tax Invoice' : 'Proforma Invoice'}
                                                                        </small>
                                                                    </div>
                                                                    <div className="fw-semibold text-dark">
                                                                        {formatCurrency(invoice.amount || 0)}
                                                                    </div>
                                                                </div>
                                                            ))}
                                                            <div className="p-3 bg-light">
                                                                {formData.type === 'income' && parseFloat(formData.applied_advance || transactionData?.applied_advance || 0) > 0 ? (
                                                                    <>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Applied Advance Amount</div>
                                                                            <div className="fw-bold text-danger">-{formatCurrency(formData.applied_advance || transactionData?.applied_advance)}</div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Invoice Amount</div>
                                                                            <div className="fw-bold text-dark">
                                                                                {formatCurrency(
                                                                                    parseFloat(formData.amount || 0) +
                                                                                    parseFloat(formData.applied_advance || transactionData?.applied_advance || 0)
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Paid Amount</div>
                                                                            <div className="fw-bold text-success">
                                                                                {formatCurrency(formData.amount)}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Total Invoice Amount</div>
                                                                            <div className="fw-bold text-success">
                                                                                {formatCurrency(formData.selected_invoices.reduce((sum, inv) => sum + (parseFloat(inv.amount) || 0), 0))}
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Total Paid</div>
                                                                            <div className="fw-bold text-success">
                                                                                {formatCurrency(formData.amount)}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                                <div className="d-flex justify-content-between align-items-center">
                                                                    <div className="fw-bold text-muted">Total Remaining Balance</div>
                                                                    <div className="fw-bold text-danger">
                                                                        {formatCurrency(formData.selected_invoices.reduce((sum, inv) => {
                                                                            // Try to find the full invoice to get the true remaining balance
                                                                            const invId = inv.value || inv.id;
                                                                            const fullInv = invoices?.find(i => i.id == invId);
                                                                            const remaining = fullInv ? (parseFloat(fullInv.remaining_balance) || 0) : (parseFloat(inv.remaining_balance) || 0);
                                                                            return sum + remaining;
                                                                        }, 0))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                    )}

                                    {/* Expense-specific details */}
                                    {formData.type === 'expense' && (
                                        <Row>




                                            {/* Show narration */}
                                            {formData.description && (
                                                <Col md={12}>
                                                    <div className="transaction-field">
                                                        <label className="form-label text-muted small fw-normal mb-1">Narration</label>
                                                        <div className="p-2 bg-light rounded border">
                                                            {formData.description}
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                            {formData.type === 'expense' && (
                                                <Col md={12}>
                                                    <div className="transaction-field">
                                                        <label className="form-label text-muted small fw-normal mb-1">Expense Breakdown</label>
                                                        <div className="border rounded">
                                                            {relatedExpenses && relatedExpenses.length > 0 ? (
                                                                relatedExpenses.map((expense, index) => {
                                                                    // Get narration from expense
                                                                    const narration = expense.narration ||
                                                                        expense.expense_type?.name ||
                                                                        'Expense';

                                                                    const amount = expense.total_amount || expense.amount || 0;
                                                                    const invoiceNo = expense.invoice_no || 'No Invoice';
                                                                    const expenseType = expense.expense_type?.name || 'N/A';

                                                                    return (
                                                                        <div key={index} className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                                                            <div>
                                                                                <div className="fw-medium">
                                                                                    {narration}
                                                                                </div>
                                                                                <div className="small text-muted mt-1">
                                                                                    {invoiceNo !== 'No Invoice' && (
                                                                                        <span className="me-2">Invoice: {invoiceNo}</span>
                                                                                    )}
                                                                                    {expenseType && narration !== expenseType && (
                                                                                        <span>Type: {expenseType}</span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="fw-semibold text-dark">
                                                                                {formatCurrency(amount)}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : formData.bills && formData.bills.length > 0 ? (
                                                                // Fallback to bills array if relatedExpenses is empty
                                                                formData.bills.map((bill, index) => {
                                                                    const narration = bill.expense_type_name ||
                                                                        (bill.label ? bill.label.split(' - ')[0] : 'Expense') ||
                                                                        'Expense';
                                                                    const amount = bill.amount || 0;
                                                                    const invoiceNo = bill.invoice_no || 'No Invoice';

                                                                    return (
                                                                        <div key={index} className="d-flex justify-content-between align-items-center p-3 border-bottom">
                                                                            <div>
                                                                                <div className="fw-medium">
                                                                                    {narration}
                                                                                </div>
                                                                                {invoiceNo !== 'No Invoice' && (
                                                                                    <div className="small text-muted mt-1">
                                                                                        Invoice: {invoiceNo}
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                            <div className="fw-semibold text-dark">
                                                                                {formatCurrency(amount)}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })
                                                            ) : (
                                                                <div className="p-3 text-center text-muted">
                                                                    {formData.expense_id ? (
                                                                        <div>
                                                                            <div>Expense IDs: {formData.expense_id}</div>
                                                                            <small>No detailed expense information available</small>
                                                                        </div>
                                                                    ) : (
                                                                        "No expense details available"
                                                                    )}
                                                                </div>
                                                            )}
                                                            <div className="p-3 bg-light">
                                                                {formData.use_advance && parseFloat(formData.applied_advance) > 0 ? (
                                                                    <>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Total Bill Amount Paid</div>
                                                                            <div className="fw-bold text-dark">
                                                                                {formatCurrency(
                                                                                    (parseFloat(formData.received_amount || formData.amount) || 0) +
                                                                                    (parseFloat(formData.applied_advance) || 0)
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <div className="fw-bold">Applied from Advance</div>
                                                                            <div className="fw-bold text-danger">-{formatCurrency(formData.applied_advance)}</div>
                                                                        </div>
                                                                        <div className="d-flex justify-content-between align-items-center pt-2 border-top">
                                                                            <div className="fw-bold">Net Paid (Cash/Bank)</div>
                                                                            <div className="fw-bold text-success">
                                                                                {formatCurrency(formData.received_amount || formData.amount)}
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                ) : (
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <div className="fw-bold">Total Paid (Cash/Bank)</div>
                                                                        <div className="fw-bold text-primary">
                                                                            {formatCurrency(formData.amount)}
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            )}
                                        </Row>
                                    )}
                                    {formData.type === 'payroll' && (
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                <h6 className="mb-0 fw-semibold text-dark">
                                                    <i className="mdi mdi-account-cash text-primary me-2"></i>
                                                    Payroll Details
                                                </h6>
                                            </Card.Header>
                                            <Card.Body className="pt-2">
                                                <Row>


                                                    <Col md={6} className="mb-3">
                                                        <label className="text-muted small">Salary Amount</label>
                                                        <div className="fw-bold text-primary">
                                                            {formatCurrency(totalSalaryAmount)}
                                                        </div>
                                                    </Col>

                                                    {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">Bank Service Charge</label>
                                                            <div className="fw-medium text-warning">
                                                                {formatCurrency(formData.bank_service_charge)}
                                                            </div>
                                                        </Col>
                                                    )}

                                                    {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">VAT on Bank Charge</label>
                                                            <div className="fw-medium text-info">
                                                                {formatCurrency(formData.bank_vat_amount)}
                                                            </div>
                                                        </Col>
                                                    )}

                                                    <Col md={12} className="mb-3">
                                                        <label className="text-muted small">Total Transaction Amount</label>
                                                        <div className="fw-bold fs-5 text-success">
                                                            {formatCurrency(formData.amount)}
                                                        </div>
                                                    </Col>
                                                </Row>

                                                {/* Show WPS charges if they exist */}
                                                {(formData.wps_charge || formData.wps_vat) && (
                                                    <div className="border-top pt-3 mt-3">
                                                        <label className="text-muted small mb-2 d-block">WPS Details</label>
                                                        <Row>
                                                            {formData.wps_charge && (
                                                                <Col md={6} className="mb-2">
                                                                    <span className="text-muted">WPS Charge:</span>
                                                                    <span className="fw-medium ms-2">
                                                                        {formatCurrency(formData.wps_charge)}
                                                                    </span>
                                                                </Col>
                                                            )}
                                                            {formData.wps_vat && (
                                                                <Col md={6} className="mb-2">
                                                                    <span className="text-muted">WPS VAT:</span>
                                                                    <span className="fw-medium ms-2">
                                                                        {formatCurrency(formData.wps_vat)}
                                                                    </span>
                                                                </Col>
                                                            )}
                                                        </Row>
                                                    </div>
                                                )}
                                            </Card.Body>
                                        </Card>
                                    )}
                                    {/* VAT Payable-specific details */}
                                    {formData.type === 'vat_payable' && (
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                <h6 className="mb-0 fw-semibold text-dark">
                                                    <i className="mdi mdi-cash text-primary me-2"></i>
                                                    VAT Payment Details
                                                </h6>
                                            </Card.Header>
                                            <Card.Body className="pt-2">
                                                <Row>
                                                    <Col md={6} className="mb-3">
                                                        <label className="text-muted small">VAT Amount</label>
                                                        <div className="fw-bold fs-5 text-primary">
                                                            {formatCurrency(formData.amount)}
                                                        </div>
                                                    </Col>
                                                    {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">Bank Service Charge</label>
                                                            <div className="fw-medium text-warning">
                                                                {formatCurrency(formData.bank_service_charge)}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">VAT on Bank Charge</label>
                                                            <div className="fw-medium text-info">
                                                                {formatCurrency(formData.bank_vat_amount)}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    <Col md={12} className="mb-3">
                                                        <label className="text-muted small">Total Bank Debit</label>
                                                        <div className="fw-bold fs-5 text-success">
                                                            {formatCurrency(
                                                                parseFloat(formData.amount || 0) +
                                                                parseFloat(formData.bank_service_charge || 0) +
                                                                parseFloat(formData.bank_vat_amount || 0)
                                                            )}
                                                        </div>
                                                    </Col>

                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    )}
                                    <br />
                                    {formData.type === 'bank_guarantee_charges' && (
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                <h6 className="mb-0 fw-semibold text-dark">
                                                    <i className="mdi mdi-bank-transfer text-primary me-2"></i>
                                                    Bank Guarantee Charges Details
                                                </h6>
                                            </Card.Header>
                                            <Card.Body className="pt-2">
                                                <Row>
                                                    {formData.commission_fee && parseFloat(formData.commission_fee) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">Commission Fee</label>
                                                            <div className="fw-medium text-warning">
                                                                {formatCurrency(formData.commission_fee)}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {formData.commission_vat && parseFloat(formData.commission_vat) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">VAT on Commission</label>
                                                            <div className="fw-medium text-info">
                                                                {formatCurrency(formData.commission_vat)}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">Bank Service Charge</label>
                                                            <div className="fw-medium text-warning">
                                                                {formatCurrency(formData.bank_service_charge)}
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                        <Col md={6} className="mb-3">
                                                            <label className="text-muted small">VAT on Bank Charge</label>
                                                            <div className="fw-medium text-info">
                                                                {formatCurrency(formData.bank_vat_amount)}
                                                            </div>
                                                        </Col>
                                                    )}

                                                    {/* Show breakdown and total */}
                                                    <Col md={12} className="mb-3 border-top pt-3">
                                                        <label className="text-muted small mb-2">Breakdown</label>
                                                        <div className="d-flex justify-content-between mb-1">
                                                            <span>Commission Fee:</span>
                                                            <span>{formatCurrency(formData.commission_fee || 0)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between mb-1">
                                                            <span>Commission VAT:</span>
                                                            <span>{formatCurrency(formData.commission_vat || 0)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between mb-1">
                                                            <span>Bank Service Charge:</span>
                                                            <span>{formatCurrency(formData.bank_service_charge || 0)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between mb-1">
                                                            <span>Bank Service VAT:</span>
                                                            <span>{formatCurrency(formData.bank_vat_amount || 0)}</span>
                                                        </div>
                                                        <div className="d-flex justify-content-between mt-2 pt-2 border-top">
                                                            <span className="fw-bold">Total (Saved to Amount):</span>
                                                            <span className="fw-bold text-success">
                                                                {formatCurrency(formData.amount || 0)}
                                                            </span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    )}
                                    {formData.type === 'bank_guarantee_charges' && (
                                        <Card className="mb-4 shadow-sm">
                                            <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                <h6 className="mb-0 fw-semibold text-dark">
                                                    <i className="mdi mdi-bank-transfer text-primary me-2"></i>
                                                    Related Bank Guarantee Details
                                                </h6>
                                            </Card.Header>
                                            <Card.Body className="pt-2">
                                                <Row>
                                                    {(() => {
                                                        // Find the related bank guarantee
                                                        const relatedGuarantee = pendingGuarantees.find(
                                                            g => g.id?.toString() === formData.guarantee_id?.toString()
                                                        ) || transactionData?.related_guarantee;

                                                        if (relatedGuarantee) {
                                                            return (
                                                                <>
                                                                    <Col md={6} className="mb-3">
                                                                        <label className="text-muted small">Bank Guarantee ID</label>
                                                                        <div className="fw-medium text-dark">
                                                                            {relatedGuarantee.transaction_voucher_id ||
                                                                                relatedGuarantee.id ||
                                                                                'N/A'}
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6} className="mb-3">
                                                                        <label className="text-muted small">Amount</label>
                                                                        <div className="fw-medium text-dark">
                                                                            {formatCurrency(relatedGuarantee.amount)}
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={6} className="mb-3">
                                                                        <label className="text-muted small">Date Issued</label>
                                                                        <div className="fw-medium text-dark">
                                                                            {formatDate(relatedGuarantee.date)}
                                                                        </div>
                                                                    </Col>
                                                                    <Col md={12} className="mb-3">
                                                                        <label className="text-muted small">Description</label>
                                                                        <div className="fw-medium text-dark">
                                                                            {relatedGuarantee.description || 'N/A'}
                                                                        </div>
                                                                    </Col>
                                                                </>
                                                            );
                                                        } else {
                                                            return (
                                                                <Col md={12}>
                                                                    <div className="text-muted text-center p-3">
                                                                        <i className="mdi mdi-alert-circle-outline me-2"></i>
                                                                        Related bank guarantee details not found
                                                                    </div>
                                                                </Col>
                                                            );
                                                        }
                                                    })()}
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    )}
                                    {/* Account & Party Information */}
                                    <Row>
                                        {formData.type !== 'bad_debt_written_off' && (
                                            <Col md={6}>
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                        <h6 className="mb-0 fw-semibold text-dark">
                                                            <i className="mdi mdi-bank text-primary me-2"></i>
                                                            Account Details
                                                        </h6>
                                                    </Card.Header>
                                                    <Card.Body className="pt-2">
                                                        <div className="transaction-field mb-3">
                                                            <label className="form-label text-muted small fw-normal mb-1">Account Type</label>
                                                            <div className="fw-medium text-dark">
                                                                {formData.account_type ?
                                                                    formData.account_type.split(' ')
                                                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                                                        .join(' ')
                                                                    : 'N/A'
                                                                }
                                                            </div>
                                                        </div>

                                                        {/* Standard Account Display (Hidden for Contra to avoid confusion, or kept if identical to From Bank) */}
                                                        {formData.type !== 'contra' && (
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Account</label>
                                                                <div className="fw-medium text-dark">
                                                                    {getDisplayName(formData.account_id, banks)}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Special Contra Account Display */}
                                                        {formData.type === 'contra' && (
                                                            <>
                                                                <div className="transaction-field mb-3">
                                                                    <label className="form-label text-muted small fw-normal mb-1">From Bank</label>
                                                                    <div className="fw-medium text-dark">
                                                                        {getDisplayName(formData.from_bank_id, banks)}
                                                                    </div>
                                                                </div>
                                                                <div className="transaction-field mb-3">
                                                                    <label className="form-label text-muted small fw-normal mb-1">To Bank</label>
                                                                    <div className="fw-medium text-dark">
                                                                        {getDisplayName(formData.to_bank_id, banks)}
                                                                    </div>
                                                                </div>

                                                            </>
                                                        )}

                                                        {formData.type === 'expense' && (
                                                            <div className="transaction-field mt-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Payment Method</label>
                                                                <div className="fw-medium text-dark">
                                                                    {formData.payment_mode ?
                                                                        formData.payment_mode.split('_')
                                                                            .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                                                            .join(' ')
                                                                        : 'N/A'
                                                                    }
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )}

                                        {/* Bank Guarantee Commission Fields - Inserted before Bank Service Charge */}


                                        {(formData.type === 'contra' || formData.type === 'withdrawal') && (
                                            <Col md={6}>
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                        <h6 className="mb-0 fw-semibold text-dark">
                                                            <i className="mdi mdi-account-circle text-primary me-2"></i>
                                                            {formData.type === 'contra' ? 'Payment Details' : 'Payment Details'}
                                                        </h6>
                                                    </Card.Header>
                                                    <Card.Body className="pt-2">
                                                        {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Bank Service Charge</label>
                                                                <div className="fw-medium text-warning">
                                                                    {formatCurrency(formData.bank_service_charge)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">VAT on Bank Charge</label>
                                                                <div className="fw-medium text-info">
                                                                    {formatCurrency(formData.bank_vat_amount)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(parseFloat(formData.bank_service_charge || 0) > 0 || parseFloat(formData.bank_vat_amount || 0) > 0 || parseFloat(formData.amount || 0) > 0) && (
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Total From Bank Debit</label>
                                                                <div className="fw-bold text-success">
                                                                    {formatCurrency(
                                                                        parseFloat(formData.amount || 0) +
                                                                        parseFloat(formData.bank_service_charge || 0) +
                                                                        parseFloat(formData.bank_vat_amount || 0)
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                        }
                                        {(formData.type === 'bank_guarantee') && (
                                            <Col md={6}>
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                        <h6 className="mb-0 fw-semibold text-dark">
                                                            <i className="mdi mdi-account-circle text-primary me-2"></i>
                                                            {formData.type === 'bank_guarantee' ? 'Payment Details' : 'Payment Details'}
                                                        </h6>
                                                    </Card.Header>
                                                    <Card.Body className="pt-2">
                                                        {formData.commission_fee && parseFloat(formData.commission_fee) > 0 && (

                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Commission Fee</label>
                                                                <div className="fw-medium text-warning">
                                                                    {formatCurrency(formData.commission_fee)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {formData.commission_vat && parseFloat(formData.commission_vat) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">VAT on Commission Fee</label>
                                                                <div className="fw-medium text-info">
                                                                    {formatCurrency(formData.commission_vat)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Bank Service Charge</label>
                                                                <div className="fw-medium text-warning">
                                                                    {formatCurrency(formData.bank_service_charge)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">VAT on Bank Charge</label>
                                                                <div className="fw-medium text-info">
                                                                    {formatCurrency(formData.bank_vat_amount)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {formData.amount && parseFloat(formData.amount) > 0 && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Amount</label>
                                                                <div className="fw-medium text-info">
                                                                    {formatCurrency(formData.amount)}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(parseFloat(formData.bank_service_charge || 0) > 0 || parseFloat(formData.bank_vat_amount || 0) > 0 || parseFloat(formData.commission_fee || 0) > 0 || parseFloat(formData.commission_vat || 0) > 0) && (
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Total From Bank Debit</label>
                                                                <div className="fw-bold text-success">
                                                                    {formatCurrency(
                                                                        parseFloat(formData.amount || 0) +
                                                                        parseFloat(formData.bank_service_charge || 0) +
                                                                        parseFloat(formData.bank_vat_amount || 0) +
                                                                        parseFloat(formData.commission_fee || 0) +
                                                                        parseFloat(formData.commission_vat || 0)
                                                                    )}
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* Misplaced income block removed */}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                        }
                                        {/* Bank Guarantee Charges-specific details */}

                                        {/* Hide Client/Payee Details for Contra/Withdrawal */}
                                        {/* Show Client/Payee Details for all non-internal types */}
                                        {(formData.type !== 'contra' && formData.type !== 'withdrawal' && formData.type !== 'bank_guarantee' && formData.type !== 'advance' && formData.type !== 'bank_guarantee_charges') && (
                                            <Col md={formData.type === 'bad_debt_written_off' ? 12 : 6}>
                                                <Card className="h-100 shadow-sm">
                                                    <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                        <h6 className="mb-0 fw-semibold text-dark">
                                                            <i className="mdi mdi-account-circle text-primary me-2"></i>
                                                            {formData.type === 'income' || formData.type === 'bad_debt_written_off' ? 'Client Details' : 'Payee Details'}
                                                        </h6>
                                                    </Card.Header>
                                                    <Card.Body className="pt-2">
                                                        <div className="transaction-field mb-3">
                                                            <label className="form-label text-muted small fw-normal mb-1">
                                                                {formData.type === 'income' || formData.type === 'bad_debt_written_off' ? 'Client' :
                                                                    formData.payment_mode === 'vendor' ? 'Vendor' : 'Employee'}
                                                            </label>
                                                            <div className="fw-medium text-dark">
                                                                {formData.type === 'income' || formData.type === 'bad_debt_written_off' ?
                                                                    (formData.client_id === "0" ?
                                                                        <span className="text-warning">Unrecognized Client</span> :
                                                                        getDisplayName(formData.client_id, clients)
                                                                    ) :
                                                                    (formData.payment_mode === 'vendor' ?
                                                                        getDisplayName(formData.vendor_id, vendors) :
                                                                        getDisplayName(formData.user_id, users)
                                                                    )
                                                                }
                                                            </div>
                                                        </div>
                                                        {/* ... (rest of the card content logic remains dependent on type != contra implicitly) */}
                                                        {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && formData.project_id && (
                                                            <div className="transaction-field mb-3">
                                                                <label className="form-label text-muted small fw-normal mb-1">Project</label>
                                                                <div className="fw-medium text-dark">
                                                                    {(() => {
                                                                        // 1. Use transactionData.projects if available (Best for View Mode)
                                                                        if (transactionData?.projects && Array.isArray(transactionData.projects) && transactionData.projects.length > 0) {
                                                                            return transactionData.projects.map(p => p.name).join(', ');
                                                                        }

                                                                        // 2. Handle multiple projects from formData
                                                                        if (formData.project_ids && formData.project_ids.length > 0) {
                                                                            // If project_ids is array of IDs
                                                                            if (Array.isArray(formData.project_ids)) {
                                                                                // Try to find names in loaded projects list
                                                                                const names = formData.project_ids.map(id => {
                                                                                    const p = projects?.find(proj => proj.id == id);
                                                                                    return p ? p.name : `Project #${id}`; // Fallback to ID if name not found
                                                                                });
                                                                                return names.join(', ');
                                                                            }
                                                                            // If it's a comma-separated string
                                                                            else if (typeof formData.project_ids === 'string') {
                                                                                const ids = formData.project_ids.split(',');
                                                                                const names = ids.map(id => {
                                                                                    const p = projects?.find(proj => proj.id == id.trim());
                                                                                    return p ? p.name : `Project #${id}`;
                                                                                });
                                                                                return names.join(', ');
                                                                            }
                                                                        }

                                                                        // 3. Fallback to single project_id
                                                                        // Check transactionData first for object
                                                                        if (transactionData?.project && transactionData.project.name) {
                                                                            return transactionData.project.name;
                                                                        }

                                                                        return getDisplayName(formData.project_id, projects);
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        )}
                                                        {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && formData.invoice_id && (
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Invoice Reference</label>
                                                                <div className="fw-medium text-dark">
                                                                    {(() => {
                                                                        // Check transactionData for source of truth
                                                                        if (transactionData?.invoice) {
                                                                            const inv = transactionData.invoice;
                                                                            return inv.display_ref_no || inv.ref_no || inv.invoice_no || `Invoice #${formData.invoice_id}`;
                                                                        }

                                                                        const inv = invoices?.find(i => i.id.toString() === formData.invoice_id?.toString());
                                                                        return inv ? (inv.display_ref_no || inv.ref_no || inv.invoice_no || `Invoice #${formData.invoice_id}`) : `Invoice #${formData.invoice_id}`;
                                                                    })()}
                                                                </div>
                                                            </div>
                                                        )}
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                        }
                                    </Row>

                                    {/* Attachment Preview for Contra */}
                                    {/* {formData.type === 'contra' && (transactionData?.statement_file || formData.statement_file) && (
                                            <Row className="mt-4">
                                                <Col>
                                                    <Card className="shadow-sm">
                                                        <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                            <h6 className="mb-0 fw-semibold text-dark">
                                                                <i className="mdi mdi-paperclip text-primary me-2"></i>
                                                                Statement Attachment
                                                            </h6>
                                                        </Card.Header>
                                                        <Card.Body className="p-0">
                                                            {(() => {
                                                                const fileUrl = transactionData?.statement_file
                                                                    ? (transactionData.statement_file.startsWith('http')
                                                                        ? transactionData.statement_file
                                                                        : `${process.env.REACT_APP_BACKEND_URL}/storage/${transactionData.statement_file}`)
                                                                    : null;

                                                                if (!fileUrl) return <div className="p-3 text-muted">No preview available</div>;

                                                                return (
                                                                    <div style={{ height: '500px', width: '100%' }}>
                                                                        <iframe
                                                                            src={fileUrl}
                                                                            title="Statement Preview"
                                                                            style={{ width: '100%', height: '100%', border: 'none' }}
                                                                        />
                                                                    </div>
                                                                );
                                                            })()}
                                                        </Card.Body>
                                                    </Card>
                                                </Col>
                                            </Row>
                                        )} */}


                                    {
                                        formData.type === 'advance' && (
                                            <Card className="mb-4 shadow-sm">
                                                <Card.Header className="bg-white border-bottom-0 pt-3 pb-2">
                                                    <h6 className="mb-0 fw-semibold text-dark">
                                                        <i className="mdi mdi-cash-plus text-primary me-2"></i>
                                                        Advance Details
                                                    </h6>
                                                </Card.Header>
                                                <Card.Body className="pt-2">
                                                    <Row className="g-3">
                                                        <Col md={6}>
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">
                                                                    {formData.advance_type === 'client' ? 'Client' : 'Vendor'}
                                                                </label>
                                                                <div className="fw-medium text-dark">
                                                                    {formData.advance_type === 'client'
                                                                        ? getDisplayName(formData.client_id, clients)
                                                                        : getDisplayName(formData.vendor_id, vendors)}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        <Col md={6}>
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Project</label>
                                                                <div className="fw-medium text-dark">
                                                                    {getDisplayName(formData.project_id, projects)}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {formData.po_id && (
                                                            <Col md={6}>
                                                                <div className="transaction-field">
                                                                    <label className="form-label text-muted small fw-normal mb-1">Purchase Order</label>
                                                                    <div className="fw-medium text-dark">
                                                                        PO-{formData.po_id}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                        <Col md={6}>
                                                            <div className="transaction-field">
                                                                <label className="form-label text-muted small fw-normal mb-1">Amount</label>
                                                                <div className="fw-bold fs-5 text-primary">
                                                                    {formatCurrency(formData.amount)}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                        {formData.bank_service_charge && parseFloat(formData.bank_service_charge) > 0 && (
                                                            <Col md={6}>
                                                                <div className="transaction-field">
                                                                    <label className="form-label text-muted small fw-normal mb-1">Bank Service Charge</label>
                                                                    <div className="fw-medium text-warning">
                                                                        {formatCurrency(formData.bank_service_charge)}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                        {formData.bank_vat_amount && parseFloat(formData.bank_vat_amount) > 0 && (
                                                            <Col md={6}>
                                                                <div className="transaction-field">
                                                                    <label className="form-label text-muted small fw-normal mb-1">VAT on Bank Charge</label>
                                                                    <div className="fw-medium text-info">
                                                                        {formatCurrency(formData.bank_vat_amount)}
                                                                    </div>
                                                                </div>
                                                            </Col>
                                                        )}
                                                        <Col md={12}>
                                                            <div className="transaction-field p-2 bg-light rounded shadow-none border">
                                                                <label className="form-label text-muted small fw-normal mb-1">
                                                                    {formData.advance_type === 'client' ? 'Total Bank Receipt' : 'Total From Bank Debit'}
                                                                </label>
                                                                <div className="fw-bold text-success fs-5">
                                                                    {formatCurrency(
                                                                        formData.advance_type === 'client'
                                                                            ? (parseFloat(formData.amount || 0) - parseFloat(formData.bank_service_charge || 0) - parseFloat(formData.bank_vat_amount || 0))
                                                                            : (parseFloat(formData.amount || 0) + parseFloat(formData.bank_service_charge || 0) + parseFloat(formData.bank_vat_amount || 0))
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </Card.Body>
                                            </Card>
                                        )
                                    }
                                </div>
                            ) : (
                                <div className="h-100 d-flex flex-column bg-light" style={{ minHeight: '400px' }}>
                                    {/* Preview Tab Content */}
                                    {formData.statement_file ? (
                                        <div className="flex-grow-1 p-3 h-100 d-flex flex-column">
                                            <div className="flex-grow-1 bg-white border rounded overflow-hidden position-relative">
                                                {(typeof formData.statement_file === 'string' && (formData.statement_file.match(/\.(jpg|jpeg|png|gif|webp)$/i))) ? (
                                                    <img
                                                        src={`${backendUrl}/storage/${formData.statement_file}`}
                                                        className="w-100 h-100"
                                                        style={{ objectFit: 'contain' }}
                                                        alt="Attachment"
                                                    />
                                                ) : (
                                                    <iframe
                                                        src={`${backendUrl}/storage/${formData.statement_file}`}
                                                        className="w-100 h-100"
                                                        style={{ border: 'none' }}
                                                        title="Document Preview"
                                                    />
                                                )}
                                            </div>
                                            {/* <div className="mt-2 text-end">
                                                <a href={`${backendUrl}/storage/${formData.statement_file}`} target="_blank" className="btn btn-sm btn-outline-primary">
                                                    <i className="mdi mdi-open-in-new me-1"></i> Open Original
                                                </a>
                                            </div> */}
                                        </div>
                                    ) : (
                                        <div className="d-flex flex-column align-items-center justify-content-center h-100 text-muted p-5">
                                            <i className="mdi mdi-paperclip fs-1 mb-2 opacity-25"></i>
                                            <p>No Attachment Found</p>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div >
                ) : (
                    // EDIT MODE - Existing form
                    <div className="p-4">
                        <div className="mb-4">
                            <Form>
                                {/* <Form.Group controlId="date" className="mb-3">
                                    <Form.Label className='form-font'>Date</Form.Label>
                                    <Form.Control
                                        className="form-feild form-control"
                                        type="date"
                                        name="date"
                                        value={formData.date}
                                        onChange={handleChange}
                                    />
                                </Form.Group> */}
                                {lockError && (
                                    <div className="alert alert-danger m-3 mb-0">
                                        <i className="mdi mdi-alert-circle-outline me-2"></i>
                                        {lockError}
                                    </div>
                                )}
                                <div className="mb-3">
                                    <label className="form-font"> Date</label>

                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DatePicker
                                            views={["year", "month", "day"]}
                                            format="DD-MM-YYYY"
                                            density="compact"
                                            className='form-feild form-control'
                                            value={
                                                formData.date && dayjs(formData.date).isValid()
                                                    ? dayjs(formData.date)
                                                    : null
                                            }
                                            onChange={(newValue) => {
                                                setFormData((prev) => ({
                                                    ...prev,
                                                    date: newValue ? newValue.format("YYYY-MM-DD") : "",
                                                }));
                                            }}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    className: "form-feild",
                                                },
                                                popper: {
                                                    disablePortal: true,   // ? KEY LINE
                                                    sx: {
                                                        zIndex: 2000,        // ? ensure above offcanvas content
                                                    },
                                                },
                                            }}
                                        />

                                    </LocalizationProvider>
                                </div>



                                <Form.Group controlId="date" className="mb-3">
                                    <Form.Label className='form-font'> Type</Form.Label>
                                    <Form.Select name='type' value={formData.type} onChange={handleChange}
                                        className={`form-feild ${errors.type ? 'is-invalid' : ''}`}
                                    >
                                        <option value="">Select</option>
                                        <option value="advance">Advance</option>
                                        <option value="bad_debt_written_off">Bad Debt Written Off</option>
                                        <option value="bank_guarantee">Bank Guarantee Issued</option>
                                        <option value="bank_guarantee_charges">Bank Guarantee Charges</option>
                                        <option value="bank_guarantee_released">Bank Guarantee Released</option>
                                        <option value="capital">Capital</option>
                                        <option value="contra">Contra</option>
                                        <option value="expense"> Expense</option>
                                        <option value="income">Income</option>
                                        <option value="payroll">Payroll</option>
                                        <option value="vat_payable">VAT Payment</option>
                                        <option value="withdrawal">Withdrawal</option>
                                    </Form.Select>
                                    {errors.type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.type}</div>}
                                </Form.Group>

                                {/* {formData.type === 'vat_payable' && (
                                    <Form.Group controlId="vat_return_id" className="mb-3">
                                        <Form.Label className='form-font'>Select VAT Return</Form.Label>
                                        <Select
                                            options={vatReturns
.filter(ret => ret.submitted_at && ret.submitted_at.trim() !== '')                                             
   .map(ret => ({
                                                value: ret.id,
                                                label: `${dayjs(ret.period_start).format('DD MMM YYYY')} - ${dayjs(ret.period_end).format('DD MMM YYYY')} (${ret.net_vat_payable} AED)`,
                                                vatReturn: ret
                                            }))}
                                            onChange={handleVatReturnSelect}
                                            isClearable
                                            placeholder="Search pending VAT returns..."
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: "white",
                                                    border: "1px solid #e8e9ed",
                                                    borderRadius: "6px",
                                                    boxShadow: "none",
                                                    minHeight: "44px",
                                                    '&:hover': {
                                                        borderColor: "#e8e9ed"
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    fontSize: "0.9rem"
                                                })
                                            }}
                                            classNamePrefix="react-select"
                                        />
                                        {errors.vat_return_id && <div className="text-danger" style={{ fontSize: '12px' }}>{errors.vat_return_id}</div>}
                                    </Form.Group>
                                )} */}
                                {formData.type === 'vat_payable' && (
                                    <Form.Group controlId="vat_return_id" className="mb-3">
                                        <Form.Label className='form-font'>Select VAT Return</Form.Label>
                                        <Select
                                            options={vatReturns
                                                .filter(ret => ret.report_data?.submitted_at && ret.report_data.submitted_at.trim() !== '')
                                                .map(ret => ({
                                                    value: ret.id,
                                                    label: `${dayjs(ret.period_start).format('DD MMM YYYY')} - ${dayjs(ret.period_end).format('DD MMM YYYY')} (${ret.net_vat_payable} AED)`,
                                                    vatReturn: ret
                                                }))}
                                            onChange={handleVatReturnSelect}
                                            isClearable
                                            placeholder="Search submitted VAT returns..." // Updated placeholder
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    backgroundColor: "white",
                                                    border: "1px solid #e8e9ed",
                                                    borderRadius: "6px",
                                                    boxShadow: "none",
                                                    minHeight: "44px",
                                                    '&:hover': {
                                                        borderColor: "#e8e9ed"
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    fontSize: "0.9rem"
                                                })
                                            }}
                                            classNamePrefix="react-select"
                                        />
                                        {errors.vat_return_id && <div className="text-danger" style={{ fontSize: '12px' }}>{errors.vat_return_id}</div>}
                                    </Form.Group>
                                )}

                                {formData.type === 'advance' && (
                                    <>
                                        <Form.Group controlId="advance_type" className="mb-3">
                                            <Form.Label className='form-font'>Advance Type</Form.Label>
                                            <Form.Select
                                                name="advance_type"
                                                value={formData.advance_type}
                                                onChange={handleChange}
                                                className="form-feild"
                                            >
                                                <option value="">Please Select</option>

                                                <option value="client">Client</option>
                                                <option value="vendor">Vendor</option>
                                                <option value="pettycash">Petty Cash (User)</option>
                                            </Form.Select>
                                        </Form.Group>
                                        {formData.advance_type === 'vendor' && (
                                            <Form.Group controlId="vendor_id" className="mb-3">
                                                <Form.Label className='form-font'>Vendor</Form.Label>
                                                <Form.Select
                                                    className={`form-feild ${errors.vendor_id ? 'is-invalid' : ''}`}
                                                    name="vendor_id"
                                                    value={formData.vendor_id ?? ""}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Vendor</option>
                                                    {vendors?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(vendor => (
                                                        <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
                                                    ))}
                                                </Form.Select>
                                                {errors.vendor_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.vendor_id}</div>}
                                            </Form.Group>
                                        )}

                                        {formData.advance_type === 'pettycash' && (
                                            <Form.Group controlId="user_id" className="mb-3">
                                                <Form.Label className='form-font'>User (Employee)</Form.Label>
                                                <Form.Select
                                                    className={`form-feild ${errors.user_id ? 'is-invalid' : ''}`}
                                                    name="user_id"
                                                    value={formData.user_id ?? ""}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select User</option>
                                                    {users?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(user => (
                                                        <option key={user.id} value={user.id}>{user.name}</option>
                                                    ))}
                                                </Form.Select>
                                                {errors.user_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.user_id}</div>}
                                            </Form.Group>
                                        )}

                                        {/* Client selection is common for both now to maintain project hierarchy */}
                                        {formData.advance_type !== 'pettycash' && (
                                            <Form.Group controlId="client_id" className="mb-3">
                                                <Form.Label className='form-font'>Client</Form.Label>
                                                <Form.Select
                                                    className={`form-feild ${errors.client_id ? 'is-invalid' : ''}`}
                                                    name="client_id"
                                                    value={formData.client_id ?? ""}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Client</option>
                                                    {clients?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(client => (
                                                        <option key={client.id} value={client.id}>{client.name}</option>
                                                    ))}
                                                </Form.Select>
                                                {errors.client_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.client_id}</div>}
                                            </Form.Group>
                                        )}

                                        {formData.client_id && (
                                            <Form.Group controlId="project_id" className="mb-3">
                                                <Form.Label className='form-font'>Project</Form.Label>
                                                <Form.Select
                                                    className='form-feild'
                                                    name="project_id"
                                                    value={formData.project_id}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Project</option>
                                                    {projects
                                                        ?.filter(project => project.client_id == formData.client_id)
                                                        ?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                        ?.map(project => (
                                                            <option key={project.id} value={project.id}>
                                                                {project.name}
                                                            </option>
                                                        ))}
                                                </Form.Select>
                                            </Form.Group>
                                        )}

                                        {formData.advance_type === 'vendor' && formData.project_id && (
                                            <>


                                                {formData.vendor_id && (
                                                    <Form.Group controlId="po_id" className="mb-3">
                                                        <Form.Label className='form-font'>Purchase Order</Form.Label>
                                                        <Form.Select
                                                            className='form-feild'
                                                            name="po_id"
                                                            value={formData.po_id}
                                                            onChange={handleChange}
                                                        >
                                                            <option value="">Select PO</option>
                                                            {pos
                                                                ?.map(po => (
                                                                    <option key={po.id} value={po.id}>
                                                                        {po.ref_no} - {po.amount || ''}
                                                                    </option>
                                                                ))}
                                                        </Form.Select>
                                                    </Form.Group>
                                                )}
                                            </>
                                        )}
                                    </>
                                )}
                                {formData.type === 'expense' && (
                                    <Form.Group controlId="payment_mode" className="mb-3">
                                        <Form.Label className='form-font'>Payment Mode</Form.Label>
                                        <Form.Select
                                            name="payment_mode"
                                            value={formData.payment_mode}
                                            onChange={handleChange}
                                            className='form-feild'
                                        >
                                            <option value="">Select</option>
                                            <option value="vendor">Vendor</option>
                                            <option value="petty_cash">Petty Cash (User)</option>
                                        </Form.Select>
                                    </Form.Group>
                                )}
                                {formData.type !== 'contra' && formData.type !== 'bad_debt_written_off' && (
                                    <>
                                        <Form.Group controlId="branch_name" className="mb-3">
                                            <Form.Label className='form-font'>Account Type</Form.Label>
                                            <Form.Select
                                                name='account_type' value={formData.account_type} onChange={handleChange}
                                                className={`form-feild  ${errors.account_type ? 'is-invalid' : ''}`}
                                            >
                                                <option value="">Select</option>
                                                <option value="bank account">Bank Account</option>
                                                <option value="cash account"> Cash Account</option>
                                            </Form.Select>
                                            {errors.account_type && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.account_type}</div>}

                                        </Form.Group>

                                        <Form.Group controlId="account_holder_name" className="mb-3">
                                            <Form.Label className='form-font'>Account</Form.Label>
                                            <Form.Select
                                                className={`form-feild  ${errors.account_id ? 'is-invalid' : ''}`}

                                                name="account_id"
                                                value={formData.account_id}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select</option>
                                                {banks
                                                    ?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                    ?.map(bank => (
                                                        <option key={bank.id} value={bank.id}>
                                                            {bank.name}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                            {errors.account_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.account_id}</div>}

                                        </Form.Group>
                                    </>
                                )}
                                {formData.type === 'contra' && (
                                    <>
                                        <Form.Group controlId="from_bank_id" className="mb-3">
                                            <Form.Label className='form-font'>From Account</Form.Label>
                                            <Form.Select
                                                className={`form-feild ${errors.from_bank_id ? 'is-invalid' : ''}`}
                                                name="from_bank_id"
                                                value={formData.from_bank_id}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select From Account</option>
                                                {(allBanks.length > 0 ? allBanks : banks)
                                                    ?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                    ?.map(account => (
                                                        <option key={account.id} value={account.id}>
                                                            {account.name}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                            {errors.from_bank_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.from_bank_id}</div>}
                                        </Form.Group>

                                        <Form.Group controlId="to_bank_id" className="mb-3">
                                            <Form.Label className='form-font'>To Account</Form.Label>
                                            <Form.Select
                                                className={`form-feild ${errors.to_bank_id ? 'is-invalid' : ''}`}
                                                name="to_bank_id"
                                                value={formData.to_bank_id}
                                                onChange={handleChange}
                                            >
                                                <option value="">Select To Account</option>
                                                {(allBanks.length > 0 ? allBanks : banks)
                                                    ?.filter(account => account.id.toString() !== formData.from_bank_id?.toString())
                                                    ?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || ''))
                                                    ?.map(account => (
                                                        <option key={account.id} value={account.id}>
                                                            {account.name}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                            {errors.to_bank_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.to_bank_id}</div>}
                                        </Form.Group>


                                    </>
                                )}

                                {formData.type === 'bank_guarantee_charges' && (
                                    <>
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group controlId="issued_bank_guarantee_id" className="mb-3">
                                                    <Form.Label className='form-font'>Select Issued Bank Guarantee</Form.Label>
                                                    <Form.Select
                                                        className='form-feild'
                                                        name="guarantee_id"
                                                        value={formData.guarantee_id}
                                                        onChange={(e) => {
                                                            const selectedId = e.target.value;
                                                            const guarantee = pendingGuarantees.find(g => g.id.toString() === selectedId);
                                                            if (guarantee) {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    guarantee_id: guarantee.id,
                                                                }));
                                                            }
                                                        }}
                                                    >
                                                        <option value="">Select Bank Guarantee</option>
                                                        {pendingGuarantees.map(g => (
                                                            <option key={g.id} value={g.id}>
                                                                {g.description} - {formatCurrency(g.amount)} ({g.date})
                                                            </option>
                                                        ))}
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <Form.Group controlId="commission_fee" className="mb-3">
                                                    <Form.Label className='form-font'>Commission Fee</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="commission_fee"
                                                        value={formData.commission_fee}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            const vat = (value * 0.05).toFixed(2);

                                                            // Calculate total amount
                                                            const commissionVat = parseFloat(vat);
                                                            const bankCharge = parseFloat(formData.bank_service_charge || 0);
                                                            const bankVat = parseFloat(formData.bank_vat_amount || 0);
                                                            const totalAmount = value + commissionVat + bankCharge + bankVat;

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                commission_fee: value,
                                                                commission_vat: vat,
                                                                amount: totalAmount.toFixed(2)  // Auto-update amount field
                                                            }));
                                                        }}
                                                        placeholder="Enter commission fee"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col md={12}>
                                                <Form.Group controlId="commission_vat" className="mb-3">
                                                    <Form.Label className='form-font'>Commission VAT (5%)</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="commission_vat"
                                                        value={formData.commission_vat}
                                                        onChange={handleChange}
                                                        placeholder="Auto-calculated VAT"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col md={12}>
                                                <Form.Group controlId="bank_service_charge" className="mb-3">
                                                    <Form.Label className='form-font'>Bank Service Charge</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="bank_service_charge"
                                                        value={formData.bank_service_charge}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            const vat = (value * 0.05).toFixed(2);

                                                            // Calculate total amount
                                                            const commissionFee = parseFloat(formData.commission_fee || 0);
                                                            const commissionVat = parseFloat(formData.commission_vat || 0);
                                                            const bankVat = parseFloat(vat);
                                                            const totalAmount = commissionFee + commissionVat + value + bankVat;

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                bank_service_charge: value,
                                                                bank_vat_amount: vat,
                                                                amount: totalAmount.toFixed(2)  // Auto-update amount field
                                                            }));
                                                        }}
                                                        placeholder="Enter service charge"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                        <Row>

                                            <Col md={12}>
                                                <Form.Group controlId="bank_vat_amount" className="mb-3">
                                                    <Form.Label className='form-font'>Bank Service VAT (5%)</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="bank_vat_amount"
                                                        value={formData.bank_vat_amount}
                                                        onChange={handleChange}
                                                        placeholder="Auto-calculated VAT"
                                                        readOnly
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>

                                        {/* Display total calculation */}

                                    </>
                                )}


                                {/* {formData.type === 'payroll' && (
                                    <>

                                        <Form.Group controlId="payroll_provider_id" className="mb-3">
                                            <Form.Label className='form-font'>Payroll Provider</Form.Label>
                                            <Form.Select
                                                name="payroll_provider_id"
                                                value={formData.payroll_provider_id || ''}
                                                onChange={(e) => {
                                                    const selectedId = Number(e.target.value);
                                                    const selected = payrollProviderOptions.find(p => p.id === selectedId);

                                                    setFormData(prev => ({
                                                        ...prev,
                                                        payroll_provider_id: selected.id,
                                                        payroll_provider_type: selected.provider_type, // ?? hidden but saved
                                                    }));
                                                }}
                                            >
                                                <option value="">Select Provider</option>

                                                {payrollProviderOptions.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(provider => (
                                                    <option key={`${provider.provider_type}-${provider.id}`} value={provider.id}>
                                                        {provider.name}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>


                                        <Form.Group controlId="salary_ids" className="mb-3">
                                            <Form.Label className='form-font'>Select Salaries</Form.Label>
                                            <Select
                                                isMulti
                                                name="salary_ids"
                                                className='form-feild'
                                                classNamePrefix="react-select"
                                                options={pendingSalaries?.map(salary => ({
                                                    label: `${salary.narration} - ${formatCurrency(salary.amount)} - ${salary.date}`,
                                                    value: salary.id,
                                                    amount: salary.amount,

                                                })) || []}
                                                value={selectedSalaries || []}
                                                onChange={(selectedOptions) => {
                                                    const salaries = selectedOptions || [];
                                                    setSelectedSalaries(salaries);

                                                    // Calculate total salary amount by looking up the original salary data
                                                    const totalSalaryAmount = salaries.reduce((sum, selectedSalary) => {
                                                        // Find the original salary in pendingSalaries to get the amount
                                                        const originalSalary = pendingSalaries?.find(s => s.id === selectedSalary.value);
                                                        return sum + (parseFloat(originalSalary?.amount) || 0);
                                                    }, 0);

                                                    // Alternative approach if you want to store amount in the state:
                                                    // You could store the full salary object in state instead

                                                    // Calculate total WPS charges (if any)
                                                    const totalWpsCharge = parseFloat(formData.wps_charge) || 0;
                                                    const totalWpsVat = parseFloat(formData.wps_vat) || 0;
                                                    const totalAmount = totalSalaryAmount + totalWpsCharge + totalWpsVat;

                                                    setTotalSalaryAmount(totalSalaryAmount);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        amount: totalAmount.toFixed(2),
                                                        salary_ids: salaries.map(s => s.value)
                                                    }));
                                                }}
                                                placeholder="Select one or more pending salaries..."
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        borderRadius: "6px",
                                                        boxShadow: "none",
                                                        minHeight: "44px",
                                                        '&:hover': {
                                                            borderColor: "#4d90fe"
                                                        }
                                                    }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#e9ecef",
                                                        borderRadius: "4px",
                                                        maxWidth: "200px",
                                                        margin: "2px"
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: "#000",
                                                        fontSize: "0.85rem",
                                                        padding: "4px 8px"
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        borderRadius: "0 4px 4px 0",
                                                        '&:hover': {
                                                            backgroundColor: "#dc3545",
                                                            color: "white"
                                                        }
                                                    })
                                                }}
                                                menuPlacement="auto"
                                                maxMenuHeight={250}
                                            />
                                        </Form.Group>

                                      
                                        <Col md={12}>
                                            <Form.Group controlId="wps_charge" className="mb-3">
                                                <Form.Label className='form-font'>WPS Charge (Total)</Form.Label>
                                                <Form.Control
                                                    className='form-control form-feild'
                                                    type="number"
                                                    step="0.01"
                                                    name="wps_charge"
                                                    value={formData.wps_charge || ''}
                                                    onChange={(e) => {
                                                        const value = parseFloat(e.target.value) || 0;
                                                        // setWpsCharge(value); // Removed dual state

                                                        // Recalculate total
                                                        // Need to get totalSalaryAmount. It is not in formData, but calculated in salary_ids onChange.
                                                        // We can infer it from (amount - old_wps - old_vat) OR re-sum if available.
                                                        // Ideally, we persist totalSalaryAmount in formData or state.
                                                        // For now, let's use the current totalSalaryAmount state which is available in scope.
                                                        const vat = parseFloat(formData.wps_vat || 0);
                                                        const totalAmount = totalSalaryAmount + value + vat;

                                                        setFormData(prev => ({
                                                            ...prev,
                                                            wps_charge: value,
                                                            amount: totalAmount.toFixed(2)
                                                        }));
                                                    }}
                                                    placeholder="Total WPS charges"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={12}>
                                            <Form.Group controlId="wps_vat" className="mb-3">
                                                <Form.Label className='form-font'>WPS VAT (5% on charge)</Form.Label>
                                                <Form.Control
                                                    className='form-control form-feild'
                                                    type="number"
                                                    step="0.01"
                                                    name="wps_vat"
                                                    value={formData.wps_vat || ''}
                                                    onChange={(e) => {
                                                        const value = parseFloat(e.target.value) || 0;
                                                        // setWpsVat(value); // Removed dual state

                                                        const charge = parseFloat(formData.wps_charge || 0);
                                                        const totalAmount = totalSalaryAmount + charge + value;

                                                        setFormData(prev => ({
                                                            ...prev,
                                                            wps_vat: value,
                                                            amount: totalAmount.toFixed(2)
                                                        }));
                                                    }}
                                                    placeholder="VAT on WPS charges"
                                                />
                                                <Form.Text className="text-muted">
                                                    {formData.wps_charge ? `5% of ${formData.wps_charge} = ${(parseFloat(formData.wps_charge) * 0.05).toFixed(2)}` : ''}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </>
                                )} */}
                                {/* Legacy payroll code removed */}
                                {formData.type === 'payroll' && (
                                    <>


                                        {/* Multiple Salary Selection Dropdown */}
                                        <Form.Group controlId="salary_ids" className="mb-3">
                                            <Form.Label className='form-font'>Select Salaries</Form.Label>
                                            <Select
                                                isMulti
                                                name="salary_ids"
                                                className='form-feild'
                                                classNamePrefix="react-select"
                                                options={pendingSalaries?.map(salary => ({
                                                    label: `${salary.narration} - ${formatCurrency(salary.total_amount)} - ${salary.date}`,
                                                    value: salary.id,
                                                    amount: salary.total_amount,
                                                })) || []}
                                                value={selectedSalaries || []}
                                                onChange={(selectedOptions) => {
                                                    const salaries = selectedOptions || [];
                                                    setSelectedSalaries(salaries);

                                                    // Calculate total salary amount
                                                    const totalSalaryAmount = salaries.reduce((sum, selectedSalary) => {
                                                        const originalSalary = pendingSalaries?.find(s => s.id === selectedSalary.value);
                                                        return sum + (parseFloat(originalSalary?.total_amount) || 0);
                                                    }, 0);

                                                    // Calculate total amount with bank charges (if any)
                                                    const totalBankCharge = parseFloat(formData.bank_service_charge) || 0;
                                                    const totalBankVat = parseFloat(formData.bank_vat_amount) || 0;
                                                    const totalAmount = totalSalaryAmount + totalBankCharge + totalBankVat;

                                                    setTotalSalaryAmount(totalSalaryAmount);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        amount: totalAmount.toFixed(2),
                                                        salary_ids: salaries.map(s => s.value)
                                                    }));
                                                }}
                                                placeholder="Select one or more pending salaries..."
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        borderRadius: "6px",
                                                        boxShadow: "none",
                                                        minHeight: "44px",
                                                        '&:hover': {
                                                            borderColor: "#4d90fe"
                                                        }
                                                    }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#e9ecef",
                                                        borderRadius: "4px",
                                                        maxWidth: "200px",
                                                        margin: "2px"
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: "#000",
                                                        fontSize: "0.85rem",
                                                        padding: "4px 8px"
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        borderRadius: "0 4px 4px 0",
                                                        '&:hover': {
                                                            backgroundColor: "#dc3545",
                                                            color: "white"
                                                        }
                                                    })
                                                }}
                                                menuPlacement="auto"
                                                maxMenuHeight={250}
                                            />
                                        </Form.Group>



                                        {/* Bank Service Charges */}
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group controlId="bank_service_charge" className="mb-3">
                                                    <Form.Label className='form-font'>Bank Service Charge</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="bank_service_charge"
                                                        value={formData.bank_service_charge || ''}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            // Recalculate total amount
                                                            const vat = parseFloat(formData.bank_vat_amount || 0);
                                                            const totalAmount = totalSalaryAmount + value + vat;

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                bank_service_charge: value,
                                                                amount: totalAmount.toFixed(2)
                                                            }));
                                                        }}
                                                        placeholder="Bank service charges"
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group controlId="bank_vat_amount" className="mb-3">
                                                    <Form.Label className='form-font'>VAT on Bank Charge (5%)</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="bank_vat_amount"
                                                        value={formData.bank_vat_amount || ''}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            const charge = parseFloat(formData.bank_service_charge || 0);
                                                            const totalAmount = totalSalaryAmount + charge + value;

                                                            setFormData(prev => ({
                                                                ...prev,
                                                                bank_vat_amount: value,
                                                                amount: totalAmount.toFixed(2)
                                                            }));
                                                        }}
                                                        placeholder="VAT on bank charges"
                                                    />
                                                    <Form.Text className="text-muted">
                                                        {formData.bank_service_charge ? `5% of ${formData.bank_service_charge} = ${(parseFloat(formData.bank_service_charge) * 0.05).toFixed(2)}` : ''}
                                                    </Form.Text>
                                                </Form.Group>
                                            </Col>
                                        </Row>


                                    </>
                                )}

                                <Form.Group controlId="payee" className="mb-3">
                                    <Form.Label className='form-font'>
                                        {formData.type === 'expense' ? 'Payee' :
                                            formData.type === 'income' || formData.type === 'bad_debt_written_off' ? 'Client' : ''}
                                    </Form.Label>

                                    {formData.type === 'expense' && formData.payment_mode === 'vendor' && (
                                        <Form.Select
                                            className='form-feild'
                                            name="vendor_id"
                                            value={formData.vendor_id ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Vendor</option>
                                            {vendors?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(vendor => (
                                                <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
                                            ))}
                                        </Form.Select>
                                    )}

                                    {formData.type === 'expense' && formData.payment_mode === 'petty_cash' && (
                                        <Form.Select
                                            className='form-feild'
                                            name="user_id"
                                            value={formData.user_id ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select User</option>
                                            {users?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(user => (
                                                <option key={user.id} value={user.id}>{user.name}</option>
                                            ))}
                                        </Form.Select>
                                    )}

                                    {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && (
                                        <Form.Select
                                            className={`form-feild  ${errors.client_id ? 'is-invalid' : ''}`}

                                            name="client_id"
                                            value={formData.client_id ?? ""}
                                            onChange={handleChange}
                                        >
                                            <option value="">Select Client</option>
                                            <option value="0">Unrecognized Client</option>
                                            {clients?.slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(client => (
                                                <option key={client.id} value={client.id}>{client.name}</option>
                                            ))}
                                        </Form.Select>
                                    )}
                                    {errors.client_id && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.client_id}</div>}

                                </Form.Group>

                                {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && (
                                    <Form.Group controlId="project_ids" className="mb-3">
                                        <Form.Label className='form-font'>Projects</Form.Label>
                                        <Select
                                            isMulti
                                            name="project_ids"
                                            className='form-feild'
                                            classNamePrefix="react-select"
                                            options={projects?.filter(project => {
                                                // 1. Always keep currently selected projects (essential for Edit mode logic)
                                                if (formData.project_ids?.includes(project.id) || formData.project_id == project.id) {
                                                    return true;
                                                }
                                                // 2. Otherwise, ONLY show if it has PENDING invoices
                                                const projectInvoices = invoices?.filter(inv => inv.project_id == project.id);
                                                const hasPending = projectInvoices?.some(inv => inv.pi_status !== 'payment_received');
                                                return hasPending;
                                            }).slice().sort((a, b) => (a.name || '').localeCompare(b.name || '')).map(project => {
                                                // Calculate status
                                                const projectInvoices = invoices?.filter(inv => inv.project_id == project.id);
                                                let status = "";

                                                if (projectInvoices && projectInvoices.length > 0) {
                                                    // Count pending invoices
                                                    const pendingInvoices = projectInvoices.filter(inv => inv.pi_status !== 'payment_received');
                                                    const pendingCount = pendingInvoices.length;

                                                    if (pendingCount > 0) {
                                                        status = ` (${pendingCount} Pending)`;
                                                    } else {
                                                        status = " (Fully Paid)";
                                                    }
                                                }

                                                return {
                                                    label: `${project.name}${status}`,
                                                    value: project.id
                                                };
                                            }) || []}
                                            value={selectedProjects}
                                            onChange={handleProjectSelect}
                                            placeholder="Select one or more projects"
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            styles={{
                                                control: (base) => ({
                                                    ...base,
                                                    border: "0.5px solid rgb(232, 233, 237)",
                                                    borderRadius: "6px",
                                                    boxShadow: "none",
                                                    minHeight: "44px",
                                                    '&:hover': {
                                                        borderColor: "#4d90fe"
                                                    }
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#e9ecef",
                                                    borderRadius: "4px",
                                                    maxWidth: "180px",
                                                    margin: "2px"
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: "#000",
                                                    fontSize: "0.85rem",
                                                    padding: "4px 8px"
                                                }),
                                                multiValueRemove: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    borderRadius: "0 4px 4px 0",
                                                    '&:hover': {
                                                        backgroundColor: "#dc3545",
                                                        color: "white"
                                                    }
                                                })
                                            }}
                                            menuPlacement="auto"
                                            maxMenuHeight={200}
                                        />

                                    </Form.Group>
                                )}

                                {(formData.type === 'income' || formData.type === 'bad_debt_written_off') && (
                                    <Form.Group controlId="invoices" className="mb-3">
                                        <Form.Label className='form-font'>Invoices</Form.Label>

                                        {isEditMode && transactionData ? (
                                            // EDIT MODE: Show only selected invoices as read-only tags
                                            <Select
                                                isMulti
                                                name="selected_invoices"
                                                className='form-feild'
                                                classNamePrefix="react-select"
                                                isDisabled={true} // Disable dropdown in edit mode
                                                options={[]} // No dropdown options in edit mode
                                                value={(() => {
                                                    // Show ONLY the already selected invoices
                                                    const selectedInvoices = [];

                                                    // Add from selected_invoices array
                                                    if (formData.selected_invoices && formData.selected_invoices.length > 0) {
                                                        formData.selected_invoices.forEach(inv => {
                                                            // Find the original invoice to get the ref_no
                                                            const originalInvoice = invoices?.find(i =>
                                                                i.id.toString() === inv.value?.toString() ||
                                                                i.id.toString() === inv?.toString()
                                                            );

                                                            selectedInvoices.push({
                                                                // Use display_ref_no if available, otherwise use original_ref_no
                                                                label: originalInvoice?.display_ref_no ||
                                                                    inv.original_ref_no ||
                                                                    inv.label ||
                                                                    `Invoice #${inv.value || inv}`,
                                                                value: inv.value || inv,
                                                                amount: inv.amount || 0,
                                                                is_paid: true // Assuming in edit mode it's already paid/partially paid
                                                            });
                                                        });
                                                    }
                                                    // Add from single invoice_id
                                                    else if (formData.invoice_id) {
                                                        const invoice = invoices?.find(inv =>
                                                            inv.id.toString() === formData.invoice_id.toString()
                                                        );
                                                        if (invoice) {
                                                            selectedInvoices.push({
                                                                // Use display_ref_no here instead of hardcoded text
                                                                label: `${invoice.display_ref_no} - ${formatCurrency(invoice.display_amount || 0)} (Selected)`,
                                                                value: invoice.id,
                                                                amount: invoice.display_amount || 0,
                                                                is_paid: invoice.pi_status === 'payment_received'
                                                            });
                                                        } else {
                                                            selectedInvoices.push({
                                                                // Fallback if invoice not found in current list
                                                                label: `Invoice #${formData.invoice_id} (Selected)`,
                                                                value: formData.invoice_id,
                                                                amount: formData.amount || 0,
                                                                is_paid: true
                                                            });
                                                        }
                                                    }

                                                    return selectedInvoices;
                                                })()}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#f8f9fa",
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        borderRadius: "6px",
                                                        boxShadow: "none",
                                                        opacity: 0.7,
                                                        cursor: "not-allowed",
                                                        minHeight: "44px",
                                                        '&:hover': {
                                                            borderColor: "#e8e9ed"
                                                        }
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        color: "#000",
                                                        padding: "2px 8px",
                                                        flexWrap: "wrap",
                                                        maxHeight: "120px",
                                                        overflowY: "auto",
                                                        gap: "4px"
                                                    }),
                                                    multiValue: (base, state) => {
                                                        const isPaid = state.data.is_paid || false;

                                                        return {
                                                            ...base,
                                                            backgroundColor: isPaid ? "#d4edda" : "#e9ecef", // Green for paid, gray for others
                                                            borderRadius: "4px",
                                                            maxWidth: "200px",
                                                            margin: "2px",
                                                            border: isPaid ? "1px solid #c3e6cb" : "none"
                                                        };
                                                    },
                                                    multiValueLabel: (base, state) => {
                                                        const isPaid = state.data.is_paid || false;

                                                        return {
                                                            ...base,
                                                            color: isPaid ? "#155724" : "#000", // Dark green for paid
                                                            fontSize: "0.85rem",
                                                            padding: "4px 8px",
                                                            whiteSpace: "nowrap",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            fontWeight: isPaid ? "bold" : "normal"
                                                        };
                                                    },
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        display: "none" // Hide remove button in edit mode
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        fontSize: "0.9rem"
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        display: "none" // Hide dropdown arrow
                                                    }),
                                                    clearIndicator: (base) => ({
                                                        ...base,
                                                        display: "none" // Hide clear button
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        display: "none" // Hide all indicators
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        display: "none" // Hide input field
                                                    })
                                                }}
                                                isClearable={false}
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder="Invoice selection is disabled for existing transactions"
                                                noOptionsMessage={() => null}
                                                menuIsOpen={false} // Don't open menu
                                            />
                                        ) : (
                                            // NEW MODE: Show dropdown with only unpaid invoices
                                            <Select
                                                isMulti
                                                name="selected_invoices"
                                                className='form-feild'
                                                classNamePrefix="react-select"
                                                menuPortalTarget={document.body}
                                                menuPosition="fixed"
                                                menuShouldBlockScroll={true}
                                                isDisabled={isInvoiceFieldReadOnly}

                                                options={(() => {
                                                    console.log("?? Building Select options:", {
                                                        invoicesCount: invoices?.length || 0,
                                                        isEditMode,
                                                        formDataSelectedCount: formData.selected_invoices?.length || 0
                                                    });

                                                    const baseOptions = [];

                                                    if (!invoices || invoices.length === 0) {
                                                        console.log("No invoices available for Select");
                                                        return baseOptions;
                                                    }

                                                    invoices.forEach(inv => {
                                                        console.log(`Processing invoice ${inv.id}:`, {
                                                            pi_status: inv.pi_status,
                                                            remaining_balance: inv.remaining_balance,
                                                            is_selected: inv.is_selected,
                                                            label: inv.label
                                                        });

                                                        // ALWAYS show if it's selected in edit mode
                                                        if (isEditMode && inv.is_selected) {
                                                            console.log(`? Adding invoice ${inv.id} - selected in edit mode`);
                                                            baseOptions.push({
                                                                label: inv.label,
                                                                value: inv.id,
                                                                amount: inv.remaining_balance,
                                                                original_amount: inv.original_amount,
                                                                remaining_balance: inv.remaining_balance,
                                                                total_paid: inv.total_paid,
                                                                invoice_type: inv.invoice_type,
                                                                has_tax_invoice: inv.has_tax_invoice,
                                                                is_selected: true
                                                            });
                                                        }
                                                        // For new transactions or non-selected in edit mode
                                                        else if (!isEditMode || !inv.is_selected) {
                                                            // FILTER BY SELECTED PROJECTS
                                                            // Only show invoices that belong to the selected projects
                                                            const belongsToSelectedProject = formData.project_ids?.includes(inv.project_id) ||
                                                                formData.project_id === inv.project_id;

                                                            if (!belongsToSelectedProject) {
                                                                return; // Skip this invoice
                                                            }

                                                            // Show if it has remaining balance AND no credit notes
                                                            const hasCreditNotes = (inv.credit_notes && inv.credit_notes.length > 0) ||
                                                                (inv.tax_invoice?.credit_notes && inv.tax_invoice.credit_notes.length > 0);

                                                            if (inv.remaining_balance > 0 && !hasCreditNotes) {
                                                                console.log(`? Adding invoice ${inv.id} - has remaining balance and no credit notes`);
                                                                baseOptions.push({
                                                                    label: inv.label,
                                                                    value: inv.id,
                                                                    amount: inv.remaining_balance,
                                                                    original_amount: inv.original_amount,
                                                                    remaining_balance: inv.remaining_balance,
                                                                    total_paid: inv.total_paid,
                                                                    invoice_type: inv.invoice_type,
                                                                    has_tax_invoice: inv.has_tax_invoice,
                                                                    is_selected: false
                                                                });
                                                            } else {
                                                                console.log(`? Skipping invoice ${inv.id} - no remaining balance`);
                                                            }
                                                        }
                                                    });

                                                    console.log("?? Final Select options:", baseOptions.map(opt => ({
                                                        value: opt.value,
                                                        label: opt.label
                                                    })));

                                                    return baseOptions;
                                                })()}
                                                value={formData?.selected_invoices || []}
                                                styles={{
                                                    control: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: isInvoiceFieldReadOnly ? "#f8f9fa" : "#fff",
                                                        border: "0.5px solid rgb(232, 233, 237)",
                                                        borderRadius: "6px",
                                                        boxShadow: "none",
                                                        opacity: isInvoiceFieldReadOnly ? 0.7 : 1,
                                                        cursor: isInvoiceFieldReadOnly ? "not-allowed" : "default",
                                                        minHeight: "44px",
                                                        '&:hover': {
                                                            borderColor: isInvoiceFieldReadOnly ? "#e8e9ed" : "#4d90fe"
                                                        }
                                                    }),
                                                    menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        borderRadius: "6px",
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        color: "#000",
                                                        padding: "2px 8px",
                                                        flexWrap: "wrap",
                                                        maxHeight: "120px",
                                                        overflowY: "auto",
                                                        gap: "4px"
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: "#e9ecef",
                                                        borderRadius: "4px",
                                                        maxWidth: "180px",
                                                        margin: "2px"
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        color: "#000",
                                                        fontSize: "0.85rem",
                                                        padding: "4px 8px",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis"
                                                    }),
                                                    multiValueRemove: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        borderRadius: "0 4px 4px 0",
                                                        '&:hover': {
                                                            backgroundColor: "#dc3545",
                                                            color: "white"
                                                        }
                                                    }),
                                                    placeholder: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        fontSize: "0.9rem"
                                                    }),
                                                    option: (base, state) => ({
                                                        ...base,
                                                        backgroundColor: state.data?.isSelectAllOption ? '#f8f9fa' :
                                                            state.isSelected ? '#e3f2fd' :
                                                                state.isFocused ? '#f5f5f5' : base.backgroundColor,
                                                        color: "#000",
                                                        fontWeight: state.data?.isSelectAllOption ? 'bold' : 'normal',
                                                        borderBottom: state.data?.isSelectAllOption ? '1px solid #dee2e6' : 'none',
                                                        padding: "10px 12px",
                                                        fontSize: "0.9rem",
                                                        '&:hover': {
                                                            backgroundColor: state.data?.isSelectAllOption ? '#e9ecef' : '#f5f5f5',
                                                        }
                                                    }),
                                                    singleValue: (base) => ({
                                                        ...base,
                                                        color: "#000"
                                                    }),
                                                    input: (base) => ({
                                                        ...base,
                                                        color: "#000"
                                                    }),
                                                    clearIndicator: (base) => ({
                                                        ...base,
                                                        padding: "6px",
                                                        cursor: "pointer",
                                                        color: "#6c757d"
                                                    }),
                                                    dropdownIndicator: (base) => ({
                                                        ...base,
                                                        padding: "6px",
                                                        cursor: "pointer",
                                                        color: "#6c757d"
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        paddingRight: "6px"
                                                    }),
                                                    noOptionsMessage: (base) => ({
                                                        ...base,
                                                        color: "#6c757d",
                                                        padding: "12px"
                                                    })
                                                }}
                                                onChange={(selectedOptions, actionMeta) => {
                                                    if (isInvoiceFieldReadOnly) return;
                                                    const { action, option } = actionMeta;

                                                    // Handle "Select All" option
                                                    if (option?.isSelectAllOption) {
                                                        if (action === 'select-option') {
                                                            const unpaidInvoices = invoices?.filter(inv => inv.pi_status !== 'payment_received') || [];
                                                            const totalAmount = unpaidInvoices.reduce(
                                                                (sum, inv) => sum + (parseFloat(inv.display_amount) || 0),
                                                                0
                                                            );

                                                            setFormData(prev => {
                                                                const next = {
                                                                    ...prev,
                                                                    selected_invoices: unpaidInvoices.map(inv => ({
                                                                        label: `${inv.display_ref_no} - ${formatCurrency(inv.display_amount || 0)}`,
                                                                        value: inv.id,
                                                                        amount: inv.display_amount || 0,
                                                                        invoice_type: inv.invoice_type,
                                                                        has_tax_invoice: inv.has_tax_invoice,
                                                                        tax_invoice_details: inv.tax_invoice_details,
                                                                        original_ref_no: inv.ref_no || inv.serial_no
                                                                    })),
                                                                    amount: totalAmount.toFixed(2),
                                                                    received_amount: '', // RESET custom amount on selection change
                                                                    invoice_id: unpaidInvoices.length === 1 ? unpaidInvoices[0].id.toString() : ''
                                                                };

                                                                // Trigger auto-currency selection
                                                                const prioritizedCurrencyId = autoSelectCurrency(next);
                                                                if (prioritizedCurrencyId) {
                                                                    // Use skipConversion because the amount is already derived from the invoices
                                                                    setTimeout(() => handleCurrencySelection(prioritizedCurrencyId, { isAutoSelect: true, skipConversion: true }), 0);
                                                                }

                                                                return next;
                                                            });
                                                        }
                                                        return;
                                                    }

                                                    // Handle regular options
                                                    const filteredOptions = selectedOptions.filter(opt => !opt.isSelectAllOption);
                                                    const totalAmount = filteredOptions.reduce(
                                                        (sum, opt) => sum + (parseFloat(opt.amount) || 0),
                                                        0
                                                    );

                                                    setFormData(prev => {
                                                        const next = {
                                                            ...prev,
                                                            selected_invoices: filteredOptions,
                                                            amount: totalAmount.toFixed(2),
                                                            received_amount: '', // RESET custom amount on selection change
                                                            invoice_id: filteredOptions.length === 1 ? filteredOptions[0].value.toString() : ''
                                                        };

                                                        // Trigger auto-currency selection
                                                        const prioritizedCurrencyId = autoSelectCurrency(next);
                                                        if (prioritizedCurrencyId) {
                                                            // Use skipConversion because the amount is already derived from the invoices
                                                            setTimeout(() => handleCurrencySelection(prioritizedCurrencyId, { isAutoSelect: true, skipConversion: true }), 0);
                                                        }

                                                        return next;
                                                    });
                                                }}
                                                closeMenuOnSelect={false}
                                                hideSelectedOptions={false}
                                                placeholder={isInvoiceFieldReadOnly ? "Invoice selection disabled for reconciled transactions" : "Select unpaid invoices..."}
                                                noOptionsMessage={() => "No unpaid invoices available"}
                                                isClearable={!isInvoiceFieldReadOnly}
                                                menuPlacement="auto"
                                                maxMenuHeight={300}
                                            />
                                        )}

                                        {formData?.selected_invoices?.length > 0 && (
                                            <div className="mt-2 p-2 rounded bg-light border border-dashed animate__animated animate__fadeIn">
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <span className="text-muted small fw-semibold">
                                                        <i className="bi bi-check2-circle text-success me-1"></i>
                                                        {formData?.selected_invoices?.length} Invoice(s) Selected
                                                    </span>
                                                    <span className="text-primary fw-bold" style={{ fontSize: '0.95rem' }}>
                                                        Selection Total: {formatCurrency(formData.selected_invoices.reduce((sum, inv) => sum + (parseFloat(inv.remaining_balance || inv.amount || 0)), 0))}
                                                    </span>
                                                </div>
                                                <div className="text-muted small border-top pt-1 d-flex justify-content-between align-items-center">
                                                    <span>Current Cash/Bank Payment</span>
                                                    <span className="fw-bold text-dark">{formatCurrency(parseFloat(formData.amount || 0))}</span>
                                                </div>
                                                {!isEditMode && !isInvoiceFieldReadOnly && (
                                                    <div className="mt-2 text-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm text-decoration-none p-0 text-danger"
                                                            style={{ fontSize: '0.75rem' }}
                                                            onClick={() => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    selected_invoices: [],
                                                                    amount: '0.00',
                                                                    invoice_id: '',
                                                                    received_amount: ''
                                                                }));
                                                            }}
                                                        >
                                                            <i className="bi bi-x-circle me-1"></i>Clear All Selections
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}


                                        {/* DEBUG ADVANCE UI - TEMPORARY */}
                                        {/* <div className="alert alert-warning mt-3">
                                            <strong>DEBUG INFO (Logic v4 - Robust Parsing):</strong><br />
                                            Total Advance: {totalAdvance}<br />
                                            Transactions: {clientIncomeTransactions?.length || 0}<br />
                                            Client ID: {formData.client_id}
                                        </div> */}

                                    </Form.Group>
                                )}
                                {formData.type === 'expense' && (
                                    <Form.Group controlId="bill_no" className="mb-3" style={{ marginBottom: '34px' }}>
                                        <Form.Label className="form-font">Expenses</Form.Label>
                                        <Select
                                            isMulti
                                            name="bills"
                                            className='form-feild'
                                            classNamePrefix="react-select"
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            menuShouldBlockScroll={true}
                                            isDisabled={isExpenseFieldReadOnly}


                                            options={(() => {
                                                const baseOptions = [];

                                                // Get the already-filtered expense list
                                                const expenseList = formData.payment_mode === 'petty_cash'
                                                    ? selectedUserExpenses
                                                    : selectedVendorExpenses;

                                                if (expenseList && expenseList.length > 0) {
                                                    // Add "Select All Unpaid" option
                                                    baseOptions.push({
                                                        label: `Select All Unpaid Expenses`,
                                                        value: 'select_all_unpaid',
                                                        isSelectAllOption: true
                                                    });

                                                    // These should already be unpaid expenses
                                                    expenseList.forEach(exp => {
                                                        if (!exp || !exp.id) return;

                                                        const remainingBalance = parseFloat(exp.remaining_balance) || 0;
                                                        const paidAmount = parseFloat(exp.amount_paid) || 0;
                                                        const totalAmount = parseFloat(exp.total_amount);
                                                        const originalAmount =
                                                            parseFloat(exp.total_amount) > 0
                                                                ? parseFloat(exp.total_amount)
                                                                : parseFloat(exp.amount || 0);


                                                        baseOptions.push({
                                                            label: `${exp.narration || exp.expense_type?.name || 'Expense'} - ${exp.invoice_no || 'No Invoice'} (Paid: ${formatCurrency(paidAmount)}, Remaining: ${formatCurrency(remainingBalance)})`,
                                                            value: exp.id,
                                                            identifier: exp.invoice_no || exp.expense_type?.name || `expense_${exp.id}`,
                                                            amount: remainingBalance,
                                                            original_amount: originalAmount,
                                                            remaining_balance: remainingBalance,
                                                            amount_paid: paidAmount,
                                                            expense_type_id: exp.expense_type_id,
                                                            expense_type_name: exp.expense_type?.name,
                                                            invoice_no: exp.invoice_no,
                                                            vendor_id: exp.vendor_id,
                                                            user_id: exp.user_id
                                                        });
                                                    });
                                                }

                                                return baseOptions;
                                            })()}
                                            value={formData?.bills || []}
                                            styles={{
                                                control: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.isDisabled || isInvoiceFieldReadOnly ? "#f8f9fa" : "#fff",
                                                    border: "0.5px solid rgb(232, 233, 237)",
                                                    borderRadius: "6px",
                                                    boxShadow: "none",
                                                    // opacity: 1,
                                                    opacity: isInvoiceFieldReadOnly ? 0.7 : 1,
                                                    // cursor: state.isDisabled ? "not-allowed" : "default",
                                                    cursor: isInvoiceFieldReadOnly ? "not-allowed" : "default",
                                                    minHeight: "44px",
                                                    '&:hover': {
                                                        borderColor: isInvoiceFieldReadOnly ? "#e8e9ed" : "#4d90fe"
                                                    }
                                                }),
                                                menuPortal: base => ({ ...base, zIndex: 9999 }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                    borderRadius: "6px",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                                }),
                                                valueContainer: (base) => ({
                                                    ...base,
                                                    color: "#000",
                                                    padding: "2px 8px",
                                                    flexWrap: "wrap",
                                                    maxHeight: "80px",
                                                    overflowY: "auto",
                                                    gap: "4px"
                                                }),
                                                multiValue: (base) => ({
                                                    ...base,
                                                    backgroundColor: "#e9ecef",
                                                    borderRadius: "4px",
                                                    maxWidth: "180px",
                                                    margin: "2px"
                                                }),
                                                multiValueLabel: (base) => ({
                                                    ...base,
                                                    color: "#000",
                                                    fontSize: "0.85rem",
                                                    padding: "4px 8px",
                                                    whiteSpace: "nowrap",
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis"
                                                }),
                                                multiValueRemove: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    borderRadius: "0 4px 4px 0",
                                                    '&:hover': {
                                                        backgroundColor: "#dc3545",
                                                        color: "white"
                                                    }
                                                }),
                                                placeholder: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    fontSize: "0.9rem"
                                                }),
                                                menu: (base) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                    borderRadius: "6px",
                                                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)"
                                                }),
                                                option: (base, state) => ({
                                                    ...base,
                                                    backgroundColor: state.data.isSelectAllOption ? '#f8f9fa' :
                                                        state.isSelected ? '#e3f2fd' :
                                                            state.isFocused ? '#f5f5f5' : base.backgroundColor,
                                                    color: "#000",
                                                    fontWeight: state.data.isSelectAllOption ? 'bold' : 'normal',
                                                    borderBottom: state.data.isSelectAllOption ? '1px solid #dee2e6' : 'none',
                                                    padding: "10px 12px",
                                                    fontSize: "0.9rem",
                                                    '&:hover': {
                                                        backgroundColor: state.data.isSelectAllOption ? '#e9ecef' : '#f5f5f5',
                                                    }
                                                }),
                                                singleValue: (base) => ({
                                                    ...base,
                                                    color: "#000"
                                                }),
                                                input: (base) => ({
                                                    ...base,
                                                    color: "#000"
                                                }),
                                                clearIndicator: (base) => ({
                                                    ...base,
                                                    padding: "6px",
                                                    cursor: "pointer",
                                                    color: "#6c757d"
                                                }),
                                                dropdownIndicator: (base) => ({
                                                    ...base,
                                                    padding: "6px",
                                                    cursor: "pointer",
                                                    color: "#6c757d"
                                                }),
                                                indicatorsContainer: (base) => ({
                                                    ...base,
                                                    paddingRight: "6px"
                                                }),
                                                noOptionsMessage: (base) => ({
                                                    ...base,
                                                    color: "#6c757d",
                                                    padding: "12px"
                                                })
                                            }}

                                            onChange={(selectedOptions, actionMeta) => {
                                                if (isExpenseFieldReadOnly) return;
                                                const { action, option } = actionMeta;

                                                setFormData(prev => {
                                                    let updatedBills = [];
                                                    let totalRemaining = 0;
                                                    let expenseIds = "";
                                                    let billNos = "";

                                                    if (option?.isSelectAllOption) {
                                                        if (action === 'select-option') {
                                                            const expenseList = prev.payment_mode === 'petty_cash'
                                                                ? selectedUserExpenses
                                                                : selectedVendorExpenses;

                                                            if (expenseList.length === 0) return prev;

                                                            totalRemaining = expenseList.reduce((sum, exp) => sum + (parseFloat(exp.remaining_balance) || 0), 0);
                                                            expenseIds = expenseList.map(e => e.id).join(',');
                                                            billNos = expenseList.map(e => e.invoice_no).join(', ');

                                                            updatedBills = expenseList.map(exp => ({
                                                                label: `${exp.narration || exp.expense_type?.name || 'Expense'} - ${exp.invoice_no || 'No Invoice'} (Paid: ${formatCurrency(exp.amount_paid)}, Remaining: ${formatCurrency(exp.remaining_balance)})`,
                                                                value: exp.id,
                                                                identifier: exp.invoice_no || exp.expense_type?.name || `expense_${exp.id}`,
                                                                amount: exp.remaining_balance,
                                                                original_amount: exp.total_amount || exp.amount,
                                                                remaining_balance: exp.remaining_balance,
                                                                amount_paid: exp.amount_paid,
                                                                expense_type_id: exp.expense_type_id,
                                                                expense_type_name: exp.expense_type?.name,
                                                                invoice_no: exp.invoice_no
                                                            }));
                                                        } else {
                                                            updatedBills = [];
                                                            totalRemaining = 0;
                                                        }
                                                    } else {
                                                        const filteredOptions = selectedOptions.filter(opt => !opt.isSelectAllOption);
                                                        totalRemaining = filteredOptions.reduce((sum, opt) => sum + (parseFloat(opt.remaining_balance) || 0), 0);
                                                        expenseIds = filteredOptions.map(opt => opt.value).join(',');
                                                        billNos = filteredOptions.map(opt => opt.invoice_no).join(', ');
                                                        updatedBills = filteredOptions;
                                                    }

                                                    const next = {
                                                        ...prev,
                                                        bills: updatedBills,
                                                        amount: totalRemaining > 0 ? totalRemaining.toFixed(2) : "",
                                                        expense_type_id: updatedBills[0]?.expense_type_id?.toString() || "",
                                                        expense_id: expenseIds,
                                                        bill_no: billNos || '',
                                                    };

                                                    // Trigger auto-currency selection
                                                    const prioritizedCurrencyId = autoSelectCurrency(next);
                                                    if (prioritizedCurrencyId) {
                                                        // Use skipConversion because the amount is already derived from the bills
                                                        setTimeout(() => handleCurrencySelection(prioritizedCurrencyId, { isAutoSelect: true, skipConversion: true }), 0);
                                                    }

                                                    return next;
                                                });
                                            }}

                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            placeholder="Select expenses..."
                                            noOptionsMessage={() => "No expenses available"}
                                            isClearable={false}
                                            menuPlacement="auto"
                                            // menuPosition="fixed"
                                            maxMenuHeight={300}
                                        />

                                        {formData?.bills?.length > 0 && (
                                            <div className="mt-2 p-2 rounded bg-light border border-dashed animate__animated animate__fadeIn">
                                                <div className="d-flex justify-content-between align-items-center mb-1">
                                                    <span className="text-muted small fw-semibold">
                                                        <i className="bi bi-check2-circle text-success me-1"></i>
                                                        {formData?.bills?.length} Expense(s) Selected
                                                    </span>
                                                    <span className="text-primary fw-bold" style={{ fontSize: '0.95rem' }}>
                                                        Selection Total: {formatCurrency(formData.bills.reduce((sum, b) => sum + (parseFloat(b.remaining_balance || b.original_amount || b.amount || 0)), 0))}
                                                    </span>
                                                </div>
                                                <div className="text-muted small border-top pt-1 d-flex justify-content-between align-items-center">
                                                    <span>Current Cash/Bank Payment</span>
                                                    <span className="fw-bold text-dark">{formatCurrency(parseFloat(formData.amount || 0))}</span>
                                                </div>
                                                {!isEditMode && !isExpenseFieldReadOnly && (
                                                    <div className="mt-2 text-end">
                                                        <button
                                                            type="button"
                                                            className="btn btn-link btn-sm text-decoration-none p-0 text-danger"
                                                            style={{ fontSize: '0.75rem' }}
                                                            onClick={() => {
                                                                setFormData(prev => ({
                                                                    ...prev,
                                                                    bills: [],
                                                                    amount: '0.00',
                                                                    bill_no: '',
                                                                    expense_id: ''
                                                                }));
                                                            }}
                                                        >
                                                            <i className="bi bi-x-circle me-1"></i>Clear All Selections
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </Form.Group>
                                )}



                                {formData.type === 'bank_guarantee_released' && (
                                    <Form.Group controlId="select_pending_guarantee" className="mb-3">
                                        <Form.Label className='form-font'>Select Bank Guarantee to Release</Form.Label>
                                        <Form.Select
                                            className='form-feild'
                                            onChange={(e) => {
                                                const selectedId = e.target.value;
                                                const guarantee = pendingGuarantees.find(g => g.id.toString() === selectedId);
                                                if (guarantee) {
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        related_transaction_id: guarantee.id,
                                                        amount: guarantee.amount,
                                                        description: guarantee.description ? `Released: ${guarantee.description}` : prev.description
                                                    }));
                                                }
                                            }}
                                        >
                                            <option value="">Select Guarantee</option>
                                            {pendingGuarantees.map(g => (
                                                <option key={g.id} value={g.id}>
                                                    {g.transaction_voucher_id} - {formatCurrency(g.amount)} ({g.date}) - {g.description}
                                                </option>
                                            ))}
                                        </Form.Select>
                                        {pendingGuarantees.length === 0 && formData.account_id && (
                                            <div className="text-muted small mt-1">No pending guarantees found for this bank.</div>
                                        )}
                                    </Form.Group>
                                )}
                                {formData.type !== 'bank_guarantee_charges' && (
                                    <>
                                        {/* Advance Application UI - Only for Client and User advances (excluding Vendor) */}
                                        {formData.type !== 'advance' && ((formData.client_id || formData.user_id) && (totalAdvance > 0 || formData.use_advance || parseFloat(formData.advance_amount) > 0)) && (
                                            <div className="mb-4">
                                                <div className="advance-application-section p-3 rounded" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef' }}>
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <span className="form-font fw-bold text-primary">
                                                            <i className="bi bi-wallet2 me-2"></i>Advance Summary - {(() => {
                                                                if (formData.client_id) return clients.find(c => c.id.toString() === formData.client_id.toString())?.name || 'Client';
                                                                if (formData.user_id) return users.find(u => u.id.toString() === formData.user_id.toString())?.name || 'User';
                                                                return 'Selected Entity';
                                                            })()}
                                                        </span>
                                                        <Badge bg="info" className="p-2" style={{ fontSize: '0.9rem' }}>
                                                            Available: {formatCurrency(totalAdvance || 0)}
                                                        </Badge>
                                                    </div>

                                                    <Row className="gy-3">
                                                        <Col md={12}>
                                                            <div className="d-flex align-items-center mb-2">
                                                                <Form.Check
                                                                    type="checkbox"
                                                                    id="use_advance"
                                                                    name="use_advance"
                                                                    label="Apply Existing Advance Balance"
                                                                    checked={formData.use_advance}
                                                                    onChange={handleChange}
                                                                    className="form-font fw-semibold"
                                                                    disabled={isInvoiceFieldReadOnly || isExpenseFieldReadOnly || (totalAdvance <= 0 && !formData.use_advance)}
                                                                />
                                                            </div>

                                                            {formData.use_advance && (
                                                                <Form.Group controlId="applied_advance" className="ms-4 animate__animated animate__fadeIn">
                                                                    <Form.Label className="form-font small text-muted">Amount to deduct from Advance</Form.Label>
                                                                    <Form.Control
                                                                        type="number"
                                                                        step="0.01"
                                                                        name="applied_advance"
                                                                        value={formData.applied_advance}
                                                                        onChange={handleAmountChange}
                                                                        className="form-feild"
                                                                        placeholder="Enter amount from advance"
                                                                        readOnly={isInvoiceFieldReadOnly || isExpenseFieldReadOnly}
                                                                    />
                                                                    <div className="mt-2 d-flex justify-content-between">
                                                                        <small className="text-muted">
                                                                            Remaining Advance: <span className="fw-bold">{formatCurrency(Math.max(0, (totalAdvance || 0) - (parseFloat(formData.applied_advance) || 0)))}</span>
                                                                        </small>
                                                                        <small className="text-primary cursor-pointer" style={{ fontWeight: 600 }} onClick={() => {
                                                                            if (isInvoiceFieldReadOnly || isExpenseFieldReadOnly) return;

                                                                            // For "Apply Max", calculate the total required based on selected entities
                                                                            let totalNeeded = 0;
                                                                            if (formData.type === 'income' && formData.selected_invoices?.length > 0) {
                                                                                totalNeeded = formData.selected_invoices.reduce((sum, inv) => sum + (parseFloat(inv.remaining_balance || inv.amount) || 0), 0);
                                                                            } else if (formData.type === 'expense' && formData.bills?.length > 0) {
                                                                                totalNeeded = formData.bills.reduce((sum, b) => sum + (parseFloat(b.remaining_balance || b.original_amount || b.amount) || 0), 0);
                                                                            } else {
                                                                                // Fallback to current transaction total
                                                                                totalNeeded = (parseFloat(formData.amount) || 0) + (parseFloat(formData.applied_advance) || 0);
                                                                            }

                                                                            const canApply = Math.min(totalAdvance, totalNeeded);
                                                                            const newCash = Math.max(0, totalNeeded - canApply);

                                                                            // Update both fields using handleAmountChange to trigger distributions
                                                                            handleAmountChange({ target: { name: 'applied_advance', value: canApply.toFixed(2) } });
                                                                            handleAmountChange({ target: { name: 'amount', value: newCash.toFixed(2) } });
                                                                        }}>
                                                                            Apply Max
                                                                        </small>
                                                                    </div>
                                                                </Form.Group>
                                                            )}
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        )}

                                        {/* Compact Calculation Summary for Income Transactions */}
                                        {formData.type === 'income' && (formData.selected_invoices?.length > 0 || formData.invoice_id) && (
                                                <div className="mb-3 d-flex flex-wrap align-items-center justify-content-between p-2 rounded bg-light border shadow-none" style={{ fontSize: '0.85rem' }}>
                                                    <div className="d-flex align-items-center flex-wrap gap-1">
                                                    <span className="text-muted">Invoice Total:</span>
                                                    <span className="fw-bold me-1">
                                                        {(() => {
                                                            let totalDue = 0;
                                                            if (formData.selected_invoices?.length > 0) {
                                                                totalDue = formData.selected_invoices.reduce((sum, inv) => {
                                                                    const fullInv = invoices?.find(i => i.id.toString() === (inv.value || inv.id).toString());
                                                                    return sum + (parseFloat(fullInv?.remaining_balance || inv.remaining_balance || inv.amount || 0));
                                                                }, 0);
                                                            } else if (formData.invoice_id) {
                                                                const fullInv = invoices?.find(i => i.id.toString() === formData.invoice_id.toString());
                                                                totalDue = fullInv ? parseFloat(fullInv.remaining_balance || fullInv.display_amount || 0) : 0;
                                                            }
                                                            return formatCurrency(totalDue);
                                                        })()}
                                                    </span>

                                                    {formData.use_advance && parseFloat(formData.applied_advance) > 0 && (
                                                        <>
                                                            <span className="text-info fw-semibold ms-1">- Applied:</span>
                                                            <span className="text-info fw-semibold">{formatCurrency(parseFloat(formData.applied_advance) || 0)}</span>
                                                        </>
                                                    )}

                                                    {parseFloat(formData.deduction_amount) > 0 && (
                                                        <>
                                                            <span className="text-secondary fw-bold ms-1">- Deduction:</span>
                                                            <span className="text-secondary fw-bold">{formatCurrency(parseFloat(formData.deduction_amount) || 0)}</span>
                                                        </>
                                                    )}

                                                    {parseFloat(formData.advance_amount) > 0 && (
                                                        <span className="text-warning fw-semibold ms-2" title="Overpaid Surplus">
                                                            (Surplus: {formatCurrency(formData.advance_amount)})
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="text-primary fw-bold ps-3 border-start ms-2">
                                                    Bank Amount: {formatCurrency(parseFloat(formData.amount || 0))} {getCurrencySymbol(formData.transaction_currency)}
                                                </div>
                                            </div>
                                        )}

                                        <Form.Group controlId="amount" className="mb-3">
                                            <Form.Label className='form-font'>Amount</Form.Label>

                                            <div className="input-group">
                                                <Form.Control
                                                    className={`form-control form-feild ${errors?.amount ? 'is-invalid' : ''}`}
                                                    type="number"
                                                    step="0.01"
                                                    name="amount"
                                                    value={formData.amount}
                                                    onChange={handleAmountChange}
                                                    disabled={!isEditMode && transactionId}
                                                />

                                                {/* Currency selector dropdown */}
                                                {isEditMode && selectedBank && (
                                                    <div className="dropdown">
                                                        <button
                                                            className="btn btn-outline-secondary dropdown-toggle"
                                                            type="button"
                                                            id="currencyDropdown"
                                                            data-bs-toggle="dropdown"
                                                            aria-expanded="false"
                                                            style={{
                                                                borderTopLeftRadius: 0,
                                                                borderBottomLeftRadius: 0,
                                                                borderLeft: 'none'
                                                            }}
                                                        >
                                                            {/* Show current currency */}
                                                            {(() => {
                                                                // 1. Check selected currency FIRST (Manual Override Priority)
                                                                if (formData.transaction_currency) {
                                                                    return getCurrencySymbol(formData.transaction_currency);
                                                                }

                                                                // 2. Then check if we have an entity-specific currency
                                                                const entityCurrency = getSelectedInvoiceExpenseCurrency();
                                                                if (entityCurrency) {
                                                                    return entityCurrency;
                                                                }

                                                                // 3. Finally bank base currency
                                                                return selectedBank.base_currency?.currency || 'AED';
                                                            })()}
                                                        </button>

                                                        <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="currencyDropdown" style={{ minWidth: '200px' }}>
                                                            {getPrioritizedCurrencies().map((curr, idx, arr) => {
                                                                const isSelected = formData.transaction_currency === curr.currency_id;

                                                                return (
                                                                    <li key={curr.currency_id}>
                                                                        <button
                                                                            className={`dropdown-item py-2 ${isSelected ? 'active bg-primary text-white' : ''}`}
                                                                            type="button"
                                                                            onClick={() => handleCurrencySelection(curr.currency_id)}
                                                                        >
                                                                            <div className="d-flex justify-content-between align-items-center">
                                                                                <div>
                                                                                    <strong>{curr.label}</strong>
                                                                                    {curr.priority_label && (
                                                                                        <span className={`badge ms-2 ${isSelected ? 'bg-light text-dark' : 'bg-primary'}`}
                                                                                            style={{ fontSize: '0.65rem' }}>
                                                                                            {curr.priority_label}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                                {isSelected && (
                                                                                    <i className="mdi mdi-check ms-2"></i>
                                                                                )}
                                                                            </div>
                                                                        </button>
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                    </div>
                                                )}
                                            </div>

                                            {/* Show conversion if different from base currency */}
                                            {/* Show conversion if different from base currency */}
                                            {(() => {
                                                const currentCurrencyId = formData.transaction_currency;
                                                const baseCurrencyId = selectedBank?.base_currency_id;

                                                // Only show if we have a selected currency that is DIFFERENT from base
                                                if (!currentCurrencyId || !baseCurrencyId || currentCurrencyId.toString() === baseCurrencyId.toString()) {
                                                    return null;
                                                }

                                                // Calculate rate
                                                let rate = 1;
                                                let rateLabel = '';
                                                const amount = parseFloat(formData.amount || 0);
                                                const baseAmount = parseFloat(formData.base_amount || 0);

                                                if (amount > 0 && baseAmount > 0) {
                                                    rate = (baseAmount / amount).toFixed(4);
                                                    rateLabel = `1 ${getCurrencySymbol(currentCurrencyId)} = ${rate} ${selectedBank.base_currency?.currency || 'AED'}`;
                                                }

                                                return (
                                                    <div className="alert alert-info mt-2 mb-0 d-flex align-items-center animate__animated animate__fadeIn">
                                                        <i className="mdi mdi-information-outline me-2 fs-4"></i>
                                                        <div>
                                                            <div className="fw-bold">
                                                                Exchange Rate Applied:
                                                            </div>
                                                            <div className="small">
                                                                {rateLabel}
                                                            </div>
                                                            <div className="mt-1 small">
                                                                <strong>{formatCurrency(amount)} {getCurrencySymbol(currentCurrencyId)}</strong>
                                                                {' '}<i className="mdi mdi-arrow-right-thin"></i>{' '}
                                                                <strong>{formatCurrency(baseAmount)} {selectedBank.base_currency?.currency || 'AED'}</strong>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })()}
                                        </Form.Group>
                                    </>
                                )}
                                {/* Bank Guarantee Commission Fields - Inserted before Bank Service Charge */}
                                {formData.type === 'bank_guarantee' && (
                                    <>
                                        <Row>
                                            <Col md={12}>
                                                <Form.Group controlId="commission_fee" className="mb-3">
                                                    <Form.Label className='form-font'>Commission Fee</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="commission_fee"
                                                        value={formData.commission_fee || ''}
                                                        onChange={(e) => {
                                                            const value = parseFloat(e.target.value) || 0;
                                                            const vat = (value * 0.05).toFixed(2);
                                                            setFormData(prev => ({
                                                                ...prev,
                                                                commission_fee: value,
                                                                commission_vat: vat
                                                            }));
                                                        }}
                                                        placeholder="Enter commission fee"
                                                    />
                                                </Form.Group>
                                            </Col>

                                            <Col md={12}>
                                                <Form.Group controlId="commission_vat" className="mb-3">
                                                    <Form.Label className='form-font'>Commission VAT (5%)</Form.Label>
                                                    <Form.Control
                                                        className='form-control form-feild'
                                                        type="number"
                                                        step="0.01"
                                                        name="commission_vat"
                                                        value={formData.commission_vat || ''}
                                                        onChange={handleChange}
                                                        placeholder="Auto-calculated VAT"
                                                    />
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </>
                                )}

                                {(formData.type === 'contra' || formData.type === 'withdrawal' || formData.type === 'bank_guarantee') && (
                                    <>
                                        <Form.Group controlId="bank_service_charge" className="mb-3">
                                            <Form.Label className='form-font'>Bank Service Charge</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                name="bank_service_charge"
                                                value={formData.bank_service_charge}
                                                onChange={(e) => {
                                                    const value = parseFloat(e.target.value) || 0;
                                                    const vat = (value * 0.05).toFixed(2);
                                                    setFormData(prev => ({
                                                        ...prev,
                                                        bank_service_charge: value,
                                                        bank_vat_amount: vat
                                                    }));
                                                }}
                                                className="form-feild"
                                                placeholder="Enter service charge"
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="bank_vat_amount" className="mb-3">
                                            <Form.Label className='form-font'>Bank Service VAT</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                name="bank_vat_amount"
                                                value={formData.bank_vat_amount}
                                                onChange={handleChange}

                                                className="form-feild"
                                                placeholder="Enter VAT amount"
                                            />
                                        </Form.Group>
                                    </>
                                )}

                                

                                {(formData.type === 'expense' || formData.type === 'vat_payable' || formData.type === 'advance') && (
                                    <>

                                        <Form.Group controlId="bank_service_charge" className="mb-3">
                                            <Form.Label className='form-font'>Bank Service Charge</Form.Label>
                                            <Form.Control
                                                className='form-control form-feild'
                                                type="number"
                                                step="0.01"
                                                name="bank_service_charge"
                                                value={formData.bank_service_charge}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                        <Form.Group controlId="bank_vat_amount" className="mb-3">
                                            <Form.Label className='form-font'>VAT on Bank Charge</Form.Label>
                                            <Form.Control
                                                className='form-control form-feild'
                                                type="number"
                                                step="0.01"
                                                name="bank_vat_amount"
                                                value={formData.bank_vat_amount}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>

                                    </>
                                )}

                                {/* OLD ADVANCE FIELDS - Now shown in Advance Summary card */}
                                {/* {formData.type === 'income' && totalAdvance > 0 && (
                                    <Row>
                                        <Col md={6}>
                                            <Form.Group controlId="available_advance" className="mb-3">
                                                <Form.Label className='form-font'>Available Advance</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className='form-control form-feild bg-light'
                                                    value={formatCurrency(totalAdvance)}
                                                    readOnly
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col md={6}>
                                            <Form.Group controlId="advance_to_apply" className="mb-3">
                                                <Form.Label className='form-font'>Advance to Apply</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    className='form-control form-feild'
                                                    name="advance_amount"
                                                    value={formData.advance_amount || "0.00"}
                                                    onChange={handleChange}
                                                    max={Math.min(totalAdvance, formData.originalAmount || 0)}
                                                />
                                                <Form.Text className="text-muted">
                                                    Max: {formatCurrency(Math.min(totalAdvance, formData.originalAmount || 0))}
                                                </Form.Text>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                )} */}

                                {formData.type === 'income' && totalCredit > 0 && (
                                    <Row className="mb-3">
                                        <Col md={12}>
                                            <Form.Check
                                                type="checkbox"
                                                id="use_credit"
                                                label={`Use Customer Credit (Available: ${formatCurrency(totalCredit)})`}
                                                name="use_credit"
                                                checked={formData.use_credit}
                                                onChange={(e) => {
                                                    const checked = e.target.checked;
                                                    setFormData(prev => {
                                                        const currentAmount = parseFloat(prev.amount || 0);
                                                        const creditToUse = checked ? Math.min(totalCredit, currentAmount) : 0;
                                                        return {
                                                            ...prev,
                                                            use_credit: checked,
                                                            credit_amount: creditToUse.toFixed(2),
                                                            amount: (currentAmount - (checked ? creditToUse : -parseFloat(prev.credit_amount || 0))).toFixed(2)
                                                        };
                                                    });
                                                }}
                                                className="form-font"
                                            />
                                        </Col>
                                        {formData.use_credit && (
                                            <Col md={12} className="mt-2">
                                                <Form.Group controlId="credit_amount_to_apply">
                                                    <Form.Label className='form-font'>Credit Amount to Apply</Form.Label>
                                                    <Form.Control
                                                        type="number"
                                                        step="0.01"
                                                        className='form-control form-feild'
                                                        name="credit_amount"
                                                        value={formData.credit_amount}
                                                        onChange={(e) => {
                                                            const val = parseFloat(e.target.value) || 0;
                                                            const maxAllowed = totalCredit;
                                                            const finalVal = Math.min(val, maxAllowed);

                                                            setFormData(prev => {
                                                                const oldCredit = parseFloat(prev.credit_amount || 0);
                                                                const currentCashAmount = parseFloat(prev.amount || 0);
                                                                return {
                                                                    ...prev,
                                                                    credit_amount: finalVal.toFixed(2),
                                                                    amount: (currentCashAmount + oldCredit - finalVal).toFixed(2)
                                                                };
                                                            });
                                                        }}
                                                    />
                                                </Form.Group>
                                            </Col>
                                        )}
                                    </Row>
                                )}

                                {formData.type === 'income' && (
                                    <Form.Group controlId="amount_received_input" className="mb-3">
                                        <Form.Label className='form-font fw-semibold'>Received Amount</Form.Label>
                                        <Form.Control
                                            className='form-control form-feild'
                                            type="number"
                                            step="0.01"
                                            name="received_amount"
                                            value={formData.received_amount}
                                            onChange={handleAmountChange}
                                        />


                                        {parseFloat(formData.advance_amount) > 0 && (
                                            <div className="mt-2 text-primary animate__animated animate__fadeIn" style={{ fontSize: '0.9rem' }}>
                                                <i className="bi bi-info-circle me-1"></i>
                                                <strong>Overpayment Detected:</strong> {formatCurrency(formData.advance_amount)} will be saved as a Customer Advance.
                                            </div>
                                        )}
                                    </Form.Group>
                                )}
                                {formData.type === 'income' && (
                                    <Form.Group controlId="deduction" className="mb-3">
                                        <Form.Label className='form-font'>Deduction Amount</Form.Label>
                                        <Form.Control
                                            className='form-control form-feild'
                                            type="text"
                                            name="deduction_amount"
                                            value={formData.deduction_amount}
                                            onChange={handleChange}
                                        />
                                    </Form.Group>
                                )}


                                <Form.Group controlId="reference_no" className="mb-3">
                                    <Form.Label className='form-font'>Reference No</Form.Label>
                                    <Form.Control
                                        className='form-control form-feild'
                                        type="text"
                                        name="reference_no"
                                        value={formData.reference_no || ""}
                                        onChange={handleChange}
                                    />
                                </Form.Group>


                                <Form.Group controlId="statement_file" className="mb-3">
                                    <Form.Label className='form-font'>Upload Attachment</Form.Label>
                                    <Form.Control
                                        type="file"
                                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file) {
                                                // Validate file size (5MB)
                                                if (file.size > 5 * 1024 * 1024) {
                                                    showToast('File size must be less than 5MB', 'error');
                                                    e.target.value = '';
                                                    return;
                                                }
                                                setFormData(prev => ({ ...prev, statement_file: file }));
                                            } else {
                                                setFormData(prev => ({ ...prev, statement_file: null }));
                                            }
                                        }}
                                        className={`form-feild ${errors.statement_file ? 'is-invalid' : ''}`}
                                    />

                                    {formData.statement_file && (
                                        <div className="mt-2">
                                            <Badge bg="success">{formData.statement_file.name}</Badge>
                                        </div>
                                    )}

                                    {/* Show existing file if viewing/editing transaction */}
                                    {transactionData && transactionData.statement_file && !formData.statement_file && (
                                        <div className="mt-2">
                                            <Badge bg="info">
                                                Current: {typeof transactionData.statement_file === 'string'
                                                    ? transactionData.statement_file.split('/').pop()
                                                    : 'Attached File'}
                                            </Badge>
                                            <a
                                                href={`${process.env.REACT_APP_BACKEND_URL}/storage/${transactionData.statement_file}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="btn btn-sm btn-outline-primary ms-2"
                                            >
                                                View File
                                            </a>
                                        </div>
                                    )}
                                    {errors.statement_file && <div className="invalid-feedback" style={{ fontSize: '12px' }}>{errors.statement_file}</div>}
                                </Form.Group>








                                <Form.Group controlId="name" className="mb-3">
                                    <Form.Label className='form-font'>
                                        {formData.type === 'bad_debt_written_off' ? 'Write-off Reason' : 'Transaction'}
                                    </Form.Label>
                                    <Form.Control
                                        className="form-feild form-control"
                                        type="text"
                                        name="transaction"
                                        value={formData.transaction}
                                        onChange={handleChange}
                                    />
                                </Form.Group>



                                <Form.Group className="mb-3" >
                                    <Form.Label className='form-font'>Description</Form.Label>
                                    <Form.Control
                                        className='form-control form-feild'
                                        type="text"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleChange}
                                    />
                                </Form.Group>
                            </Form>
                        </div>
                    </div >
                )
                }
            </Offcanvas.Body >

            <div className="p-3 border-top  d-flex justify-content-end">
                <button type="button" className="btn btn-secondary me-2" onClick={handleClose}>
                    Close
                </button>
                {!isEditMode && transactionId ? (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => setIsEditMode(true)}
                    >
                        Edit
                    </button>
                ) : (
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={handleSubmit}
                        disabled={loading}
                    >
                        {loading ? <Spinner animation="border" size="sm" /> : 'Save'}
                    </button>
                )}
            </div>
        </Offcanvas >
    );
};

export default TransactionModal;
